// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"l3Hza":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AIGenerate);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAIGenerateGeneric1160Svg = require("illustration:./S2_fill_AIGenerate_generic1_160.svg");
var _s2FillAIGenerateGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateGeneric1160Svg);
var _s2FillAIGenerateGeneric196Svg = require("illustration:./S2_fill_AIGenerate_generic1_96.svg");
var _s2FillAIGenerateGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateGeneric196Svg);
var _s2FillAIGenerateGeneric148Svg = require("illustration:./S2_fill_AIGenerate_generic1_48.svg");
var _s2FillAIGenerateGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function AIGenerate(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_AIGenerate_generic1_160.svg":"d5CTL","illustration:./S2_fill_AIGenerate_generic1_96.svg":"0FrB4","illustration:./S2_fill_AIGenerate_generic1_48.svg":"lSlJx","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d5CTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21bacb__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21bacb__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21bacb__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "21bacb__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "21bacb__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "21bacb__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "21bacb__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m126.787 55.017 9.316 2.186c4.137.97 6.999-4.204 4.126-7.455l-6.47-7.326c-.961-1.088-1.35-2.604-1.037-4.047l2.096-9.72c.929-4.318-4.029-7.304-7.145-4.306l-7.021 6.751c-1.043 1.003-2.495 1.409-3.878 1.082l-9.316-2.187c-4.137-.969-6.999 4.204-4.126 7.456l6.47 7.326c.374.423.661.911.854 1.434q.176.478.246.985c.073.535.054 1.086-.063 1.627l-2.096 9.721c-.116.54-.14 1.059-.087 1.548q.06.551.242 1.046c.997 2.744 4.556 4.054 6.99 1.712l7.021-6.751c1.042-1.003 2.495-1.409 3.878-1.082m-32.4-18.239h-44.43c-8.836 0-16 7.164-16 16v60.087c0 8.837 7.163 16 16 16h60.087c8.837 0 16-7.163 16-16V64.183l-4.609 4.432-.002.001c-4.438 4.269-10.487 4.253-14.763 1.676-4.221-2.543-6.984-7.687-5.748-13.43l1.742-8.082-5.327-6.032-.002-.002c-1.616-1.83-2.557-3.888-2.948-5.968m2.75 49.805-6.848-1.543c-.907-.203-1.847.05-2.529.675l-5.158 4.759c-2.032 1.875-5.265.005-4.657-2.686l1.543-6.848c.203-.906-.05-1.847-.675-2.528l-4.759-5.158c-1.875-2.033-.005-5.265 2.686-4.657l6.848 1.543c.907.203 1.847-.05 2.528-.676l5.158-4.758c2.033-1.875 5.265-.006 4.657 2.686l-1.543 6.847c-.203.907.05 1.847.676 2.529l4.758 5.158c1.875 2.032.006 5.265-2.686 4.656"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#21bacb__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#21bacb__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#21bacb__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21bacb__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21bacb__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21bacb__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#21bacb__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"0FrB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "038618__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "038618__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "038618__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "038618__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "038618__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "038618__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "038618__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M80.934 33.977c-.293 1.304-1.518 2.355-3.034 2l-5.463-1.282q-.208-.05-.418-.061c-.677-.039-1.349.208-1.856.696l-4.117 3.959c-1.827 1.758-4.734.006-4.19-2.525l1.23-5.7c.183-.847-.045-1.736-.609-2.373l-3.794-4.296q-.168-.192-.293-.395c-.344-.562-.446-1.185-.36-1.77.205-1.397 1.477-2.581 3.073-2.207l5.463 1.282c.81.191 1.662-.046 2.273-.635l4.118-3.959c1.827-1.758 4.734-.006 4.19 2.525l-1.23 5.7q-.034.16-.049.32c-.072.745.165 1.495.658 2.053l3.794 4.296c.51.577.711 1.257.678 1.91q-.012.233-.064.462M54.143 24c.222 1.06.716 2.108 1.542 3.042v.001l3.356 3.8-1.095 5.08c-.658 3.058.81 5.788 3.051 7.138 2.27 1.367 5.468 1.375 7.822-.889l3.2-3.078V70c0 4.418-3.581 8-8 8h-38c-4.418 0-8-3.582-8-8V32c0-4.419 3.582-8 8-8zm-2.177 27.368 4.016.905c1.578.357 2.674-1.539 1.575-2.73l-2.79-3.025c-.367-.4-.516-.951-.397-1.483l.905-4.015c.357-1.579-1.539-2.675-2.73-1.576l-3.026 2.79c-.4.367-.95.516-1.482.397l-4.016-.905c-1.578-.356-2.674 1.539-1.575 2.731l2.79 3.025c.367.4.516.95.397 1.483l-.905 4.015c-.357 1.578 1.539 2.675 2.73 1.575l3.026-2.79c.4-.367.95-.516 1.482-.397"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#038618__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#038618__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#038618__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#038618__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#038618__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#038618__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#038618__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lSlJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3ccbc6__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3ccbc6__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3ccbc6__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3ccbc6__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3ccbc6__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3ccbc6__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3ccbc6__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M38.075 7.775c.916-.741 2.268.119 2.004 1.343l-.614 2.85c-.092.423.022.868.304 1.187l1.897 2.148c.556.63.379 1.505-.155 1.945-.274.221-.639.329-1.046.234l-2.732-.642c-.405-.095-.831.024-1.137.318l-2.058 1.98c-.914.878-2.367.002-2.095-1.263l.614-2.85c.092-.423-.022-.868-.304-1.187l-1.897-2.148c-.556-.63-.379-1.505.155-1.945.274-.221.639-.33 1.046-.234l2.732.641c.373.089.765-.005 1.063-.251q.042-.034.082-.073l2.059-1.98q.04-.038.082-.073M28.078 11.5H14.516c-2.21 0-4 1.79-4 4v19c0 2.21 1.79 4 4 4h19c2.209 0 4-1.79 4-4V19.742l-1.245 1.197c-1.357 1.305-3.209 1.3-4.516.513-1.29-.778-2.133-2.35-1.756-4.103l.494-2.293-1.51-1.71c-.5-.566-.788-1.203-.905-1.846m-1.59 14.684 2.008.453c.79.178 1.338-.77.788-1.366l-1.395-1.512c-.184-.2-.258-.476-.198-.741l.452-2.008c.178-.79-.77-1.338-1.366-.788l-1.512 1.395c-.2.184-.475.258-.741.199l-2.008-.453c-.789-.178-1.337.77-.787 1.366l1.395 1.512c.183.2.257.476.198.741l-.453 2.008c-.178.79.77 1.337 1.366.788l1.512-1.396c.2-.183.476-.257.742-.198"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3ccbc6__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3ccbc6__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#3ccbc6__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3ccbc6__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3ccbc6__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3ccbc6__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#3ccbc6__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4PAM8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AIGenerateImage);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAIGenerateImageGeneric1160Svg = require("illustration:./S2_fill_AIGenerateImage_generic1_160.svg");
var _s2FillAIGenerateImageGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateImageGeneric1160Svg);
var _s2FillAIGenerateImageGeneric196Svg = require("illustration:./S2_fill_AIGenerateImage_generic1_96.svg");
var _s2FillAIGenerateImageGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateImageGeneric196Svg);
var _s2FillAIGenerateImageGeneric148Svg = require("illustration:./S2_fill_AIGenerateImage_generic1_48.svg");
var _s2FillAIGenerateImageGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAIGenerateImageGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function AIGenerateImage(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateImageGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateImageGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIGenerateImageGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_AIGenerateImage_generic1_160.svg":"1Sci7","illustration:./S2_fill_AIGenerateImage_generic1_96.svg":"7DeSd","illustration:./S2_fill_AIGenerateImage_generic1_48.svg":"eJXsa","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Sci7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f99fb7__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f99fb7__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f99fb7__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f99fb7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f99fb7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f99fb7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f99fb7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m142.816 50.766-10.391-2.338c-1.543-.35-3.163.085-4.326 1.157l-7.831 7.217c-3.476 3.205-9.007.012-7.97-4.603l2.337-10.391c.349-1.543-.084-3.163-1.157-4.326l-7.217-7.831c-3.205-3.476-.012-9.007 4.603-7.97l10.392 2.337c1.542.35 3.162-.084 4.325-1.157l7.832-7.217c3.476-3.205 9.006-.012 7.97 4.603l-2.338 10.392c-.349 1.542.085 3.162 1.157 4.325l7.217 7.831c3.205 3.477.012 9.007-4.603 7.97M18.824 63.347c5.228-19.513 25.286-31.094 44.8-25.865 8.472 2.27 15.441 7.329 20.197 13.929 1.291 1.792 3.791 2.198 5.583.907 1.793-1.292 2.199-3.792.907-5.584-5.794-8.041-14.3-14.215-24.617-16.98-23.781-6.372-48.225 7.741-54.598 31.522-4.089 15.261.258 30.788 10.173 41.64l-7.253-.023c-2.21-.007-4.006 1.778-4.013 3.987s1.778 4.006 3.987 4.013l16.494.053c2.155.006 3.928-1.696 4.01-3.849l.601-15.913c.084-2.207-1.638-4.065-3.846-4.148-2.207-.084-4.065 1.638-4.148 3.846l-.238 6.293c-7.922-8.893-11.35-21.473-8.04-33.828m87.964 8.09.183.199.003.003 1.404 1.522c2.006 2.175.006 5.633-2.873 4.982l-2.031-.457-1.869-.421-.411-.093-3.015-.68c-.97-.216-1.976.055-2.705.724l-2.272 2.096-.31.285-1.41 1.302-.004.003-1.522 1.404c-2.175 2.006-5.633.006-4.982-2.873l.458-2.031.42-1.87.093-.41.68-3.015q.075-.334.073-.67c-.002-.747-.28-1.473-.796-2.035l-5.09-5.518c-2.007-2.175-.007-5.633 2.873-4.982l7.325 1.65c.97.218 1.976-.054 2.705-.722l5.519-5.09c2.174-2.007 5.632-.007 4.982 2.873l-1.651 7.325c-.217.97.054 1.976.723 2.705zm9.772 0h15.073c7.179 0 13 5.82 13 13v48.915c0 2.214-.554 4.299-1.531 6.124l-16.296-24.123c-3.871-5.77-12.353-5.755-16.223.001l-.018.028-8.848 13.394-16.175-24.985v-.002h-.001c-3.847-5.947-12.557-5.948-16.405-.003l-.003.005-23.842 36.672V84.438c0-7.18 5.82-13 13-13h18.604l1.35 1.463-1.074 4.769v.002l-.001.002C74.79 88.22 87.444 95.508 95.38 88.186l3.593-3.314 4.769 1.075h.004c9.013 2.034 15.646-6.912 12.814-14.51m-65.555 74.915h39.102l6.797-10.29-18.079-27.926-.001-.002c-.695-1.075-2.278-1.075-2.972 0l-.006.009zm69.168-26.527 17.064 25.26c-1.697.812-3.598 1.267-5.604 1.267H99.695l17.534-26.544c.711-1.044 2.243-1.029 2.934.004zM120.666 98c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f99fb7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f99fb7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f99fb7__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f99fb7__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f99fb7__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f99fb7__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f99fb7__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7DeSd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "90836c__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "90836c__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "90836c__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "90836c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "90836c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "90836c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "90836c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m85.692 28.859-6.235-1.403c-.925-.21-1.897.05-2.595.694l-4.699 4.33c-2.085 1.923-5.404.008-4.782-2.761l1.403-6.235c.21-.926-.051-1.898-.695-2.596l-4.33-4.698c-1.923-2.086-.007-5.404 2.762-4.782l6.235 1.402c.925.21 1.897-.05 2.595-.694l4.699-4.33c2.086-1.923 5.404-.007 4.782 2.761l-1.402 6.235c-.21.926.05 1.898.694 2.596l4.33 4.698c1.923 2.086.007 5.404-2.762 4.783M10.91 36.305c3.194-11.921 15.448-18.996 27.37-15.802 5.175 1.387 9.433 4.478 12.339 8.51.645.896 1.895 1.1 2.791.453.897-.645 1.1-1.895.454-2.791-3.424-4.753-8.451-8.402-14.55-10.035-14.055-3.767-28.502 4.574-32.268 18.63-2.503 9.34.34 18.848 6.65 25.283l-5.286-.017c-1.104-.003-2.002.89-2.006 1.994-.003 1.104.89 2.003 1.994 2.006l9.896.032c1.078.003 1.964-.848 2.005-1.925l.36-9.547c.042-1.104-.819-2.033-1.922-2.074-1.104-.042-2.033.819-2.075 1.923l-.179 4.739c-5.307-5.46-7.686-13.494-5.573-21.379m40.076 9.756c-.39 1.727 1.685 2.928 2.99 1.724l3.31-3.054c.438-.402 1.042-.564 1.624-.434l4.395.99c1.727.39 2.927-1.684 1.724-2.989l-.956-1.036-2.098-2.275c-.402-.437-.564-1.04-.434-1.623l.99-4.395c.39-1.728-1.684-2.928-2.989-1.724l-3.31 3.054c-.438.401-1.042.564-1.624.434l-4.395-.99c-1.728-.391-2.928 1.684-1.724 2.989l3.054 3.31c.309.337.476.772.478 1.22q0 .202-.044.404zm-3.76-4.8h-12.05c-4.419 0-8 3.582-8 8v34.214l14.631-23 1.688 1.072-1.687-1.073-.001.001c2.148-3.383 7.042-3.383 9.19 0l-1.687 1.072 1.688-1.072 10.075 15.848 5.6-8.475.009-.013c2.164-3.22 6.908-3.226 9.07 0l.002.003 9.824 14.592c.763-1.225 1.203-2.672 1.203-4.221V49.262c0-4.419-3.582-8-8-8h-9.71c1.766 4.062-1.784 9.024-6.645 7.927h-.002l-3.272-.737-2.464 2.273c-4.186 3.861-10.858.017-9.604-5.544v-.002l.738-3.271zM30.175 86.21H54.54l4.117-6.23L47.62 62.62c-.578-.91-1.861-.91-2.438 0h-.001zm42.257-16.141L82.634 85.22c-1.143.63-2.457.988-3.854.988H59.334l10.67-16.147c.585-.863 1.852-.855 2.425.002zM72.001 57c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#90836c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#90836c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#90836c__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#90836c__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#90836c__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#90836c__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#90836c__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eJXsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8aa66b__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8aa66b__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8aa66b__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8aa66b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8aa66b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8aa66b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8aa66b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m39.729 13.728 3.117.701c1.385.311 2.343-1.348 1.381-2.39l-2.165-2.35c-.322-.349-.452-.835-.347-1.298l.701-3.117c.311-1.385-1.348-2.343-2.39-1.381l-2.35 2.165c-.35.322-.835.452-1.298.347l-3.117-.701c-1.385-.311-2.343 1.348-1.381 2.39l2.165 2.35c.322.35.452.835.347 1.298l-.701 3.117c-.311 1.385 1.348 2.343 2.39 1.381l2.35-2.165c.349-.322.835-.452 1.298-.347M5.696 18.217c1.561-5.827 7.551-9.286 13.379-7.724 2.53.678 4.61 2.188 6.031 4.16.404.56 1.185.686 1.745.283s.687-1.185.283-1.745c-1.744-2.421-4.306-4.28-7.412-5.113C12.56 6.159 5.2 10.408 3.282 17.57c-1.222 4.556.054 9.19 2.986 12.454l-2.063-.007c-.69-.002-1.252.556-1.254 1.247-.002.69.555 1.251 1.246 1.253l4.948.016c.673.002 1.228-.53 1.253-1.203l.18-4.773c.026-.69-.512-1.27-1.202-1.297s-1.27.512-1.296 1.202l-.067 1.763c-2.306-2.65-3.294-6.362-2.317-10.008m26.34 2.414.056.06v.001l.422.457q.112.124.171.26c.277.633-.277 1.405-1.033 1.235l-.61-.138-.681-.153-.174-.04-.733-.165c-.29-.065-.592.017-.811.217l-.552.51-.131.12-.515.475-.001.001-.457.421c-.652.602-1.69.002-1.494-.862l.137-.609.154-.682.039-.174.165-.732q.022-.101.022-.202c0-.224-.085-.442-.239-.61l-1.527-1.655c-.602-.653-.002-1.69.862-1.495l2.198.495c.29.065.593-.016.811-.216l1.656-1.528c.652-.601 1.69-.001 1.494.862l-.495 2.198c-.065.291.016.593.217.812zm3.04 0h4.313c2.21 0 4 1.79 4 4v14.474c0 .675-.167 1.311-.462 1.869l-4.843-7.194-.001-.001c-1.181-1.762-3.77-1.758-4.95-.001l-.006.008-2.614 3.955-4.81-7.43c-1.174-1.815-3.831-1.815-5.005-.002l-.001.002-7.11 10.931V24.631c0-2.21 1.79-4 4-4h5.345l.433.47-.31 1.378v.001h-.001c-.735 3.26 3.175 5.513 5.629 3.25l1.039-.959 1.38.311c2.773.626 4.817-2.11 3.973-4.451m-19.72 22.475h11.612l2.04-3.089-5.404-8.348c-.189-.293-.62-.293-.808 0l-.002.002zm20.652-7.932 5.085 7.552c-.517.243-1.095.38-1.704.38h-9.425l5.245-7.936c.193-.284.61-.28.797 0zm-.007-6.424c-.967 0-1.75-.784-1.75-1.75s.783-1.75 1.75-1.75c.966 0 1.75.784 1.75 1.75s-.784 1.75-1.75 1.75"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8aa66b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8aa66b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#8aa66b__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8aa66b__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8aa66b__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8aa66b__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#8aa66b__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9QwJC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AIchat);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAIchatGeneric1160Svg = require("illustration:./S2_fill_AIchat_generic1_160.svg");
var _s2FillAIchatGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAIchatGeneric1160Svg);
var _s2FillAIchatGeneric196Svg = require("illustration:./S2_fill_AIchat_generic1_96.svg");
var _s2FillAIchatGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAIchatGeneric196Svg);
var _s2FillAIchatGeneric148Svg = require("illustration:./S2_fill_AIchat_generic1_48.svg");
var _s2FillAIchatGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAIchatGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function AIchat(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIchatGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIchatGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAIchatGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_AIchat_generic1_160.svg":"3hF2D","illustration:./S2_fill_AIchat_generic1_96.svg":"joqSl","illustration:./S2_fill_AIchat_generic1_48.svg":"1A9fh","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3hF2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f9adf7__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f9adf7__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f9adf7__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f9adf7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f9adf7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f9adf7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f9adf7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m106.073 50.902-2.121 9.84c-.94 4.37 4.078 7.393 7.233 4.358l7.107-6.833c1.055-1.016 2.525-1.427 3.925-1.096l9.43 2.214q.156.036.31.061c4.018.66 6.703-4.4 3.867-7.609l-6.55-7.416c-.84-.95-1.248-2.224-1.14-3.494q.015-.163.04-.327.021-.138.051-.274l2.121-9.84c.94-4.37-4.078-7.394-7.233-4.359l-7.107 6.834c-1.055 1.016-2.525 1.426-3.925 1.095l-9.43-2.213c-3.251-.762-5.725 2.225-5.307 5.14.12.839.48 1.672 1.13 2.407l6.55 7.416c.832.942 1.24 2.201 1.143 3.46q-.025.319-.094.636m-16.757-13.92H40.489c-6.76 0-12.239 5.323-12.239 12.04v39.66c0 6.717 5.48 12.04 12.239 12.04h10.424c.024 5.739.046 13.952 0 20.207-.026 3.488 4.1 5.375 6.752 3.09l27.242-23.297h34.811c6.759 0 12.239-5.323 12.239-12.04V67.491q-1.044-.063-2.135-.317l-.003-.001-7.433-1.745-5.655 5.438-.001.001c-4.458 4.287-10.531 4.271-14.826 1.683-4.24-2.554-7.014-7.72-5.773-13.49l1.774-8.23-5.426-6.142-.001-.002c-2.066-2.339-3.034-5.051-3.162-7.704m1.042 47.08-6.93-1.562c-.919-.205-1.87.051-2.56.684l-5.221 4.817c-2.058 1.898-5.33.005-4.714-2.72l1.561-6.93c.206-.918-.05-1.87-.684-2.56l-4.816-5.221c-1.898-2.058-.006-5.33 2.719-4.714l6.931 1.562c.918.205 1.87-.052 2.56-.684l5.22-4.817c2.058-1.898 5.33-.005 4.715 2.72l-1.562 6.93c-.206.918.051 1.87.684 2.56l4.816 5.221c1.898 2.058.006 5.33-2.719 4.714"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f9adf7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f9adf7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f9adf7__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f9adf7__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f9adf7__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f9adf7__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f9adf7__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"joqSl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7650e2__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.166,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7650e2__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.684,
                        y2: 89.681,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7650e2__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.618,
                        y2: 33.126,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7650e2__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.278 29.003)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7650e2__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.53 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "7650e2__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "7650e2__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M61.817 36.974q.015-.105.038-.21l1.229-5.7q.045-.213.058-.427c.04-.71-.197-1.415-.666-1.946l-3.794-4.296c-.36-.407-.566-.865-.645-1.329-.29-1.709 1.156-3.49 3.064-3.043l5.463 1.282c.811.191 1.663-.046 2.274-.635l4.117-3.959c1.828-1.758 4.735-.006 4.19 2.525l-1.229 5.7-.014.072q-.008.043-.015.088-.023.142-.03.284c-.035.704.202 1.402.667 1.93l3.794 4.295c1.647 1.864.081 4.804-2.255 4.406q-.083-.014-.164-.033l-5.463-1.282c-.811-.192-1.663.046-2.274.634l-4.117 3.959c-1.777 1.71-4.574.101-4.228-2.315m10.526 1.808 4.643 1.09q.55.128 1.076.164v12.936c0 3.885-3.169 6.964-7.079 6.964H50.847L35.09 73.412c-1.534 1.322-3.92.23-3.906-1.788.027-3.618.014-8.369 0-11.688h-6.03c-3.91 0-7.079-3.079-7.079-6.964V30.03c0-3.886 3.17-6.965 7.08-6.965h28.86c.088 1.372.602 2.768 1.67 3.977l3.355 3.8-1.095 5.08c-.658 3.058.81 5.788 3.052 7.138 2.269 1.367 5.468 1.375 7.821-.889h.001zM53.98 50.273l-4.015-.904c-.532-.12-1.083.03-1.483.396l-3.025 2.79c-1.192 1.1-3.087.004-2.73-1.575l.904-4.015c.12-.532-.03-1.083-.396-1.483l-2.79-3.025c-1.1-1.192-.004-3.087 1.575-2.73l4.015.904c.532.12 1.083-.03 1.483-.396l3.025-2.79c1.192-1.1 3.087-.004 2.73 1.575l-.904 4.015c-.12.532.03 1.083.396 1.483l2.79 3.025c1.1 1.192.004 3.087-1.575 2.73"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#7650e2__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#7650e2__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.724,
                            r: 41.765,
                            fill: "url(#7650e2__c)",
                            transform: "rotate(-.08 54.28 3.724)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7650e2__d)",
                            d: "M36.643-16.957c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.426-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7650e2__e)",
                            d: "M13.837 45.58C15.477 9.74 45.86-17.983 81.7-16.343s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922S12.196 81.419 13.837 45.58"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7650e2__f)",
                            d: "M-38.895 69.21c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.315 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.345,
                            r: 41.765,
                            fill: "url(#7650e2__g)",
                            transform: "rotate(-.08 90.406 17.345)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1A9fh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1691df__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1691df__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1691df__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1691df__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1691df__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1691df__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1691df__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m30.92 18.423.008-.041.615-2.85.007-.037c.078-.412-.038-.84-.311-1.149l-1.897-2.148c-.177-.2-.28-.424-.32-.651-.155-.859.57-1.76 1.53-1.536l2.731.641c.405.096.831-.023 1.137-.317l2.059-1.98c.913-.878 2.367-.003 2.095 1.263l-.615 2.85c-.092.423.022.868.304 1.187l1.897 2.148c.832.94.025 2.43-1.162 2.196l-.028-.005-.02-.005-2.731-.64c-.406-.096-.832.023-1.137.317l-2.059 1.98c-.904.869-2.336.02-2.103-1.223m5.403 1.518 2.056.482q.316.074.619.095V26.5c0 1.942-1.585 3.482-3.54 3.482H25.39l-7.879 6.738c-.767.66-1.96.115-1.952-.894.013-1.81.006-4.185 0-5.844h-3.015c-1.955 0-3.54-1.54-3.54-3.482V15.029c0-1.943 1.585-3.482 3.54-3.482h13.964c.046.795.341 1.606.96 2.306l1.51 1.71-.494 2.294c-.377 1.753.467 3.325 1.757 4.102 1.307.788 3.159.793 4.516-.512zm-9.332 5.196-2.008-.453c-.265-.06-.541.015-.741.198l-1.512 1.396c-.596.55-1.544.001-1.366-.788l.453-2.008c.06-.265-.015-.541-.198-.74l-1.396-1.513c-.55-.596-.001-1.544.788-1.366l2.008.453c.265.06.541-.015.74-.198l1.513-1.396c.596-.55 1.544-.001 1.366.788l-.453 2.008c-.06.265.015.541.198.74l1.396 1.513c.55.596.001 1.544-.788 1.366"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1691df__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1691df__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#1691df__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1691df__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1691df__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1691df__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#1691df__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1XwTL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Accessibility);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAccessibilityGeneric1160Svg = require("illustration:./S2_fill_accessibility_generic1_160.svg");
var _s2FillAccessibilityGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAccessibilityGeneric1160Svg);
var _s2FillAccessibilityGeneric196Svg = require("illustration:./S2_fill_accessibility_generic1_96.svg");
var _s2FillAccessibilityGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAccessibilityGeneric196Svg);
var _s2FillAccessibilityGeneric148Svg = require("illustration:./S2_fill_accessibility_generic1_48.svg");
var _s2FillAccessibilityGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAccessibilityGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Accessibility(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAccessibilityGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAccessibilityGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAccessibilityGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_accessibility_generic1_160.svg":"aY201","illustration:./S2_fill_accessibility_generic1_96.svg":"kwIAH","illustration:./S2_fill_accessibility_generic1_48.svg":"eq9gU","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aY201":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f659fe__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f659fe__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f659fe__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f659fe__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f659fe__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f659fe__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f659fe__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M80 136c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56m8.484-86.296c0 4.686-3.799 8.484-8.485 8.484s-8.485-3.798-8.485-8.484c0-4.687 3.8-8.485 8.485-8.485 4.686 0 8.485 3.798 8.485 8.485M51.087 61.78c.515-1.802 2.394-2.845 4.196-2.33 15.945 4.563 32.842 4.622 48.818.172l.638-.178c1.806-.503 3.677.553 4.18 2.359.503 1.805-.553 3.677-2.359 4.18l-.637.178c-5.1 1.42-10.288 2.414-15.51 2.98-1.029.111-1.82.974-1.82 2.01v14.884q0 .279.076.546c1.371 4.829 2.945 10.39 4.322 15.269.978 3.461 1.856 6.58 2.495 8.853l.76 2.715.041.149c.133.476.272.974.309 1.156.367 1.838-.825 3.626-2.663 3.993-1.838.368-3.626-.824-3.994-2.662.019.09.004.037-.082-.272l-.15-.542-.756-2.701c-.638-2.269-1.516-5.386-2.492-8.845-1.186-4.2-2.516-8.901-3.737-13.205-.244-.86-1.03-1.454-1.923-1.454h-1.6c-.894 0-1.68.594-1.923 1.454-1.221 4.304-2.551 9.006-3.737 13.205-.976 3.459-1.854 6.576-2.492 8.845l-.756 2.701-.15.54v.002c-.086.309-.1.362-.083.272-.367 1.838-2.155 3.03-3.993 2.662s-3.03-2.155-2.662-3.993c.036-.182.175-.68.308-1.156l.041-.149.76-2.715c.639-2.273 1.518-5.392 2.495-8.853 1.377-4.88 2.95-10.44 4.322-15.269q.075-.266.076-.546V71.151c0-1.036-.791-1.898-1.82-2.01-5.448-.59-10.858-1.645-16.169-3.165-1.802-.515-2.845-2.394-2.33-4.196"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f659fe__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f659fe__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f659fe__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f659fe__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f659fe__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f659fe__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f659fe__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kwIAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eb8add__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eb8add__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eb8add__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eb8add__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eb8add__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "eb8add__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "eb8add__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M48 81c18.225 0 33-14.775 33-33S66.225 15 48 15 15 29.775 15 48s14.775 33 33 33m5-50.853c0 2.76-2.238 5-5 5s-5-2.24-5-5c0-2.762 2.239-5 5-5s5 2.238 5 5m-22.038 7.116c.304-1.062 1.412-1.677 2.473-1.373 9.396 2.689 19.353 2.724 28.768.101l.376-.105c1.064-.296 2.167.326 2.463 1.39s-.326 2.167-1.39 2.464l-.376.104c-2.762.77-5.568 1.326-8.392 1.67-1.028.126-1.82.986-1.82 2.022v7.905q0 .279.077.546c.8 2.82 1.714 6.05 2.515 8.887.576 2.04 1.094 3.878 1.47 5.218l.448 1.6.025.087c.078.281.16.575.181.681.217 1.084-.486 2.137-1.569 2.354s-2.137-.486-2.353-1.57c.01.054.002.023-.048-.16l-.001-.002-.088-.317-.446-1.592c-.375-1.337-.893-3.173-1.468-5.212-.657-2.327-1.39-4.917-2.073-7.326-.22-.776-.928-1.31-1.734-1.31s-1.514.534-1.734 1.31c-.683 2.41-1.416 4.999-2.073 7.326-.575 2.039-1.093 3.875-1.468 5.212l-.446 1.592-.06.218-.028.102c-.05.182-.06.213-.049.16-.216 1.083-1.27 1.785-2.353 1.569-1.083-.217-1.786-1.27-1.57-2.353.022-.108.104-.401.182-.682l.025-.087.448-1.6c.376-1.34.894-3.178 1.47-5.218.801-2.838 1.715-6.067 2.515-8.887q.075-.267.076-.546v-7.905c0-1.035-.79-1.896-1.819-2.02-2.958-.361-5.894-.954-8.78-1.78-1.063-.304-1.677-1.411-1.374-2.473"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#eb8add__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#eb8add__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#eb8add__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eb8add__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eb8add__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eb8add__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#eb8add__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eq9gU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "737917__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "737917__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "737917__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "737917__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "737917__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "737917__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "737917__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M24 40.5c9.113 0 16.5-7.387 16.5-16.5S33.113 7.5 24 7.5 7.5 14.887 7.5 24 14.887 40.5 24 40.5m2.5-25.428c0 1.381-1.12 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5m-11.019 3.56c.152-.532.706-.839 1.237-.687 4.698 1.344 9.676 1.362 14.384.05l.187-.052c.532-.148 1.084.163 1.232.695s-.163 1.084-.695 1.232l-.188.052c-1.381.385-2.784.663-4.196.835-.514.063-.91.493-.91 1.011v3.953q0 .139.038.273l1.258 4.444.735 2.608.224.8.012.044c.04.14.08.287.091.34.108.542-.243 1.07-.784 1.177-.542.109-1.069-.242-1.177-.784.005.026 0 .011-.024-.08l-.045-.16-.223-.796c-.187-.668-.446-1.587-.734-2.606-.328-1.164-.694-2.459-1.036-3.664-.11-.387-.464-.655-.867-.655s-.757.268-.867.655c-.341 1.205-.708 2.5-1.036 3.664l-.735 2.606-.222.796-.045.16c-.025.091-.03.106-.024.08-.108.541-.635.893-1.177.784-.541-.108-.892-.635-.784-1.176.01-.054.052-.2.09-.34l.013-.045.224-.8.735-2.608c.4-1.42.857-3.034 1.258-4.444q.038-.133.038-.273v-3.953c0-.518-.396-.948-.91-1.01-1.479-.18-2.947-.477-4.39-.89-.531-.152-.839-.706-.687-1.237"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#737917__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#737917__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#737917__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#737917__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#737917__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#737917__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#737917__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gD4GR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Animation);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAnimationGeneric1160Svg = require("illustration:./S2_fill_animation_generic1_160.svg");
var _s2FillAnimationGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAnimationGeneric1160Svg);
var _s2FillAnimationGeneric196Svg = require("illustration:./S2_fill_animation_generic1_96.svg");
var _s2FillAnimationGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAnimationGeneric196Svg);
var _s2FillAnimationGeneric148Svg = require("illustration:./S2_fill_animation_generic1_48.svg");
var _s2FillAnimationGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAnimationGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Animation(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAnimationGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAnimationGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAnimationGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_animation_generic1_160.svg":"3p90H","illustration:./S2_fill_animation_generic1_96.svg":"dsSvr","illustration:./S2_fill_animation_generic1_48.svg":"cTv74","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3p90H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "05508f__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "05508f__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "05508f__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "05508f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "05508f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "05508f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "05508f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M136.004 30.806c0 3.293-1.998 6.12-4.848 7.335-2.815-3.466-6.671-6.053-11.093-7.282l-.001-.053c0-4.402 3.569-7.971 7.971-7.971s7.971 3.569 7.971 7.97m-7.973 21.085c0 5.786-3.554 10.742-8.598 12.805-3.844-7.275-10.719-12.701-18.943-14.6.88-6.789 6.684-12.032 13.713-12.032 7.637 0 13.828 6.19 13.828 13.827m-25.604 7.253c3.042 1.354 5.699 3.418 7.758 5.982 2.855 3.555 4.563 8.07 4.563 12.983 0 11.46-9.29 20.749-20.75 20.749q-.352 0-.703-.012C91.12 87.396 83.936 77.72 74.11 72.18 76.662 63.61 84.6 57.36 94 57.36c3 0 5.853.637 8.428 1.784m-16.445 47.028c0 17.117-13.876 30.993-30.993 30.993s-30.993-13.876-30.993-30.993S37.872 75.179 54.99 75.179c6.937 0 13.342 2.279 18.506 6.129 5.075 3.783 8.953 9.084 10.961 15.23.99 3.032 1.526 6.271 1.526 9.634"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#05508f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#05508f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#05508f__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#05508f__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#05508f__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#05508f__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#05508f__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dsSvr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5c8bb8__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5c8bb8__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5c8bb8__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5c8bb8__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5c8bb8__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5c8bb8__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5c8bb8__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M82.053 18.086c0 2.331-1.646 4.278-3.84 4.742-1.505-1.755-3.494-3.083-5.758-3.78q-.095-.468-.096-.962c0-2.677 2.17-4.847 4.847-4.847s4.847 2.17 4.847 4.847m-4.848 12.821c0 3.827-2.556 7.056-6.054 8.074-2.213-4.11-6.106-7.18-10.76-8.293.117-4.542 3.835-8.189 8.405-8.189 4.644 0 8.409 3.765 8.409 8.408M51.637 63.914c0 10.408-8.438 18.846-18.846 18.846s-18.846-8.438-18.846-18.846 8.438-18.846 18.846-18.846c4.218 0 8.113 1.386 11.253 3.727 3.086 2.3 5.443 5.523 6.664 9.26.603 1.844.929 3.813.929 5.86m17.49-17.065c0 6.968-5.648 12.617-12.616 12.617q-.669 0-1.32-.069c-1.31-6.533-5.408-12.059-10.999-15.285 1.25-5.652 6.291-9.88 12.32-9.88 6.967 0 12.616 5.649 12.616 12.617"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5c8bb8__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5c8bb8__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#5c8bb8__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5c8bb8__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5c8bb8__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5c8bb8__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#5c8bb8__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cTv74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "085d4b__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "085d4b__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "085d4b__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "085d4b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "085d4b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "085d4b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "085d4b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M41.026 9.042c0 .977-.578 1.819-1.41 2.203-.87-1.076-2.065-1.878-3.436-2.255.028-1.314 1.102-2.37 2.423-2.37 1.338 0 2.423 1.084 2.423 2.422m-2.424 6.412c0 1.735-1.05 3.225-2.551 3.867-1.178-2.234-3.288-3.9-5.813-4.48.297-2.031 2.046-3.591 4.16-3.591 2.322 0 4.204 1.882 4.204 4.204m-7.784 2.205c-.783-.348-1.65-.542-2.562-.542-2.834 0-5.23 1.868-6.027 4.44 3.015 1.695 5.219 4.663 5.882 8.175l.145.002c3.484 0 6.308-2.825 6.308-6.309 0-2.483-1.435-4.631-3.522-5.66q-.11-.055-.224-.106m-5 14.299c0 5.204-4.218 9.423-9.423 9.423-5.204 0-9.422-4.219-9.422-9.423s4.218-9.423 9.423-9.423c2.109 0 4.056.693 5.626 1.864 1.543 1.15 2.722 2.761 3.332 4.63.302.921.464 1.906.464 2.929"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#085d4b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#085d4b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#085d4b__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#085d4b__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#085d4b__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#085d4b__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#085d4b__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"T9ZLI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Apps);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAppsGeneric1160Svg = require("illustration:./S2_fill_apps_generic1_160.svg");
var _s2FillAppsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAppsGeneric1160Svg);
var _s2FillAppsGeneric196Svg = require("illustration:./S2_fill_apps_generic1_96.svg");
var _s2FillAppsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAppsGeneric196Svg);
var _s2FillAppsGeneric148Svg = require("illustration:./S2_fill_apps_generic1_48.svg");
var _s2FillAppsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAppsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Apps(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAppsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAppsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAppsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_apps_generic1_160.svg":"acdwt","illustration:./S2_fill_apps_generic1_96.svg":"ix5MR","illustration:./S2_fill_apps_generic1_48.svg":"ir0qO","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"acdwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "09f9ef__d",
                        x1: -18.921,
                        x2: 187.087,
                        y1: 132.357,
                        y2: -0.598,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "09f9ef__e",
                        x1: 151.995,
                        x2: 66.38,
                        y1: 44.747,
                        y2: 142.405,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "09f9ef__f",
                        x1: 40.959,
                        x2: 198.223,
                        y1: 150.143,
                        y2: 56.689,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "09f9ef__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "09f9ef__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "09f9ef__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 14,
                            y: 22,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "09f9ef__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M90.309 21.68h31.97c8.836 0 16 7.163 16 16v31.97c0 8.836-7.164 16-16 16h-31.97c-8.837 0-16-7.164-16-16V37.68c0-8.837 7.163-16 16-16m-54.59 19.46h16.52c7.732 0 14 6.268 14 14v16.52c0 7.732-6.268 14-14 14h-16.52c-7.732 0-14-6.268-14-14V55.14c0-7.732 6.268-14 14-14m16.52 52.66h-16.52c-7.732 0-14 6.268-14 14v16.52c0 7.732 6.268 14 14 14h16.52c7.732 0 14-6.268 14-14V107.8c0-7.732-6.268-14-14-14m36.07 0h16.52c7.732 0 14 6.268 14 14v16.52c0 7.732-6.268 14-14 14h-16.52c-7.732 0-14-6.268-14-14V107.8c0-7.732 6.268-14 14-14"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#09f9ef__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#09f9ef__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 14,
                            y: 22,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M14 22h131v123.491H14z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#09f9ef__c)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 31 -26.86)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#09f9ef__d)",
                            d: "M64.001.186C53.941-5.682 41.194-5.718 31.096.094l-101 58.131c-9.891 5.694-9.907 19.133-.03 24.847L30.4 141.122c10.082 5.833 22.83 5.826 32.904-.021l100.125-58.104c9.826-5.703 9.844-19.066.03-24.79z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#09f9ef__e)",
                            d: "M32.878 80.631C35.118 34.528 76.58-1.134 125.485.976c48.907 2.111 86.738 41.196 84.499 87.299-2.239 46.102-43.701 81.765-92.607 79.654-48.906-2.11-86.738-41.195-84.499-87.298"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#09f9ef__f)",
                            d: "M-39.075 111.029c19.44-7.818 40.406-7.483 58.57-.645 36.349 13.717 57.498 5.236 72.167-28.95 7.307-17.153 21.572-31.681 41.035-39.508 38.911-15.625 83.833 1.329 100.384 37.902s-1.565 78.852-40.467 94.497c-19.506 7.844-40.512 7.477-58.705.577-36.288-13.644-57.398-5.131-72.048 29.096-7.325 17.113-21.588 31.591-41.028 39.409-38.88 15.636-83.803-1.317-100.344-37.869-16.542-36.553 1.555-78.874 40.436-94.509"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#09f9ef__g)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 80.293 -9.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ix5MR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a9fb23__d",
                        x1: -11.355,
                        x2: 112.249,
                        y1: 79.415,
                        y2: -0.358,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a9fb23__e",
                        x1: 91.194,
                        x2: 39.825,
                        y1: 26.849,
                        y2: 85.444,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a9fb23__f",
                        x1: 24.574,
                        x2: 118.933,
                        y1: 90.087,
                        y2: 34.014,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a9fb23__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a9fb23__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a9fb23__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 8.398,
                            y: 13.2,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "a9fb23__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M54.185 13.008h19.182c5.302 0 9.6 4.298 9.6 9.6V41.79c0 5.302-4.298 9.6-9.6 9.6H54.185c-5.302 0-9.6-4.298-9.6-9.6V22.608c0-5.302 4.298-9.6 9.6-9.6M21.431 24.684h9.912c4.64 0 8.4 3.76 8.4 8.4v9.912c0 4.639-3.76 8.4-8.4 8.4h-9.912c-4.639 0-8.4-3.761-8.4-8.4v-9.912c0-4.64 3.761-8.4 8.4-8.4m9.912 31.596h-9.912c-4.639 0-8.4 3.76-8.4 8.4v9.912c0 4.639 3.761 8.4 8.4 8.4h9.912c4.64 0 8.4-3.761 8.4-8.4V64.68c0-4.64-3.76-8.4-8.4-8.4m21.642 0h9.912c4.64 0 8.4 3.76 8.4 8.4v9.912c0 4.639-3.76 8.4-8.4 8.4h-9.912c-4.639 0-8.4-3.761-8.4-8.4V64.68c0-4.64 3.761-8.4 8.4-8.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a9fb23__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#a9fb23__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 8.398,
                            y: 13.2,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M8.398 13.2h78.6v74.094h-78.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#a9fb23__c)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 18.598 -16.116)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a9fb23__d)",
                            d: "M38.398.112C32.36-3.409 24.713-3.43 18.654.056l-60.6 34.88c-5.934 3.416-5.944 11.479-.017 14.908l60.199 34.83c6.05 3.499 13.698 3.495 19.742-.013l60.076-34.863c5.895-3.421 5.906-11.44.018-14.874z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a9fb23__e)",
                            d: "M19.724 48.379C21.067 20.717 45.944-.681 75.288.586c29.344 1.266 52.043 24.717 50.699 52.379-1.343 27.662-26.22 49.059-55.564 47.793-29.344-1.267-52.043-24.717-50.7-52.38"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a9fb23__f)",
                            d: "M-23.446 66.618c11.664-4.691 24.244-4.49 35.143-.387 21.808 8.23 34.498 3.142 43.3-17.37C59.38 38.57 67.94 29.852 79.617 25.156c23.347-9.374 50.3.797 60.231 22.741s-.939 47.312-24.28 56.699c-11.704 4.706-24.308 4.486-35.223.346-21.773-8.187-34.439-3.079-43.23 17.457-4.394 10.268-12.952 18.955-24.616 23.646-23.328 9.382-50.282-.79-60.207-22.722-9.925-21.931.934-47.324 24.262-56.705"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#a9fb23__g)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 48.176 -5.604)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ir0qO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5a1465__d",
                        x1: -5.676,
                        x2: 56.126,
                        y1: 39.707,
                        y2: -0.18,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5a1465__e",
                        x1: 45.597,
                        x2: 19.913,
                        y1: 13.423,
                        y2: 42.721,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5a1465__f",
                        x1: 12.287,
                        x2: 59.466,
                        y1: 45.043,
                        y2: 17.006,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5a1465__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5a1465__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5a1465__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 4.199,
                            y: 6.6,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5a1465__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M27.093 6.504h9.59c2.651 0 4.8 2.149 4.8 4.8v9.59c0 2.652-2.148 4.8-4.8 4.8h-9.59c-2.651 0-4.8-2.148-4.8-4.8v-9.59c0-2.651 2.149-4.8 4.8-4.8m-16.377 5.838h4.956c2.32 0 4.2 1.88 4.2 4.2v4.956c0 2.32-1.88 4.2-4.2 4.2h-4.956c-2.32 0-4.2-1.88-4.2-4.2v-4.956c0-2.32 1.88-4.2 4.2-4.2m4.956 15.798h-4.956c-2.32 0-4.2 1.88-4.2 4.2v4.956c0 2.32 1.88 4.2 4.2 4.2h4.956c2.32 0 4.2-1.88 4.2-4.2V32.34c0-2.32-1.88-4.2-4.2-4.2m10.82 0h4.957c2.32 0 4.2 1.88 4.2 4.2v4.956c0 2.32-1.88 4.2-4.2 4.2h-4.956c-2.32 0-4.2-1.88-4.2-4.2V32.34c0-2.32 1.88-4.2 4.2-4.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5a1465__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5a1465__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 4.199,
                            y: 6.6,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.2 6.6h39.3v37.047H4.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#5a1465__c)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 9.3 -8.059)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5a1465__d)",
                            d: "M19.2.056C16.184-1.705 12.36-1.716 9.33.028l-30.3 17.44c-2.968 1.707-2.973 5.739-.01 7.453l30.1 17.415c3.025 1.75 6.849 1.748 9.871-.006L49.03 24.899c2.947-1.711 2.953-5.72.009-7.437z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5a1465__e)",
                            d: "M9.862 24.188c.672-13.83 13.11-24.53 27.782-23.896 14.672.633 26.021 12.359 25.35 26.19-.672 13.83-13.11 24.53-27.782 23.896-14.672-.633-26.022-12.359-25.35-26.19"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5a1465__f)",
                            d: "M-11.723 33.308c5.832-2.345 12.122-2.244 17.571-.193 10.905 4.115 17.25 1.57 21.65-8.685 2.192-5.146 6.472-9.504 12.31-11.852 11.674-4.688 25.15.398 30.116 11.37 4.965 10.972-.47 23.656-12.14 28.35-5.852 2.353-12.154 2.242-17.612.172-10.886-4.093-17.219-1.539-21.614 8.73-2.198 5.133-6.476 9.477-12.309 11.822-11.664 4.69-25.14-.395-30.103-11.36-4.962-10.966.467-23.663 12.131-28.354"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#5a1465__g)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 24.086 -2.803)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"yT7oo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Artboard);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillArtboardGeneric1160Svg = require("illustration:./S2_fill_artboard_generic1_160.svg");
var _s2FillArtboardGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillArtboardGeneric1160Svg);
var _s2FillArtboardGeneric196Svg = require("illustration:./S2_fill_artboard_generic1_96.svg");
var _s2FillArtboardGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillArtboardGeneric196Svg);
var _s2FillArtboardGeneric148Svg = require("illustration:./S2_fill_artboard_generic1_48.svg");
var _s2FillArtboardGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillArtboardGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Artboard(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillArtboardGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillArtboardGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillArtboardGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_artboard_generic1_160.svg":"ewmsv","illustration:./S2_fill_artboard_generic1_96.svg":"jhZxz","illustration:./S2_fill_artboard_generic1_48.svg":"zGV5k","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ewmsv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "56d8eb__d",
                        x1: -32.085,
                        x2: 187.45,
                        y1: 127.603,
                        y2: -14.082,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "56d8eb__e",
                        x1: 150.059,
                        x2: 58.822,
                        y1: 34.24,
                        y2: 138.311,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "56d8eb__f",
                        x1: 31.728,
                        x2: 199.32,
                        y1: 146.558,
                        y2: 46.967,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "56d8eb__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 57.2532 -60.7348 0 60.735 57.253)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "56d8eb__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 57.2532 -60.7348 0 60.735 57.253)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "56d8eb__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.603,
                            height: 131.6,
                            x: 3,
                            y: 10,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "56d8eb__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M40 24V14c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 2.21 1.79 4 4 4s4-1.79 4-4m39 46.02c0 5.5 4.5 9.98 10.03 9.98h34.98v48c0 6.63-5.34 12-11.93 12H47.93C41.34 140 36 134.63 36 128V48c0-6.63 5.34-12 11.93-12H79zM121.3 72H89.04c-1.12 0-2.03-.89-2.03-1.98V38.89q.075.066.155.132c.116.098.235.198.345.308l32.81 31.59c.35.34.67.7.98 1.08M14 32h10c2.21 0 4 1.79 4 4s-1.79 4-4 4H14c-2.21 0-4-1.79-4-4s1.79-4 4-4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#56d8eb__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#56d8eb__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.603,
                            height: 131.6,
                            x: 3,
                            y: 10,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3 10h139.603v131.6H3z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.735,
                            cy: 57.253,
                            fill: "url(#56d8eb__c)",
                            rx: 60.735,
                            ry: 57.253,
                            transform: "matrix(1 -.00132 .00148 1 21.117 -42.068)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#56d8eb__d)",
                            d: "M56.282-13.246c-10.721-6.254-24.305-6.293-35.066-.1l-107.632 61.95c-10.54 6.067-10.558 20.388-.032 26.478l106.92 61.861c10.746 6.216 24.33 6.209 35.066-.022l106.7-61.919c10.471-6.077 10.49-20.318.032-26.418z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#56d8eb__e)",
                            d: "M23.12 72.48c2.386-49.13 46.57-87.134 98.688-84.885 52.118 2.25 92.434 43.9 90.048 93.031-2.387 49.13-46.571 87.135-98.688 84.885s-92.434-43.9-90.048-93.03"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#56d8eb__f)",
                            d: "M-53.56 104.875c20.716-8.331 43.06-7.974 62.416-.687 38.735 14.618 61.273 5.58 76.906-30.85 7.786-18.28 22.988-33.763 43.729-42.103 41.466-16.65 89.338 1.416 106.976 40.39s-1.667 84.031-43.124 100.703c-20.787 8.359-43.173 7.968-62.56.615-38.672-14.54-61.167-5.468-76.78 31.006-7.806 18.237-23.005 33.666-43.722 41.998-41.433 16.662-89.305-1.404-106.933-40.357-17.628-38.952 1.657-84.052 43.091-100.715"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.735,
                            cy: 57.253,
                            fill: "url(#56d8eb__g)",
                            rx: 60.735,
                            ry: 57.253,
                            transform: "matrix(1 -.00132 .00148 1 73.644 -23.398)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jhZxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea8a3b__d",
                        x1: -19.253,
                        x2: 112.468,
                        y1: 76.562,
                        y2: -8.449,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea8a3b__e",
                        x1: 90.03,
                        x2: 35.288,
                        y1: 20.545,
                        y2: 82.987,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea8a3b__f",
                        x1: 19.033,
                        x2: 119.588,
                        y1: 87.935,
                        y2: 28.18,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ea8a3b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.3519 -36.4409 0 36.44 34.352)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ea8a3b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.3519 -36.4409 0 36.44 34.352)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ea8a3b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.762,
                            height: 78.96,
                            x: 1.797,
                            y: 6,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ea8a3b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M24 14.4v-6C24 7.074 22.926 6 21.6 6s-2.4 1.074-2.4 2.4v6c0 1.326 1.074 2.4 2.4 2.4s2.4-1.074 2.4-2.4m23.4 27.612c0 3.3 2.7 5.988 6.018 5.988h20.988v28.8c0 3.978-3.204 7.2-7.158 7.2h-38.49c-3.954 0-7.158-3.222-7.158-7.2v-48c0-3.978 3.204-7.2 7.158-7.2H47.4zM72.78 43.2H53.424c-.672 0-1.218-.534-1.218-1.188V23.334l.093.08q.106.086.207.184l19.686 18.954c.21.204.402.42.588.648M8.4 19.2h6c1.326 0 2.4 1.074 2.4 2.4S15.726 24 14.4 24h-6C7.074 24 6 22.926 6 21.6s1.074-2.4 2.4-2.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ea8a3b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ea8a3b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.762,
                            height: 78.96,
                            x: 1.797,
                            y: 6,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M1.797 6h83.762v78.96H1.797z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.441,
                            cy: 34.352,
                            fill: "url(#ea8a3b__c)",
                            rx: 36.441,
                            ry: 34.352,
                            transform: "matrix(1 -.00132 .00148 1 12.668 -25.241)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea8a3b__d)",
                            d: "M33.767-7.948c-6.433-3.752-14.583-3.775-21.04-.06l-64.579 37.17c-6.324 3.64-6.335 12.233-.019 15.887l64.152 37.117c6.447 3.73 14.598 3.725 21.04-.013L97.34 45c6.282-3.646 6.293-12.19.018-15.85z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea8a3b__e)",
                            d: "M13.867 43.489c1.431-29.478 27.942-52.28 59.212-50.931s55.46 26.34 54.029 55.818c-1.432 29.478-27.942 52.281-59.213 50.931-31.27-1.35-55.46-26.34-54.028-55.818"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea8a3b__f)",
                            d: "M-32.14 62.925c12.43-4.999 25.836-4.785 37.45-.412 23.24 8.77 36.764 3.348 46.143-18.51C56.125 33.034 65.246 23.745 77.69 18.74c24.881-9.99 53.604.85 64.186 24.234s-1 50.418-25.874 60.422c-12.472 5.015-25.904 4.78-37.536.369-23.203-8.725-36.7-3.281-46.068 18.603-4.684 10.943-13.803 20.2-26.233 25.199-24.86 9.997-53.583-.843-64.16-24.214s.994-50.432 25.855-60.43"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.441,
                            cy: 34.352,
                            fill: "url(#ea8a3b__g)",
                            rx: 36.441,
                            ry: 34.352,
                            transform: "matrix(1 -.00132 .00148 1 44.184 -14.04)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"zGV5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea280d__d",
                        x1: -9.627,
                        x2: 56.234,
                        y1: 38.282,
                        y2: -4.224,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea280d__e",
                        x1: 45.015,
                        x2: 17.644,
                        y1: 10.272,
                        y2: 41.493,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ea280d__f",
                        x1: 9.519,
                        x2: 59.796,
                        y1: 43.968,
                        y2: 14.091,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ea280d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.176 -18.2204 0 18.22 17.176)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ea280d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.176 -18.2204 0 18.22 17.176)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ea280d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.881,
                            height: 39.48,
                            x: 0.898,
                            y: 3,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ea280d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M12 7.2v-3c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v3c0 .663.537 1.2 1.2 1.2S12 7.863 12 7.2m11.7 13.806c0 1.65 1.35 2.994 3.009 2.994h10.494v14.4c0 1.989-1.602 3.6-3.579 3.6H14.379c-1.977 0-3.579-1.611-3.579-3.6v-24c0-1.989 1.602-3.6 3.579-3.6H23.7zm12.69.594h-9.678c-.336 0-.61-.267-.61-.594v-9.339l.047.04q.053.043.104.092l9.843 9.477c.105.102.2.21.294.324M4.2 9.6h3c.663 0 1.2.537 1.2 1.2S7.863 12 7.2 12h-3c-.663 0-1.2-.537-1.2-1.2s.537-1.2 1.2-1.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ea280d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ea280d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.881,
                            height: 39.48,
                            x: 0.898,
                            y: 3,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M.898 3H42.78v39.48H.9z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.22,
                            cy: 17.176,
                            fill: "url(#ea280d__c)",
                            rx: 18.22,
                            ry: 17.176,
                            transform: "matrix(1 -.00132 .00148 1 6.332 -12.621)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea280d__d)",
                            d: "M16.884-3.973c-3.217-1.877-7.292-1.888-10.52-.03l-32.29 18.585c-3.162 1.82-3.168 6.116-.01 7.943L6.142 41.084c3.223 1.864 7.298 1.862 10.52-.007L48.67 22.5c3.14-1.823 3.146-6.095.009-7.925z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea280d__e)",
                            d: "M6.933 21.744C7.65 7.004 20.904-4.396 36.54-3.722c15.635.675 27.73 13.17 27.014 27.91s-13.971 26.14-29.607 25.465-27.73-13.17-27.014-27.909"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ea280d__f)",
                            d: "M-16.068 31.463c6.215-2.5 12.918-2.392 18.725-.206 11.62 4.385 18.382 1.674 23.072-9.255 2.335-5.484 6.896-10.129 13.118-12.631 12.44-4.995 26.802.425 32.093 12.117s-.5 25.21-12.937 30.21c-6.236 2.509-12.952 2.391-18.768.185-11.602-4.362-18.35-1.64-23.034 9.302-2.342 5.471-6.902 10.1-13.117 12.6-12.43 4.998-26.791-.422-32.08-12.107-5.288-11.686.498-25.216 12.928-30.215"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.22,
                            cy: 17.176,
                            fill: "url(#ea280d__g)",
                            rx: 18.22,
                            ry: 17.176,
                            transform: "matrix(1 -.00132 .00148 1 22.094 -7.02)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8mBp6":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assets);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAssetsGeneric1160Svg = require("illustration:./S2_fill_assets_generic1_160.svg");
var _s2FillAssetsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAssetsGeneric1160Svg);
var _s2FillAssetsGeneric196Svg = require("illustration:./S2_fill_assets_generic1_96.svg");
var _s2FillAssetsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAssetsGeneric196Svg);
var _s2FillAssetsGeneric148Svg = require("illustration:./S2_fill_assets_generic1_48.svg");
var _s2FillAssetsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAssetsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Assets(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAssetsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAssetsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAssetsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_assets_generic1_160.svg":"8TNcs","illustration:./S2_fill_assets_generic1_96.svg":"co9Bp","illustration:./S2_fill_assets_generic1_48.svg":"6W8c5","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8TNcs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5d12de__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5d12de__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5d12de__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5d12de__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5d12de__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5d12de__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5d12de__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M28.25 41.384c0-5.523 4.477-10 10-10h66.54c5.523 0 10 4.477 10 10v19.744H82.262c-5.367 0-10.186 2.35-13.484 6.076l-4.553-7.499-.011-.018c-3.581-5.828-12.02-5.921-15.728-.173l-.008.013-19.754 30.876c-.308-.962-.474-1.987-.474-3.051zm36.012 37.744v18.224H38.25c-1.404 0-2.741-.29-3.954-.813l20.913-32.688.002-.004c.517-.794 1.683-.782 2.183.022l.004.006 7.188 11.838c-.213 1.106-.324 2.247-.324 3.415m29.906-21.97c3.314 0 6-2.687 6-6 0-3.315-2.686-6-6-6s-6 2.685-6 6c0 3.313 2.686 6 6 6m-21.906 21.97c0-5.523 4.477-10 10-10h39.488c5.523 0 10 4.477 10 10v39.488c0 5.523-4.477 10-10 10H82.262c-5.523 0-10-4.477-10-10zm42.583 17.766-19.507-11.19c-2.185-1.252-4.92.308-4.923 2.809l-.027 22.331c-.003 2.501 2.728 4.067 4.916 2.819l19.534-11.142c2.187-1.248 2.191-4.374.007-5.627"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5d12de__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5d12de__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#5d12de__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5d12de__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5d12de__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5d12de__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#5d12de__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"co9Bp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "383fc0__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.788,
                        y2: -9.168,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "383fc0__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.682,
                        y2: 89.679,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "383fc0__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.616,
                        y2: 33.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "383fc0__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.28 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "383fc0__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.532 53.874)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "383fc0__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: -0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "383fc0__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M18.25 26.05c0-3.313 2.686-6 6-6H62c3.314 0 6 2.687 6 6v11.7H49.552c-3.144 0-5.948 1.45-7.782 3.718l-3.1-4.99-.003-.006c-1.945-3.158-6.52-3.206-8.532-.089l-.001.003-11.459 17.811c-.274-.687-.425-1.437-.425-2.222zm17.017 12.53 4.477 7.207q-.19.954-.192 1.963v10.225H24.25c-1.012 0-1.966-.251-2.803-.694l12.05-18.73c.417-.644 1.363-.634 1.765.02zm23.878-7.162c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3M43.552 47.75c0-3.314 2.686-6 6-6H71.75c3.314 0 6 2.686 6 6v22.198c0 3.314-2.686 6-6 6H49.552c-3.314 0-6-2.686-6-6zm24.48 9.96-11.215-6.432c-1.256-.72-2.828.176-2.83 1.614l-.015 12.838c-.002 1.437 1.568 2.338 2.826 1.62l11.23-6.405c1.257-.718 1.26-2.515.003-3.235"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#383fc0__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#383fc0__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: -0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0-.001h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.722,
                            r: 41.765,
                            fill: "url(#383fc0__c)",
                            transform: "rotate(-.08 54.28 3.722)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#383fc0__d)",
                            d: "M36.643-16.96c-7.373-4.561-16.714-4.59-24.114-.071l-74.015 45.19c-7.249 4.427-7.26 14.874-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#383fc0__e)",
                            d: "M13.837 45.578C15.477 9.738 45.86-17.985 81.7-16.345s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#383fc0__f)",
                            d: "M-38.895 69.208c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.343,
                            r: 41.765,
                            fill: "url(#383fc0__g)",
                            transform: "rotate(-.08 90.406 17.343)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6W8c5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b93fd3__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b93fd3__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b93fd3__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b93fd3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b93fd3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b93fd3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b93fd3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M9.125 14.027c0-2.209 1.79-4 4-4H30c2.21 0 4 1.791 4 4v4.348h-8.224c-1.892 0-3.594.808-4.782 2.097l-1.445-2.36-.001-.002c-1.068-1.738-3.584-1.766-4.69-.052l-5.44 8.434c-.19-.464-.293-.972-.293-1.504zm10.15 10.848v4.113h-6.15c-.728 0-1.41-.194-1.998-.534l5.831-9.04c.109-.168.355-.166.46.004l2.152 3.518c-.191.612-.294 1.264-.294 1.939m8.798-7.664c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5c-.829 0-1.5.672-1.5 1.5s.671 1.5 1.5 1.5m-6.297 7.664c0-2.21 1.79-4 4-4h9.099c2.21 0 4 1.79 4 4v9.1c0 2.208-1.79 4-4 4h-9.1c-2.208 0-4-1.792-4-4zm12.24 3.982-5.607-3.216c-.628-.36-1.414.088-1.415.807l-.008 6.419c0 .719.784 1.169 1.413.81l5.615-3.203c.629-.358.63-1.257.002-1.617"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b93fd3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b93fd3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#b93fd3__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b93fd3__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b93fd3__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b93fd3__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#b93fd3__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hPr4e":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AudioWave);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillAudioWaveGeneric1160Svg = require("illustration:./S2_fill_audioWave_generic1_160.svg");
var _s2FillAudioWaveGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillAudioWaveGeneric1160Svg);
var _s2FillAudioWaveGeneric196Svg = require("illustration:./S2_fill_audioWave_generic1_96.svg");
var _s2FillAudioWaveGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillAudioWaveGeneric196Svg);
var _s2FillAudioWaveGeneric148Svg = require("illustration:./S2_fill_audioWave_generic1_48.svg");
var _s2FillAudioWaveGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillAudioWaveGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function AudioWave(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAudioWaveGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAudioWaveGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillAudioWaveGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_audioWave_generic1_160.svg":"iGuGf","illustration:./S2_fill_audioWave_generic1_96.svg":"3hW43","illustration:./S2_fill_audioWave_generic1_48.svg":"aVKjy","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iGuGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4ed7ec__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4ed7ec__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4ed7ec__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4ed7ec__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4ed7ec__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "4ed7ec__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "4ed7ec__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M84 22.568c0-2.209-1.79-4-4-4s-4 1.791-4 4v114.863c0 2.209 1.791 4 4 4s4-1.791 4-4zM28.25 67.33c2.21 0 4 1.79 4 4v17.341c0 2.21-1.79 4-4 4s-4-1.79-4-4v-17.34c0-2.21 1.79-4 4-4m103.5 0c2.209 0 4 1.79 4 4v17.341c0 2.21-1.791 4-4 4s-4-1.79-4-4v-17.34c0-2.21 1.791-4 4-4m-69-20.898c2.21 0 4 1.79 4 4v59.137c0 2.209-1.79 4-4 4s-4-1.791-4-4V50.432c0-2.21 1.79-4 4-4m38.5 4c0-2.21-1.79-4-4-4s-4 1.79-4 4v59.137c0 2.209 1.79 4 4 4s4-1.791 4-4zM45.5 32.512c2.209 0 4 1.79 4 4v86.976c0 2.209-1.791 4-4 4s-4-1.791-4-4V36.512c0-2.21 1.79-4 4-4m73 4c0-2.21-1.791-4-4-4s-4 1.79-4 4v86.976c0 2.209 1.79 4 4 4s4-1.791 4-4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#4ed7ec__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#4ed7ec__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#4ed7ec__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4ed7ec__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4ed7ec__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4ed7ec__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#4ed7ec__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3hW43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b2b0f9__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b2b0f9__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b2b0f9__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b2b0f9__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b2b0f9__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b2b0f9__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b2b0f9__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M50 14.984c0-1.104-.896-2-2-2s-2 .896-2 2v66.032c0 1.104.895 2 2 2s2-.896 2-2zM18.25 41.016c1.105 0 2 .895 2 2v9.968c0 1.105-.895 2-2 2s-2-.895-2-2v-9.968c0-1.105.895-2 2-2m59.5 0c1.104 0 2 .895 2 2v9.968c0 1.105-.896 2-2 2s-2-.895-2-2v-9.968c0-1.105.895-2 2-2M38.082 29.002c1.105 0 2 .895 2 2v33.996c0 1.105-.895 2-2 2s-2-.895-2-2V31.002c0-1.105.896-2 2-2m21.833 2c0-1.105-.895-2-2-2s-2 .895-2 2v33.996c0 1.105.896 2 2 2s2-.895 2-2zM28.166 21c1.105 0 2 .895 2 2v50c0 1.105-.895 2-2 2s-2-.895-2-2V23c0-1.105.896-2 2-2m41.667 2c0-1.105-.896-2-2-2s-2 .895-2 2v50c0 1.105.895 2 2 2s2-.895 2-2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b2b0f9__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b2b0f9__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#b2b0f9__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b2b0f9__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b2b0f9__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b2b0f9__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#b2b0f9__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aVKjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e9308c__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e9308c__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e9308c__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e9308c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e9308c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "e9308c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "e9308c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M25.25 7.492c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v33.016c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25zM9.125 20.258c.69 0 1.25.56 1.25 1.25v4.984c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-4.984c0-.69.56-1.25 1.25-1.25m29.75 0c.69 0 1.25.56 1.25 1.25v4.984c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-4.984c0-.69.56-1.25 1.25-1.25M19.042 14.25c.69 0 1.25.56 1.25 1.25v16.998c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25V15.501c0-.69.56-1.25 1.25-1.25m11.166 1.25c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v16.998c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25zM14.083 10.25c.69 0 1.25.56 1.25 1.25v25c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-25c0-.69.56-1.25 1.25-1.25m21.083 1.25c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v25c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#e9308c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#e9308c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#e9308c__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e9308c__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e9308c__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e9308c__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#e9308c__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csZiV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BadgeVerified);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBadgeVerifiedGeneric1160Svg = require("illustration:./S2_fill_badgeVerified_generic1_160.svg");
var _s2FillBadgeVerifiedGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBadgeVerifiedGeneric1160Svg);
var _s2FillBadgeVerifiedGeneric196Svg = require("illustration:./S2_fill_badgeVerified_generic1_96.svg");
var _s2FillBadgeVerifiedGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBadgeVerifiedGeneric196Svg);
var _s2FillBadgeVerifiedGeneric148Svg = require("illustration:./S2_fill_badgeVerified_generic1_48.svg");
var _s2FillBadgeVerifiedGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBadgeVerifiedGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function BadgeVerified(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBadgeVerifiedGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBadgeVerifiedGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBadgeVerifiedGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_badgeVerified_generic1_160.svg":"hRaRb","illustration:./S2_fill_badgeVerified_generic1_96.svg":"5JkBC","illustration:./S2_fill_badgeVerified_generic1_48.svg":"2MA8h","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hRaRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3de3d7__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3de3d7__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3de3d7__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3de3d7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3de3d7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3de3d7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3de3d7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M126.891 64.173c5.511 3.126 9.247 9.044 9.247 15.834h.015c0 6.82-3.766 12.752-9.32 15.878-2.181 1.221-3.199 3.707-2.53 6.121.742 2.632.902 5.511.305 8.491-1.41 7.11-7.095 12.81-14.205 14.22-2.995.596-5.903.436-8.549-.32-2.37-.669-4.842.335-6.078 2.472C92.621 132.321 86.746 136 80 136s-12.62-3.679-15.775-9.131c-1.236-2.137-3.693-3.141-6.078-2.472-2.646.756-5.554.916-8.55.32-7.11-1.41-12.794-7.11-14.205-14.22-.596-2.98-.436-5.859.306-8.491.668-2.414-.35-4.9-2.53-6.121-5.555-3.126-9.32-9.088-9.32-15.878S27.57 67.3 33.095 64.173c2.108-1.192 3.082-3.678 2.5-5.96-.58-2.284-.74-4.726-.377-7.256 1.148-7.866 7.502-14.191 15.368-15.325 2.574-.378 4.944-.233 7.358.422 2.413.654 4.885-.393 6.092-2.574C67.133 27.839 73.123 24 80 24s12.868 3.839 15.965 9.48c1.207 2.18 3.795 3.184 6.092 2.574s4.769-.8 7.343-.422c7.88 1.134 14.22 7.459 15.368 15.325.364 2.53.233 4.914-.378 7.255-.61 2.341.393 4.77 2.501 5.961m-19.88 3.905c1.631-1.49 1.745-4.02.255-5.651s-4.02-1.745-5.651-.255L71.712 89.497 58.349 77.071c-1.617-1.505-4.148-1.413-5.653.205s-1.412 4.149.206 5.653l16.062 14.938c1.526 1.418 3.884 1.429 5.422.023z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3de3d7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3de3d7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#3de3d7__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3de3d7__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3de3d7__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3de3d7__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#3de3d7__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5JkBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "03bd4f__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.166,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "03bd4f__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.684,
                        y2: 89.681,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "03bd4f__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.618,
                        y2: 33.126,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "03bd4f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.278 29.003)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "03bd4f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.53 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "03bd4f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "03bd4f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M75.766 38.628c3.263 1.851 5.475 5.355 5.475 9.376h.009c0 4.038-2.23 7.55-5.519 9.401-1.291.724-1.894 2.196-1.498 3.625.44 1.558.534 3.263.181 5.028-.835 4.21-4.201 7.585-8.412 8.42-1.773.353-3.495.258-5.062-.19-1.403-.395-2.867.199-3.599 1.464-1.868 3.229-5.346 5.407-9.341 5.407s-7.473-2.178-9.341-5.407c-.732-1.265-2.187-1.86-3.6-1.463-1.566.447-3.288.542-5.061.189-4.21-.835-7.577-4.21-8.412-8.42-.353-1.765-.258-3.47.18-5.028.397-1.43-.206-2.901-1.497-3.625-3.29-1.85-5.519-5.38-5.519-9.401 0-4.02 2.204-7.525 5.476-9.376 1.248-.706 1.825-2.178 1.48-3.53-.344-1.352-.439-2.798-.223-4.296.68-4.658 4.442-8.403 9.1-9.074 1.524-.224 2.927-.138 4.356.25 1.43.387 2.893-.233 3.608-1.525 1.834-3.34 5.38-5.613 9.453-5.613s7.62 2.273 9.453 5.613c.715 1.292 2.247 1.886 3.608 1.524 1.36-.361 2.824-.473 4.348-.25 4.666.672 8.42 4.417 9.1 9.075.215 1.498.138 2.91-.224 4.296s.232 2.824 1.48 3.53m-11.981 2.01c.816-.744.875-2.009.13-2.825-.743-.816-2.008-.875-2.825-.131l-3.177 2.896-3.112 2.836-.053.049-.054.048-.053.05-.054.048-.214.196-.434.395-.11.1-.11.1-.109.1-.055.05-.055.05-.055.05-.056.05-.055.051-.055.05-.222.203-.223.203-.111.102-.112.101-.112.102-.056.051-.056.052-.112.102-.113.102-.45.41-.056.052-.056.05-.056.052-.057.051-.225.206-1.79 1.632-.878.8-.054.048-.054.05-.108.098-.107.098-.107.098-.107.097-.053.048-.053.049-.053.048-.053.048-.053.048-.053.048-.052.048-.052.048-.053.048-.052.047-.104.095-.104.094-.051.048-.052.047-.102.093-.102.093-.102.092-.201.184-.1.09-.099.091-.05.045-.049.045-.049.045-.049.044-.048.045-.049.044-.048.044-.048.044-.38.346-.369.336-.045.041-.045.041-.045.04-.044.042-.177.16-.087.08-.043.039-.043.04-.17.154-1.618 1.475-8.13-7.581c-.808-.754-2.074-.71-2.827.098s-.71 2.074.099 2.827l9.478 8.84c.762.71 1.941.717 2.711.015l-1.347-1.478 1.347 1.478h.001l.003-.003.002-.002.002-.002.006-.006.017-.015.005-.005.006-.005.013-.012m19.342-17.629-3.177 2.896Zm-3.177 2.896-.043.04Zm-.043.04-.044.039Zm-.044.039-.043.04Zm-.043.04-.044.04Zm-.044.04-.044.04Zm-.044.04-.044.04Zm-.044.04-.089.08Zm-.089.08-.363.332Zm-.363.332-.047.042Zm-.047.042-.046.042Zm-.046.042-.093.085Zm-.093.085-.095.086Zm-.095.086-.047.043Zm-.047.043-.047.044Zm-.047.044-.048.043Zm-.048.043-.048.044Zm-.048.044-.048.044Zm-.048.044-.048.044Zm-.048.044-.048.044Zm-.048.044-.05.044Zm-.05.044-.097.089Zm-.097.089-.396.36Zm-.396.36-.05.047Zm-.05.047-.05.045Zm-.05.045-.05.046Zm-.05.046-.051.047Zm-.051.047-.102.092Zm-.102.092-.051.047Zm-.051.047-.051.046Zm-.051.046-.206.188Zm-.206.188-.208.19Zm-.208.19-.105.095Zm-.105.095-.053.048Zm-.053.048-.052.048Zm-.052.048-.212.193Zm-.212.193-.862.785Zm-.862.785-.439.4Zm-.439.4-.055.05Zm-.055.05-.055.051Zm-.055.051-.055.05Zm-.055.05-.056.05Zm-.056.05-.11.102Zm-.11.102-.112.101Zm-.112.101-.222.203Zm-.222.203-.224.204Zm-.224.204-.224.204Zm-.224.204-.112.102Zm-.112.102-.056.051Zm-.056.051-.056.052Zm-.056.052-.056.05Zm-.056.05-.056.052Zm-.056.052-.057.051Zm-.057.051-.056.051Zm-.056.051-.056.052Zm-.056.052-.056.05Zm-.056.05-.113.103Zm-.113.103-.056.052Zm-.056.052-.057.051Zm-.057.051-.112.103Zm-.112.103-.226.205Zm-.226.205-1.79 1.633Zm-1.79 1.633-.056.05Zm-.056.05-.055.05Zm-.055.05-.055.05Zm-.055.05-.055.05Zm-.055.05-.055.05Zm-.055.05-.055.051Zm-.055.051-.11.1Zm-.11.1-.219.2Zm-.219.2-.054.049Zm-.054.049-.055.05Zm-.055.05-.108.099Zm-.108.099-.054.049Zm-.054.049-.054.05Zm-.054.05-.054.048Zm-.054.048-.054.05Zm-.054.05-.054.048Zm-.054.048-.054.05Zm-.054.05-.053.048Zm-.053.048-.054.049Zm-.054.049-.106.097Zm-.106.097-.107.097Zm-.107.097-.211.193Zm-.211.193-.417.38Zm-.417.38-.052.047Zm-.052.047-.051.047Zm-.051.047-.103.093Zm-.103.093-.05.047Zm-.05.047-.052.046Zm-.052.046-.05.047Zm-.05.047-.051.046Zm-.051.046-.201.183Zm-.201.183-.1.091Zm-.1.091-.05.045Zm-.05.045-.05.046Zm-.05.046-.196.179Zm-.196.179-.194.176Zm-.194.176-.38.346Zm-.38.346-.368.336Zm-.368.336-.18.164Zm-.18.164-.088.08Zm-.088.08-.044.04Zm-.044.04-.044.04Zm-.044.04-.087.08Zm-.087.08-.043.04Zm-.043.04-.043.038Zm-.043.038-.043.04Zm-.043.04-.042.038Zm-.042.038-.085.077Zm-.085.077-.083.076Zm-.083.076-.083.076Zm-.083.076-.041.037Zm-.041.037-.04.037Zm-.04.037-.041.037Zm-.041.037-.04.037Zm-.04.037-.04.036Zm-.04.036-.04.036Zm-.04.036-.04.037Zm-.04.037-.04.035Zm-.04.035-.154.142Zm-.154.142-.298.271Zm-.298.271-.143.13Zm-.143.13-.07.064Zm-.07.064-.034.031Zm-.034.031-.035.032Zm-.035.032-.067.061Zm-.067.061-.067.06Zm-.067.06-.032.03Zm-.032.03-.033.03Zm-.033.03-.064.059Zm-.064.059-.032.029Zm-.032.029-.031.028Zm-.031.028-.062.057Zm-.062.057-.12.11Zm-.12.11-.433.393Zm-.433.393-.348.318Zm-.348.318-.257.234Zm-.257.234-.05.045Zm-.05.045-.01.01Zm-.01.01-.011.01Zm-.011.01-.021.019Zm-.021.019-.037.033Zm-.037.033-.002.002Z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#03bd4f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#03bd4f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.724,
                            r: 41.765,
                            fill: "url(#03bd4f__c)",
                            transform: "rotate(-.08 54.28 3.724)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#03bd4f__d)",
                            d: "M36.643-16.957c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.426-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#03bd4f__e)",
                            d: "M13.837 45.58C15.477 9.74 45.86-17.983 81.7-16.343s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922S12.196 81.419 13.837 45.58"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#03bd4f__f)",
                            d: "M-38.895 69.21c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.315 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.345,
                            r: 41.765,
                            fill: "url(#03bd4f__g)",
                            transform: "rotate(-.08 90.406 17.345)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2MA8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eec53c__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eec53c__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eec53c__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eec53c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eec53c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "eec53c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "eec53c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M37.883 19.314c1.631.925 2.738 2.678 2.738 4.688h.004c0 2.019-1.115 3.775-2.76 4.7-.645.362-.946 1.098-.748 1.813.22.78.267 1.632.09 2.514-.418 2.105-2.1 3.792-4.206 4.21-.886.177-1.747.13-2.53-.095-.703-.198-1.434.1-1.8.732-.934 1.614-2.674 2.704-4.671 2.704s-3.736-1.09-4.67-2.704c-.367-.633-1.094-.93-1.8-.732-.784.224-1.645.272-2.531.095-2.105-.417-3.789-2.105-4.206-4.21-.176-.883-.13-1.735.09-2.514.198-.715-.103-1.45-.749-1.812-1.644-.926-2.759-2.69-2.759-4.701s1.102-3.762 2.738-4.688c.624-.353.912-1.09.74-1.765-.172-.676-.22-1.399-.112-2.148.34-2.329 2.222-4.201 4.55-4.537.762-.112 1.464-.07 2.179.125.714.193 1.446-.117 1.803-.762.917-1.67 2.69-2.807 4.727-2.807 2.036 0 3.81 1.136 4.727 2.807.357.645 1.123.942 1.803.762.68-.181 1.412-.237 2.174-.125 2.333.335 4.21 2.208 4.55 4.537.108.749.07 1.455-.112 2.148-.18.693.117 1.412.74 1.765m-5.822 1.19c.51-.465.547-1.256.082-1.766s-1.256-.547-1.766-.082l-.138.126-.03.028-.018.015-.017.016-.077.07-.043.04-.022.02-.011.01-.012.01-.099.09-.493.45-.145.132-.154.14-.161.147-.169.154-.021.02-.022.02-.022.02-.022.02-.022.02-.022.02-.022.02-.022.02-.182.165-.093.085-.094.086-.024.022-.024.022-.048.044-.024.022-.025.022-.024.022-.024.022-.05.045-.024.023-.025.022-.025.023-.025.022-.024.023-.026.023-.025.023-.025.023-.025.023-.025.023-.026.023-.025.023-.051.047-.207.188-.211.193-.214.195-.027.024-.027.025-.054.05-.027.024-.028.025-.027.024-.027.025-.055.05-.054.05-.11.1-.028.025-.028.026-.027.025-.028.025-.055.05-.056.051-.055.05-.056.052-.028.025-.028.026-.056.05-.028.026-.028.026-.028.025-.028.025-.056.052-.056.05-.113.103-.028.026-.028.025-.056.052-.028.026-.029.025-.056.051-.112.103-.45.41-.224.204-.028.025-.027.026-.028.025-.028.025-.11.101-.221.201-.11.1-.027.025-.027.024-.054.05-.054.05-.027.024-.027.024-.108.098-.106.097-.026.024-.027.024-.053.048-1.532 1.397-.02.019-.021.019-.021.019-.02.018-.041.038-.04.036-.158.143-.149.136-.036.033-.035.032-.035.032-.017.016-.017.015-.029.026-3.896-3.633c-.505-.471-1.296-.444-1.767.061s-.443 1.296.062 1.767l4.739 4.42c.476.444 1.213.448 1.695.01l-.843-.925.843.924.001-.001.005-.004v-.001l.004-.004.005-.004.003-.002.003-.003.006-.006.033-.03.047-.042.128-.117.082-.075.044-.04.012-.011.012-.011.024-.022.103-.094.027-.025.014-.012.014-.013.015-.013.014-.013.03-.027.06-.055.062-.057.132-.12.017-.015.017-.016.017-.016.018-.016.017-.016.018-.016.036-.033.037-.033.018-.017.019-.017.018-.017.02-.017.018-.018.02-.017.156-.143.04-.037.02-.018.021-.019.021-.019.02-.019.021-.019.021-.019.35-.318.023-.02.022-.022.023-.02.023-.021.093-.085.047-.043.024-.021.023-.022.024-.022.024-.021.024-.022.024-.022.097-.088.024-.023.025-.022.024-.023.025-.022.05-.045.05-.046.025-.023.025-.022.05-.046.102-.093.051-.047.026-.023.026-.024.104-.094.026-.024.026-.024.026-.024.026-.024.027-.024.026-.024.053-.048.027-.024.026-.025.027-.024.026-.024.027-.025.027-.024.054-.049.108-.099.109-.099.054-.05.027-.024.028-.025.11-.1.027-.025.028-.026.055-.05.111-.101.028-.025.028-.026.027-.025.028-.026.028-.025.028-.025.028-.026.028-.025.028-.026.028-.025.056-.051.028-.026.028-.025.056-.051.113-.103.225-.205.45-.41.028-.026.028-.026.056-.05.112-.103.056-.05.056-.052.111-.101.111-.101.055-.05.028-.026.028-.025.219-.2.109-.1.054-.049.054-.049.107-.098.107-.097.106-.096.026-.024.026-.024.053-.048.207-.189.102-.092.025-.023.025-.023.025-.023.026-.023.05-.046.024-.023.025-.022.05-.045.049-.045.048-.044.025-.022.024-.023.024-.021.024-.022.024-.022.024-.022.187-.17.357-.326.022-.02.021-.02.042-.038.084-.076.02-.019.02-.018.041-.037.08-.073.078-.07.076-.07.074-.067.036-.033.035-.033.07-.063.017-.016.017-.015.017-.015.016-.016.017-.015.016-.015.017-.014.016-.015.063-.057.118-.109.015-.012.014-.013.027-.025.027-.025.013-.012.013-.012.187-.17.142-.13z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#eec53c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#eec53c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#eec53c__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eec53c__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eec53c__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eec53c__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#eec53c__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iSDZg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Bell);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBellGeneric1160Svg = require("illustration:./S2_fill_bell_generic1_160.svg");
var _s2FillBellGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBellGeneric1160Svg);
var _s2FillBellGeneric196Svg = require("illustration:./S2_fill_bell_generic1_96.svg");
var _s2FillBellGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBellGeneric196Svg);
var _s2FillBellGeneric148Svg = require("illustration:./S2_fill_bell_generic1_48.svg");
var _s2FillBellGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBellGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Bell(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBellGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBellGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBellGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_bell_generic1_160.svg":"jVjlj","illustration:./S2_fill_bell_generic1_96.svg":"dtFVQ","illustration:./S2_fill_bell_generic1_48.svg":"y4ye9","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jVjlj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "822ad5__d",
                        x1: -24.021,
                        x2: 201.071,
                        y1: 134.5,
                        y2: -2.444,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "822ad5__e",
                        x1: 156.616,
                        x2: 60.052,
                        y1: 36.277,
                        y2: 140.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "822ad5__f",
                        x1: 39.265,
                        x2: 210.447,
                        y1: 154.441,
                        y2: 58.547,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "822ad5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.455 52.6)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "822ad5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.682 88.47)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "822ad5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "822ad5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M122.955 102.887c-5.292-8.32-10.748-19.933-11.153-32.867V59.93h-.004q.002-.064.004-.13C111.802 42.238 97.564 28 80 28c-17.563 0-31.8 14.238-31.8 31.801l.002.13H48.2V70.02c-.406 12.934-5.861 24.547-11.154 32.867-3.615 5.683.43 13.113 7.166 13.113h23.79v4c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12v-4h23.789c6.735 0 10.781-7.43 7.165-13.113"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#822ad5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#822ad5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.773 10.775h138.45v138.45H10.772z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.055,
                            cy: 16.146,
                            r: 60.233,
                            fill: "url(#822ad5__c)",
                            transform: "rotate(-.08 89.055 16.146)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#822ad5__d)",
                            d: "M63.616-13.68c-10.633-6.58-24.104-6.62-34.777-.105L-77.903 51.39c-10.454 6.383-10.471 21.45-.031 27.856l106.037 65.081c10.656 6.54 24.127 6.532 34.775-.023l105.818-65.142c10.385-6.393 10.404-21.376.032-27.793z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#822ad5__e)",
                            d: "M30.726 76.508c2.366-51.688 46.185-91.67 97.872-89.304 51.688 2.367 91.67 46.186 89.304 97.873-2.367 51.687-46.186 91.67-97.873 89.303-51.687-2.366-91.67-46.185-89.303-97.872"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#822ad5__f)",
                            d: "M-45.32 110.588c20.546-8.765 42.705-8.389 61.902-.723 38.415 15.38 60.767 5.871 76.27-32.455 7.722-19.233 22.799-35.52 43.368-44.295 41.124-17.517 88.601 1.49 106.093 42.493s-1.654 88.404-42.769 105.944c-20.615 8.794-42.816 8.382-62.042.647-38.353-15.297-60.662-5.753-76.146 32.62-7.742 19.186-22.815 35.418-43.36 44.183-41.092 17.53-88.568-1.477-106.05-42.457-17.483-40.98 1.643-88.427 42.735-105.957"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.153,
                            cy: 35.788,
                            r: 60.233,
                            fill: "url(#822ad5__g)",
                            transform: "rotate(-.08 141.153 35.788)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dtFVQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7e4da7__d",
                        x1: -14.409,
                        x2: 120.646,
                        y1: 80.7,
                        y2: -1.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7e4da7__e",
                        x1: 93.971,
                        x2: 36.033,
                        y1: 21.766,
                        y2: 84.066,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7e4da7__f",
                        x1: 23.561,
                        x2: 126.271,
                        y1: 92.664,
                        y2: 35.128,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7e4da7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.875 31.562)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7e4da7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.611 53.083)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "7e4da7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "7e4da7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M73.772 61.732c-3.175-4.992-6.448-11.96-6.692-19.72v-6.053h-.002l.002-.079c0-10.537-8.543-19.08-19.08-19.08-10.539 0-19.081 8.543-19.081 19.08l.002.078h-.002v6.054c-.244 7.76-3.517 14.728-6.693 19.72-2.169 3.41.258 7.868 4.3 7.868h14.273V72c0 3.976 3.224 7.2 7.2 7.2s7.2-3.224 7.2-7.2v-2.4h14.274c4.041 0 6.469-4.458 4.3-7.868"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#7e4da7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#7e4da7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.465 6.465h83.07v83.07H6.465z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.436,
                            cy: 9.687,
                            r: 36.14,
                            fill: "url(#7e4da7__c)",
                            transform: "rotate(-.08 53.436 9.687)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7e4da7__d)",
                            d: "M38.173-8.209c-6.38-3.947-14.463-3.972-20.866-.062L-46.74 30.833c-6.272 3.83-6.283 12.87-.019 16.714l63.623 39.048c6.393 3.924 14.477 3.92 20.865-.014l63.491-39.085c6.231-3.836 6.242-12.825.019-16.676z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7e4da7__e)",
                            d: "M18.437 45.905c1.42-31.013 27.711-55.002 58.724-53.582s55.001 27.711 53.582 58.723c-1.42 31.013-27.712 55.002-58.724 53.582-31.012-1.419-55.002-27.71-53.582-58.723"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7e4da7__f)",
                            d: "M-27.19 66.352c12.328-5.259 25.623-5.033 37.142-.433C33 75.146 46.412 69.44 55.714 46.445c4.633-11.539 13.679-21.312 26.02-26.576 24.675-10.51 53.161.893 63.656 25.495s-.992 53.043-25.661 63.567c-12.369 5.276-25.69 5.029-37.226.388-23.011-9.178-36.397-3.452-45.687 19.572-4.645 11.512-13.689 21.251-26.016 26.51-24.655 10.518-53.141-.886-63.63-25.474s.986-53.057 25.64-63.575"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.694,
                            cy: 21.472,
                            r: 36.14,
                            fill: "url(#7e4da7__g)",
                            transform: "rotate(-.08 84.694 21.472)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"y4ye9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b1ad1__d",
                        x1: -7.203,
                        x2: 60.325,
                        y1: 40.349,
                        y2: -0.734,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b1ad1__e",
                        x1: 46.986,
                        x2: 18.016,
                        y1: 10.883,
                        y2: 42.033,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b1ad1__f",
                        x1: 11.783,
                        x2: 63.137,
                        y1: 46.333,
                        y2: 17.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5b1ad1__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.938 15.782)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5b1ad1__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.806 26.543)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5b1ad1__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5b1ad1__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M36.886 30.866c-1.588-2.495-3.224-5.98-3.346-9.86V17.94c0-5.268-4.271-9.54-9.54-9.54-5.27 0-9.54 4.272-9.54 9.54v3.066c-.122 3.88-1.759 7.365-3.347 9.86-1.084 1.705.13 3.934 2.15 3.934H20.4V36c0 1.989 1.612 3.6 3.6 3.6s3.6-1.611 3.6-3.6v-1.2h7.136c2.021 0 3.235-2.229 2.15-3.934"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5b1ad1__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5b1ad1__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.234 3.232H44.77v41.535H3.234z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.72,
                            cy: 4.843,
                            r: 18.07,
                            fill: "url(#5b1ad1__c)",
                            transform: "rotate(-.08 26.72 4.843)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b1ad1__d)",
                            d: "M19.088-4.105c-3.19-1.974-7.231-1.986-10.433-.031l-32.022 19.552c-3.137 1.915-3.142 6.435-.01 8.357L8.434 43.297c3.197 1.962 7.239 1.96 10.433-.007l31.745-19.542c3.116-1.918 3.121-6.413.01-8.338z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b1ad1__e)",
                            d: "M9.219 22.952c.71-15.506 13.855-27.5 29.361-26.79s27.501 13.855 26.791 29.361S51.516 53.024 36.01 52.314 8.509 38.46 9.219 22.952"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b1ad1__f)",
                            d: "M-13.593 33.177c6.164-2.63 12.812-2.517 18.57-.217 11.525 4.614 18.23 1.761 22.882-9.737 2.316-5.77 6.84-10.656 13.01-13.288 12.337-5.255 26.58.447 31.828 12.748s-.496 26.52-12.83 31.783c-6.185 2.638-12.845 2.515-18.613.194-11.506-4.59-18.199-1.726-22.844 9.786C16.087 70.202 11.566 75.07 5.402 77.7c-12.328 5.259-26.57-.443-31.815-12.737s.493-26.528 12.82-31.787"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.349,
                            cy: 10.736,
                            r: 18.07,
                            fill: "url(#5b1ad1__g)",
                            transform: "rotate(-.08 42.35 10.736)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bIkVd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Bolt);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBoltGeneric1160Svg = require("illustration:./S2_fill_bolt_generic1_160.svg");
var _s2FillBoltGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBoltGeneric1160Svg);
var _s2FillBoltGeneric196Svg = require("illustration:./S2_fill_bolt_generic1_96.svg");
var _s2FillBoltGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBoltGeneric196Svg);
var _s2FillBoltGeneric148Svg = require("illustration:./S2_fill_bolt_generic1_48.svg");
var _s2FillBoltGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBoltGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Bolt(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBoltGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBoltGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBoltGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_bolt_generic1_160.svg":"gmSk1","illustration:./S2_fill_bolt_generic1_96.svg":"iqv1f","illustration:./S2_fill_bolt_generic1_48.svg":"2egjz","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gmSk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3c0618__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3c0618__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3c0618__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3c0618__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3c0618__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3c0618__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3c0618__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    stroke: "#fff",
                    strokeWidth: 3.5,
                    d: "M48.874 77.084v.001c-2.614 2.93-1.597 7.56 2.013 9.113l18.87 8.12c1.138.49 1.664 1.798 1.18 2.94v.002l-11.21 26.6c-2.517 5.969 5.232 10.896 9.572 6.082l41.8-46.39c2.645-2.933 1.611-7.605-2.028-9.144l-19-8.05h-.002c-1.146-.483-1.68-1.802-1.19-2.951v-.003l11.57-27.259c2.545-5.981-5.245-10.928-9.575-6.08l-.445.497v.01z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3c0618__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3c0618__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#3c0618__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3c0618__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3c0618__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3c0618__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#3c0618__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iqv1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "64e965__d",
                        x1: -8.937,
                        x2: 109.572,
                        y1: 75.484,
                        y2: -1,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "64e965__e",
                        x1: 89.384,
                        x2: 40.132,
                        y1: 25.086,
                        y2: 81.265,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "64e965__f",
                        x1: 25.507,
                        x2: 115.976,
                        y1: 85.716,
                        y2: 31.955,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "64e965__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "64e965__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "64e965__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 10,
                            y: 12,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "64e965__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m53.243 17.419-25.2 28.211c-2.044 2.291-1.25 5.915 1.577 7.13l11.321 4.873c.153.066.221.237.157.39L34.37 73.984c-1.97 4.672 4.095 8.525 7.49 4.76l25.08-27.833c2.068-2.296 1.26-5.951-1.589-7.156l-11.398-4.83h-.004c-.15-.064-.222-.236-.156-.392l6.943-16.356v-.002c1.99-4.68-4.105-8.551-7.495-4.757"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#64e965__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#64e965__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 10,
                            y: 12,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10 12h75.36v71.04H10z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#64e965__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 19.777 -16.107)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#64e965__d)",
                            d: "M38.765-.55c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.356 13.133 3.352 18.928-.012L95.962 47.09c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#64e965__e)",
                            d: "M20.86 45.728C22.148 19.207 46-1.308 74.133-.094s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822s-49.897-23.698-48.61-50.22"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#64e965__f)",
                            d: "M-20.534 63.215c11.184-4.498 23.245-4.305 33.694-.37 20.91 7.89 33.076 3.011 41.515-16.654 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804 9.521 21.04-.901 45.361-23.28 54.361-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.448 16.738-4.213 9.845-12.418 18.173-23.601 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#64e965__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 48.137 -6.028)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2egjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deedd1__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deedd1__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deedd1__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "deedd1__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "deedd1__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "deedd1__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "deedd1__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M14.522 22.817 26.856 9.01v-.003l.267-.299c1.695-1.898 4.744.039 3.748 2.38l-3.472 8.18c-.033.078.003.164.078.195h.002l5.7 2.416c1.425.603 1.828 2.431.794 3.579L21.432 39.377c-1.698 1.883-4.731-.044-3.746-2.38l3.364-7.983c.032-.076-.002-.162-.079-.195l-5.661-2.436c-1.413-.608-1.81-2.42-.788-3.566"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#deedd1__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#deedd1__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#deedd1__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deedd1__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deedd1__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deedd1__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#deedd1__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4tYaF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Brand);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBrandGeneric1160Svg = require("illustration:./S2_fill_brand_generic1_160.svg");
var _s2FillBrandGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBrandGeneric1160Svg);
var _s2FillBrandGeneric196Svg = require("illustration:./S2_fill_brand_generic1_96.svg");
var _s2FillBrandGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBrandGeneric196Svg);
var _s2FillBrandGeneric148Svg = require("illustration:./S2_fill_brand_generic1_48.svg");
var _s2FillBrandGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBrandGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Brand(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrandGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrandGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrandGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_brand_generic1_160.svg":"3evXZ","illustration:./S2_fill_brand_generic1_96.svg":"4IWi4","illustration:./S2_fill_brand_generic1_48.svg":"28fJD","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3evXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eed3bc__d",
                        x1: -18.921,
                        x2: 187.087,
                        y1: 128.357,
                        y2: -4.598,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eed3bc__e",
                        x1: 151.995,
                        x2: 66.38,
                        y1: 40.747,
                        y2: 138.405,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "eed3bc__f",
                        x1: 40.959,
                        x2: 198.223,
                        y1: 146.143,
                        y2: 52.689,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eed3bc__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "eed3bc__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "eed3bc__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 14,
                            y: 18,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "eed3bc__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M45.75 26.06h68.5c6.63 0 12 5.37 12 12v49.63c0 25.55-20.7 46.25-46.25 46.25s-46.25-20.71-46.25-46.25V38.06c0-6.63 5.37-12 12-12m4.08 65.75c.629.369 1.317.539 1.995.54 1.388-.002 2.726-.722 3.465-2l13.96-24.18c1.11-1.91.45-4.36-1.46-5.46-1.91-1.11-4.36-.45-5.46 1.46L48.37 86.35c-1.11 1.91-.45 4.36 1.46 5.46m52.52.54c2.89 0 5.48-1.5 6.93-4 1.45-2.51 1.45-5.5 0-8L96.71 58.58c-1.45-2.5-4.04-4-6.93-4s-5.48 1.5-6.93 4L70.28 80.35c-1.45 2.5-1.45 5.5 0 8s4.04 4 6.93 4zM89.78 62.57l12.571 21.78h-25.14z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#eed3bc__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#eed3bc__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 14,
                            y: 18,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M14 18h131v123.491H14z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#eed3bc__c)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 31 -30.86)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eed3bc__d)",
                            d: "M64.001-3.814c-10.06-5.868-22.807-5.904-32.905-.092l-101 58.131c-9.891 5.694-9.907 19.133-.03 24.847L30.4 137.122c10.082 5.833 22.83 5.826 32.904-.021l100.125-58.104c9.826-5.703 9.844-19.066.03-24.79z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eed3bc__e)",
                            d: "M32.878 76.631c2.24-46.103 43.701-81.765 92.607-79.655 48.907 2.111 86.738 41.196 84.499 87.299-2.239 46.102-43.701 81.765-92.607 79.654-48.906-2.11-86.738-41.195-84.499-87.298"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#eed3bc__f)",
                            d: "M-39.075 107.029c19.44-7.818 40.406-7.483 58.57-.645 36.349 13.717 57.498 5.236 72.167-28.95 7.307-17.153 21.572-31.681 41.035-39.508 38.911-15.625 83.833 1.329 100.384 37.902s-1.565 78.852-40.467 94.497c-19.506 7.844-40.512 7.477-58.705.577-36.288-13.644-57.398-5.131-72.048 29.096-7.325 17.113-21.588 31.591-41.028 39.409-38.88 15.636-83.803-1.317-100.344-37.869-16.542-36.553 1.555-78.874 40.436-94.509"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#eed3bc__g)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 80.293 -13.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4IWi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4e31e1__d",
                        x1: -11.355,
                        x2: 112.249,
                        y1: 77.014,
                        y2: -2.759,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4e31e1__e",
                        x1: 91.194,
                        x2: 39.825,
                        y1: 24.448,
                        y2: 83.043,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4e31e1__f",
                        x1: 24.574,
                        x2: 118.933,
                        y1: 87.686,
                        y2: 31.613,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4e31e1__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4e31e1__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "4e31e1__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 8.398,
                            y: 10.8,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "4e31e1__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M27.45 15.636h41.1c3.978 0 7.2 3.222 7.2 7.2v29.778c0 15.33-12.42 27.75-27.75 27.75s-27.75-12.426-27.75-27.75V22.836c0-3.978 3.222-7.2 7.2-7.2m2.448 39.45c.377.221.79.323 1.197.324.833-.001 1.636-.433 2.079-1.2l8.376-14.508c.666-1.146.27-2.616-.876-3.276-1.146-.666-2.616-.27-3.276.876L29.022 51.81c-.666 1.146-.27 2.616.876 3.276m31.512.324c1.734 0 3.288-.9 4.158-2.4.87-1.506.87-3.3 0-4.8l-7.542-13.062c-.87-1.5-2.424-2.4-4.158-2.4s-3.288.9-4.158 2.4L42.168 48.21c-.87 1.5-.87 3.3 0 4.8s2.424 2.4 4.158 2.4zm-7.541-17.868L61.41 50.61H46.327z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#4e31e1__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#4e31e1__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 8.398,
                            y: 10.8,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M8.398 10.8h78.6v74.094h-78.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#4e31e1__c)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 18.598 -18.517)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4e31e1__d)",
                            d: "M38.398-2.288C32.36-5.81 24.713-5.831 18.654-2.344l-60.6 34.88c-5.934 3.415-5.944 11.478-.017 14.907l60.199 34.83c6.05 3.5 13.698 3.495 19.742-.013l60.076-34.862c5.895-3.422 5.906-11.44.018-14.874z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4e31e1__e)",
                            d: "M19.724 45.978C21.067 18.317 45.944-3.08 75.288-1.814s52.043 24.717 50.699 52.379c-1.343 27.661-26.22 49.059-55.564 47.792S18.38 73.64 19.723 45.978"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4e31e1__f)",
                            d: "M-23.446 64.217c11.664-4.69 24.244-4.49 35.143-.386 21.808 8.23 34.498 3.141 43.3-17.37 4.383-10.292 12.943-19.01 24.62-23.705 23.347-9.375 50.3.797 60.231 22.74 9.931 21.944-.939 47.312-24.28 56.699-11.704 4.707-24.308 4.486-35.223.347-21.773-8.187-34.439-3.079-43.23 17.457-4.394 10.268-12.952 18.955-24.616 23.646-23.328 9.381-50.282-.791-60.207-22.722s.934-47.324 24.262-56.706"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#4e31e1__g)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 48.176 -8.004)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"28fJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de1123__d",
                        x1: -5.676,
                        x2: 56.126,
                        y1: 38.508,
                        y2: -1.379,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de1123__e",
                        x1: 45.597,
                        x2: 19.913,
                        y1: 12.224,
                        y2: 41.522,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de1123__f",
                        x1: 12.287,
                        x2: 59.466,
                        y1: 43.844,
                        y2: 15.807,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "de1123__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "de1123__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "de1123__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 4.199,
                            y: 5.4,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "de1123__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M13.725 7.818h20.55c1.989 0 3.6 1.611 3.6 3.6v14.89c0 7.664-6.21 13.874-13.875 13.874S10.125 33.97 10.125 26.307V11.418c0-1.989 1.611-3.6 3.6-3.6m1.224 19.725c.188.111.395.162.598.162.417 0 .818-.216 1.04-.6l4.188-7.254c.333-.573.135-1.308-.438-1.638-.573-.333-1.308-.135-1.638.438l-4.188 7.254c-.333.573-.135 1.308.438 1.638m15.756.162c.867 0 1.644-.45 2.079-1.2.435-.753.435-1.65 0-2.4l-3.771-6.53c-.435-.75-1.212-1.2-2.079-1.2s-1.644.45-2.079 1.2l-3.771 6.53c-.435.75-.435 1.65 0 2.4s1.212 1.2 2.079 1.2zm-3.77-8.934 3.77 6.534h-7.542z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#de1123__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#de1123__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 4.199,
                            y: 5.4,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.2 5.4h39.3v37.047H4.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#de1123__c)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 9.3 -9.258)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de1123__d)",
                            d: "M19.2-1.144c-3.017-1.76-6.841-1.771-9.87-.028l-30.3 17.44c-2.968 1.708-2.973 5.74-.01 7.454l30.1 17.415c3.025 1.75 6.849 1.748 9.871-.006L49.03 23.7c2.947-1.711 2.953-5.72.009-7.437z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de1123__e)",
                            d: "M9.862 22.99C10.534 9.157 22.972-1.54 37.644-.908s26.021 12.358 25.35 26.19c-.672 13.83-13.11 24.529-27.782 23.896C20.54 48.545 9.19 36.82 9.862 22.989"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de1123__f)",
                            d: "M-11.723 32.11c5.832-2.346 12.122-2.246 17.571-.194 10.905 4.115 17.25 1.57 21.65-8.685 2.192-5.146 6.472-9.505 12.31-11.853 11.674-4.687 25.15.399 30.116 11.37 4.965 10.973-.47 23.657-12.14 28.35-5.852 2.353-12.154 2.243-17.612.173C29.286 47.178 22.953 49.732 18.558 60c-2.198 5.134-6.476 9.477-12.309 11.823-11.664 4.69-25.14-.395-30.103-11.361-4.962-10.966.467-23.662 12.131-28.353"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#de1123__g)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 24.086 -4.002)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fi9Bg":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Briefcase);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBriefcaseGeneric1160Svg = require("illustration:./S2_fill_briefcase_generic1_160.svg");
var _s2FillBriefcaseGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBriefcaseGeneric1160Svg);
var _s2FillBriefcaseGeneric196Svg = require("illustration:./S2_fill_briefcase_generic1_96.svg");
var _s2FillBriefcaseGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBriefcaseGeneric196Svg);
var _s2FillBriefcaseGeneric148Svg = require("illustration:./S2_fill_briefcase_generic1_48.svg");
var _s2FillBriefcaseGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBriefcaseGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Briefcase(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBriefcaseGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBriefcaseGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBriefcaseGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_briefcase_generic1_160.svg":"iyFZE","illustration:./S2_fill_briefcase_generic1_96.svg":"cIu6K","illustration:./S2_fill_briefcase_generic1_48.svg":"enIZO","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iyFZE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1910bd__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1910bd__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1910bd__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1910bd__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1910bd__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1910bd__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1910bd__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M115 49h9c8.84 0 16 7.16 16 16v22h-25v-2c0-2.21-1.79-4-4-4s-4 1.79-4 4v2H53v-2c0-2.21-1.79-4-4-4s-4 1.79-4 4v2H20V65c0-8.84 7.16-16 16-16h9V38c0-7.72 6.28-14 14-14h42c7.72 0 14 6.28 14 14zm-62 0h54V38c0-3.31-2.69-6-6-6H59c-3.31 0-6 2.69-6 6zm58 53c2.21 0 4-1.79 4-4v-3h25v21c0 8.84-7.16 16-16 16H36c-8.84 0-16-7.16-16-16V95h25v3c0 2.21 1.79 4 4 4s4-1.79 4-4v-3h54v3c0 2.21 1.79 4 4 4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1910bd__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1910bd__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#1910bd__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1910bd__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1910bd__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1910bd__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#1910bd__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cIu6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "94f212__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "94f212__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "94f212__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "94f212__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "94f212__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "94f212__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "94f212__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M69 29.4h5.4c5.304 0 9.6 4.296 9.6 9.6v13.2H69V51c0-1.326-1.074-2.4-2.4-2.4s-2.4 1.074-2.4 2.4v1.2H31.8V51c0-1.326-1.074-2.4-2.4-2.4S27 49.674 27 51v1.2H12V39c0-5.304 4.296-9.6 9.6-9.6H27v-6.6c0-4.632 3.768-8.4 8.4-8.4h25.2c4.632 0 8.4 3.768 8.4 8.4zm-37.2 0h32.4v-6.6c0-1.986-1.614-3.6-3.6-3.6H35.4c-1.986 0-3.6 1.614-3.6 3.6zm34.8 31.8c1.326 0 2.4-1.074 2.4-2.4V57h15v12.6c0 5.304-4.296 9.6-9.6 9.6H21.6c-5.304 0-9.6-4.296-9.6-9.6V57h15v1.8c0 1.326 1.074 2.4 2.4 2.4s2.4-1.074 2.4-2.4V57h32.4v1.8c0 1.326 1.074 2.4 2.4 2.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#94f212__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#94f212__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#94f212__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#94f212__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#94f212__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#94f212__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#94f212__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"enIZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c155c__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c155c__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c155c__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9c155c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9c155c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "9c155c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "9c155c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M34.5 14.7h2.7c2.652 0 4.8 2.148 4.8 4.8v6.6h-7.5v-.6c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v.6H15.9v-.6c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v.6H6v-6.6c0-2.652 2.148-4.8 4.8-4.8h2.7v-3.3c0-2.316 1.884-4.2 4.2-4.2h12.6c2.316 0 4.2 1.884 4.2 4.2zm-18.6 0h16.2v-3.3c0-.993-.807-1.8-1.8-1.8H17.7c-.993 0-1.8.807-1.8 1.8zm17.4 15.9c.663 0 1.2-.537 1.2-1.2v-.9H42v6.3c0 2.652-2.148 4.8-4.8 4.8H10.8c-2.652 0-4.8-2.148-4.8-4.8v-6.3h7.5v.9c0 .663.537 1.2 1.2 1.2s1.2-.537 1.2-1.2v-.9h16.2v.9c0 .663.537 1.2 1.2 1.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#9c155c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#9c155c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#9c155c__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c155c__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c155c__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c155c__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#9c155c__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lWhHV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BrightnessContrast);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBrightnessContrastGeneric1160Svg = require("illustration:./S2_fill_brightnessContrast_generic1_160.svg");
var _s2FillBrightnessContrastGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBrightnessContrastGeneric1160Svg);
var _s2FillBrightnessContrastGeneric196Svg = require("illustration:./S2_fill_brightnessContrast_generic1_96.svg");
var _s2FillBrightnessContrastGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBrightnessContrastGeneric196Svg);
var _s2FillBrightnessContrastGeneric148Svg = require("illustration:./S2_fill_brightnessContrast_generic1_48.svg");
var _s2FillBrightnessContrastGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBrightnessContrastGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function BrightnessContrast(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrightnessContrastGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrightnessContrastGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrightnessContrastGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_brightnessContrast_generic1_160.svg":"aJEGh","illustration:./S2_fill_brightnessContrast_generic1_96.svg":"5xtri","illustration:./S2_fill_brightnessContrast_generic1_48.svg":"dSkoI","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJEGh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f9d21__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f9d21__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f9d21__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0f9d21__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0f9d21__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0f9d21__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0f9d21__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M80 20c2.21 0 4 1.79 4 4v7.938c0 2.21-1.79 4-4 4s-4-1.79-4-4V24c0-2.21 1.791-4 4-4m-.228 35.72c-13.306.123-24.055 10.947-24.055 24.282s10.749 24.16 24.055 24.283zm.23-8.001c17.829 0 32.283 14.454 32.283 32.283s-14.454 32.284-32.284 32.284-32.284-14.454-32.284-32.284S62.171 47.72 80.001 47.72M84 128.062c0-2.21-1.791-4-4-4s-4 1.79-4 4V136c0 2.209 1.79 4 4 4s4-1.791 4-4zM140 80c0 2.21-1.791 4-4 4h-7.939c-2.209 0-4-1.79-4-4s1.791-4 4-4h7.939c2.209 0 4 1.79 4 4M31.938 84c2.21 0 4-1.79 4-4s-1.79-4-4-4H24c-2.21 0-4 1.79-4 4s1.79 4 4 4zm90.488-46.427c1.562 1.562 1.562 4.095 0 5.657l-5.613 5.613c-1.562 1.562-4.095 1.562-5.657 0s-1.562-4.095 0-5.657l5.613-5.613c1.562-1.562 4.095-1.562 5.657 0m-73.582 79.24c1.562-1.562 1.562-4.094 0-5.657s-4.095-1.562-5.657 0l-5.613 5.614c-1.562 1.562-1.562 4.094 0 5.656s4.095 1.562 5.657 0zm-11.27-79.242c-1.563 1.562-1.563 4.095 0 5.657l5.612 5.613c1.562 1.562 4.095 1.562 5.657 0s1.562-4.095 0-5.657l-5.613-5.613c-1.562-1.562-4.095-1.562-5.657 0m73.583 79.24c-1.562-1.562-1.562-4.094 0-5.657s4.095-1.562 5.657 0l5.613 5.614c1.562 1.562 1.562 4.094 0 5.656-1.562 1.563-4.095 1.563-5.657 0z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0f9d21__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0f9d21__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#0f9d21__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f9d21__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f9d21__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f9d21__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#0f9d21__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5xtri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d49d__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d49d__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d49d__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f3d49d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f3d49d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f3d49d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f3d49d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M48 13.234c1.105 0 2 .896 2 2v4.645c0 1.104-.895 2-2 2s-2-.896-2-2v-4.645c0-1.104.895-2 2-2M48 29.452c10.244 0 18.548 8.305 18.548 18.549S58.244 66.55 48 66.55c-10.245 0-18.55-8.305-18.55-18.55 0-10.243 8.305-18.548 18.55-18.548m-.228 4.002C39.842 33.576 33.45 40.042 33.45 48s6.39 14.425 14.32 14.547zM50 76.121c0-1.104-.895-2-2-2s-2 .896-2 2v4.645c0 1.104.895 2 2 2s2-.896 2-2zM82.766 48c0 1.105-.896 2-2 2H76.12c-1.105 0-2-.895-2-2s.895-2 2-2h4.645c1.104 0 2 .895 2 2M19.879 50c1.104 0 2-.895 2-2s-.896-2-2-2h-4.645c-1.104 0-2 .895-2 2s.896 2 2 2zM72.583 23.416c.78.781.78 2.047 0 2.828l-3.284 3.285c-.782.78-2.048.78-2.829 0-.78-.781-.78-2.048 0-2.829l3.284-3.284c.781-.78 2.048-.78 2.829 0M29.53 69.298c.78-.781.78-2.048 0-2.829-.782-.78-2.048-.78-2.83 0l-3.284 3.285c-.78.78-.78 2.047 0 2.828.782.781 2.048.781 2.829 0zM23.416 23.416c-.78.781-.78 2.047 0 2.828l3.285 3.285c.78.78 2.047.78 2.828 0 .78-.781.78-2.048 0-2.829l-3.284-3.284c-.781-.78-2.048-.78-2.829 0M66.47 69.298c-.781-.781-.781-2.048 0-2.829.781-.78 2.047-.78 2.829 0l3.284 3.285c.78.78.78 2.047 0 2.828-.781.781-2.048.781-2.829 0z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f3d49d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f3d49d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#f3d49d__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d49d__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d49d__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d49d__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#f3d49d__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dSkoI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "758c49__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.894,
                        y2: -4.584,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "758c49__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.841,
                        y2: 44.839,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "758c49__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.808,
                        y2: 16.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "758c49__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "758c49__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "758c49__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "758c49__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M24 6.231c.69 0 1.25.56 1.25 1.25v2.341c0 .69-.56 1.25-1.25 1.25-.691 0-1.25-.56-1.25-1.25v-2.34c0-.69.559-1.25 1.25-1.25M23.999 14.407c5.298 0 9.593 4.295 9.593 9.594S29.297 33.594 24 33.594c-5.299 0-9.594-4.295-9.594-9.593 0-5.299 4.295-9.594 9.594-9.594m-.228 2.504c-3.812.12-6.866 3.248-6.866 7.09s3.054 6.97 6.866 7.09zM25.25 38.179c0-.69-.56-1.25-1.25-1.25-.691 0-1.25.56-1.25 1.25v2.34c0 .69.559 1.25 1.25 1.25.69 0 1.25-.56 1.25-1.25zM41.769 24.001c0 .69-.56 1.25-1.25 1.25h-2.34c-.691 0-1.25-.56-1.25-1.25s.559-1.25 1.25-1.25h2.34c.69 0 1.25.56 1.25 1.25M9.821 25.251c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25h-2.34c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25zM36.564 11.435c.488.488.488 1.28 0 1.767l-1.655 1.655c-.488.488-1.28.488-1.768 0s-.488-1.28 0-1.767l1.655-1.655c.489-.489 1.28-.489 1.768 0M14.857 34.91c.488-.489.488-1.28 0-1.769s-1.28-.488-1.768 0l-1.655 1.656c-.488.488-.488 1.28 0 1.767.489.488 1.28.488 1.768 0zM11.434 11.435c-.489.488-.489 1.28 0 1.767l1.655 1.655c.488.488 1.28.488 1.767 0 .488-.488.488-1.28 0-1.767l-1.655-1.655c-.488-.489-1.28-.489-1.767 0M33.14 34.91c-.488-.489-.488-1.28 0-1.769.489-.488 1.28-.488 1.768 0l1.655 1.656c.488.488.488 1.28 0 1.767-.488.488-1.28.488-1.768 0z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#758c49__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#758c49__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0-.001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.861,
                            r: 20.883,
                            fill: "url(#758c49__c)",
                            transform: "rotate(-.08 27.142 1.861)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#758c49__d)",
                            d: "M18.321-8.48c-3.686-2.28-8.357-2.295-12.057-.036L-30.743 14.08c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.3c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#758c49__e)",
                            d: "M6.916 22.788C7.736 4.868 22.93-8.993 40.85-8.172S72.63 7.84 71.809 25.758c-.82 17.92-16.012 31.782-33.931 30.962-17.92-.82-31.782-16.013-30.962-33.933"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#758c49__f)",
                            d: "M-19.448 34.604c7.124-3.039 14.806-2.908 21.462-.25C15.332 39.686 23.08 36.389 28.456 23.1c2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.671,
                            r: 20.883,
                            fill: "url(#758c49__g)",
                            transform: "rotate(-.08 45.2 8.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gp5R9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Browser);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBrowserGeneric1160Svg = require("illustration:./S2_fill_browser_generic1_160.svg");
var _s2FillBrowserGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBrowserGeneric1160Svg);
var _s2FillBrowserGeneric196Svg = require("illustration:./S2_fill_browser_generic1_96.svg");
var _s2FillBrowserGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBrowserGeneric196Svg);
var _s2FillBrowserGeneric148Svg = require("illustration:./S2_fill_browser_generic1_48.svg");
var _s2FillBrowserGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBrowserGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Browser(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrowserGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrowserGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrowserGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_browser_generic1_160.svg":"ku8Yh","illustration:./S2_fill_browser_generic1_96.svg":"cE2lE","illustration:./S2_fill_browser_generic1_48.svg":"24iB8","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ku8Yh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "984179__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "984179__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "984179__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "984179__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "984179__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "984179__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "984179__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M36 28h88c8.84 0 16 7.16 16 16v12H20V44c0-8.84 7.16-16 16-16m-3.98 16c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4h-.01c-2.2 0-3.99 1.79-3.99 4M36 132c-8.84 0-16-7.16-16-16V64h120v52c0 8.84-7.16 16-16 16z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#984179__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#984179__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#984179__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#984179__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#984179__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#984179__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#984179__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cE2lE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "98a62b__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "98a62b__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "98a62b__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "98a62b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "98a62b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "98a62b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "98a62b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M21.6 16.8h52.8c5.304 0 9.6 4.296 9.6 9.6v7.2H12v-7.2c0-5.304 4.296-9.6 9.6-9.6m-2.388 9.6c0 1.326 1.074 2.4 2.4 2.4s2.4-1.074 2.4-2.4-1.074-2.4-2.4-2.4h-.006c-1.32 0-2.394 1.074-2.394 2.4M21.6 79.2c-5.304 0-9.6-4.296-9.6-9.6V38.4h72v31.2c0 5.304-4.296 9.6-9.6 9.6z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#98a62b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#98a62b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#98a62b__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#98a62b__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#98a62b__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#98a62b__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#98a62b__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"24iB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab24ef__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab24ef__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab24ef__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ab24ef__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ab24ef__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ab24ef__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ab24ef__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M10.8 8.4h26.4c2.652 0 4.8 2.148 4.8 4.8v3.6H6v-3.6c0-2.652 2.148-4.8 4.8-4.8m-1.194 4.8c0 .663.537 1.2 1.2 1.2s1.2-.537 1.2-1.2-.537-1.2-1.2-1.2h-.003c-.66 0-1.197.537-1.197 1.2M10.8 39.6c-2.652 0-4.8-2.148-4.8-4.8V19.2h36v15.6c0 2.652-2.148 4.8-4.8 4.8z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ab24ef__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ab24ef__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#ab24ef__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab24ef__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab24ef__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab24ef__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#ab24ef__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iCgMs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Brush);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBrushGeneric1160Svg = require("illustration:./S2_fill_brush_generic1_160.svg");
var _s2FillBrushGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBrushGeneric1160Svg);
var _s2FillBrushGeneric196Svg = require("illustration:./S2_fill_brush_generic1_96.svg");
var _s2FillBrushGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBrushGeneric196Svg);
var _s2FillBrushGeneric148Svg = require("illustration:./S2_fill_brush_generic1_48.svg");
var _s2FillBrushGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBrushGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Brush(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrushGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrushGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBrushGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_brush_generic1_160.svg":"1K6Tk","illustration:./S2_fill_brush_generic1_96.svg":"2l5Ba","illustration:./S2_fill_brush_generic1_48.svg":"j5PCK","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1K6Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a59f7__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a59f7__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a59f7__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3a59f7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3a59f7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3a59f7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3a59f7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "m120.503 28.91-42.69 42.689c3.866 1.587 7.277 3.927 10.101 7.09 3.08 3.45 5.157 7.539 6.429 12.017l43.979-43.978c4.92-4.92 4.92-12.898 0-17.819-4.921-4.92-12.898-4.92-17.819 0M86.332 91.857c-.931-2.847-2.262-5.325-4.004-7.4-2.513-2.994-5.88-5.146-10.132-6.346C69.602 77.379 66.68 77 63.423 77c-16.666 0-24.123 17.69-29.751 31.36-4.312 10.471-14.286 18.583-18.717 21.806-.748.544-.463 1.763.453 1.885 7.238.963 27.809 3.322 42.387 1.236 17.963-2.571 30.176-13.377 30.176-29.877 0-4.324-.54-8.195-1.64-11.553"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3a59f7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3a59f7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#3a59f7__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a59f7__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a59f7__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a59f7__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#3a59f7__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2l5Ba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fec76__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fec76__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fec76__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1fec76__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1fec76__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1fec76__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1fec76__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "m71.427 19.096-24.66 24.66c2.215.874 4.155 2.186 5.748 3.97 1.752 1.962 2.919 4.312 3.614 6.904l25.416-25.416c2.794-2.794 2.794-7.324 0-10.118s-7.324-2.794-10.118 0m-19.32 36.018c.566 1.844.846 3.95.846 6.29 0 9.37-6.936 15.506-17.137 16.966-7.608 1.089-18.09.046-22.928-.555-.918-.114-1.206-1.346-.474-1.912 2.786-2.154 7.521-6.39 9.703-11.688 3.196-7.763 7.43-17.809 16.895-17.809 2.138 0 4.02.287 5.655.84 3.343 1.129 5.646 3.368 6.96 6.532q.268.642.48 1.336"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1fec76__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1fec76__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#1fec76__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fec76__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fec76__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fec76__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#1fec76__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j5PCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5fd8b__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5fd8b__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5fd8b__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b5fd8b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b5fd8b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b5fd8b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b5fd8b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M35.714 9.548 23.766 21.495c1.09.462 2.058 1.133 2.865 2.036.873.978 1.467 2.127 1.839 3.38l12.303-12.304c1.397-1.397 1.397-3.662 0-5.06-1.397-1.396-3.662-1.396-5.06 0M17.908 39.185c5.1-.73 8.568-3.798 8.568-8.483s-2.238-7.499-6.97-7.499-6.85 5.023-8.447 8.904c-1.091 2.65-3.46 4.767-4.852 5.845-.366.282-.222.899.237.956 2.42.3 7.66.822 11.464.277"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b5fd8b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b5fd8b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#b5fd8b__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5fd8b__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5fd8b__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5fd8b__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#b5fd8b__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"loXrT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuildTable);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBuildTableGeneric1160Svg = require("illustration:./S2_fill_buildTable_generic1_160.svg");
var _s2FillBuildTableGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBuildTableGeneric1160Svg);
var _s2FillBuildTableGeneric196Svg = require("illustration:./S2_fill_buildTable_generic1_96.svg");
var _s2FillBuildTableGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBuildTableGeneric196Svg);
var _s2FillBuildTableGeneric148Svg = require("illustration:./S2_fill_buildTable_generic1_48.svg");
var _s2FillBuildTableGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBuildTableGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function BuildTable(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildTableGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildTableGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildTableGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_buildTable_generic1_160.svg":"b7ZVs","illustration:./S2_fill_buildTable_generic1_96.svg":"aDPBH","illustration:./S2_fill_buildTable_generic1_48.svg":"5CPSL","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b7ZVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1feae4__d",
                        x1: -16.181,
                        x2: 200.204,
                        y1: 139.116,
                        y2: -0.536,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1feae4__e",
                        x1: 163.345,
                        x2: 73.417,
                        y1: 47.092,
                        y2: 149.67,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1feae4__f",
                        x1: 46.716,
                        x2: 211.902,
                        y1: 157.799,
                        y2: 59.636,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1feae4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 56.4317 -59.8633 0 59.863 56.432)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1feae4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 56.4317 -59.8633 0 59.863 56.432)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1feae4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 137.6,
                            height: 129.712,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1feae4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M123.969 33.9c8.84 0 16 7.16 16 16v4.09H19.949V49.9c0-8.84 7.16-16 16-16zm16.001 52.56c-2.58-.66-5.28-1.01-8.06-1.01h-.01c-17.94 0-32.53 14.59-32.53 32.53 0 2.77.35 5.47 1.01 8.04H48V61.99h91.97zM19.95 110.03c0 8.84 7.16 16 16 16H40V62H19.95zM131.91 93.46c2.82 0 5.53.48 8.06 1.36h.01c9.59 3.34 16.47 12.45 16.47 23.17 0 13.55-10.98 24.53-24.53 24.53-10.73 0-19.85-6.89-23.18-16.49-.88-2.52-1.36-5.22-1.36-8.04 0-13.55 10.98-24.53 24.53-24.53m4.01 28.48h7.88c2.21 0 4-1.79 4-4s-1.79-4-4-4h-7.88v-7.88c0-2.21-1.79-4-4-4s-4 1.79-4 4v7.88h-7.88c-2.21 0-4 1.79-4 4s1.79 4 4 4h7.88v7.88c0 2.21 1.79 4 4 4s4-1.79 4-4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1feae4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1feae4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 137.6,
                            height: 129.712,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h137.6v129.712h-137.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 59.863,
                            cy: 56.432,
                            fill: "url(#1feae4__c)",
                            rx: 59.863,
                            ry: 56.432,
                            transform: "matrix(1 -.00132 .00148 1 36.254 -28.121)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1feae4__d)",
                            d: "M70.918.287C60.351-5.877 46.962-5.915 36.355.19L-69.732 61.25c-10.39 5.98-10.407 20.096-.032 26.099l105.386 60.973c10.591 6.127 23.98 6.12 34.562-.021L175.353 87.27c10.321-5.99 10.34-20.027.032-26.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1feae4__e)",
                            d: "M38.227 84.784C40.58 36.359 84.13-1.1 135.5 1.117s91.107 43.27 88.755 91.696c-2.351 48.425-45.901 85.884-97.271 83.667s-91.107-43.271-88.756-91.696"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1feae4__f)",
                            d: "M-37.35 116.713c20.42-8.211 42.442-7.859 61.522-.676 38.179 14.408 60.394 5.5 75.802-30.408 7.674-18.019 22.659-33.278 43.101-41.5 40.872-16.41 88.057 1.397 105.442 39.812s-1.644 82.825-42.506 99.258c-20.488 8.239-42.553 7.853-61.662.606-38.117-14.332-60.29-5.39-75.678 30.561-7.694 17.976-22.675 33.183-43.095 41.395-40.84 16.424-88.024-1.384-105.399-39.777s1.634-82.847 42.473-99.271"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 59.863,
                            cy: 56.432,
                            fill: "url(#1feae4__g)",
                            rx: 59.863,
                            ry: 56.432,
                            transform: "matrix(1 -.00132 .00148 1 88.031 -9.719)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aDPBH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa6b1d__d",
                        x1: -9.711,
                        x2: 120.12,
                        y1: 83.47,
                        y2: -0.321,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa6b1d__e",
                        x1: 98.009,
                        x2: 44.052,
                        y1: 28.256,
                        y2: 89.803,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa6b1d__f",
                        x1: 28.029,
                        x2: 127.141,
                        y1: 94.679,
                        y2: 35.782,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aa6b1d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 33.859 -35.918 0 35.918 33.859)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aa6b1d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 33.859 -35.918 0 35.918 33.859)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "aa6b1d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 82.56,
                            height: 77.827,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "aa6b1d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M74.38 20.34c5.305 0 9.6 4.296 9.6 9.6v2.454H11.97V29.94c0-5.304 4.296-9.6 9.6-9.6zm9.601 31.536c-1.548-.396-3.168-.606-4.836-.606h-.006c-10.764 0-19.518 8.754-19.518 19.518 0 1.662.21 3.282.606 4.824H28.8V37.194h55.182zM11.97 66.018c0 5.304 4.296 9.6 9.6 9.6h2.43V37.2h-12.03zm67.177-9.942c1.692 0 3.318.288 4.836.816h.006c5.754 2.004 9.882 7.47 9.882 13.902 0 8.13-6.588 14.718-14.718 14.718-6.438 0-11.91-4.134-13.908-9.894-.528-1.512-.816-3.132-.816-4.824 0-8.13 6.588-14.718 14.718-14.718m2.406 17.088h4.728c1.326 0 2.4-1.074 2.4-2.4s-1.074-2.4-2.4-2.4h-4.728v-4.728c0-1.326-1.074-2.4-2.4-2.4s-2.4 1.074-2.4 2.4v4.728h-4.728c-1.326 0-2.4 1.074-2.4 2.4s1.074 2.4 2.4 2.4h4.728v4.728c0 1.326 1.074 2.4 2.4 2.4s2.4-1.074 2.4-2.4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#aa6b1d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#aa6b1d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 82.56,
                            height: 77.827,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H93.6v77.827H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 35.918,
                            cy: 33.859,
                            fill: "url(#aa6b1d__c)",
                            rx: 35.918,
                            ry: 33.859,
                            transform: "matrix(1 -.00132 .00148 1 21.754 -16.873)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa6b1d__d)",
                            d: "M42.549.173C36.207-3.526 28.174-3.55 21.81.114L-41.842 36.75c-6.234 3.588-6.244 12.058-.019 15.66l63.232 36.584c6.355 3.676 14.388 3.671 20.737-.013l63.102-36.619c6.192-3.594 6.203-12.016.018-15.623z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa6b1d__e)",
                            d: "M22.939 50.87C24.349 21.817 50.479-.66 81.302.67c30.822 1.33 54.664 25.963 53.253 55.018s-27.541 51.531-58.363 50.2-54.664-25.962-53.253-55.017"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa6b1d__f)",
                            d: "M-22.41 70.028c12.251-4.927 25.465-4.716 36.912-.406 22.908 8.645 36.237 3.3 45.481-18.245 4.605-10.81 13.596-19.967 25.861-24.9 24.523-9.846 52.834.838 63.265 23.888 10.431 23.048-.986 49.694-25.503 59.554-12.293 4.944-25.532 4.712-36.997.364-22.87-8.599-36.174-3.234-45.407 18.337-4.617 10.785-13.605 19.909-25.857 24.837-24.504 9.854-52.815-.831-63.24-23.867s.98-49.708 25.484-59.562"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 35.918,
                            cy: 33.859,
                            fill: "url(#aa6b1d__g)",
                            rx: 35.918,
                            ry: 33.859,
                            transform: "matrix(1 -.00132 .00148 1 52.82 -5.831)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5CPSL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "364c63__d",
                        x1: -4.856,
                        x2: 60.06,
                        y1: 41.735,
                        y2: -0.161,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "364c63__e",
                        x1: 49.005,
                        x2: 22.026,
                        y1: 14.128,
                        y2: 44.901,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "364c63__f",
                        x1: 14.016,
                        x2: 63.572,
                        y1: 47.34,
                        y2: 17.891,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "364c63__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.9295 -17.959 0 17.959 16.93)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "364c63__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.9295 -17.959 0 17.959 16.93)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "364c63__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.28,
                            height: 38.913,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "364c63__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M37.19 10.17c2.652 0 4.8 2.148 4.8 4.8v1.227H5.984V14.97c0-2.652 2.148-4.8 4.8-4.8zm4.8 15.768c-.773-.198-1.583-.303-2.417-.303h-.003c-5.382 0-9.76 4.377-9.76 9.759 0 .83.106 1.64.304 2.412H14.4v-19.21h27.59zm-36.006 7.07c0 2.653 2.148 4.8 4.8 4.8H12V18.6H5.984zm33.589-4.97c.846 0 1.659.144 2.418.408h.003c2.877 1.002 4.94 3.735 4.94 6.95 0 4.066-3.293 7.36-7.358 7.36-3.22 0-5.955-2.067-6.954-4.947-.264-.756-.408-1.566-.408-2.412 0-4.065 3.294-7.36 7.359-7.36m1.203 8.544h2.364c.663 0 1.2-.537 1.2-1.2s-.537-1.2-1.2-1.2h-2.364v-2.364c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v2.364h-2.364c-.663 0-1.2.537-1.2 1.2s.537 1.2 1.2 1.2h2.364v2.364c0 .663.537 1.2 1.2 1.2s1.2-.537 1.2-1.2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#364c63__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#364c63__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.28,
                            height: 38.913,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H46.8v38.913H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.959,
                            cy: 16.93,
                            fill: "url(#364c63__c)",
                            rx: 17.959,
                            ry: 16.93,
                            transform: "matrix(1 -.00132 .00148 1 10.875 -8.437)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#364c63__d)",
                            d: "M21.274.086c-3.17-1.849-7.187-1.86-10.369-.029L-20.92 18.375c-3.117 1.794-3.122 6.029-.01 7.83l31.617 18.292c3.177 1.838 7.194 1.836 10.368-.007l31.55-18.309c3.097-1.797 3.103-6.008.01-7.812z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#364c63__e)",
                            d: "M11.47 25.435C12.174 10.908 25.24-.33 40.65.335 56.063 1 67.984 13.316 67.279 27.844c-.706 14.527-13.771 25.765-29.182 25.1S10.764 39.963 11.469 25.435"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#364c63__f)",
                            d: "M-11.203 35.014c6.126-2.464 12.732-2.358 18.456-.203 11.454 4.322 18.118 1.65 22.74-9.122 2.303-5.406 6.798-9.984 12.931-12.45 12.262-4.924 26.417.419 31.633 11.943 5.215 11.525-.493 24.848-12.752 29.778-6.147 2.471-12.766 2.356-18.499.181-11.435-4.299-18.087-1.616-22.703 9.169-2.308 5.392-6.803 9.955-12.929 12.418-12.251 4.927-26.407-.415-31.62-11.933-5.212-11.518.49-24.854 12.743-29.781"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.959,
                            cy: 16.93,
                            fill: "url(#364c63__g)",
                            rx: 17.959,
                            ry: 16.93,
                            transform: "matrix(1 -.00132 .00148 1 26.41 -2.916)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"91Uor":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Buildings);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillBuildingsGeneric1160Svg = require("illustration:./S2_fill_buildings_generic1_160.svg");
var _s2FillBuildingsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillBuildingsGeneric1160Svg);
var _s2FillBuildingsGeneric196Svg = require("illustration:./S2_fill_buildings_generic1_96.svg");
var _s2FillBuildingsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillBuildingsGeneric196Svg);
var _s2FillBuildingsGeneric148Svg = require("illustration:./S2_fill_buildings_generic1_48.svg");
var _s2FillBuildingsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillBuildingsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Buildings(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildingsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildingsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillBuildingsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_buildings_generic1_160.svg":"kmcLG","illustration:./S2_fill_buildings_generic1_96.svg":"euSG2","illustration:./S2_fill_buildings_generic1_48.svg":"1irBn","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmcLG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6fc07f__d",
                        x1: -28.688,
                        x2: 194.754,
                        y1: 137.748,
                        y2: -6.308,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6fc07f__e",
                        x1: 156.584,
                        x2: 63.67,
                        y1: 42.682,
                        y2: 148.555,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6fc07f__f",
                        x1: 36.222,
                        x2: 206.784,
                        y1: 157.049,
                        y2: 55.798,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6fc07f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 58.2973 -61.7778 0 61.778 58.297)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6fc07f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 58.2973 -61.7778 0 61.778 58.297)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "6fc07f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 142,
                            height: 134,
                            x: 7,
                            y: 18,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "6fc07f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M35.75 27.93h48.07c8.84 0 16 7.16 16 16v88.13H73.83v-20.58c0-4.42-3.58-8-8-8H53.74c-4.42 0-8 3.58-8 8v20.58H19.75V43.93c0-8.84 7.16-16 16-16m12.79 56.56c2.21 0 4-1.79 4-4v-5.76c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4zm0-28.06c2.21 0 4-1.79 4-4v-5.76c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4zM76.8 84.49c2.21 0 4-1.79 4-4v-5.76c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4zm0-28.06c2.21 0 4-1.79 4-4v-5.76c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4zm47.44-6.87c8.84 0 16 7.16 16 16v66.5h-32.41v-82.5zm-1.33 62.16c2.21 0 4-1.79 4-4v-5.76c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4zm0-28.06c2.21 0 4-1.79 4-4V73.9c0-2.21-1.79-4-4-4h-5.76c-2.21 0-4 1.79-4 4v5.76c0 2.21 1.79 4 4 4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#6fc07f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#6fc07f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 142,
                            height: 134,
                            x: 7,
                            y: 18,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7 18h142v134H7z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 61.778,
                            cy: 58.297,
                            fill: "url(#6fc07f__c)",
                            rx: 61.778,
                            ry: 58.297,
                            transform: "matrix(1 -.00132 .00148 1 25.426 -35.019)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6fc07f__d)",
                            d: "M61.197-5.67c-10.906-6.368-24.723-6.407-35.669-.1l-109.48 63.078c-10.722 6.178-10.74 20.76-.032 26.961l108.756 62.99c10.93 6.329 24.747 6.321 35.667-.023l108.533-63.048c10.651-6.188 10.67-20.689.032-26.9z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6fc07f__e)",
                            d: "M27.465 81.62c2.427-50.026 47.37-88.724 100.383-86.434s94.02 44.702 91.593 94.728-47.369 88.723-100.382 86.433-94.02-44.701-91.594-94.727"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6fc07f__f)",
                            d: "M-50.532 114.605c21.073-8.483 43.8-8.119 63.49-.699 39.399 14.885 62.324 5.682 78.225-31.413 7.92-18.614 23.384-34.378 44.48-42.871 42.179-16.954 90.873 1.442 108.813 41.127 17.941 39.685-1.696 85.563-43.865 102.539-21.143 8.512-43.914 8.114-63.634.627-39.335-14.806-62.217-5.568-78.098 31.571-7.94 18.57-23.4 34.28-44.472 42.764-42.146 16.966-90.84-1.43-108.77-41.093-17.931-39.663 1.686-85.585 43.831-102.552"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 61.778,
                            cy: 58.297,
                            fill: "url(#6fc07f__g)",
                            rx: 61.778,
                            ry: 58.297,
                            transform: "matrix(1 -.00132 .00148 1 78.86 -16.007)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"euSG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3be0ba__d",
                        x1: -17.213,
                        x2: 116.852,
                        y1: 82.649,
                        y2: -3.785,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3be0ba__e",
                        x1: 93.95,
                        x2: 38.201,
                        y1: 25.61,
                        y2: 89.133,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3be0ba__f",
                        x1: 21.733,
                        x2: 124.07,
                        y1: 94.229,
                        y2: 33.479,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3be0ba__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.9784 -37.0667 0 37.067 34.978)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3be0ba__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.9784 -37.0667 0 37.067 34.978)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3be0ba__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 85.2,
                            height: 80.4,
                            x: 4.199,
                            y: 10.8,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3be0ba__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M21.452 16.758h28.842c5.304 0 9.6 4.296 9.6 9.6v52.878H44.3V66.888c0-2.652-2.148-4.8-4.8-4.8h-7.254c-2.652 0-4.8 2.148-4.8 4.8v12.348H11.852V26.358c0-5.304 4.296-9.6 9.6-9.6m7.674 33.936c1.326 0 2.4-1.074 2.4-2.4v-3.456c0-1.326-1.074-2.4-2.4-2.4H25.67c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4zm0-16.836c1.326 0 2.4-1.074 2.4-2.4v-3.456c0-1.326-1.074-2.4-2.4-2.4H25.67c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4zm16.956 16.836c1.326 0 2.4-1.074 2.4-2.4v-3.456c0-1.326-1.074-2.4-2.4-2.4h-3.456c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4zm0-16.836c1.326 0 2.4-1.074 2.4-2.4v-3.456c0-1.326-1.074-2.4-2.4-2.4h-3.456c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4zm28.464-4.122c5.304 0 9.6 4.296 9.6 9.6v39.9H64.7v-49.5zm-.798 37.296c1.326 0 2.4-1.074 2.4-2.4v-3.456c0-1.326-1.074-2.4-2.4-2.4h-3.456c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4zm0-16.836c1.326 0 2.4-1.074 2.4-2.4V44.34c0-1.326-1.074-2.4-2.4-2.4h-3.456c-1.326 0-2.4 1.074-2.4 2.4v3.456c0 1.326 1.074 2.4 2.4 2.4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3be0ba__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3be0ba__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 85.2,
                            height: 80.4,
                            x: 4.199,
                            y: 10.8,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.2 10.8h85.2v80.4H4.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.067,
                            cy: 34.978,
                            fill: "url(#3be0ba__c)",
                            rx: 37.067,
                            ry: 34.978,
                            transform: "matrix(1 -.00132 .00148 1 15.254 -21.01)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3be0ba__d)",
                            d: "M36.717-3.402c-6.543-3.821-14.833-3.844-21.4-.06l-65.689 37.847c-6.433 3.707-6.444 12.456-.02 16.177l65.255 37.793c6.557 3.798 14.848 3.793 21.4-.013l65.119-37.83c6.391-3.712 6.402-12.413.02-16.14z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3be0ba__e)",
                            d: "M16.478 48.972C17.934 18.957 44.9-4.262 76.708-2.888s56.412 26.821 54.956 56.837c-1.456 30.015-28.422 53.234-60.23 51.86S15.023 78.988 16.478 48.972"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3be0ba__f)",
                            d: "M-30.32 68.763c12.644-5.09 26.28-4.872 38.094-.42 23.64 8.931 37.395 3.41 46.936-18.847 4.752-11.169 14.03-20.627 26.688-25.723 25.307-10.172 54.523.865 65.288 24.676s-1.018 51.338-26.319 61.524c-12.686 5.107-26.349 4.868-38.18.376-23.602-8.884-37.331-3.341-46.86 18.943-4.764 11.141-14.04 20.568-26.683 25.658-25.287 10.18-54.504-.858-65.262-24.656s1.012-51.351 26.299-61.531"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.067,
                            cy: 34.978,
                            fill: "url(#3be0ba__g)",
                            rx: 37.067,
                            ry: 34.978,
                            transform: "matrix(1 -.00132 .00148 1 47.316 -9.604)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1irBn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "275b76__d",
                        x1: -8.603,
                        x2: 58.43,
                        y1: 41.325,
                        y2: -1.892,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "275b76__e",
                        x1: 46.977,
                        x2: 19.103,
                        y1: 12.805,
                        y2: 44.567,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "275b76__f",
                        x1: 10.87,
                        x2: 62.039,
                        y1: 47.115,
                        y2: 16.74,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "275b76__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.4892 -18.5333 0 18.533 17.49)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "275b76__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.4892 -18.5333 0 18.533 17.49)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "275b76__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 42.6,
                            height: 40.2,
                            x: 2.102,
                            y: 5.4,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "275b76__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M10.726 8.379h14.42c2.653 0 4.8 2.148 4.8 4.8v26.439H22.15v-6.174c0-1.326-1.074-2.4-2.4-2.4h-3.627c-1.326 0-2.4 1.074-2.4 2.4v6.174H5.926v-26.44c0-2.651 2.148-4.8 4.8-4.8m3.837 16.968c.663 0 1.2-.537 1.2-1.2v-1.728c0-.663-.537-1.2-1.2-1.2h-1.728c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2zm0-8.418c.663 0 1.2-.537 1.2-1.2V14c0-.663-.537-1.2-1.2-1.2h-1.728c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2zm8.478 8.418c.663 0 1.2-.537 1.2-1.2v-1.728c0-.663-.537-1.2-1.2-1.2h-1.728c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2zm0-8.418c.663 0 1.2-.537 1.2-1.2V14c0-.663-.537-1.2-1.2-1.2h-1.728c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2zm14.232-2.061c2.652 0 4.8 2.148 4.8 4.8v19.95H32.35v-24.75zm-.4 18.648c.664 0 1.2-.537 1.2-1.2v-1.728c0-.663-.536-1.2-1.2-1.2h-1.727c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2zm0-8.418c.664 0 1.2-.537 1.2-1.2V22.17c0-.663-.536-1.2-1.2-1.2h-1.727c-.663 0-1.2.537-1.2 1.2v1.728c0 .663.537 1.2 1.2 1.2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#275b76__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#275b76__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 42.6,
                            height: 40.2,
                            x: 2.102,
                            y: 5.4,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.102 5.4h42.6v40.2h-42.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.533,
                            cy: 17.489,
                            fill: "url(#275b76__c)",
                            rx: 18.533,
                            ry: 17.489,
                            transform: "matrix(1 -.00132 .00148 1 7.629 -10.505)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#275b76__d)",
                            d: "M18.363-1.7c-3.272-1.911-7.417-1.923-10.701-.03l-32.844 18.923c-3.217 1.853-3.222 6.228-.01 8.088L7.435 44.178c3.28 1.899 7.424 1.897 10.7-.007l32.56-18.914c3.195-1.857 3.201-6.207.01-8.07z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#275b76__e)",
                            d: "M8.241 24.486C8.97 9.478 22.452-2.13 38.356-1.444s28.206 13.41 27.478 28.418-14.211 26.617-30.115 25.93S7.513 39.494 8.241 24.486"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#275b76__f)",
                            d: "M-15.156 34.383c6.322-2.546 13.14-2.436 19.047-.21 11.82 4.465 18.697 1.704 23.468-9.424 2.376-5.584 7.015-10.314 13.344-12.862 12.653-5.086 27.262.433 32.644 12.339 5.382 11.905-.509 25.669-13.16 30.761-6.343 2.554-13.174 2.434-19.09.188-11.8-4.441-18.665-1.67-23.43 9.472-2.381 5.57-7.02 10.284-13.341 12.829-12.644 5.09-27.252-.43-32.631-12.328s.506-25.676 13.15-30.765"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.533,
                            cy: 17.489,
                            fill: "url(#275b76__g)",
                            rx: 18.533,
                            ry: 17.489,
                            transform: "matrix(1 -.00132 .00148 1 23.66 -4.802)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fBDS2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Calendar);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCalendarGeneric1160Svg = require("illustration:./S2_fill_calendar_generic1_160.svg");
var _s2FillCalendarGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCalendarGeneric1160Svg);
var _s2FillCalendarGeneric196Svg = require("illustration:./S2_fill_calendar_generic1_96.svg");
var _s2FillCalendarGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCalendarGeneric196Svg);
var _s2FillCalendarGeneric148Svg = require("illustration:./S2_fill_calendar_generic1_48.svg");
var _s2FillCalendarGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCalendarGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Calendar(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCalendarGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCalendarGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCalendarGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_calendar_generic1_160.svg":"aIskh","illustration:./S2_fill_calendar_generic1_96.svg":"bUgHn","illustration:./S2_fill_calendar_generic1_48.svg":"k0ItI","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aIskh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6653d8__d",
                        x1: -23.686,
                        x2: 195.849,
                        y1: 127.603,
                        y2: -14.082,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6653d8__e",
                        x1: 158.458,
                        x2: 67.22,
                        y1: 34.24,
                        y2: 138.311,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6653d8__f",
                        x1: 40.127,
                        x2: 207.718,
                        y1: 146.558,
                        y2: 46.967,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6653d8__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 57.2532 -60.7348 0 60.735 57.253)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6653d8__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 57.2532 -60.7348 0 60.735 57.253)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "6653d8__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.603,
                            height: 131.6,
                            x: 11.398,
                            y: 10,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "6653d8__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M116 34h-7v10c0 2.21-1.79 4-4 4s-4-1.79-4-4V34H59v10c0 2.21-1.79 4-4 4s-4-1.79-4-4V34h-7c-8.84 0-16 7.16-16 16v10h104V50c0-8.84-7.16-16-16-16m-88 82c0 8.84 7.16 16 16 16h72c8.84 0 16-7.16 16-16V68H28zm73-32c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zm0 22c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zM73 84c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zm0 22c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zM45 84c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zm0 22c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4zm14-82c0-2.21-1.79-4-4-4s-4 1.79-4 4v10h8zm50 0c0-2.21-1.79-4-4-4s-4 1.79-4 4v10h8z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#6653d8__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#6653d8__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.603,
                            height: 131.6,
                            x: 11.398,
                            y: 10,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.398 10h139.603v131.6H11.398z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.735,
                            cy: 57.253,
                            fill: "url(#6653d8__c)",
                            rx: 60.735,
                            ry: 57.253,
                            transform: "matrix(1 -.00132 .00148 1 29.516 -42.068)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6653d8__d)",
                            d: "M64.68-13.246c-10.72-6.254-24.305-6.293-35.066-.1l-107.631 61.95c-10.541 6.067-10.559 20.388-.032 26.478l106.92 61.861c10.745 6.216 24.33 6.209 35.065-.022l106.7-61.919c10.471-6.077 10.49-20.318.032-26.418z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6653d8__e)",
                            d: "M31.519 72.48c2.386-49.13 46.57-87.134 98.688-84.885 52.118 2.25 92.433 43.9 90.047 93.031-2.386 49.13-46.57 87.135-98.688 84.885s-92.433-43.9-90.047-93.03"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6653d8__f)",
                            d: "M-45.162 104.875c20.717-8.331 43.06-7.974 62.417-.687 38.734 14.618 61.273 5.58 76.905-30.85 7.787-18.28 22.989-33.763 43.729-42.103 41.467-16.65 89.339 1.416 106.977 40.39 17.637 38.974-1.668 84.031-43.125 100.703-20.787 8.359-43.173 7.968-62.56.615-38.671-14.54-61.167-5.468-76.78 31.006-7.806 18.237-23.004 33.666-43.721 41.998-41.434 16.662-89.306-1.404-106.934-40.357-17.628-38.952 1.658-84.052 43.092-100.715"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.735,
                            cy: 57.253,
                            fill: "url(#6653d8__g)",
                            rx: 60.735,
                            ry: 57.253,
                            transform: "matrix(1 -.00132 .00148 1 82.043 -23.398)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bUgHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ffa5ef__d",
                        x1: -14.214,
                        x2: 117.507,
                        y1: 76.562,
                        y2: -8.449,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ffa5ef__e",
                        x1: 95.069,
                        x2: 40.327,
                        y1: 20.545,
                        y2: 82.987,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ffa5ef__f",
                        x1: 24.072,
                        x2: 124.627,
                        y1: 87.935,
                        y2: 28.18,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ffa5ef__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.3519 -36.4409 0 36.44 34.352)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ffa5ef__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.3519 -36.4409 0 36.44 34.352)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ffa5ef__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.762,
                            height: 78.96,
                            x: 6.836,
                            y: 6,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ffa5ef__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M69.597 20.4h-4.2v6c0 1.326-1.074 2.4-2.4 2.4s-2.4-1.074-2.4-2.4v-6h-25.2v6c0 1.326-1.074 2.4-2.4 2.4s-2.4-1.074-2.4-2.4v-6h-4.2c-5.304 0-9.6 4.296-9.6 9.6v6h62.4v-6c0-5.304-4.296-9.6-9.6-9.6m-52.8 49.2c0 5.304 4.296 9.6 9.6 9.6h43.2c5.304 0 9.6-4.296 9.6-9.6V40.8h-62.4zm43.8-19.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4V54c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm0 13.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4v3.6c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm-16.8-13.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4V54c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm0 13.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4v3.6c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm-16.8-13.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4V54c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm0 13.2c0-1.326 1.074-2.4 2.4-2.4h3.6c1.326 0 2.4 1.074 2.4 2.4v3.6c0 1.326-1.074 2.4-2.4 2.4h-3.6c-1.326 0-2.4-1.074-2.4-2.4zm8.4-49.2c0-1.326-1.074-2.4-2.4-2.4s-2.4 1.074-2.4 2.4v6h4.8zm30 0c0-1.326-1.074-2.4-2.4-2.4s-2.4 1.074-2.4 2.4v6h4.8z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ffa5ef__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ffa5ef__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.762,
                            height: 78.96,
                            x: 6.836,
                            y: 6,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.836 6h83.762v78.96H6.836z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.441,
                            cy: 34.352,
                            fill: "url(#ffa5ef__c)",
                            rx: 36.441,
                            ry: 34.352,
                            transform: "matrix(1 -.00132 .00148 1 17.707 -25.241)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ffa5ef__d)",
                            d: "M38.806-7.948c-6.433-3.752-14.583-3.775-21.04-.06l-64.579 37.17c-6.324 3.64-6.335 12.233-.019 15.887L17.32 82.166c6.447 3.73 14.598 3.725 21.04-.013L102.378 45c6.283-3.646 6.294-12.19.019-15.85z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ffa5ef__e)",
                            d: "M18.906 43.489c1.431-29.478 27.942-52.28 59.213-50.931 31.27 1.35 55.46 26.34 54.028 55.818s-27.942 52.281-59.213 50.931c-31.27-1.35-55.46-26.34-54.028-55.818"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ffa5ef__f)",
                            d: "M-27.101 62.925c12.43-4.999 25.836-4.785 37.45-.412 23.24 8.77 36.764 3.348 46.143-18.51C61.164 33.034 70.285 23.745 82.73 18.74c24.88-9.99 53.603.85 64.185 24.234s-1 50.418-25.874 60.422c-12.472 5.015-25.904 4.78-37.536.369-23.203-8.725-36.7-3.281-46.068 18.603-4.684 10.943-13.803 20.2-26.233 25.199-24.86 9.997-53.583-.843-64.16-24.214s.994-50.432 25.855-60.43"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.441,
                            cy: 34.352,
                            fill: "url(#ffa5ef__g)",
                            rx: 36.441,
                            ry: 34.352,
                            transform: "matrix(1 -.00132 .00148 1 49.223 -14.04)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k0ItI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4a63bb__d",
                        x1: -7.107,
                        x2: 58.753,
                        y1: 38.282,
                        y2: -4.224,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4a63bb__e",
                        x1: 47.535,
                        x2: 20.163,
                        y1: 10.272,
                        y2: 41.493,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4a63bb__f",
                        x1: 12.038,
                        x2: 62.315,
                        y1: 43.968,
                        y2: 14.091,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4a63bb__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.176 -18.2204 0 18.22 17.176)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4a63bb__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.176 -18.2204 0 18.22 17.176)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "4a63bb__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.881,
                            height: 39.48,
                            x: 3.418,
                            y: 3,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "4a63bb__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M34.798 10.2h-2.1v3c0 .663-.537 1.2-1.2 1.2s-1.2-.537-1.2-1.2v-3h-12.6v3c0 .663-.537 1.2-1.2 1.2s-1.2-.537-1.2-1.2v-3h-2.1c-2.652 0-4.8 2.148-4.8 4.8v3h31.2v-3c0-2.652-2.148-4.8-4.8-4.8m-26.4 24.6c0 2.652 2.148 4.8 4.8 4.8h21.6c2.652 0 4.8-2.148 4.8-4.8V20.4h-31.2zm21.9-9.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2V27c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm0 6.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2v1.8c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm-8.4-6.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2V27c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm0 6.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2v1.8c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm-8.4-6.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2V27c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm0 6.6c0-.663.537-1.2 1.2-1.2h1.8c.663 0 1.2.537 1.2 1.2v1.8c0 .663-.537 1.2-1.2 1.2h-1.8c-.663 0-1.2-.537-1.2-1.2zm4.2-24.6c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v3h2.4zm15 0c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v3h2.4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#4a63bb__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#4a63bb__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.881,
                            height: 39.48,
                            x: 3.418,
                            y: 3,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.418 3h41.881v39.48H3.418z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.22,
                            cy: 17.176,
                            fill: "url(#4a63bb__c)",
                            rx: 18.22,
                            ry: 17.176,
                            transform: "matrix(1 -.00132 .00148 1 8.852 -12.621)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4a63bb__d)",
                            d: "M19.403-3.973c-3.216-1.877-7.291-1.888-10.52-.03l-32.29 18.585c-3.162 1.82-3.167 6.116-.009 7.943L8.66 41.084c3.224 1.864 7.299 1.862 10.52-.007L51.19 22.5c3.141-1.823 3.147-6.095.01-7.925z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4a63bb__e)",
                            d: "M9.453 21.744c.716-14.74 13.97-26.14 29.606-25.466 15.636.675 27.73 13.17 27.015 27.91-.716 14.739-13.972 26.14-29.607 25.465S8.737 36.483 9.453 21.744"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4a63bb__f)",
                            d: "M-13.549 31.463c6.215-2.5 12.918-2.392 18.725-.206 11.62 4.385 18.382 1.674 23.072-9.255 2.336-5.484 6.897-10.129 13.119-12.631 12.44-4.995 26.801.425 32.093 12.117 5.291 11.692-.5 25.21-12.938 30.21-6.236 2.509-12.951 2.391-18.768.185-11.601-4.362-18.35-1.64-23.033 9.302-2.342 5.471-6.902 10.1-13.117 12.6-12.43 4.998-26.792-.422-32.08-12.107-5.289-11.686.497-25.216 12.927-30.215"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.22,
                            cy: 17.176,
                            fill: "url(#4a63bb__g)",
                            rx: 18.22,
                            ry: 17.176,
                            transform: "matrix(1 -.00132 .00148 1 24.613 -7.02)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6lgV2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Camera);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCameraGeneric1160Svg = require("illustration:./S2_fill_camera_generic1_160.svg");
var _s2FillCameraGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCameraGeneric1160Svg);
var _s2FillCameraGeneric196Svg = require("illustration:./S2_fill_camera_generic1_96.svg");
var _s2FillCameraGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCameraGeneric196Svg);
var _s2FillCameraGeneric148Svg = require("illustration:./S2_fill_camera_generic1_48.svg");
var _s2FillCameraGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCameraGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Camera(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCameraGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCameraGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCameraGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_camera_generic1_160.svg":"9s15V","illustration:./S2_fill_camera_generic1_96.svg":"aceyn","illustration:./S2_fill_camera_generic1_48.svg":"2l01x","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9s15V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2e84a6__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2e84a6__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2e84a6__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2e84a6__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2e84a6__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "2e84a6__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "2e84a6__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M105.002 44H54.998l6.472-10.36C63.66 30.13 67.51 28 71.65 28h16.7c4.14 0 7.98 2.13 10.18 5.64zM36 52h88c8.837 0 16 7.163 16 16v48c0 8.837-7.163 16-16 16H36c-8.837 0-16-7.163-16-16V68c0-8.837 7.163-16 16-16m1.5 23c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6M80 116c13.255 0 24-10.745 24-24S93.255 68 80 68 56 78.745 56 92s10.745 24 24 24"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#2e84a6__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#2e84a6__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#2e84a6__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2e84a6__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2e84a6__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2e84a6__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#2e84a6__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aceyn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "213500__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "213500__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "213500__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "213500__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "213500__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "213500__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "213500__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M63.001 26.4H33l3.883-6.216c1.314-2.106 3.624-3.384 6.108-3.384h10.02c2.484 0 4.788 1.278 6.108 3.384zM21.6 31.2h52.8c5.302 0 9.6 4.298 9.6 9.6v28.8c0 5.302-4.298 9.6-9.6 9.6H21.6c-5.302 0-9.6-4.298-9.6-9.6V40.8c0-5.302 4.298-9.6 9.6-9.6m.9 13.8c1.988 0 3.6-1.612 3.6-3.6s-1.612-3.6-3.6-3.6-3.6 1.612-3.6 3.6 1.612 3.6 3.6 3.6M48 69.6c7.953 0 14.4-6.447 14.4-14.4S55.953 40.8 48 40.8s-14.4 6.447-14.4 14.4S40.047 69.6 48 69.6"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#213500__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#213500__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#213500__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#213500__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#213500__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#213500__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#213500__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2l01x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41b4b1__d",
                        x1: -3.945,
                        x2: 55.309,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41b4b1__e",
                        x1: 45.217,
                        x2: 20.591,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41b4b1__f",
                        x1: 13.277,
                        x2: 58.511,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "41b4b1__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "41b4b1__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "41b4b1__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.523,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "41b4b1__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M31.5 13.2h-15l1.941-3.108C19.098 9.04 20.253 8.4 21.495 8.4h5.01c1.242 0 2.394.64 3.054 1.692zm-20.7 2.4h26.4c2.651 0 4.8 2.15 4.8 4.8v14.4c0 2.652-2.149 4.8-4.8 4.8H10.8c-2.651 0-4.8-2.148-4.8-4.8V20.4c0-2.65 2.149-4.8 4.8-4.8m.45 6.9c.994 0 1.8-.805 1.8-1.8 0-.994-.806-1.8-1.8-1.8s-1.8.806-1.8 1.8c0 .995.806 1.8 1.8 1.8M24 34.8c3.977 0 7.2-3.223 7.2-7.2 0-3.976-3.223-7.2-7.2-7.2s-7.2 3.224-7.2 7.2 3.223 7.2 7.2 7.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#41b4b1__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#41b4b1__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.523,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.523 6.96h37.68v35.52H5.523z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#41b4b1__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.414 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41b4b1__d)",
                            d: "M19.906.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.566 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41b4b1__e)",
                            d: "M10.955 23.824C11.6 10.564 23.525.306 37.592.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41b4b1__f)",
                            d: "M-9.743 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.454 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.653 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336-11.184 4.497-24.105-.38-28.863-10.893s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#41b4b1__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.59 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3XLkp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CardTapPayment);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCardTapPaymentGeneric1160Svg = require("illustration:./S2_fill_cardTapPayment_generic1_160.svg");
var _s2FillCardTapPaymentGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCardTapPaymentGeneric1160Svg);
var _s2FillCardTapPaymentGeneric196Svg = require("illustration:./S2_fill_cardTapPayment_generic1_96.svg");
var _s2FillCardTapPaymentGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCardTapPaymentGeneric196Svg);
var _s2FillCardTapPaymentGeneric148Svg = require("illustration:./S2_fill_cardTapPayment_generic1_48.svg");
var _s2FillCardTapPaymentGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCardTapPaymentGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function CardTapPayment(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCardTapPaymentGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCardTapPaymentGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCardTapPaymentGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_cardTapPayment_generic1_160.svg":"aekpV","illustration:./S2_fill_cardTapPayment_generic1_96.svg":"bcoax","illustration:./S2_fill_cardTapPayment_generic1_48.svg":"3TcbW","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aekpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2fc2be__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2fc2be__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2fc2be__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2fc2be__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2fc2be__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "2fc2be__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "2fc2be__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M112.544 26.78c.267-2.193 2.262-3.753 4.455-3.485 11.158 1.362 21.579 7.773 27.64 18.27 6.11 10.582 6.406 22.927 1.893 33.325-.879 2.026-3.235 2.956-5.262 2.076s-2.956-3.235-2.076-5.261c3.547-8.173 3.306-17.845-1.483-26.14-4.751-8.229-12.912-13.258-21.682-14.33-2.193-.267-3.753-2.262-3.485-4.455m-1.254 13.945c.267-2.193 2.262-3.753 4.455-3.486 6.857.838 13.268 4.779 16.995 11.234 3.757 6.509 3.938 14.102 1.164 20.491-.879 2.026-3.235 2.956-5.262 2.077-2.026-.88-2.956-3.236-2.076-5.262 1.807-4.165 1.682-9.085-.754-13.306-2.418-4.186-6.568-6.747-11.037-7.292-2.193-.268-3.753-2.263-3.485-4.456M18.393 74.417C10.741 78.835 8.12 88.62 12.537 96.273l.42.729 90.245-52.14-.405-.7c-4.418-7.653-14.203-10.275-21.856-5.857zm88.809-22.627-90.244 52.14 14.32 24.804c4.419 7.653 14.204 10.275 21.857 5.857l62.547-36.112c7.653-4.419 10.275-14.204 5.857-21.857zm-76.773 56.311c-1.104-1.914-.449-4.36 1.464-5.465l32.38-18.697c1.913-1.104 4.36-.449 5.465 1.464s.449 4.36-1.464 5.464l-32.38 18.697c-1.914 1.105-4.36.45-5.465-1.463m8.476 6.68c-1.913 1.105-2.569 3.551-1.464 5.464s3.551 2.569 5.464 1.464l16.19-9.349c1.913-1.104 2.569-3.551 1.464-5.464s-3.55-2.568-5.464-1.464zm43.14-36.48c-1.104-1.912-.449-4.359 1.464-5.463l15.18-8.766c1.914-1.105 4.36-.45 5.465 1.464s.449 4.36-1.464 5.464l-15.18 8.766c-1.913 1.104-4.36.449-5.464-1.464"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#2fc2be__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#2fc2be__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#2fc2be__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2fc2be__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2fc2be__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2fc2be__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#2fc2be__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bcoax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "112f9f__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "112f9f__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "112f9f__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "112f9f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "112f9f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "112f9f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "112f9f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M68.322 15.752c.134-1.097 1.132-1.877 2.228-1.743 6.553.8 12.672 4.565 16.23 10.728 3.588 6.214 3.763 13.463 1.112 19.57-.44 1.012-1.617 1.477-2.63 1.038-1.014-.44-1.479-1.618-1.039-2.631 2.168-4.994 2.02-10.906-.906-15.977-2.904-5.029-7.893-8.103-13.252-8.757-1.096-.134-1.876-1.132-1.743-2.228m-.75 8.334c.135-1.096 1.132-1.877 2.228-1.743 3.982.486 7.704 2.775 9.868 6.523 2.181 3.778 2.286 8.186.676 11.897-.44 1.013-1.618 1.478-2.631 1.038s-1.478-1.618-1.038-2.63c1.127-2.6 1.05-5.67-.471-8.305-1.51-2.614-4.1-4.212-6.888-4.552-1.097-.134-1.877-1.132-1.743-2.228m-57.27 20.878c-3.826 2.209-5.137 7.102-2.928 10.928l1.211 2.098 53.978-31.106-1.236-2.142c-2.21-3.826-7.102-5.137-10.928-2.928zm54.261-14.616L10.585 61.454l9.555 16.55c2.21 3.827 7.102 5.138 10.929 2.928l40.096-23.15c3.827-2.208 5.138-7.101 2.928-10.928zM19.19 64.122c-.553-.956-.225-2.18.732-2.732l19.355-11.176c.956-.553 2.18-.225 2.732.732.552.956.225 2.18-.732 2.732L21.922 64.854c-.957.552-2.18.225-2.732-.732m4.923 4.526c-.956.552-1.284 1.775-.732 2.732.552.956 1.776 1.284 2.732.732l9.678-5.588c.956-.553 1.284-1.776.732-2.732-.553-.957-1.776-1.285-2.732-.732zm25.93-22.338c-.552-.957-.224-2.18.732-2.733l9.074-5.24c.957-.552 2.18-.224 2.732.733.553.956.225 2.18-.732 2.732l-9.074 5.24c-.956.552-2.18.224-2.732-.733"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#112f9f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#112f9f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#112f9f__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#112f9f__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#112f9f__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#112f9f__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#112f9f__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3TcbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd36c4__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd36c4__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd36c4__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "cd36c4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "cd36c4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "cd36c4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "cd36c4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M34.79 7.126c.083-.685.707-1.173 1.392-1.09 3.351.41 6.481 2.335 8.301 5.488 1.836 3.179 1.925 6.886.57 10.009-.276.633-1.012.924-1.645.649s-.924-1.011-.65-1.644c1.054-2.428.983-5.3-.44-7.764-1.41-2.444-3.834-3.938-6.439-4.256-.685-.083-1.173-.707-1.09-1.392m-1.133 4.606c.084-.685.707-1.172 1.393-1.089 2.065.252 3.997 1.44 5.12 3.385 1.132 1.96 1.186 4.248.35 6.173-.274.633-1.01.923-1.644.649-.633-.275-.924-1.012-.649-1.645.534-1.23.497-2.682-.222-3.927-.714-1.236-1.939-1.992-3.258-2.153-.686-.084-1.173-.707-1.09-1.393M5.27 22.2c-1.913 1.104-2.568 3.55-1.464 5.464l.485.84 26.985-15.56-.493-.855c-1.105-1.913-3.551-2.569-5.465-1.464zm27.256-7.09L5.541 30.67l4.648 8.05c1.105 1.913 3.551 2.569 5.464 1.464l20.049-11.575c1.913-1.105 2.569-3.55 1.464-5.464zM10.58 31.923c-.346-.598-.14-1.362.457-1.707l9.468-5.467c.598-.346 1.363-.14 1.708.457.345.598.14 1.362-.458 1.708l-9.468 5.467c-.598.345-1.362.14-1.707-.458m2.88 2.49c-.598.345-.802 1.11-.457 1.708s1.11.802 1.707.457l4.84-2.794c.597-.345.802-1.11.457-1.708s-1.11-.802-1.708-.457zm10.922-10.458c-.345-.598-.14-1.363.458-1.708l4.537-2.62c.598-.345 1.362-.14 1.707.458.346.598.14 1.362-.457 1.707l-4.537 2.62c-.598.345-1.362.14-1.708-.457"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#cd36c4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#cd36c4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#cd36c4__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd36c4__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd36c4__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd36c4__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#cd36c4__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hhqlq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Channel);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillChannelGeneric1160Svg = require("illustration:./S2_fill_channel_generic1_160.svg");
var _s2FillChannelGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillChannelGeneric1160Svg);
var _s2FillChannelGeneric196Svg = require("illustration:./S2_fill_channel_generic1_96.svg");
var _s2FillChannelGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillChannelGeneric196Svg);
var _s2FillChannelGeneric148Svg = require("illustration:./S2_fill_channel_generic1_48.svg");
var _s2FillChannelGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillChannelGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Channel(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChannelGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChannelGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChannelGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_channel_generic1_160.svg":"ata7q","illustration:./S2_fill_channel_generic1_96.svg":"72W03","illustration:./S2_fill_channel_generic1_48.svg":"g1GJw","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ata7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dd25c5__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dd25c5__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dd25c5__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "dd25c5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "dd25c5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "dd25c5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "dd25c5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M56.933 48.045h.008l8.451 14.638c-3.96 3.344-6.758 8.02-7.704 13.337H40.805c-1.38-2.402-3.972-4.02-6.942-4.02-4.418 0-8 3.582-8 8s3.582 8 8 8c2.953 0 5.532-1.6 6.918-3.98h16.907c.945 5.318 3.744 9.995 7.704 13.34l-8.428 14.596h-.03c-4.42 0-8 3.582-8 8s3.58 8 8 8c4.417 0 8-3.582 8-8 0-1.446-.385-2.803-1.056-3.974l8.439-14.617c2.405.868 5 1.342 7.705 1.342s5.3-.474 7.705-1.342l8.418 14.582c-.684 1.179-1.075 2.548-1.075 4.009 0 4.418 3.582 8 8 8s8-3.582 8-8c0-4.415-3.577-7.995-7.991-8L94.652 97.36c3.96-3.345 6.758-8.022 7.704-13.34h16.865c1.386 2.38 3.966 3.98 6.918 3.98 4.418 0 8-3.582 8-8s-3.582-8-8-8c-2.969 0-5.561 1.618-6.941 4.02h-16.842c-.946-5.317-3.745-9.993-7.705-13.337l8.451-14.638c4.404-.018 7.968-3.593 7.968-8 0-4.418-3.582-8-8-8s-8 3.582-8 8c0 1.47.396 2.846 1.087 4.03l-8.431 14.603c-2.405-.869-5-1.342-7.704-1.342-2.705 0-5.3.473-7.705 1.342L63.866 44.04c.679-1.176 1.067-2.54 1.067-3.995 0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#dd25c5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#dd25c5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#dd25c5__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dd25c5__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dd25c5__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dd25c5__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#dd25c5__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"72W03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0e6198__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0e6198__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0e6198__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0e6198__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0e6198__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0e6198__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0e6198__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M33.62 28.094q.283 0 .558-.031l5.338 9.245c-2.654 2.108-4.504 5.183-5.02 8.692H23.822c-.771-1.766-2.533-3-4.584-3-2.761 0-5 2.239-5 5s2.239 5 5 5c2.05 0 3.813-1.234 4.584-3h10.675c.515 3.509 2.366 6.584 5.02 8.691l-5.339 9.246q-.275-.03-.559-.03c-2.761 0-5 2.238-5 5 0 2.76 2.239 5 5 5s5-2.24 5-5c0-1.113-.363-2.14-.977-2.97l5.337-9.243c1.553.615 3.247.953 5.02.953s3.466-.338 5.02-.953l5.337 9.243c-.614.83-.977 1.858-.977 2.97 0 2.76 2.239 5 5 5s5-2.24 5-5c0-2.762-2.238-5-5-5q-.283 0-.56.03l-5.337-9.245c2.653-2.108 4.504-5.183 5.02-8.692h10.674c.771 1.766 2.533 3 4.584 3 2.761 0 5-2.239 5-5s-2.239-5-5-5c-2.05 0-3.813 1.234-4.584 3H61.5c-.515-3.51-2.365-6.584-5.019-8.692l5.338-9.245q.276.03.56.03c2.76 0 5-2.238 5-5 0-2.76-2.24-5-5-5-2.762 0-5 2.24-5 5 0 1.112.362 2.14.976 2.97l-5.336 9.242c-1.554-.615-3.248-.953-5.021-.953s-3.467.338-5.02.953l-5.337-9.242c.614-.83.977-1.857.977-2.97 0-2.76-2.238-5-5-5s-5 2.24-5 5c0 2.762 2.239 5 5 5"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0e6198__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0e6198__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#0e6198__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0e6198__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0e6198__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0e6198__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#0e6198__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g1GJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e1c481__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e1c481__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e1c481__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e1c481__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e1c481__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "e1c481__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "e1c481__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M14.312 11.547c0 1.38 1.119 2.5 2.5 2.5l2.625 4.548c-1.233 1.042-2.105 2.499-2.4 4.155h-5.25c-.433-.747-1.24-1.25-2.166-1.25-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5c.925 0 1.733-.503 2.166-1.25h5.25c.296 1.656 1.167 3.113 2.4 4.155l-2.626 4.548c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5c1.381 0 2.5-1.12 2.5-2.5 0-.455-.121-.883-.334-1.25l2.625-4.547c.749.27 1.557.418 2.4.418.842 0 1.65-.148 2.4-.418l2.624 4.547c-.212.368-.334.795-.334 1.25 0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5l-2.627-4.549c1.233-1.042 2.105-2.498 2.4-4.154h5.251c.433.747 1.24 1.25 2.166 1.25 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5c-.925 0-1.733.503-2.166 1.25h-5.25c-.296-1.656-1.168-3.113-2.4-4.155l2.625-4.548c1.382 0 2.5-1.12 2.5-2.5s-1.118-2.5-2.5-2.5c-1.38 0-2.5 1.12-2.5 2.5 0 .455.123.882.335 1.25l-2.625 4.546c-.749-.27-1.557-.417-2.4-.417-.842 0-1.65.147-2.4.417l-2.624-4.546c.213-.367.334-.795.334-1.25 0-1.38-1.119-2.5-2.5-2.5-1.38 0-2.5 1.12-2.5 2.5"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#e1c481__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#e1c481__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#e1c481__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e1c481__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e1c481__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e1c481__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#e1c481__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6SKjY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChartAreaStack);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillChartAreaStackGeneric1160Svg = require("illustration:./S2_fill_chartAreaStack_generic1_160.svg");
var _s2FillChartAreaStackGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillChartAreaStackGeneric1160Svg);
var _s2FillChartAreaStackGeneric196Svg = require("illustration:./S2_fill_chartAreaStack_generic1_96.svg");
var _s2FillChartAreaStackGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillChartAreaStackGeneric196Svg);
var _s2FillChartAreaStackGeneric148Svg = require("illustration:./S2_fill_chartAreaStack_generic1_48.svg");
var _s2FillChartAreaStackGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillChartAreaStackGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function ChartAreaStack(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChartAreaStackGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChartAreaStackGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChartAreaStackGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_chartAreaStack_generic1_160.svg":"lyh4J","illustration:./S2_fill_chartAreaStack_generic1_96.svg":"1nDGw","illustration:./S2_fill_chartAreaStack_generic1_48.svg":"lsYaV","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lyh4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c1c14__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c1c14__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9c1c14__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9c1c14__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9c1c14__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "9c1c14__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "9c1c14__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#8F8F8F",
                    fillRule: "evenodd",
                    d: "M120.637 37.144c3.993-7.24 15.006-4.405 15.006 3.863v82.712c0 6.628-5.373 12-12 12H36c-6.627 0-12-5.372-12-12V79.994c0-2.203.908-4.308 2.51-5.82L43.543 58.11c3.313-3.124 8.56-2.858 11.54.585l12.31 14.228 16.1-24.9c2.946-4.558 9.477-4.921 12.912-.72l11.126 13.611zl3.503 1.932.039.021m-.039-.021-3.503-1.932Zm3.503 1.931-13.108 23.77c-2.734 4.96-9.615 5.585-13.199 1.2L90.21 52.366l-16.1 24.9c-2.896 4.478-9.28 4.924-12.768.891L49.032 63.93 32 79.994v24.14l16.119-10.386c2.48-1.598 5.696-1.469 8.04.322L72.429 106.5l19.93-23.184c2.655-3.09 7.377-3.267 10.258-.387l14.209 14.21 10.818-5.187zm0 59.816-9.914 4.753c-1.53.734-3.357.422-4.557-.778l-15.45-15.45-19.535 22.724c-2.59 3.013-7.082 3.483-10.24 1.07L51.86 100.854 32 113.651v10.068c0 2.21 1.79 4 4 4h87.643c2.209 0 4-1.79 4-4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#9c1c14__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#9c1c14__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#9c1c14__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c1c14__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c1c14__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9c1c14__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#9c1c14__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1nDGw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a2451c__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a2451c__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a2451c__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a2451c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a2451c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a2451c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "a2451c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#8F8F8F",
                    fillRule: "evenodd",
                    d: "M71.905 23.235c2.151-3.895 8.094-2.38 8.094 2.083v47.806c0 3.661-2.972 6.624-6.631 6.624H22.63c-3.66 0-6.631-2.963-6.631-6.624V47.852c0-1.188.49-2.323 1.356-3.138l9.86-9.285c1.785-1.682 4.615-1.54 6.222.315l7.126 8.224c.138.159.392.14.506-.035l9.32-14.392c1.59-2.455 5.111-2.65 6.964-.388l6.44 7.867c.143.174.416.147.523-.047zm3.644 1.786c-.026.01-.08.034-.143.148L67.82 38.907l-1.751-.967 1.75.967c-1.475 2.673-5.185 3.008-7.118.647l-6.441-7.867c-.136-.166-.396-.15-.511.028l-9.32 14.392c-1.563 2.413-5.005 2.652-6.887.48l-7.126-8.223c-.117-.136-.326-.147-.457-.023l-9.86 9.285-1.336-1.419 1.336 1.42c-.063.058-.098.14-.098.225v14.527l9.075-5.837c1.77-1.14 4.064-1.047 5.737.229l7.829 5.971c.631.482 1.528.388 2.046-.214l9.924-11.525c1.896-2.203 5.265-2.33 7.322-.276l7.423 7.411 6.643-3.18v-29.64c0-.13-.035-.176-.052-.196-.03-.036-.09-.082-.184-.106-.093-.024-.17-.013-.214.005M76 59.393l-6.192 2.964c-.764.366-1.677.21-2.277-.389l-8.424-8.41c-.411-.41-1.085-.386-1.464.055l-9.924 11.525c-1.899 2.206-5.188 2.55-7.503.785l-7.829-5.972c-.334-.255-.793-.273-1.147-.045L20 67.136v5.988c0 1.446 1.175 2.624 2.631 2.624h50.737c1.456 0 2.631-1.178 2.631-2.624z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a2451c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#a2451c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#a2451c__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a2451c__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a2451c__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a2451c__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#a2451c__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lsYaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b8d90__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.894,
                        y2: -4.584,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b8d90__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.841,
                        y2: 44.839,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5b8d90__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.808,
                        y2: 16.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5b8d90__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5b8d90__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5b8d90__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5b8d90__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#8F8F8F",
                    fillRule: "evenodd",
                    d: "M35.743 11.242c1.195-2.164 4.497-1.323 4.497 1.157v23.697c0 1.958-1.59 3.542-3.545 3.542h-25.15C9.59 39.638 8 38.054 8 36.096V23.569c0-.66.273-1.291.753-1.744l4.887-4.602c.993-.935 2.565-.855 3.458.175l3.444 3.974 4.546-7.02c.883-1.364 2.84-1.473 3.869-.216l3.098 3.784zM20.468 21.486Zm17.272-8.69-3.57 6.464-1.094-.604 1.094.604c-.82 1.485-2.88 1.671-3.955.36l-3.104-3.792-4.545 7.017c-.868 1.34-2.78 1.473-3.825.266l-3.463-3.996-4.778 4.5v6.68l4.1-2.637c.969-.623 2.224-.573 3.14.126l3.88 2.96c.205.156.495.125.662-.07l4.92-5.712c1.037-1.206 2.881-1.275 4.007-.151l3.55 3.544 2.981-1.427zm0 16.904-2.699 1.292c-.478.229-1.048.131-1.423-.243l-4.175-4.169c-.098-.097-.258-.091-.347.013l-4.92 5.713c-1.03 1.197-2.815 1.384-4.071.426l-3.88-2.96c-.08-.06-.189-.065-.273-.01L10.5 33.267v2.828c0 .573.466 1.042 1.046 1.042h25.149c.579 0 1.045-.469 1.045-1.042zm-27.273-6.055-.072-.076zm16.72-7.934-.086-.055z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5b8d90__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5b8d90__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0-.001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.861,
                            r: 20.883,
                            fill: "url(#5b8d90__c)",
                            transform: "rotate(-.08 27.142 1.861)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b8d90__d)",
                            d: "M18.321-8.48c-3.686-2.28-8.357-2.295-12.057-.036L-30.743 14.08c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.3c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b8d90__e)",
                            d: "M6.916 22.788C7.736 4.868 22.93-8.993 40.85-8.172S72.63 7.84 71.809 25.758c-.82 17.92-16.012 31.782-33.931 30.962-17.92-.82-31.782-16.013-30.962-33.933"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5b8d90__f)",
                            d: "M-19.448 34.604c7.124-3.039 14.806-2.908 21.462-.25C15.332 39.686 23.08 36.389 28.456 23.1c2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.671,
                            r: 20.883,
                            fill: "url(#5b8d90__g)",
                            transform: "rotate(-.08 45.2 8.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"94wVJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chatbubble);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillChatbubbleGeneric1160Svg = require("illustration:./S2_fill_chatbubble_generic1_160.svg");
var _s2FillChatbubbleGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillChatbubbleGeneric1160Svg);
var _s2FillChatbubbleGeneric196Svg = require("illustration:./S2_fill_chatbubble_generic1_96.svg");
var _s2FillChatbubbleGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillChatbubbleGeneric196Svg);
var _s2FillChatbubbleGeneric148Svg = require("illustration:./S2_fill_chatbubble_generic1_48.svg");
var _s2FillChatbubbleGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillChatbubbleGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Chatbubble(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChatbubbleGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChatbubbleGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillChatbubbleGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_chatbubble_generic1_160.svg":"aVJU8","illustration:./S2_fill_chatbubble_generic1_96.svg":"8OC1y","illustration:./S2_fill_chatbubble_generic1_48.svg":"hfEGX","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aVJU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2ef790__d",
                        x1: -24.537,
                        x2: 201.681,
                        y1: 134.772,
                        y2: -2.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2ef790__e",
                        x1: 157.003,
                        x2: 59.956,
                        y1: 36.058,
                        y2: 140.411,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2ef790__f",
                        x1: 39.065,
                        x2: 211.102,
                        y1: 154.813,
                        y2: 58.44,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2ef790__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.639 52.464)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2ef790__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.948 88.515)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "2ef790__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "2ef790__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M119.641 35.937H40.362c-6.913 0-12.518 5.228-12.518 11.677v41.442c0 6.45 5.605 11.678 12.518 11.678h11.21c.025 5.51-.021 13.396-.068 19.402-.026 3.349 4.194 5.161 6.906 2.967l27.66-22.369h33.571c6.914 0 12.518-5.228 12.518-11.678V47.614c0-6.45-5.604-11.677-12.518-11.677"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#2ef790__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#2ef790__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.43 10.429h139.142V149.57H10.43z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.103,
                            cy: 15.826,
                            r: 60.534,
                            fill: "url(#2ef790__c)",
                            transform: "rotate(-.08 89.103 15.826)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2ef790__d)",
                            d: "M63.539-14.15c-10.686-6.612-24.225-6.653-34.95-.104L-78.689 51.244C-89.194 57.66-89.212 72.8-78.72 79.24l106.568 65.406c10.71 6.572 24.248 6.564 34.949-.023l106.347-65.468c10.437-6.425 10.456-21.483.032-27.932z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2ef790__e)",
                            d: "M30.483 76.49c2.378-51.946 46.417-92.128 98.362-89.75 51.946 2.378 92.128 46.417 89.75 98.362-2.378 51.946-46.416 92.128-98.362 89.75s-92.128-46.416-89.75-98.362"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2ef790__f)",
                            d: "M-45.943 110.741c20.649-8.809 42.918-8.432 62.211-.727 38.607 15.456 61.07 5.9 76.651-32.618 7.761-19.328 22.913-35.697 43.585-44.516 41.33-17.604 89.044 1.497 106.623 42.705s-1.662 88.847-42.982 106.474c-20.718 8.839-43.03 8.425-62.353.65-38.544-15.373-60.965-5.781-76.526 32.784-7.78 19.282-22.93 35.595-43.578 44.404-41.297 17.617-89.01-1.485-106.58-42.669-17.57-41.185 1.652-88.87 42.95-106.487"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.463,
                            cy: 35.567,
                            r: 60.534,
                            fill: "url(#2ef790__g)",
                            transform: "rotate(-.08 141.463 35.567)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8OC1y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "123cbc__d",
                        x1: -14.724,
                        x2: 121.006,
                        y1: 80.862,
                        y2: -1.715,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "123cbc__e",
                        x1: 94.203,
                        x2: 35.974,
                        y1: 21.634,
                        y2: 84.246,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "123cbc__f",
                        x1: 23.438,
                        x2: 126.661,
                        y1: 92.887,
                        y2: 35.063,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "123cbc__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.983 31.478)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "123cbc__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.768 53.107)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "123cbc__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.257,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "123cbc__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M71.781 21.562H24.214c-4.148 0-7.51 3.136-7.51 7.006v24.865c0 3.87 3.362 7.007 7.51 7.007h6.727c.014 3.306-.014 8.038-.042 11.641-.015 2.01 2.516 3.097 4.144 1.78l16.596-13.42H71.78c4.149 0 7.511-3.138 7.511-7.008V28.568c0-3.87-3.362-7.007-7.51-7.007"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#123cbc__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#123cbc__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.257,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.258 6.257h83.485v83.485H6.258z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.461,
                            cy: 9.495,
                            r: 36.321,
                            fill: "url(#123cbc__c)",
                            transform: "rotate(-.08 53.461 9.495)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#123cbc__d)",
                            d: "M38.121-8.49c-6.412-3.968-14.535-3.992-20.97-.063l-64.366 39.3c-6.304 3.848-6.314 12.933-.02 16.797l63.941 39.244c6.426 3.943 14.55 3.938 20.97-.015l63.808-39.28c6.262-3.855 6.274-12.89.019-16.76z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#123cbc__e)",
                            d: "M18.29 45.893c1.428-31.167 27.85-55.277 59.018-53.85s55.277 27.85 53.85 59.018-27.85 55.276-59.017 53.849c-31.168-1.426-55.277-27.85-53.85-59.017"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#123cbc__f)",
                            d: "M-27.566 66.444c12.389-5.286 25.75-5.059 37.326-.436 23.164 9.274 36.642 3.54 45.99-19.57 4.657-11.598 13.749-21.42 26.152-26.71 24.798-10.563 53.426.898 63.974 25.623 10.547 24.724-.998 53.307-25.79 63.884-12.43 5.303-25.818 5.055-37.412.39-23.126-9.224-36.579-3.469-45.915 19.67C32.09 140.864 23 150.652 10.612 155.937c-24.778 10.571-53.406-.89-63.948-25.601s.991-53.322 25.77-63.892"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.875,
                            cy: 21.339,
                            r: 36.321,
                            fill: "url(#123cbc__g)",
                            transform: "rotate(-.08 84.875 21.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hfEGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3b4374__d",
                        x1: -7.36,
                        x2: 60.505,
                        y1: 40.432,
                        y2: -0.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3b4374__e",
                        x1: 47.099,
                        x2: 17.985,
                        y1: 10.818,
                        y2: 42.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3b4374__f",
                        x1: 11.721,
                        x2: 63.332,
                        y1: 46.444,
                        y2: 17.532,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3b4374__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.992 15.74)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3b4374__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.885 26.555)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3b4374__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3b4374__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M35.89 10.781H12.108c-2.074 0-3.755 1.569-3.755 3.504v12.432c0 1.935 1.681 3.504 3.755 3.504h3.363c.008 1.653-.006 4.018-.02 5.82-.008 1.005 1.258 1.548 2.072.89l8.297-6.71h10.072c2.074 0 3.755-1.569 3.755-3.504V14.285c0-1.935-1.681-3.504-3.755-3.504"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3b4374__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3b4374__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.129 3.129H44.87V44.87H3.129z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.733,
                            cy: 4.748,
                            r: 18.16,
                            fill: "url(#3b4374__c)",
                            transform: "rotate(-.08 26.733 4.748)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3b4374__d)",
                            d: "M19.062-4.245c-3.205-1.984-7.267-1.996-10.485-.031l-32.183 19.65c-3.151 1.924-3.157 6.466-.01 8.398L8.356 43.394c3.213 1.972 7.275 1.97 10.485-.007l31.904-19.64c3.131-1.928 3.137-6.445.01-8.38z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3b4374__e)",
                            d: "M9.143 22.948C9.857 7.364 23.068-4.691 38.652-3.977S66.29 9.948 65.577 25.53c-.713 15.584-13.925 27.639-29.509 26.925S8.43 38.531 9.143 22.948"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3b4374__f)",
                            d: "M-13.781 33.222c6.194-2.642 12.875-2.529 18.663-.218 11.582 4.637 18.321 1.77 22.995-9.785 2.329-5.798 6.874-10.71 13.076-13.355 12.399-5.281 26.713.45 31.987 12.812S72.44 49.33 60.045 54.618c-6.215 2.651-12.909 2.527-18.706.195-11.563-4.612-18.29-1.734-22.958 9.835-2.334 5.785-6.878 10.679-13.073 13.321-12.389 5.285-26.703-.445-31.974-12.8s.496-26.661 12.885-31.947"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.44,
                            cy: 10.67,
                            r: 18.16,
                            fill: "url(#3b4374__g)",
                            transform: "rotate(-.08 42.44 10.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3d7wX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Clipboard);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillClipboardGeneric1160Svg = require("illustration:./S2_fill_clipboard_generic1_160.svg");
var _s2FillClipboardGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillClipboardGeneric1160Svg);
var _s2FillClipboardGeneric196Svg = require("illustration:./S2_fill_clipboard_generic1_96.svg");
var _s2FillClipboardGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillClipboardGeneric196Svg);
var _s2FillClipboardGeneric148Svg = require("illustration:./S2_fill_clipboard_generic1_48.svg");
var _s2FillClipboardGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillClipboardGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Clipboard(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClipboardGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClipboardGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClipboardGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_clipboard_generic1_160.svg":"OCti8","illustration:./S2_fill_clipboard_generic1_96.svg":"3gAz7","illustration:./S2_fill_clipboard_generic1_48.svg":"g4NWi","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"OCti8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "095ebc__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "095ebc__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "095ebc__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "095ebc__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "095ebc__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "095ebc__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "095ebc__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M55 40h-8.59C39.555 40 34 45.617 34 52.545v66.91C34 126.383 39.556 132 46.41 132h66.181c6.853 0 12.409-5.617 12.409-12.545v-66.91C125 45.617 119.444 40 112.591 40h-9.592l.001.029-.02 16c-.001 1.06-.423 2.077-1.175 2.827-.751.749-1.768 1.17-2.83 1.168l-40-.048c-2.208-.003-3.997-1.796-3.995-4.005zm7.985 11.98.01-8 4 .006c2.209.002 4.002-1.786 4.005-3.996l.004-4c.006-4.418 3.592-7.995 8.01-7.99s7.996 3.591 7.99 8.01l-.004 4c-.003 2.209 1.786 4.002 3.995 4.004l4 .005-.01 8z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#095ebc__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#095ebc__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#095ebc__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#095ebc__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#095ebc__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#095ebc__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#095ebc__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3gAz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8f7e16__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8f7e16__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8f7e16__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8f7e16__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8f7e16__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8f7e16__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8f7e16__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M32.999 24h-5.155c-4.112 0-7.446 3.37-7.446 7.527v40.146c0 4.157 3.334 7.527 7.446 7.527h39.709c4.112 0 7.445-3.37 7.445-7.528V31.527c0-4.157-3.333-7.527-7.445-7.527h-5.754v.017l-.012 9.6c0 .637-.254 1.247-.705 1.696-.45.45-1.061.702-1.698.701l-24-.029c-1.325-.001-2.398-1.077-2.397-2.402zm4.791 7.188.006-4.8 2.4.003c1.325.002 2.401-1.071 2.403-2.397l.002-2.4c.004-2.65 2.155-4.797 4.806-4.794s4.798 2.155 4.794 4.805l-.002 2.4c-.002 1.326 1.071 2.402 2.397 2.403l2.4.003-.006 4.8z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8f7e16__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8f7e16__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#8f7e16__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8f7e16__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8f7e16__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8f7e16__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#8f7e16__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g4NWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "08eb16__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "08eb16__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "08eb16__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "08eb16__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "08eb16__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "08eb16__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "08eb16__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M16.502 12h-2.576c-2.056 0-3.723 1.685-3.723 3.764v20.073c0 2.078 1.667 3.763 3.723 3.763H33.78c2.056 0 3.723-1.685 3.723-3.763V15.764c0-2.078-1.667-3.764-3.723-3.764h-2.878v.009l-.006 4.8c0 .318-.127.623-.352.848s-.53.35-.849.35l-12-.014c-.663 0-1.2-.538-1.198-1.201zm2.396 3.595.003-2.4 1.2.001c.663 0 1.2-.536 1.201-1.198l.002-1.2c.001-1.326 1.077-2.4 2.403-2.398 1.325.002 2.398 1.078 2.397 2.403l-.002 1.2c0 .663.536 1.2 1.199 1.202l1.2.001-.003 2.4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#08eb16__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#08eb16__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#08eb16__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#08eb16__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#08eb16__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#08eb16__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#08eb16__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"N174r":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Clock);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillClockGeneric1160Svg = require("illustration:./S2_fill_clock_generic1_160.svg");
var _s2FillClockGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillClockGeneric1160Svg);
var _s2FillClockGeneric196Svg = require("illustration:./S2_fill_clock_generic1_96.svg");
var _s2FillClockGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillClockGeneric196Svg);
var _s2FillClockGeneric148Svg = require("illustration:./S2_fill_clock_generic1_48.svg");
var _s2FillClockGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillClockGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Clock(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClockGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClockGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillClockGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_clock_generic1_160.svg":"b9Jeb","illustration:./S2_fill_clock_generic1_96.svg":"4QXJA","illustration:./S2_fill_clock_generic1_48.svg":"fbrNy","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b9Jeb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "177119__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "177119__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "177119__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "177119__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "177119__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "177119__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "177119__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M136 80c0 30.928-25.072 56-56 56s-56-25.072-56-56 25.072-56 56-56 56 25.072 56 56M76 41v38.89q-.013.455.077.899.091.454.28.865c.307.68.807 1.279 1.475 1.708q.104.067.213.129L99.82 96.062c1.913 1.105 4.36.45 5.464-1.464s.449-4.36-1.464-5.464l-19.82-11.443V41c0-2.21-1.79-4-4-4s-4 1.79-4 4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#177119__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#177119__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#177119__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#177119__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#177119__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#177119__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#177119__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4QXJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de777a__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de777a__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "de777a__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "de777a__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "de777a__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "de777a__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "de777a__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M81.598 48c0 18.557-15.043 33.6-33.6 33.6-18.556 0-33.6-15.043-33.6-33.6 0-18.556 15.044-33.6 33.6-33.6s33.6 15.044 33.6 33.6m-36-23.4v23.335q-.007.272.047.539.055.272.167.52c.185.407.485.766.885 1.024q.063.04.128.077l13.065 7.543c1.148.662 2.616.27 3.278-.879.663-1.148.27-2.615-.878-3.278l-11.892-6.866V24.6c0-1.325-1.075-2.4-2.4-2.4s-2.4 1.075-2.4 2.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#de777a__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#de777a__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#de777a__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de777a__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de777a__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#de777a__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#de777a__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fbrNy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4088f5__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4088f5__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4088f5__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4088f5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4088f5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "4088f5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "4088f5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M40.8 24c0 9.279-7.522 16.8-16.8 16.8-9.28 0-16.8-7.521-16.8-16.8S14.72 7.2 24 7.2c9.278 0 16.8 7.522 16.8 16.8m-18-11.7v11.667q-.003.137.023.27.028.136.084.26c.106.233.285.426.507.55l6.532 3.772c.574.331 1.308.135 1.64-.44.33-.573.134-1.307-.44-1.639L25.2 23.308V12.3c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#4088f5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#4088f5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#4088f5__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4088f5__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4088f5__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4088f5__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#4088f5__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d1eFs":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CodeBrackets);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCodeBracketsGeneric1160Svg = require("illustration:./S2_fill_CodeBrackets_generic1_160.svg");
var _s2FillCodeBracketsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCodeBracketsGeneric1160Svg);
var _s2FillCodeBracketsGeneric196Svg = require("illustration:./S2_fill_CodeBrackets_generic1_96.svg");
var _s2FillCodeBracketsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCodeBracketsGeneric196Svg);
var _s2FillCodeBracketsGeneric148Svg = require("illustration:./S2_fill_CodeBrackets_generic1_48.svg");
var _s2FillCodeBracketsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCodeBracketsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function CodeBrackets(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCodeBracketsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCodeBracketsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCodeBracketsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_CodeBrackets_generic1_160.svg":"d4go1","illustration:./S2_fill_CodeBrackets_generic1_96.svg":"e3Nxu","illustration:./S2_fill_CodeBrackets_generic1_48.svg":"gnsFU","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d4go1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7df63f__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7df63f__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7df63f__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7df63f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7df63f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "7df63f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "7df63f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M124 32H36c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h88c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16M62.75 96.31c1.51 1.62 1.42 4.15-.19 5.65-.77.72-1.75 1.08-2.73 1.08-1.07 0-2.14-.43-2.93-1.27l-18.39-19.7c-1.47-1.58-1.43-4.03.1-5.56L57 58.12c1.56-1.56 4.1-1.56 5.66 0s1.56 4.09 0 5.66L47.01 79.43 62.76 96.3zm29.62-43.33-17.08 56.36c-.52 1.73-2.11 2.84-3.83 2.84-.38 0-.77-.06-1.16-.17-2.11-.64-3.31-2.87-2.67-4.99l17.08-56.36c.64-2.11 2.87-3.31 4.99-2.67 2.11.64 3.31 2.87 2.67 4.99m29.02 30.5L103 101.87c-.78.78-1.8 1.17-2.83 1.17s-2.05-.39-2.83-1.17c-1.56-1.56-1.56-4.09 0-5.66l15.65-15.65-15.75-16.87c-1.51-1.62-1.42-4.15.19-5.65 1.61-1.51 4.15-1.42 5.65.19l18.39 19.7c1.47 1.58 1.43 4.03-.1 5.56z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#7df63f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#7df63f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#7df63f__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7df63f__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7df63f__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7df63f__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#7df63f__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e3Nxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "574a20__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "574a20__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "574a20__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "574a20__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "574a20__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "574a20__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "574a20__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M74.4 19.2H21.6c-5.304 0-9.6 4.296-9.6 9.6v38.4c0 5.304 4.296 9.6 9.6 9.6h52.8c5.304 0 9.6-4.296 9.6-9.6V28.8c0-5.304-4.296-9.6-9.6-9.6M37.65 57.786c.906.972.852 2.49-.114 3.39-.462.432-1.05.648-1.638.648-.642 0-1.284-.258-1.758-.762l-11.034-11.82c-.882-.948-.858-2.418.06-3.336L34.2 34.872c.936-.936 2.46-.936 3.396 0s.936 2.454 0 3.396l-9.39 9.39 9.45 10.122zm17.772-25.998L45.174 65.604c-.312 1.038-1.266 1.704-2.298 1.704q-.344-.001-.696-.102c-1.266-.384-1.986-1.722-1.602-2.994l10.248-33.816c.384-1.266 1.722-1.986 2.994-1.602 1.266.384 1.986 1.722 1.602 2.994m17.412 18.3L61.8 61.122c-.468.468-1.08.702-1.698.702s-1.23-.234-1.698-.702c-.936-.936-.936-2.454 0-3.396l9.39-9.39-9.45-10.122c-.906-.972-.852-2.49.114-3.39.966-.906 2.49-.852 3.39.114l11.034 11.82c.882.948.858 2.418-.06 3.336z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#574a20__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#574a20__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#574a20__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#574a20__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#574a20__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#574a20__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#574a20__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gnsFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6d6cf5__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6d6cf5__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6d6cf5__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6d6cf5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6d6cf5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "6d6cf5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "6d6cf5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M37.2 9.6H10.8C8.148 9.6 6 11.748 6 14.4v19.2c0 2.652 2.148 4.8 4.8 4.8h26.4c2.652 0 4.8-2.148 4.8-4.8V14.4c0-2.652-2.148-4.8-4.8-4.8M18.825 28.893c.453.486.426 1.245-.057 1.695-.231.216-.525.324-.819.324-.321 0-.642-.13-.879-.381l-5.517-5.91c-.441-.474-.429-1.21.03-1.668l5.517-5.517c.468-.468 1.23-.468 1.698 0s.468 1.227 0 1.698l-4.695 4.695 4.725 5.06zm8.886-13-5.124 16.909c-.156.519-.633.852-1.149.852q-.172 0-.348-.051c-.633-.192-.993-.861-.801-1.497l5.124-16.908c.192-.633.861-.993 1.497-.801.633.192.993.86.801 1.497m8.706 9.15L30.9 30.562c-.234.234-.54.35-.849.35s-.615-.116-.849-.35c-.468-.468-.468-1.227 0-1.698l4.695-4.695-4.725-5.061c-.453-.486-.426-1.245.057-1.695.483-.453 1.245-.426 1.695.057l5.517 5.91c.441.474.429 1.209-.03 1.668z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#6d6cf5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#6d6cf5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#6d6cf5__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6d6cf5__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6d6cf5__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6d6cf5__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#6d6cf5__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Q9oJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Color);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillColorGeneric1160Svg = require("illustration:./S2_fill_color_generic1_160.svg");
var _s2FillColorGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillColorGeneric1160Svg);
var _s2FillColorGeneric196Svg = require("illustration:./S2_fill_color_generic1_96.svg");
var _s2FillColorGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillColorGeneric196Svg);
var _s2FillColorGeneric148Svg = require("illustration:./S2_fill_color_generic1_48.svg");
var _s2FillColorGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillColorGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Color(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillColorGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillColorGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillColorGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_color_generic1_160.svg":"1VzES","illustration:./S2_fill_color_generic1_96.svg":"3mXDY","illustration:./S2_fill_color_generic1_48.svg":"5yx2A","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1VzES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "53a984__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "53a984__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "53a984__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "53a984__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "53a984__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "53a984__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "53a984__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M120.63 81.15c4.55-3.99 9.49-8.33 11.34-15.98 4.76-19.77-16.09-40.67-47.36-40.67S28 50.09 28 81.66s29.16 54.41 60.42 54.41c17.19 0 43.55-10.44 41.91-22.53-1-7.4-5.87-8.36-10.38-9.24-3.87-.76-7.47-1.47-8.13-6.14-1.17-8.24 3.55-12.39 8.8-16.99zm-59.3 25.76c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10m0-32.56c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10m25 46.81c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10m0-60c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#53a984__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#53a984__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#53a984__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#53a984__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#53a984__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#53a984__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#53a984__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3mXDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f8f466__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f8f466__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f8f466__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f8f466__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f8f466__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f8f466__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f8f466__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M72.766 49.02c2.74-2.397 5.713-5.003 6.827-9.597C82.458 27.551 69.906 15 51.08 15S17 30.367 17 49.326C17 68.284 34.555 82 53.375 82c10.348 0 26.218-6.27 25.23-13.53-.602-4.444-3.533-5.02-6.249-5.548-2.33-.457-4.497-.883-4.894-3.688-.704-4.948 2.137-7.44 5.298-10.202zm-35.7 15.469c-3.324 0-6.02-2.69-6.02-6.005s2.696-6.006 6.02-6.006 6.02 2.69 6.02 6.006c0 3.314-2.697 6.005-6.02 6.005m0-19.553c-3.324 0-6.02-2.69-6.02-6.005s2.696-6.005 6.02-6.005 6.02 2.69 6.02 6.005-2.697 6.005-6.02 6.005m15.05 28.11c-3.323 0-6.02-2.69-6.02-6.005s2.697-6.005 6.02-6.005c3.324 0 6.02 2.69 6.02 6.005s-2.697 6.005-6.02 6.005m0-36.03c-3.323 0-6.02-2.691-6.02-6.006s2.697-6.005 6.02-6.005c3.324 0 6.02 2.69 6.02 6.005s-2.697 6.005-6.02 6.005"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f8f466__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f8f466__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#f8f466__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f8f466__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f8f466__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f8f466__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#f8f466__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5yx2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "925dd4__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "925dd4__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "925dd4__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "925dd4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "925dd4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "925dd4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "925dd4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M36.44 25.256c1.348-1.18 2.812-2.464 3.36-4.727C41.21 14.682 35.033 8.5 25.77 8.5S9 16.069 9 25.407C9 34.744 17.638 41.5 26.899 41.5c5.092 0 12.9-3.088 12.415-6.664-.296-2.189-1.74-2.473-3.075-2.733-1.146-.225-2.213-.435-2.408-1.816-.347-2.437 1.051-3.665 2.606-5.025zm-17.566 7.62c-1.636 0-2.963-1.326-2.963-2.959 0-1.632 1.327-2.958 2.963-2.958 1.635 0 2.962 1.326 2.962 2.958s-1.327 2.958-2.962 2.958m0-9.631c-1.636 0-2.963-1.326-2.963-2.958s1.327-2.958 2.963-2.958c1.635 0 2.962 1.325 2.962 2.958s-1.327 2.958-2.962 2.958M26.28 37.09c-1.636 0-2.963-1.325-2.963-2.958s1.327-2.958 2.962-2.958 2.963 1.325 2.963 2.958-1.327 2.958-2.963 2.958m0-17.747c-1.636 0-2.963-1.325-2.963-2.957 0-1.633 1.327-2.958 2.962-2.958s2.963 1.325 2.963 2.957c0 1.633-1.327 2.958-2.963 2.958"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#925dd4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#925dd4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#925dd4__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#925dd4__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#925dd4__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#925dd4__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#925dd4__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iDLi4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CommentText);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCommentTextGeneric1160Svg = require("illustration:./S2_fill_commentText_generic1_160.svg");
var _s2FillCommentTextGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCommentTextGeneric1160Svg);
var _s2FillCommentTextGeneric196Svg = require("illustration:./S2_fill_commentText_generic1_96.svg");
var _s2FillCommentTextGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCommentTextGeneric196Svg);
var _s2FillCommentTextGeneric148Svg = require("illustration:./S2_fill_commentText_generic1_48.svg");
var _s2FillCommentTextGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCommentTextGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function CommentText(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCommentTextGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCommentTextGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCommentTextGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_commentText_generic1_160.svg":"7xEnl","illustration:./S2_fill_commentText_generic1_96.svg":"amfc6","illustration:./S2_fill_commentText_generic1_48.svg":"ho71a","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7xEnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec4be7__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec4be7__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec4be7__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ec4be7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ec4be7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ec4be7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ec4be7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M34.4 28.254H125.6c7.954 0 14.401 6.407 14.401 14.311v50.788c0 7.904-6.447 14.312-14.401 14.312H86.981l-31.819 27.413c-3.12 2.689-7.974.468-7.944-3.636.054-7.36.107-17.025.079-23.777H34.4c-7.954 0-14.401-6.408-14.401-14.312V42.565c0-7.904 6.447-14.311 14.4-14.311m15.643 25.719c-2.21 0-4 1.79-4 4s1.79 4 4 4h59.914c2.209 0 4-1.791 4-4s-1.791-4-4-4zm0 19.97c-2.21 0-4 1.792-4 4 0 2.21 1.79 4 4 4h59.914c2.209 0 4-1.79 4-4 0-2.208-1.791-4-4-4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ec4be7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ec4be7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#ec4be7__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec4be7__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec4be7__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec4be7__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#ec4be7__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"amfc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c82d38__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.788,
                        y2: -9.168,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c82d38__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.682,
                        y2: 89.679,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c82d38__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.616,
                        y2: 33.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c82d38__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.28 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c82d38__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.532 53.874)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c82d38__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: -0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "c82d38__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M20.64 17.178h54.72c4.772 0 8.64 3.757 8.64 8.5v28c0 4.742-3.868 8.5-8.64 8.5H52L32.767 78.626c-1.873 1.613-4.785.28-4.767-2.182.032-4.416.017-10.215 0-14.266h-7.36c-4.772 0-8.64-3.758-8.64-8.5v-28c0-4.743 3.868-8.5 8.64-8.5M30 31.656c-1.105 0-2 .896-2 2s.895 2 2 2h36c1.105 0 2-.895 2-2s-.895-2-2-2zm0 12c-1.105 0-2 .896-2 2s.895 2 2 2h36c1.105 0 2-.895 2-2s-.895-2-2-2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c82d38__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#c82d38__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            y: -0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0-.001h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.722,
                            r: 41.765,
                            fill: "url(#c82d38__c)",
                            transform: "rotate(-.08 54.28 3.722)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c82d38__d)",
                            d: "M36.643-16.96c-7.373-4.561-16.714-4.59-24.114-.071l-74.015 45.19c-7.249 4.427-7.26 14.874-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c82d38__e)",
                            d: "M13.837 45.578C15.477 9.738 45.86-17.985 81.7-16.345s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c82d38__f)",
                            d: "M-38.895 69.208c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.343,
                            r: 41.765,
                            fill: "url(#c82d38__g)",
                            transform: "rotate(-.08 90.406 17.343)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ho71a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "907906__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "907906__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "907906__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "907906__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "907906__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "907906__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "907906__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M9.863 8.012h28.274c2.41 0 4.363 1.874 4.363 4.24v14.463c0 2.366-1.953 4.24-4.363 4.24H26.02l-9.711 8.205c-.946.804-2.416.14-2.407-1.089.016-2.202.008-5.095 0-7.116h-4.04c-2.409 0-4.362-1.874-4.362-4.24V12.252c0-2.366 1.953-4.24 4.363-4.24M15 15.254c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h18c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25zm0 6c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h18c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#907906__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#907906__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#907906__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#907906__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#907906__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#907906__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#907906__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1ReqF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Confetti);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillConfettiGeneric1160Svg = require("illustration:./S2_fill_confetti_generic1_160.svg");
var _s2FillConfettiGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillConfettiGeneric1160Svg);
var _s2FillConfettiGeneric196Svg = require("illustration:./S2_fill_confetti_generic1_96.svg");
var _s2FillConfettiGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillConfettiGeneric196Svg);
var _s2FillConfettiGeneric148Svg = require("illustration:./S2_fill_confetti_generic1_48.svg");
var _s2FillConfettiGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillConfettiGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Confetti(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConfettiGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConfettiGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConfettiGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_confetti_generic1_160.svg":"9Aial","illustration:./S2_fill_confetti_generic1_96.svg":"3OkAI","illustration:./S2_fill_confetti_generic1_48.svg":"5rg5Q","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Aial":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6a042f__d",
                        x1: -28.688,
                        x2: 194.754,
                        y1: 137.748,
                        y2: -6.308,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6a042f__e",
                        x1: 156.584,
                        x2: 63.67,
                        y1: 42.682,
                        y2: 148.555,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6a042f__f",
                        x1: 36.222,
                        x2: 206.784,
                        y1: 157.049,
                        y2: 55.798,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6a042f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 58.2973 -61.7778 0 61.778 58.297)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6a042f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 58.2973 -61.7778 0 61.778 58.297)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "6a042f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 142,
                            height: 134,
                            x: 7,
                            y: 18,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "6a042f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M109.922 32.16c2.86-2.86 2.86-7.48 0-10.34s-7.48-2.86-10.34 0-2.86 7.48 0 10.34 7.48 2.86 10.34 0m-45.12 39.96c-1.73 1.38-2.01 3.9-.63 5.62.79.99 1.95 1.5 3.13 1.5.88 0 1.76-.29 2.49-.88 19.22-15.35 18.34-31.46 18.299-32.14-.15-2.19-2.03-3.82-4.22-3.7-2.19.13-3.87 2.02-3.76 4.21.02.52.43 12.81-15.31 25.38zm34 29.87c-1.03-1.95-.28-4.37 1.671-5.4h.01c1.95-1.03 4.37-.28 5.4 1.67 5.73 10.86 3.89 16.18 1.34 18.73-.83.83-1.95 1.58-3.45 2.02l-69.25 24.6c-1.34.48-2.71.71-4.06.71-3.11 0-6.14-1.23-8.44-3.53-3.3-3.3-4.38-8.09-2.82-12.5l24.32-68.53c.14-.52.32-1.02.55-1.5.45-1.12 1.07-2 1.75-2.68 2.57-2.57 7.94-4.4 18.93 1.45 1.95 1.04 2.69 3.46 1.65 5.41s-3.46 2.69-5.41 1.65c-6.19-3.29-9.03-3.09-9.52-2.84v.02l-.18.51c-.4 3.04 4.2 14.87 19.53 30.2 11.62 11.62 21.22 17.07 26.54 18.84 2.06.42 3.52.52 4.26.42.19-.55.29-3.35-2.82-9.25m-21.31-12.56c-1.03 0-2.05-.39-2.83-1.17-1.56-1.57-1.56-4.1 0-5.66l15.61-15.61c1.57-1.56 4.1-1.56 5.66 0 1.56 1.57 1.56 4.1 0 5.66l-15.61 15.61c-.78.78-1.8 1.17-2.83 1.17m7.05 3.7c15.35-19.22 31.46-18.34 32.14-18.3l-.01.01c2.21.15 3.87 2.06 3.72 4.26-.15 2.19-2.04 3.86-4.23 3.72-.59-.02-12.84-.37-25.37 15.31-.79.99-1.96 1.5-3.13 1.5-.87 0-1.75-.29-2.49-.88-1.73-1.38-2.01-3.89-.63-5.62m40.499-.96c2.86-2.86 7.48-2.86 10.34 0s2.86 7.48 0 10.34-7.48 2.86-10.34 0-2.86-7.48 0-10.34M56.354 28.195l-1.921 1.406c-1.783 1.305-2.17 3.807-.865 5.59l7.813 10.676c1.305 1.783 3.808 2.17 5.59.866l1.921-1.406c1.783-1.305 2.17-3.808.865-5.59L61.944 29.06c-1.305-1.783-3.808-2.17-5.59-.866m50.876 26.656 13.146-1.488c2.196-.249 4.177 1.33 4.425 3.524l.268 2.365c.248 2.195-1.33 4.176-3.525 4.425l-13.146 1.488c-2.195.249-4.176-1.329-4.424-3.524l-.268-2.365c-.249-2.195 1.329-4.176 3.524-4.425"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#6a042f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#6a042f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 142,
                            height: 134,
                            x: 7,
                            y: 18,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7 18h142v134H7z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 61.778,
                            cy: 58.297,
                            fill: "url(#6a042f__c)",
                            rx: 61.778,
                            ry: 58.297,
                            transform: "matrix(1 -.00132 .00148 1 25.426 -35.019)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6a042f__d)",
                            d: "M61.197-5.67c-10.906-6.368-24.723-6.407-35.669-.1l-109.48 63.078c-10.722 6.178-10.74 20.76-.032 26.961l108.756 62.99c10.93 6.329 24.747 6.321 35.667-.023l108.533-63.048c10.651-6.188 10.67-20.689.032-26.9z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6a042f__e)",
                            d: "M27.465 81.62c2.427-50.026 47.37-88.724 100.383-86.434s94.02 44.702 91.593 94.728-47.369 88.723-100.382 86.433-94.02-44.701-91.594-94.727"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6a042f__f)",
                            d: "M-50.532 114.605c21.073-8.483 43.8-8.119 63.49-.699 39.399 14.885 62.324 5.682 78.225-31.413 7.92-18.614 23.384-34.378 44.48-42.871 42.179-16.954 90.873 1.442 108.813 41.127 17.941 39.685-1.696 85.563-43.865 102.539-21.143 8.512-43.914 8.114-63.634.627-39.335-14.806-62.217-5.568-78.098 31.571-7.94 18.57-23.4 34.28-44.472 42.764-42.146 16.966-90.84-1.43-108.77-41.093-17.931-39.663 1.686-85.585 43.831-102.552"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 61.778,
                            cy: 58.297,
                            fill: "url(#6a042f__g)",
                            rx: 61.778,
                            ry: 58.297,
                            transform: "matrix(1 -.00132 .00148 1 78.86 -16.007)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3OkAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "60da7a__d",
                        x1: -17.213,
                        x2: 116.852,
                        y1: 82.649,
                        y2: -3.785,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "60da7a__e",
                        x1: 93.95,
                        x2: 38.201,
                        y1: 25.61,
                        y2: 89.133,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "60da7a__f",
                        x1: 21.733,
                        x2: 124.07,
                        y1: 94.229,
                        y2: 33.479,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "60da7a__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.9784 -37.0667 0 37.067 34.978)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "60da7a__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.9784 -37.0667 0 37.067 34.978)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "60da7a__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 85.2,
                            height: 80.4,
                            x: 4.199,
                            y: 10.8,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "60da7a__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M65.951 19.296c1.716-1.716 1.716-4.488 0-6.204s-4.488-1.716-6.204 0-1.716 4.488 0 6.204 4.488 1.716 6.204 0M38.878 43.272c-1.038.828-1.206 2.34-.378 3.372.474.594 1.17.9 1.878.9.528 0 1.056-.174 1.494-.528 11.532-9.21 11.004-18.876 10.98-19.284-.09-1.314-1.218-2.292-2.532-2.22-1.314.078-2.322 1.212-2.256 2.526.012.312.258 7.686-9.186 15.228zM59.28 61.194c-.618-1.17-.168-2.622 1.002-3.24h.006c1.17-.618 2.622-.168 3.24 1.002 3.438 6.516 2.334 9.708.804 11.238-.498.498-1.17.948-2.07 1.212l-41.55 14.76c-.804.288-1.626.426-2.436.426-1.866 0-3.684-.738-5.064-2.118-1.98-1.98-2.628-4.854-1.692-7.5l14.592-41.118q.125-.468.33-.9c.27-.672.642-1.2 1.05-1.608 1.542-1.542 4.764-2.64 11.358.87 1.17.624 1.614 2.076.99 3.246s-2.076 1.614-3.246.99c-3.714-1.974-5.418-1.854-5.712-1.704v.012l-.108.306c-.24 1.824 2.52 8.922 11.718 18.12 6.972 6.972 12.732 10.242 15.924 11.304 1.236.252 2.112.312 2.556.252.114-.33.174-2.01-1.692-5.55m-12.786-7.536c-.618 0-1.23-.234-1.698-.702-.936-.942-.936-2.46 0-3.396l9.366-9.366c.942-.936 2.46-.936 3.396 0 .936.942.936 2.46 0 3.396l-9.366 9.366c-.468.468-1.08.702-1.698.702m4.23 2.22c9.21-11.532 18.876-11.004 19.284-10.98l-.006.006c1.326.09 2.322 1.236 2.232 2.556-.09 1.314-1.224 2.316-2.538 2.232-.354-.012-7.704-.222-15.222 9.186-.474.594-1.176.9-1.878.9-.522 0-1.05-.174-1.494-.528-1.038-.828-1.206-2.334-.378-3.372m24.3-.576c1.716-1.716 4.488-1.716 6.204 0s1.716 4.488 0 6.204-4.489 1.716-6.205 0-1.716-4.488 0-6.204M33.81 16.917l-1.153.843c-1.07.783-1.302 2.285-.519 3.354l4.688 6.406c.783 1.07 2.285 1.302 3.355.52l1.152-.844c1.07-.783 1.302-2.285.52-3.354l-4.69-6.406c-.782-1.07-2.284-1.302-3.353-.52M64.336 32.91l7.888-.894c1.317-.149 2.505.798 2.654 2.115l.161 1.42c.15 1.316-.798 2.505-2.115 2.654l-7.887.893c-1.317.15-2.506-.798-2.655-2.115l-.16-1.419c-.15-1.317.797-2.505 2.114-2.654"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#60da7a__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#60da7a__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 85.2,
                            height: 80.4,
                            x: 4.199,
                            y: 10.8,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.2 10.8h85.2v80.4H4.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.067,
                            cy: 34.978,
                            fill: "url(#60da7a__c)",
                            rx: 37.067,
                            ry: 34.978,
                            transform: "matrix(1 -.00132 .00148 1 15.254 -21.01)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#60da7a__d)",
                            d: "M36.717-3.402c-6.543-3.821-14.833-3.844-21.4-.06l-65.689 37.847c-6.433 3.707-6.444 12.456-.02 16.177l65.255 37.793c6.557 3.798 14.848 3.793 21.4-.013l65.119-37.83c6.391-3.712 6.402-12.413.02-16.14z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#60da7a__e)",
                            d: "M16.478 48.972C17.934 18.957 44.9-4.262 76.708-2.888s56.412 26.821 54.956 56.837c-1.456 30.015-28.422 53.234-60.23 51.86S15.023 78.988 16.478 48.972"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#60da7a__f)",
                            d: "M-30.32 68.763c12.644-5.09 26.28-4.872 38.094-.42 23.64 8.931 37.395 3.41 46.936-18.847 4.752-11.169 14.03-20.627 26.688-25.723 25.307-10.172 54.523.865 65.288 24.676s-1.018 51.338-26.319 61.524c-12.686 5.107-26.349 4.868-38.18.376-23.602-8.884-37.331-3.341-46.86 18.943-4.764 11.141-14.04 20.568-26.683 25.658-25.287 10.18-54.504-.858-65.262-24.656s1.012-51.351 26.299-61.531"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.067,
                            cy: 34.978,
                            fill: "url(#60da7a__g)",
                            rx: 37.067,
                            ry: 34.978,
                            transform: "matrix(1 -.00132 .00148 1 47.316 -9.604)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5rg5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0639ef__d",
                        x1: -8.603,
                        x2: 58.43,
                        y1: 41.325,
                        y2: -1.892,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0639ef__e",
                        x1: 46.977,
                        x2: 19.103,
                        y1: 12.805,
                        y2: 44.567,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0639ef__f",
                        x1: 10.87,
                        x2: 62.039,
                        y1: 47.115,
                        y2: 16.74,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0639ef__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.4892 -18.5333 0 18.533 17.49)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0639ef__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.4892 -18.5333 0 18.533 17.49)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0639ef__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 42.6,
                            height: 40.2,
                            x: 2.102,
                            y: 5.4,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0639ef__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M32.978 9.648c.858-.858.858-2.244 0-3.102s-2.245-.858-3.103 0-.858 2.244 0 3.102 2.245.858 3.102 0M19.44 21.636c-.519.414-.603 1.17-.189 1.686.237.297.585.45.94.45.263 0 .527-.087.746-.264 5.766-4.605 5.502-9.438 5.49-9.642-.045-.657-.609-1.146-1.266-1.11-.657.039-1.16.606-1.128 1.263.006.156.13 3.843-4.593 7.614zm10.2 8.96c-.308-.584-.083-1.31.502-1.62h.003c.585-.308 1.31-.083 1.62.502 1.719 3.258 1.167 4.854.402 5.619-.25.249-.585.474-1.035.606l-20.775 7.38c-.402.144-.813.213-1.218.213-.933 0-1.842-.37-2.532-1.06-.99-.99-1.314-2.426-.846-3.75l7.296-20.558q.062-.234.165-.45c.135-.336.32-.6.525-.804.77-.771 2.382-1.32 5.679.435.585.312.807 1.038.495 1.623s-1.038.807-1.623.495c-1.857-.987-2.71-.927-2.856-.852v.006l-.054.153c-.12.912 1.26 4.46 5.859 9.06 3.486 3.486 6.366 5.12 7.962 5.652.618.126 1.056.156 1.278.126.057-.165.087-1.005-.846-2.775m-6.393-3.767c-.309 0-.615-.117-.849-.351-.468-.471-.468-1.23 0-1.698l4.683-4.683c.471-.468 1.23-.468 1.698 0 .468.47.468 1.23 0 1.698l-4.683 4.683c-.234.234-.54.35-.849.35m2.115 1.11c4.605-5.766 9.438-5.502 9.642-5.49l-.003.003c.663.045 1.161.618 1.116 1.278-.045.657-.612 1.158-1.269 1.116-.177-.006-3.852-.111-7.61 4.593-.238.297-.589.45-.94.45-.26 0-.525-.087-.747-.264-.519-.414-.603-1.167-.189-1.686m12.15-.288c.858-.858 2.244-.858 3.102 0s.858 2.244 0 3.102-2.244.858-3.102 0-.858-2.244 0-3.102M16.907 8.458l-.576.422c-.535.392-.651 1.142-.26 1.677l2.344 3.203c.392.535 1.142.651 1.677.26l.576-.422c.535-.391.651-1.142.26-1.677l-2.344-3.203c-.392-.535-1.142-.651-1.677-.26m15.263 7.997 3.944-.446c.658-.075 1.253.399 1.327 1.057l.08.71c.075.658-.398 1.252-1.057 1.327l-3.944.446c-.658.075-1.253-.398-1.327-1.057l-.08-.71c-.075-.658.398-1.252 1.057-1.327"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0639ef__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0639ef__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 42.6,
                            height: 40.2,
                            x: 2.102,
                            y: 5.4,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.102 5.4h42.6v40.2h-42.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.533,
                            cy: 17.489,
                            fill: "url(#0639ef__c)",
                            rx: 18.533,
                            ry: 17.489,
                            transform: "matrix(1 -.00132 .00148 1 7.629 -10.505)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0639ef__d)",
                            d: "M18.363-1.7c-3.272-1.911-7.417-1.923-10.701-.03l-32.844 18.923c-3.217 1.853-3.222 6.228-.01 8.088L7.435 44.178c3.28 1.899 7.424 1.897 10.7-.007l32.56-18.914c3.195-1.857 3.201-6.207.01-8.07z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0639ef__e)",
                            d: "M8.241 24.486C8.97 9.478 22.452-2.13 38.356-1.444s28.206 13.41 27.478 28.418-14.211 26.617-30.115 25.93S7.513 39.494 8.241 24.486"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0639ef__f)",
                            d: "M-15.156 34.383c6.322-2.546 13.14-2.436 19.047-.21 11.82 4.465 18.697 1.704 23.468-9.424 2.376-5.584 7.015-10.314 13.344-12.862 12.653-5.086 27.262.433 32.644 12.339 5.382 11.905-.509 25.669-13.16 30.761-6.343 2.554-13.174 2.434-19.09.188-11.8-4.441-18.665-1.67-23.43 9.472-2.381 5.57-7.02 10.284-13.341 12.829-12.644 5.09-27.252-.43-32.631-12.328s.506-25.676 13.15-30.765"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.533,
                            cy: 17.489,
                            fill: "url(#0639ef__g)",
                            rx: 18.533,
                            ry: 17.489,
                            transform: "matrix(1 -.00132 .00148 1 23.66 -4.802)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8AR0h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Conversationbubbles);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillConversationbubblesGeneric1160Svg = require("illustration:./S2_fill_conversationbubbles_generic1_160.svg");
var _s2FillConversationbubblesGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillConversationbubblesGeneric1160Svg);
var _s2FillConversationbubblesGeneric196Svg = require("illustration:./S2_fill_conversationbubbles_generic1_96.svg");
var _s2FillConversationbubblesGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillConversationbubblesGeneric196Svg);
var _s2FillConversationbubblesGeneric148Svg = require("illustration:./S2_fill_conversationbubbles_generic1_48.svg");
var _s2FillConversationbubblesGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillConversationbubblesGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Conversationbubbles(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConversationbubblesGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConversationbubblesGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillConversationbubblesGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_conversationbubbles_generic1_160.svg":"lXDGz","illustration:./S2_fill_conversationbubbles_generic1_96.svg":"fLFFm","illustration:./S2_fill_conversationbubbles_generic1_48.svg":"9AKQy","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lXDGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "797dbd__d",
                        x1: -24.537,
                        x2: 201.681,
                        y1: 134.772,
                        y2: -2.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "797dbd__e",
                        x1: 157.003,
                        x2: 59.956,
                        y1: 36.058,
                        y2: 140.411,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "797dbd__f",
                        x1: 39.065,
                        x2: 211.102,
                        y1: 154.813,
                        y2: 58.44,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "797dbd__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.639 52.464)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "797dbd__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.948 88.515)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "797dbd__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "797dbd__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M131.619 69.36h-15.436v11.455c0 9.893-8.368 17.94-18.654 17.94H72.325v7.452c0 4.473 3.888 8.1 8.684 8.1h18.906l19.186 15.517c1.882 1.521 4.809.265 4.79-2.059-.032-4.165-.064-9.636-.047-13.458h7.776c4.796 0 8.684-3.626 8.684-8.1V77.46c0-4.474-3.888-8.1-8.684-8.1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M97.53 90.716c5.861 0 10.613-4.433 10.613-9.901V45.68c0-5.468-4.752-9.9-10.613-9.9H30.317c-5.862 0-10.614 4.432-10.614 9.9v35.135c0 5.468 4.752 9.9 10.614 9.9h9.504c.02 4.672-.019 11.358-.058 16.449-.022 2.84 3.555 4.376 5.855 2.516l23.45-18.964z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#797dbd__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#797dbd__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.43 10.429h139.142V149.57H10.43z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.103,
                            cy: 15.826,
                            r: 60.534,
                            fill: "url(#797dbd__c)",
                            transform: "rotate(-.08 89.103 15.826)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#797dbd__d)",
                            d: "M63.539-14.15c-10.686-6.612-24.225-6.653-34.95-.104L-78.689 51.244C-89.194 57.66-89.212 72.8-78.72 79.24l106.568 65.406c10.71 6.572 24.248 6.564 34.949-.023l106.347-65.468c10.437-6.425 10.456-21.483.032-27.932z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#797dbd__e)",
                            d: "M30.483 76.49c2.378-51.946 46.417-92.128 98.362-89.75 51.946 2.378 92.128 46.417 89.75 98.362-2.378 51.946-46.416 92.128-98.362 89.75s-92.128-46.416-89.75-98.362"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#797dbd__f)",
                            d: "M-45.943 110.741c20.649-8.809 42.918-8.432 62.211-.727 38.607 15.456 61.07 5.9 76.651-32.618 7.761-19.328 22.913-35.697 43.585-44.516 41.33-17.604 89.044 1.497 106.623 42.705s-1.662 88.847-42.982 106.474c-20.718 8.839-43.03 8.425-62.353.65-38.544-15.373-60.965-5.781-76.526 32.784-7.78 19.282-22.93 35.595-43.578 44.404-41.297 17.617-89.01-1.485-106.58-42.669-17.57-41.185 1.652-88.87 42.95-106.487"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.463,
                            cy: 35.567,
                            r: 60.534,
                            fill: "url(#797dbd__g)",
                            transform: "rotate(-.08 141.463 35.567)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fLFFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d3b240__d",
                        x1: -14.724,
                        x2: 121.006,
                        y1: 80.863,
                        y2: -1.714,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d3b240__e",
                        x1: 94.203,
                        x2: 35.974,
                        y1: 21.635,
                        y2: 84.246,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d3b240__f",
                        x1: 23.438,
                        x2: 126.661,
                        y1: 92.888,
                        y2: 35.064,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d3b240__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.982 31.479)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d3b240__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.768 53.108)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d3b240__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "d3b240__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M78.968 41.615h-9.262v6.874c0 5.935-5.02 10.764-11.192 10.764H43.39v4.47c0 2.685 2.332 4.861 5.21 4.861h11.343l11.512 9.31c1.13.913 2.885.159 2.874-1.235-.02-2.5-.038-5.782-.028-8.075h4.666c2.877 0 5.21-2.176 5.21-4.86V46.476c0-2.685-2.333-4.86-5.21-4.86"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M58.512 54.43c3.517 0 6.368-2.66 6.368-5.94V27.407c0-3.28-2.85-5.94-6.368-5.94H18.184c-3.517 0-6.368 2.66-6.368 5.94V48.49c0 3.28 2.851 5.94 6.368 5.94h5.703c.013 2.803-.011 6.815-.035 9.87-.013 1.703 2.133 2.625 3.513 1.51l14.07-11.38z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#d3b240__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#d3b240__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.258 6.258h83.485v83.485H6.258z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.461,
                            cy: 9.496,
                            r: 36.321,
                            fill: "url(#d3b240__c)",
                            transform: "rotate(-.08 53.461 9.496)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d3b240__d)",
                            d: "M38.121-8.49c-6.412-3.967-14.535-3.992-20.97-.062l-64.366 39.3c-6.304 3.848-6.314 12.933-.02 16.797l63.941 39.243c6.426 3.944 14.55 3.939 20.97-.014l63.808-39.28c6.262-3.855 6.274-12.89.019-16.76z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d3b240__e)",
                            d: "M18.29 45.894c1.428-31.167 27.85-55.277 59.018-53.85s55.277 27.85 53.85 59.018-27.85 55.276-59.017 53.849c-31.168-1.426-55.277-27.85-53.85-59.017"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d3b240__f)",
                            d: "M-27.566 66.445c12.389-5.285 25.75-5.059 37.326-.436 23.164 9.274 36.642 3.54 45.99-19.57 4.657-11.598 13.749-21.42 26.152-26.71 24.798-10.563 53.426.898 63.974 25.623 10.547 24.724-.998 53.307-25.79 63.884-12.43 5.303-25.818 5.055-37.412.39-23.126-9.224-36.579-3.469-45.915 19.67C32.09 140.865 23 150.653 10.612 155.938c-24.778 10.571-53.406-.89-63.948-25.601s.991-53.322 25.77-63.892"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.875,
                            cy: 21.34,
                            r: 36.321,
                            fill: "url(#d3b240__g)",
                            transform: "rotate(-.08 84.875 21.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9AKQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2c41be__d",
                        x1: -7.36,
                        x2: 60.505,
                        y1: 40.432,
                        y2: -0.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2c41be__e",
                        x1: 47.099,
                        x2: 17.985,
                        y1: 10.818,
                        y2: 42.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2c41be__f",
                        x1: 11.721,
                        x2: 63.332,
                        y1: 46.444,
                        y2: 17.532,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2c41be__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.992 15.74)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2c41be__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.885 26.555)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "2c41be__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "2c41be__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M39.484 20.808h-4.631v3.436c0 2.968-2.51 5.383-5.596 5.383h-7.562v2.235c0 1.342 1.167 2.43 2.605 2.43h5.672l5.756 4.655c.565.456 1.443.08 1.437-.618-.01-1.25-.02-2.89-.014-4.037h2.333c1.439 0 2.605-1.088 2.605-2.43v-8.624c0-1.342-1.166-2.43-2.605-2.43"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M29.258 27.214c1.759 0 3.184-1.33 3.184-2.97v-10.54c0-1.64-1.425-2.97-3.184-2.97H9.094c-1.758 0-3.184 1.33-3.184 2.97v10.54c0 1.64 1.426 2.97 3.184 2.97h2.851c.007 1.402-.005 3.408-.017 4.935-.007.852 1.067 1.313 1.757.755l7.035-5.69z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#2c41be__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#2c41be__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.129 3.129H44.87V44.87H3.129z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.733,
                            cy: 4.748,
                            r: 18.16,
                            fill: "url(#2c41be__c)",
                            transform: "rotate(-.08 26.733 4.748)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2c41be__d)",
                            d: "M19.062-4.245c-3.205-1.984-7.267-1.996-10.485-.031l-32.183 19.65c-3.151 1.924-3.157 6.466-.01 8.398L8.356 43.394c3.213 1.972 7.275 1.97 10.485-.007l31.904-19.64c3.131-1.928 3.137-6.445.01-8.38z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2c41be__e)",
                            d: "M9.143 22.948C9.857 7.364 23.068-4.691 38.652-3.977S66.29 9.948 65.577 25.53c-.713 15.584-13.925 27.639-29.509 26.925S8.43 38.531 9.143 22.948"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2c41be__f)",
                            d: "M-13.781 33.222c6.194-2.642 12.875-2.529 18.663-.218 11.582 4.637 18.321 1.77 22.995-9.785 2.329-5.798 6.874-10.71 13.076-13.355 12.399-5.281 26.713.45 31.987 12.812S72.44 49.33 60.045 54.618c-6.215 2.651-12.909 2.527-18.706.195-11.563-4.612-18.29-1.734-22.958 9.835-2.334 5.785-6.878 10.679-13.073 13.321-12.389 5.285-26.703-.445-31.974-12.8s.496-26.661 12.885-31.947"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.44,
                            cy: 10.67,
                            r: 18.16,
                            fill: "url(#2c41be__g)",
                            transform: "rotate(-.08 42.44 10.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4DWoN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Crop);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCropGeneric1160Svg = require("illustration:./S2_fill_crop_generic1_160.svg");
var _s2FillCropGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCropGeneric1160Svg);
var _s2FillCropGeneric196Svg = require("illustration:./S2_fill_crop_generic1_96.svg");
var _s2FillCropGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCropGeneric196Svg);
var _s2FillCropGeneric148Svg = require("illustration:./S2_fill_crop_generic1_48.svg");
var _s2FillCropGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCropGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Crop(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCropGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCropGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCropGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_crop_generic1_160.svg":"41kzf","illustration:./S2_fill_crop_generic1_96.svg":"lMewt","illustration:./S2_fill_crop_generic1_48.svg":"19Vzj","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"41kzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c52692__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c52692__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c52692__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c52692__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c52692__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c52692__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "c52692__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M53.446 24.063c0-2.21-1.791-4-4-4s-4 1.79-4 4v21.262H24.063c-2.21 0-4 1.791-4 4s1.79 4 4 4h21.383v41.35c0 11.046 8.954 20 20 20h41.108v21.263c0 2.209 1.791 4 4 4s4-1.791 4-4v-21.263h21.384c2.209 0 4-1.791 4-4s-1.791-4-4-4H65.446c-6.628 0-12-5.372-12-12V24.063m8.613 21.262c-2.209 0-4 1.791-4 4s1.791 4 4 4h32.496c6.627 0 11.999 5.373 11.999 12v32.72c0 2.209 1.791 4 4 4s4-1.791 4-4v-32.72c0-11.046-8.954-20-20-20z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c52692__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#c52692__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#c52692__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c52692__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c52692__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c52692__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#c52692__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lMewt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 97,
        height: 96,
        viewBox: "0 0 97 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8d7b6e__d",
                        x1: -23.183,
                        x2: 132.895,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8d7b6e__e",
                        x1: 102.07,
                        x2: 35.113,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8d7b6e__f",
                        x1: 20.697,
                        x2: 139.393,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8d7b6e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.75 29.473)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8d7b6e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 37.002 54.345)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8d7b6e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            x: 0.941,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8d7b6e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M32.916 15c0-1.105-.896-2-2-2s-2 .895-2 2v12.903H15.94c-1.104 0-2 .896-2 2s.896 2 2 2h12.975v26.193c0 5.523 4.477 10 10 10h26.05v12.903c0 1.105.896 2 2 2s2-.895 2-2V68.096h12.975c1.104 0 2-.895 2-2s-.896-2-2-2H38.916c-3.314 0-6-2.686-6-6V15m5.441 12.903c-1.104 0-2 .896-2 2s.896 2 2 2h20.61c3.313 0 6 2.687 6 6v20.742c0 1.104.895 2 2 2s2-.896 2-2V37.903c0-5.523-4.478-10-10-10z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8d7b6e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8d7b6e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            x: 0.941,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M.941 0h96v96h-96z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 55.222,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#8d7b6e__c)",
                            transform: "rotate(-.08 55.222 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8d7b6e__d)",
                            d: "M37.584-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.014 45.19c-7.25 4.427-7.261 14.873-.022 19.316l73.525 45.127c7.39 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.201-4.433 7.214-14.821.022-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8d7b6e__e)",
                            d: "M14.778 45.579c1.64-35.84 32.025-63.563 67.864-61.923s63.564 32.025 61.923 67.865-32.025 63.563-67.865 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8d7b6e__f)",
                            d: "M-37.954 69.21c14.247-6.078 29.611-5.818 42.922-.502 26.637 10.664 42.136 4.071 52.885-22.504 5.355-13.336 15.81-24.63 30.071-30.714 28.516-12.146 61.436 1.033 73.565 29.464s-1.147 61.299-29.656 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.062-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.492 12.155-61.412-1.024-73.534-29.44-12.123-28.415 1.14-61.314 29.632-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 91.347,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#8d7b6e__g)",
                            transform: "rotate(-.08 91.347 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"19Vzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f84e3__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f84e3__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0f84e3__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0f84e3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0f84e3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0f84e3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0f84e3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M16.237 7.5c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v6.202H7.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h6.237v12.846c0 2.9 2.35 5.25 5.25 5.25h12.775V40.5c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-6.202H40.5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H18.987c-1.519 0-2.75-1.231-2.75-2.75V7.5M19 13.702c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h10.012c1.52 0 2.75 1.23 2.75 2.75v10.063c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V18.952c0-2.9-2.35-5.25-5.25-5.25z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0f84e3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0f84e3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#0f84e3__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f84e3__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f84e3__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0f84e3__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#0f84e3__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hvjtV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Cursor);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCursorGeneric1160Svg = require("illustration:./S2_fill_cursor_generic1_160.svg");
var _s2FillCursorGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCursorGeneric1160Svg);
var _s2FillCursorGeneric196Svg = require("illustration:./S2_fill_cursor_generic1_96.svg");
var _s2FillCursorGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCursorGeneric196Svg);
var _s2FillCursorGeneric148Svg = require("illustration:./S2_fill_cursor_generic1_48.svg");
var _s2FillCursorGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCursorGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Cursor(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCursorGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCursorGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCursorGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_cursor_generic1_160.svg":"hlCEW","illustration:./S2_fill_cursor_generic1_96.svg":"5PnMp","illustration:./S2_fill_cursor_generic1_48.svg":"lraoG","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hlCEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c33521__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c33521__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c33521__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c33521__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c33521__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c33521__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "c33521__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m27.96 42.996 35.652 86.584c4.533 11.009 20.024 11.288 24.95.449l11.162-24.554c1.36-2.992 3.759-5.391 6.751-6.751l24.554-11.161c10.839-4.927 10.56-20.418-.449-24.951L43.996 26.959c-10.097-4.157-20.194 5.94-16.037 16.037"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c33521__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#c33521__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#c33521__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c33521__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c33521__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c33521__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#c33521__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5PnMp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bc84c4__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bc84c4__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bc84c4__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bc84c4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bc84c4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "bc84c4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "bc84c4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m16.775 25.797 21.391 51.95c2.72 6.606 12.015 6.774 14.97.27l6.697-14.732c.817-1.796 2.256-3.235 4.051-4.051l14.733-6.697c6.503-2.956 6.336-12.25-.27-14.97l-51.95-21.392c-6.058-2.494-12.117 3.564-9.622 9.622"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#bc84c4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#bc84c4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#bc84c4__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bc84c4__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bc84c4__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bc84c4__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#bc84c4__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lraoG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c78e8e__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c78e8e__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c78e8e__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c78e8e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c78e8e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c78e8e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "c78e8e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m8.39 12.899 10.695 25.975c1.36 3.303 6.007 3.386 7.485.135l3.349-7.367c.408-.897 1.127-1.617 2.025-2.025l7.366-3.348c3.252-1.478 3.168-6.126-.134-7.486L13.2 8.088c-3.029-1.248-6.058 1.781-4.81 4.81"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c78e8e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#c78e8e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#c78e8e__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c78e8e__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c78e8e__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c78e8e__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#c78e8e__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8Gr0F":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Cut);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCutGeneric1160Svg = require("illustration:./S2_fill_cut_generic1_160.svg");
var _s2FillCutGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCutGeneric1160Svg);
var _s2FillCutGeneric196Svg = require("illustration:./S2_fill_cut_generic1_96.svg");
var _s2FillCutGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCutGeneric196Svg);
var _s2FillCutGeneric148Svg = require("illustration:./S2_fill_cut_generic1_48.svg");
var _s2FillCutGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCutGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Cut(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCutGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCutGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCutGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_cut_generic1_160.svg":"h4Crc","illustration:./S2_fill_cut_generic1_96.svg":"2De7f","illustration:./S2_fill_cut_generic1_48.svg":"ikI1E","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"h4Crc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b40601__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b40601__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b40601__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b40601__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b40601__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b40601__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b40601__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M99.929 23.655c2.09.716 3.204 2.99 2.489 5.08L87.936 71.037l43.076-14.67c2.092-.711 4.364.407 5.076 2.498s-.406 4.364-2.497 5.076L85.677 80.258q-.143.048-.285.085c-.249.982-.48 1.98-.714 3-.86 3.72-1.783 7.72-3.876 12.236-.41.887-.861 1.786-1.338 2.68q.333-.01.67-.01c10.58 0 19.156 8.576 19.156 19.155s-8.577 19.157-19.156 19.157c-10.58 0-19.156-8.577-19.156-19.157 0-4.155 1.322-8.001 3.57-11.139q.2-.334.472-.632.382-.49.795-.954c1.8-2.297 5.478-7.605 7.729-12.463 1.649-3.56 2.335-6.388 3.1-9.69-1.505.56-3.144 1.208-5.112 2.019-2.812 1.158-6.1 2.997-8.955 4.776-2.89 1.801-5.055 3.363-5.661 3.878q-.212.18-.439.324c-3.473 3.514-8.295 5.692-13.626 5.692-10.58 0-19.156-8.577-19.156-19.156 0-10.58 8.577-19.156 19.156-19.156 10.58 0 19.157 8.576 19.157 19.156l-.003.3c2.117-1.193 4.359-2.338 6.48-3.211 4.208-1.734 7.05-2.786 10.198-3.782l16.166-47.222c.715-2.09 2.99-3.204 5.08-2.489m-28.732 87.071c-1.394 1.862-2.22 4.174-2.22 6.678 0 6.162 4.995 11.157 11.157 11.157 6.161 0 11.156-4.995 11.156-11.157 0-6.161-4.995-11.156-11.156-11.156-3.263 0-6.199 1.401-8.239 3.634q-.389.487-.698.844M42.85 68.903c-6.16 0-11.156 4.994-11.156 11.156 0 6.161 4.995 11.156 11.156 11.156s11.157-4.995 11.157-11.156-4.995-11.156-11.157-11.156"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b40601__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b40601__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#b40601__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b40601__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b40601__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b40601__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#b40601__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2De7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5dd92__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5dd92__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b5dd92__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b5dd92__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b5dd92__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b5dd92__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b5dd92__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M59.312 14.848c1.045.357 1.602 1.495 1.245 2.54l-8.849 25.846 26.64-9.072c1.046-.356 2.182.203 2.538 1.248.356 1.046-.203 2.182-1.249 2.538l-28.776 9.8q-.017.12-.048.238c-.187.712-.353 1.43-.522 2.163-.505 2.188-1.04 4.499-2.257 7.127-.328.707-.699 1.427-1.092 2.137q.507-.047 1.025-.047c6.047 0 10.948 4.901 10.948 10.948 0 6.046-4.901 10.948-10.948 10.948-6.046 0-10.948-4.902-10.948-10.948 0-2.38.76-4.583 2.05-6.38q.105-.177.25-.335.227-.29.471-.565c1.084-1.381 3.273-4.543 4.615-7.44 1.03-2.222 1.438-3.988 1.916-6.056l.09-.385c-1.069.384-2.215.832-3.66 1.427-1.687.695-3.647 1.792-5.34 2.847-1.71 1.066-3.007 2-3.386 2.321q-.121.103-.253.184c-1.987 2.025-4.755 3.281-7.816 3.281-6.047 0-10.948-4.901-10.948-10.948 0-6.046 4.901-10.948 10.948-10.948 6.046 0 10.948 4.902 10.948 10.948q0 .413-.03.818c1.402-.814 2.927-1.614 4.353-2.202 2.361-.972 3.988-1.579 5.738-2.14l9.807-28.649c.358-1.045 1.495-1.602 2.54-1.244M42.408 66.146c-.872 1.16-1.389 2.604-1.389 4.168 0 3.837 3.11 6.948 6.948 6.948 3.837 0 6.948-3.11 6.948-6.948 0-3.837-3.11-6.948-6.948-6.948-2.035 0-3.866.875-5.137 2.27q-.237.296-.422.51M25.956 41.317c-3.837 0-6.948 3.11-6.948 6.948 0 3.837 3.11 6.948 6.948 6.948 3.837 0 6.948-3.11 6.948-6.948 0-3.837-3.11-6.948-6.948-6.948"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b5dd92__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b5dd92__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#b5dd92__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5dd92__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5dd92__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b5dd92__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#b5dd92__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ikI1E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "63fb8d__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.896,
                        y2: -4.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "63fb8d__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.843,
                        y2: 44.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "63fb8d__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.81,
                        y2: 16.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "63fb8d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.503)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "63fb8d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.264 26.937)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "63fb8d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "63fb8d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M29.97 7.346c.654.224 1.002.934.779 1.588l-4.218 12.32 12.485-4.252c.653-.222 1.363.127 1.586.78.222.654-.127 1.364-.78 1.587L25.807 24.14q-.076.025-.154.042-.093.378-.182.77v.001c-.255 1.1-.53 2.29-1.15 3.63q-.159.344-.342.69h.081c3.162 0 5.724 2.563 5.724 5.724s-2.562 5.724-5.724 5.724c-3.16 0-5.724-2.562-5.724-5.724 0-1.24.395-2.39 1.066-3.327q.06-.1.144-.192.113-.145.235-.283c.528-.674 1.61-2.234 2.271-3.662.464-1.001.667-1.802.882-2.722-.41.155-.858.333-1.386.55-.825.34-1.792.88-2.633 1.405-.853.531-1.488.99-1.663 1.139q-.064.054-.131.097c-1.038 1.047-2.476 1.695-4.066 1.695-3.161 0-5.724-2.563-5.724-5.724s2.563-5.724 5.724-5.724c3.152 0 5.708 2.547 5.724 5.694.596-.332 1.222-.648 1.817-.893 1.265-.522 2.113-.835 3.064-1.134l4.722-13.793c.224-.653.935-1.002 1.588-.778m-8.493 25.725c-.402.537-.64 1.205-.64 1.927 0 1.78 1.444 3.224 3.224 3.224s3.224-1.443 3.224-3.224c0-1.78-1.443-3.224-3.224-3.224-.942 0-1.79.404-2.379 1.048q-.113.143-.205.249m-8.42-12.321c-1.782 0-3.225 1.443-3.225 3.224 0 1.78 1.443 3.224 3.224 3.224 1.78 0 3.224-1.444 3.224-3.224s-1.443-3.224-3.224-3.224"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#63fb8d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#63fb8d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.863,
                            r: 20.883,
                            fill: "url(#63fb8d__c)",
                            transform: "rotate(-.08 27.142 1.863)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#63fb8d__d)",
                            d: "M18.321-8.478c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.657L6.008 46.304c3.694 2.267 8.365 2.264 12.056-.008L54.752 23.71c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#63fb8d__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.99 40.85-8.17S72.63 7.84 71.809 25.76 55.798 57.543 37.879 56.722C19.957 55.902 6.095 40.71 6.915 22.79"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#63fb8d__f)",
                            d: "M-19.448 34.606c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.331 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.649-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.279-15.033 15.318-14.246 6.077-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.673,
                            r: 20.883,
                            fill: "url(#63fb8d__g)",
                            transform: "rotate(-.08 45.2 8.673)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8rmp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Data);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDataGeneric1160Svg = require("illustration:./S2_fill_data_generic1_160.svg");
var _s2FillDataGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDataGeneric1160Svg);
var _s2FillDataGeneric196Svg = require("illustration:./S2_fill_data_generic1_96.svg");
var _s2FillDataGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDataGeneric196Svg);
var _s2FillDataGeneric148Svg = require("illustration:./S2_fill_data_generic1_48.svg");
var _s2FillDataGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDataGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Data(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_data_generic1_160.svg":"3Pr9W","illustration:./S2_fill_data_generic1_96.svg":"6ySL8","illustration:./S2_fill_data_generic1_48.svg":"bGzRN","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Pr9W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "952440__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "952440__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "952440__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "952440__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "952440__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "952440__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "952440__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m127.749 44.509.001-.082c0-6.854-21.379-12.41-47.75-12.41-26.372 0-47.75 5.556-47.75 12.41l.001.082v.197c.159.516.693 1.431 2.373 2.662 2.123 1.556 5.451 3.125 9.923 4.512C53.445 54.638 65.98 56.406 80 56.406c14.02 0 26.555-1.768 35.452-4.526 4.473-1.387 7.801-2.956 9.924-4.512 1.683-1.233 2.216-2.15 2.374-2.665v-.194zM32.251 62.557v-7.204c2.78 1.615 6.164 3.001 9.927 4.168 9.856 3.056 23.227 4.885 37.822 4.885 14.594 0 27.965-1.83 37.821-4.885 3.764-1.167 7.148-2.553 9.929-4.169v7.202c-.158.515-.691 1.431-2.374 2.665-2.123 1.556-5.451 3.125-9.924 4.512-8.897 2.758-21.432 4.525-35.452 4.525s-26.556-1.767-35.452-4.525c-4.473-1.387-7.801-2.956-9.924-4.512-1.68-1.231-2.214-2.146-2.373-2.662m95.499 10.646c-2.781 1.616-6.165 3.002-9.929 4.169-9.856 3.055-23.227 4.884-37.821 4.884-14.595 0-27.966-1.829-37.822-4.884-3.763-1.167-7.147-2.553-9.927-4.168v7.16c.159.516.693 1.431 2.373 2.663 2.123 1.556 5.451 3.124 9.923 4.511C53.445 90.296 65.98 92.064 80 92.064c14.02 0 26.555-1.768 35.452-4.526 4.473-1.386 7.801-2.955 9.924-4.511 1.683-1.234 2.216-2.15 2.374-2.665zM32.25 98.26v-7.249c2.781 1.616 6.165 3.002 9.928 4.168 9.856 3.056 23.227 4.885 37.822 4.885 14.594 0 27.965-1.83 37.821-4.885 3.764-1.166 7.148-2.553 9.929-4.168v7.246c-.158.515-.691 1.431-2.374 2.665-2.123 1.556-5.451 3.125-9.924 4.512-8.897 2.758-21.432 4.525-35.452 4.525s-26.556-1.767-35.452-4.525c-4.473-1.387-7.801-2.956-9.924-4.512-1.68-1.231-2.214-2.146-2.373-2.662m0 10.647v7.616c10.25 13.938 81.25 16.563 95.5 0v-7.617c-2.781 1.616-6.165 3.002-9.929 4.169-9.856 3.055-23.227 4.884-37.821 4.884-14.595 0-27.966-1.829-37.822-4.884-3.763-1.167-7.147-2.553-9.927-4.168"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#952440__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#952440__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#952440__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#952440__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#952440__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#952440__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#952440__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ySL8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "25f53e__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "25f53e__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "25f53e__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "25f53e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "25f53e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "25f53e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "25f53e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m78.803 25.5.002-.078c0-4.513-13.792-8.172-30.805-8.172s-30.805 3.659-30.805 8.172q0 .039.002.078h-.002v.032c.049.478.415 1.25 1.755 2.233 1.411 1.034 3.58 2.049 6.442 2.936C31.09 32.467 39.083 33.59 48 33.59s16.91-1.124 22.609-2.89c2.86-.887 5.03-1.902 6.44-2.936 1.34-.982 1.706-1.753 1.756-2.232V25.5zM17.195 36.838v-5.424c1.845 1.215 4.251 2.251 7.012 3.107 6.177 1.916 14.59 3.07 23.793 3.07 9.204 0 17.616-1.154 23.793-3.07 2.761-.856 5.167-1.892 7.012-3.107v5.426c-.05.479-.416 1.25-1.755 2.231-1.41 1.034-3.58 2.05-6.441 2.936-5.698 1.767-13.692 2.89-22.609 2.89s-16.91-1.123-22.608-2.89c-2.861-.887-5.03-1.902-6.442-2.936-1.34-.982-1.706-1.754-1.755-2.233m61.61 5.883c-1.845 1.215-4.25 2.25-7.012 3.107-6.177 1.915-14.589 3.07-23.793 3.07s-17.615-1.155-23.793-3.07c-2.761-.856-5.167-1.892-7.012-3.107v5.393c.049.478.415 1.25 1.755 2.233 1.411 1.034 3.58 2.049 6.442 2.936 5.698 1.766 13.691 2.89 22.608 2.89s16.91-1.124 22.609-2.89c2.86-.887 5.03-1.902 6.44-2.937 1.34-.98 1.706-1.752 1.756-2.23zm-61.61 16.727v-5.452c1.845 1.215 4.251 2.251 7.012 3.107 6.177 1.916 14.59 3.07 23.793 3.07 9.204 0 17.616-1.154 23.793-3.07 2.761-.856 5.167-1.891 7.012-3.107v5.453c-.05.48-.416 1.25-1.755 2.232-1.41 1.034-3.58 2.049-6.441 2.936-5.698 1.766-13.692 2.89-22.609 2.89s-16.91-1.124-22.608-2.89c-2.861-.887-5.03-1.902-6.442-2.937-1.34-.982-1.706-1.754-1.755-2.233m0 5.882v5.498c1.5 4.484 15.448 7.922 30.5 7.922 11.879 0 28.375-2.375 31.11-7.922V65.33c-1.845 1.216-4.25 2.251-7.012 3.107-6.177 1.916-14.589 3.07-23.793 3.07s-17.615-1.154-23.793-3.07c-2.761-.856-5.167-1.891-7.012-3.107"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#25f53e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#25f53e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#25f53e__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#25f53e__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#25f53e__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#25f53e__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#25f53e__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bGzRN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8a2177__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8a2177__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8a2177__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8a2177__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8a2177__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8a2177__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8a2177__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M35.97 17.516c1.21-.375 2.295-.821 3.182-1.342v2.232c-.02.146-.15.469-.776.928-.674.494-1.73.992-3.146 1.43C32.41 21.64 28.44 22.2 24 22.2s-8.412-.56-11.23-1.434c-1.418-.44-2.473-.937-3.148-1.431-.623-.457-.753-.779-.774-.925v-2.235c.886.52 1.971.967 3.18 1.342 3.12.967 7.352 1.546 11.971 1.546 4.62 0 8.852-.58 11.97-1.546m3.181-4.743c-.048-2.156-6.813-3.899-15.152-3.899S8.896 10.617 8.848 12.773c.021.146.152.468.774.924.675.494 1.73.992 3.147 1.431 2.82.874 6.79 1.434 11.23 1.434s8.412-.56 11.23-1.434c1.418-.44 2.473-.937 3.148-1.43.621-.457.752-.778.774-.925m0 9.037c-.886.521-1.971.968-3.181 1.343-3.119.967-7.35 1.546-11.97 1.546s-8.852-.58-11.971-1.546c-1.21-.375-2.295-.822-3.181-1.343v2.235c.02.147.151.47.774.926.675.494 1.73.991 3.147 1.43 2.82.875 6.79 1.434 11.23 1.434s8.412-.56 11.23-1.433c1.418-.44 2.473-.937 3.148-1.431.626-.46.754-.782.774-.928zM8.848 29.713v-2.266c.886.521 1.971.968 3.18 1.343 3.12.966 7.352 1.545 11.971 1.545 4.62 0 8.852-.579 11.97-1.546 1.21-.375 2.296-.821 3.182-1.342v2.264c-.02.146-.148.469-.775.928-.674.494-1.73.991-3.146 1.43-2.82.874-6.79 1.434-11.23 1.434s-8.412-.56-11.23-1.433c-1.418-.44-2.473-.937-3.148-1.431-.623-.457-.753-.78-.774-.926m0 3.402v2.212c.402 2 7.598 3.798 15.002 3.798 5.842 0 13.916-1.094 15.301-3.735v-2.275c-.886.521-1.971.967-3.181 1.342-3.119.967-7.35 1.546-11.97 1.546s-8.852-.579-11.971-1.546c-1.21-.375-2.295-.82-3.181-1.342"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8a2177__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8a2177__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#8a2177__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8a2177__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8a2177__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8a2177__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#8a2177__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eHVZM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DataAnalytics);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDataAnalyticsGeneric1160Svg = require("illustration:./S2_fill_dataAnalytics_generic1_160.svg");
var _s2FillDataAnalyticsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDataAnalyticsGeneric1160Svg);
var _s2FillDataAnalyticsGeneric196Svg = require("illustration:./S2_fill_dataAnalytics_generic1_96.svg");
var _s2FillDataAnalyticsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDataAnalyticsGeneric196Svg);
var _s2FillDataAnalyticsGeneric148Svg = require("illustration:./S2_fill_dataAnalytics_generic1_48.svg");
var _s2FillDataAnalyticsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDataAnalyticsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function DataAnalytics(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataAnalyticsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataAnalyticsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDataAnalyticsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_dataAnalytics_generic1_160.svg":"187GN","illustration:./S2_fill_dataAnalytics_generic1_96.svg":"eFa1r","illustration:./S2_fill_dataAnalytics_generic1_48.svg":"4sKKA","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"187GN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec1bf2__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec1bf2__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ec1bf2__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ec1bf2__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ec1bf2__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ec1bf2__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ec1bf2__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M135.135 32.355c1.371 1.733 1.078 4.249-.655 5.62L94.276 69.78c-1.238.98-2.936 1.139-4.334.408l-25.31-13.226-34.04 28.873c-1.685 1.428-4.21 1.221-5.639-.464-1.428-1.684-1.221-4.209.464-5.637L61.51 49.119c1.241-1.053 2.997-1.249 4.44-.495l25.396 13.272L129.516 31.7c1.733-1.37 4.249-1.077 5.619.655M118.043 72.51c0-3.798 3.079-6.877 6.877-6.877s6.877 3.079 6.877 6.877v45.777c0 3.798-3.079 6.877-6.877 6.877s-6.877-3.079-6.877-6.877zM58.158 87.515c0-3.798 3.08-6.877 6.877-6.877 3.798 0 6.877 3.079 6.877 6.877v30.771c0 3.798-3.079 6.877-6.877 6.877s-6.877-3.079-6.877-6.877zm36.82-.916c-3.798 0-6.877 3.079-6.877 6.877v24.81c0 3.798 3.079 6.877 6.877 6.877s6.877-3.079 6.877-6.877v-24.81c0-3.798-3.08-6.877-6.877-6.877m-59.885 11.79c-3.798 0-6.877 3.08-6.877 6.878v13.019c0 3.798 3.079 6.877 6.877 6.877s6.877-3.079 6.877-6.877v-13.019c0-3.798-3.08-6.877-6.877-6.877"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ec1bf2__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ec1bf2__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#ec1bf2__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec1bf2__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec1bf2__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ec1bf2__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#ec1bf2__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eFa1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "514d2c__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "514d2c__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "514d2c__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "514d2c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "514d2c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "514d2c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "514d2c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M79.44 20.813c.686.866.539 2.124-.328 2.81L56.016 41.893c-.619.49-1.468.57-2.167.204L39.13 34.407 19.423 51.124c-.843.714-2.105.61-2.82-.232s-.61-2.104.232-2.819l20.736-17.587c.62-.527 1.498-.625 2.22-.248l14.76 7.714 22.08-17.467c.866-.685 2.124-.538 2.81.328M35.76 51.856c0-1.927 1.562-3.49 3.49-3.49 1.927 0 3.49 1.563 3.49 3.49v18.597c0 1.928-1.563 3.49-3.49 3.49s-3.49-1.562-3.49-3.49zm20.998-.066c-1.928 0-3.49 1.563-3.49 3.49v15.175c0 1.928 1.562 3.49 3.49 3.49 1.927 0 3.49-1.562 3.49-3.49V55.28c0-1.927-1.563-3.49-3.49-3.49m14.018-8.555c0-1.927 1.563-3.49 3.49-3.49s3.49 1.563 3.49 3.49v27.22c0 1.927-1.562 3.49-3.49 3.49s-3.49-1.563-3.49-3.49zM21.74 58.564c-1.928 0-3.49 1.562-3.49 3.49v8.4c0 1.928 1.562 3.49 3.49 3.49 1.927 0 3.49-1.562 3.49-3.49v-8.4c0-1.928-1.563-3.49-3.49-3.49"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#514d2c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#514d2c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#514d2c__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#514d2c__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#514d2c__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#514d2c__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#514d2c__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4sKKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8dd955__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8dd955__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8dd955__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8dd955__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8dd955__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8dd955__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8dd955__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M39.914 10.252c.428.541.337 1.327-.205 1.756l-11.548 9.136c-.387.306-.917.356-1.354.127l-7.21-3.768-9.726 8.25c-.526.447-1.315.382-1.762-.145-.446-.526-.382-1.315.145-1.762l10.368-8.793c.388-.33.936-.39 1.387-.155l7.237 3.782 10.912-8.633c.542-.428 1.328-.337 1.756.205M17.727 26.184c0-1.105.895-2 2-2s2 .895 2 2v8.788c0 1.105-.896 2-2 2s-2-.895-2-2zm10.603-.29c-1.104 0-2 .896-2 2v7.078c0 1.105.896 2 2 2s2-.895 2-2v-7.077c0-1.105-.895-2-2-2m6.604-4.02c0-1.105.895-2 2-2s2 .895 2 2v13.099c0 1.105-.896 2-2 2s-2-.895-2-2zm-23.81 7.41c-1.106 0-2 .895-2 2v3.69c0 1.104.894 2 2 2 1.104 0 2-.896 2-2v-3.69c0-1.105-.896-2-2-2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8dd955__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8dd955__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#8dd955__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8dd955__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8dd955__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8dd955__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#8dd955__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"liZ4p":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Desktop);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDesktopGeneric1160Svg = require("illustration:./S2_fill_desktop_generic1_160.svg");
var _s2FillDesktopGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDesktopGeneric1160Svg);
var _s2FillDesktopGeneric196Svg = require("illustration:./S2_fill_desktop_generic1_96.svg");
var _s2FillDesktopGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDesktopGeneric196Svg);
var _s2FillDesktopGeneric148Svg = require("illustration:./S2_fill_desktop_generic1_48.svg");
var _s2FillDesktopGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDesktopGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Desktop(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDesktopGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDesktopGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDesktopGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_desktop_generic1_160.svg":"gfpnl","illustration:./S2_fill_desktop_generic1_96.svg":"aLQpY","illustration:./S2_fill_desktop_generic1_48.svg":"81qtq","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gfpnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fe9f57__d",
                        x1: -17.287,
                        x2: 187.234,
                        y1: 128.56,
                        y2: -3.435,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fe9f57__e",
                        x1: 152.4,
                        x2: 67.403,
                        y1: 41.582,
                        y2: 138.536,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fe9f57__f",
                        x1: 42.163,
                        x2: 198.293,
                        y1: 146.219,
                        y2: 53.439,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fe9f57__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.3377 -56.5812 0 56.581 53.338)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fe9f57__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.3377 -56.5812 0 56.581 53.338)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "fe9f57__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 130.055,
                            height: 122.6,
                            x: 15.398,
                            y: 19,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "fe9f57__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M127.029 28h-94.06c-8.84 0-16 7.16-16 16v44c0 8.84 7.16 16 16 16h36.03v24h-10.01c-2.21 0-4 1.79-4 4s1.79 4 4 4h42.02c2.21 0 4-1.79 4-4s-1.79-4-4-4h-10.01v-24h36.03c8.84 0 16-7.16 16-16V44c0-8.84-7.16-16-16-16m-47.01 20c-2.21 0-4-1.79-4-4s1.79-4 3.99-4h.01c2.21 0 4 1.79 4 4s-1.79 4-4 4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#fe9f57__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#fe9f57__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 130.055,
                            height: 122.6,
                            x: 15.398,
                            y: 19,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M15.398 19h130.055v122.6H15.398z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.581,
                            cy: 53.338,
                            fill: "url(#fe9f57__c)",
                            rx: 56.581,
                            ry: 53.338,
                            transform: "matrix(1 -.00132 .00148 1 32.273 -29.508)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fe9f57__d)",
                            d: "M65.037-2.657c-9.989-5.826-22.643-5.862-32.669-.092l-100.27 57.712c-9.82 5.653-9.837 18.994-.03 24.668l99.608 57.631c10.01 5.79 22.665 5.783 32.667-.021l99.403-57.685c9.755-5.661 9.773-18.928.029-24.611z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fe9f57__e)",
                            d: "M34.142 77.207c2.223-45.77 43.386-81.175 91.939-79.08 48.554 2.096 86.112 40.899 83.889 86.669s-43.385 81.175-91.939 79.08c-48.553-2.096-86.111-40.898-83.889-86.669"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fe9f57__f)",
                            d: "M-37.293 107.386c19.3-7.761 40.115-7.428 58.149-.64 36.085 13.619 57.082 5.199 71.645-28.74 7.254-17.03 21.417-31.454 40.739-39.224 38.631-15.512 83.229 1.32 99.66 37.628 16.432 36.309-1.553 78.284-40.175 93.816-19.365 7.788-40.22 7.423-58.281.573-36.027-13.546-56.984-5.094-71.529 28.886-7.272 16.99-21.432 31.364-40.732 39.125-38.6 15.523-83.198-1.308-99.62-37.596-16.423-36.289 1.544-78.305 40.144-93.828"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.581,
                            cy: 53.338,
                            fill: "url(#fe9f57__g)",
                            rx: 56.581,
                            ry: 53.338,
                            transform: "matrix(1 -.00132 .00148 1 81.215 -12.113)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aLQpY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fd0ff__d",
                        x1: -10.37,
                        x2: 112.343,
                        y1: 77.137,
                        y2: -2.061,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fd0ff__e",
                        x1: 91.443,
                        x2: 40.445,
                        y1: 24.95,
                        y2: 83.122,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1fd0ff__f",
                        x1: 25.3,
                        x2: 118.977,
                        y1: 87.732,
                        y2: 32.064,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1fd0ff__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.0026 -33.9487 0 33.949 32.003)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1fd0ff__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.0026 -33.9487 0 33.949 32.003)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1fd0ff__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.033,
                            height: 73.56,
                            x: 9.242,
                            y: 11.4,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1fd0ff__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M76.22 16.8H19.784c-5.304 0-9.6 4.296-9.6 9.6v26.4c0 5.304 4.296 9.6 9.6 9.6h21.618v14.4h-6.006c-1.326 0-2.4 1.074-2.4 2.4s1.074 2.4 2.4 2.4h25.212c1.326 0 2.4-1.074 2.4-2.4s-1.074-2.4-2.4-2.4h-6.006V62.4H76.22c5.304 0 9.6-4.296 9.6-9.6V26.4c0-5.304-4.296-9.6-9.6-9.6m-28.206 12c-1.326 0-2.4-1.074-2.4-2.4s1.074-2.4 2.394-2.4h.006c1.326 0 2.4 1.074 2.4 2.4s-1.074 2.4-2.4 2.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1fd0ff__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1fd0ff__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.033,
                            height: 73.56,
                            x: 9.242,
                            y: 11.4,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M9.242 11.4h78.033v73.56H9.242z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 33.949,
                            cy: 32.003,
                            fill: "url(#1fd0ff__c)",
                            rx: 33.949,
                            ry: 32.003,
                            transform: "matrix(1 -.00132 .00148 1 19.367 -17.704)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fd0ff__d)",
                            d: "M39.024-1.594c-5.993-3.495-13.585-3.517-19.6-.055L-40.74 32.98c-5.892 3.391-5.902 11.396-.018 14.8l59.765 34.579c6.006 3.474 13.6 3.47 19.6-.013l59.642-34.61c5.853-3.398 5.863-11.358.018-14.767z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fd0ff__e)",
                            d: "M20.489 46.325C21.822 18.863 46.519-2.38 75.652-1.123s51.667 24.539 50.333 52.001c-1.333 27.462-26.03 48.705-55.163 47.448S19.155 73.787 20.489 46.325"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1fd0ff__f)",
                            d: "M-22.374 64.432c11.58-4.657 24.069-4.457 34.889-.384 21.651 8.171 34.25 3.12 42.987-17.244 4.353-10.218 12.85-18.872 24.443-23.534 23.179-9.307 49.938.791 59.797 22.577 9.859 21.785-.932 46.97-24.106 56.289-11.619 4.673-24.132 4.454-34.968.344-21.616-8.127-34.19-3.056-42.917 17.332-4.364 10.193-12.86 18.818-24.44 23.475-23.16 9.314-49.918-.785-59.772-22.558s.927-46.983 24.087-56.297"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 33.949,
                            cy: 32.003,
                            fill: "url(#1fd0ff__g)",
                            rx: 33.949,
                            ry: 32.003,
                            transform: "matrix(1 -.00132 .00148 1 48.73 -7.268)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"81qtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d5bd05__d",
                        x1: -5.189,
                        x2: 56.167,
                        y1: 38.568,
                        y2: -1.03,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d5bd05__e",
                        x1: 45.718,
                        x2: 20.218,
                        y1: 12.476,
                        y2: 41.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d5bd05__f",
                        x1: 12.646,
                        x2: 59.485,
                        y1: 43.865,
                        y2: 16.031,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d5bd05__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.0013 -16.9744 0 16.974 16.001)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d5bd05__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.0013 -16.9744 0 16.974 16.001)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d5bd05__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.017,
                            height: 36.78,
                            x: 4.617,
                            y: 5.7,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "d5bd05__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M38.108 8.4H9.89c-2.652 0-4.8 2.148-4.8 4.8v13.2c0 2.652 2.148 4.8 4.8 4.8h10.809v7.2h-3.003c-.663 0-1.2.537-1.2 1.2s.537 1.2 1.2 1.2h12.606c.663 0 1.2-.537 1.2-1.2s-.537-1.2-1.2-1.2h-3.003v-7.2h10.809c2.652 0 4.8-2.148 4.8-4.8V13.2c0-2.652-2.148-4.8-4.8-4.8m-14.103 6c-.663 0-1.2-.537-1.2-1.2s.537-1.2 1.197-1.2h.003c.663 0 1.2.537 1.2 1.2s-.537 1.2-1.2 1.2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#d5bd05__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#d5bd05__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.017,
                            height: 36.78,
                            x: 4.617,
                            y: 5.7,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.617 5.7h39.017v36.78H4.617z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.974,
                            cy: 16.001,
                            fill: "url(#d5bd05__c)",
                            rx: 16.974,
                            ry: 16.001,
                            transform: "matrix(1 -.00132 .00148 1 9.68 -8.853)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d5bd05__d)",
                            d: "M19.508-.797c-2.996-1.748-6.793-1.758-9.8-.027l-30.081 17.313c-2.947 1.696-2.951 5.698-.01 7.4L9.5 41.18c3.003 1.737 6.8 1.735 9.8-.006l29.821-17.306c2.926-1.698 2.932-5.678.009-7.383z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d5bd05__e)",
                            d: "M10.24 23.163C10.907 9.432 23.256-1.19 37.822-.561s25.834 12.27 25.167 26-13.016 24.353-27.582 23.725c-14.566-.63-25.833-12.27-25.167-26.001"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d5bd05__f)",
                            d: "M-11.191 32.216c5.79-2.329 12.035-2.229 17.445-.192 10.825 4.085 17.124 1.56 21.493-8.622 2.177-5.11 6.425-9.436 12.222-11.768 11.59-4.653 24.969.396 29.898 11.289 4.93 10.893-.466 23.485-12.053 28.145-5.81 2.336-12.066 2.227-17.484.172-10.808-4.064-17.095-1.529-21.459 8.665-2.181 5.097-6.43 9.41-12.22 11.738-11.58 4.657-24.959-.392-29.885-11.28-4.927-10.886.463-23.49 12.043-28.147"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.974,
                            cy: 16.001,
                            fill: "url(#d5bd05__g)",
                            rx: 16.974,
                            ry: 16.001,
                            transform: "matrix(1 -.00132 .00148 1 24.363 -3.634)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c3ZM2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Diamond);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDiamondGeneric1160Svg = require("illustration:./S2_fill_diamond_generic1_160.svg");
var _s2FillDiamondGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDiamondGeneric1160Svg);
var _s2FillDiamondGeneric196Svg = require("illustration:./S2_fill_diamond_generic1_96.svg");
var _s2FillDiamondGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDiamondGeneric196Svg);
var _s2FillDiamondGeneric148Svg = require("illustration:./S2_fill_diamond_generic1_48.svg");
var _s2FillDiamondGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDiamondGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Diamond(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDiamondGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDiamondGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDiamondGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_diamond_generic1_160.svg":"jQcaD","illustration:./S2_fill_diamond_generic1_96.svg":"3AyFg","illustration:./S2_fill_diamond_generic1_48.svg":"9SlMS","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jQcaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b4b09c__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b4b09c__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b4b09c__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b4b09c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b4b09c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b4b09c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b4b09c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M81.538 24.563h-3.055L64.168 55.707h31.688zm23.123 31.144L90.343 24.563h14.005c2.106 0 4.127.83 5.625 2.311l26.289 25.996c.837.827 1.455 1.797 1.851 2.837zm-7.54 8H62.903L80.01 127.25zm-8.756 63.28 17.04-63.28h31.366zM55.5 24.563H69.68L55.363 55.707H21.887c.393-1.035 1.007-2.003 1.837-2.828L49.86 26.89c1.5-1.49 3.527-2.326 5.641-2.326M23.235 63.707H54.62l17.144 63.686z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b4b09c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b4b09c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#b4b09c__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b4b09c__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b4b09c__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b4b09c__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#b4b09c__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3AyFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f40fdc__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f40fdc__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f40fdc__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f40fdc__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f40fdc__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f40fdc__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f40fdc__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M49.566 16.701H46.42q-.033.099-.077.196l-8.12 17.84h19.558l-8.188-17.97q-.015-.033-.028-.066m12.612 18.035L53.96 16.701h8.265c1.053 0 2.064.415 2.812 1.156l15.646 15.47c.415.411.723.893.921 1.41zm-4.07 4H37.902l10.117 37.958zm-5.817 37.459 9.956-37.459h18.698zM33.68 16.7h8.357L33.83 34.736H14.391c.196-.514.502-.994.915-1.404L30.86 17.865c.75-.745 1.764-1.164 2.82-1.164M15.054 38.736h18.708l10.065 37.761z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f40fdc__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f40fdc__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#f40fdc__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f40fdc__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f40fdc__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f40fdc__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#f40fdc__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9SlMS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "35b7b3__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "35b7b3__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "35b7b3__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "35b7b3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "35b7b3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "35b7b3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "35b7b3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M24.515 8.352h-1.023l-3.943 8.767h8.908l-3.915-8.704q-.015-.03-.027-.063m6.684 8.767-3.944-8.767h3.859c.526 0 1.031.207 1.406.577l7.822 7.736q.21.207.345.454zm-2.434 2.5h-9.524l4.762 18.032zm-2.123 17.832 4.709-17.832h8.931zm-9.8-29.1h3.91l-3.945 8.768H7.313q.135-.245.34-.452l7.778-7.734c.375-.372.882-.581 1.41-.581M7.717 19.62h8.937l4.74 17.95z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#35b7b3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#35b7b3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#35b7b3__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#35b7b3__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#35b7b3__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#35b7b3__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#35b7b3__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7neWy":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Document);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDocumentGeneric1160Svg = require("illustration:./S2_fill_document_generic1_160.svg");
var _s2FillDocumentGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDocumentGeneric1160Svg);
var _s2FillDocumentGeneric196Svg = require("illustration:./S2_fill_document_generic1_96.svg");
var _s2FillDocumentGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDocumentGeneric196Svg);
var _s2FillDocumentGeneric148Svg = require("illustration:./S2_fill_document_generic1_48.svg");
var _s2FillDocumentGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDocumentGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Document(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDocumentGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDocumentGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDocumentGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_document_generic1_160.svg":"iOfzW","illustration:./S2_fill_document_generic1_96.svg":"49J0n","illustration:./S2_fill_document_generic1_48.svg":"dCXlJ","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iOfzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b0fe3a__d",
                        x1: -24.537,
                        x2: 201.681,
                        y1: 134.772,
                        y2: -2.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b0fe3a__e",
                        x1: 157.003,
                        x2: 59.956,
                        y1: 36.058,
                        y2: 140.411,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b0fe3a__f",
                        x1: 39.065,
                        x2: 211.102,
                        y1: 154.813,
                        y2: 58.44,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b0fe3a__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.639 52.464)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b0fe3a__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.948 88.515)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b0fe3a__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "b0fe3a__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M80.001 61.91V27.787c-.323-.027-.648-.049-.975-.049H47.84c-6.66 0-12.06 5.4-12.06 12.06v80.4c0 6.661 5.4 12.06 12.06 12.06h64.32c6.661 0 12.06-5.399 12.06-12.06V72.935c0-.328-.022-.652-.048-.976H90.051c-5.541 0-10.05-4.508-10.05-10.05"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M90.053 63.92h30.15l-32.16-32.16v30.15c0 1.108.902 2.01 2.01 2.01"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b0fe3a__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b0fe3a__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.43 10.429h139.142V149.57H10.43z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.103,
                            cy: 15.826,
                            r: 60.534,
                            fill: "url(#b0fe3a__c)",
                            transform: "rotate(-.08 89.103 15.826)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b0fe3a__d)",
                            d: "M63.539-14.15c-10.686-6.612-24.225-6.653-34.95-.104L-78.689 51.244C-89.194 57.66-89.212 72.8-78.72 79.24l106.568 65.406c10.71 6.572 24.248 6.564 34.949-.023l106.347-65.468c10.437-6.425 10.456-21.483.032-27.932z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b0fe3a__e)",
                            d: "M30.483 76.49c2.378-51.946 46.417-92.128 98.362-89.75 51.946 2.378 92.128 46.417 89.75 98.362-2.378 51.946-46.416 92.128-98.362 89.75s-92.128-46.416-89.75-98.362"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b0fe3a__f)",
                            d: "M-45.943 110.741c20.649-8.809 42.918-8.432 62.211-.727 38.607 15.456 61.07 5.9 76.651-32.618 7.761-19.328 22.913-35.697 43.585-44.516 41.33-17.604 89.044 1.497 106.623 42.705s-1.662 88.847-42.982 106.474c-20.718 8.839-43.03 8.425-62.353.65-38.544-15.373-60.965-5.781-76.526 32.784-7.78 19.282-22.93 35.595-43.578 44.404-41.297 17.617-89.01-1.485-106.58-42.669-17.57-41.185 1.652-88.87 42.95-106.487"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.463,
                            cy: 35.567,
                            r: 60.534,
                            fill: "url(#b0fe3a__g)",
                            transform: "rotate(-.08 141.463 35.567)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"49J0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "868fc6__d",
                        x1: -14.724,
                        x2: 121.006,
                        y1: 80.863,
                        y2: -1.714,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "868fc6__e",
                        x1: 94.203,
                        x2: 35.974,
                        y1: 21.635,
                        y2: 84.246,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "868fc6__f",
                        x1: 23.438,
                        x2: 126.661,
                        y1: 92.888,
                        y2: 35.064,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "868fc6__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.982 31.479)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "868fc6__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.768 53.108)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "868fc6__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "868fc6__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M47.997 37.146V16.673c-.194-.016-.39-.03-.585-.03H28.7c-3.997 0-7.236 3.24-7.236 7.237v48.24c0 3.996 3.24 7.236 7.236 7.236h38.592c3.996 0 7.236-3.24 7.236-7.236V43.76c0-.195-.013-.39-.03-.584H54.028c-3.325 0-6.03-2.705-6.03-6.03"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M54.026 38.352h18.09L52.82 19.056v18.09c0 .665.541 1.206 1.206 1.206"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#868fc6__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#868fc6__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.258 6.258h83.485v83.485H6.258z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.461,
                            cy: 9.496,
                            r: 36.321,
                            fill: "url(#868fc6__c)",
                            transform: "rotate(-.08 53.461 9.496)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#868fc6__d)",
                            d: "M38.121-8.49c-6.412-3.967-14.535-3.992-20.97-.062l-64.366 39.3c-6.304 3.848-6.314 12.933-.02 16.797l63.941 39.243c6.426 3.944 14.55 3.939 20.97-.014l63.808-39.28c6.262-3.855 6.274-12.89.019-16.76z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#868fc6__e)",
                            d: "M18.29 45.894c1.428-31.167 27.85-55.277 59.018-53.85s55.277 27.85 53.85 59.018-27.85 55.276-59.017 53.849c-31.168-1.426-55.277-27.85-53.85-59.017"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#868fc6__f)",
                            d: "M-27.566 66.445c12.389-5.285 25.75-5.059 37.326-.436 23.164 9.274 36.642 3.54 45.99-19.57 4.657-11.598 13.749-21.42 26.152-26.71 24.798-10.563 53.426.898 63.974 25.623 10.547 24.724-.998 53.307-25.79 63.884-12.43 5.303-25.818 5.055-37.412.39-23.126-9.224-36.579-3.469-45.915 19.67C32.09 140.865 23 150.653 10.612 155.938c-24.778 10.571-53.406-.89-63.948-25.601s.991-53.322 25.77-63.892"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.875,
                            cy: 21.34,
                            r: 36.321,
                            fill: "url(#868fc6__g)",
                            transform: "rotate(-.08 84.875 21.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dCXlJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "632733__d",
                        x1: -7.36,
                        x2: 60.505,
                        y1: 40.432,
                        y2: -0.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "632733__e",
                        x1: 47.099,
                        x2: 17.985,
                        y1: 10.818,
                        y2: 42.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "632733__f",
                        x1: 11.721,
                        x2: 63.332,
                        y1: 46.444,
                        y2: 17.532,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "632733__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.992 15.74)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "632733__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.885 26.555)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "632733__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "632733__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24 18.573V8.337q-.145-.014-.292-.015h-9.356c-1.998 0-3.618 1.62-3.618 3.618v24.12c0 1.998 1.62 3.618 3.618 3.618h19.296c1.999 0 3.618-1.62 3.618-3.618V21.88q-.001-.146-.014-.292H27.015c-1.662 0-3.015-1.352-3.015-3.015"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M27.013 19.176h9.045L26.41 9.528v9.045c0 .333.27.603.603.603"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#632733__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#632733__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.129 3.129H44.87V44.87H3.129z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.733,
                            cy: 4.748,
                            r: 18.16,
                            fill: "url(#632733__c)",
                            transform: "rotate(-.08 26.733 4.748)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#632733__d)",
                            d: "M19.062-4.245c-3.205-1.984-7.267-1.996-10.485-.031l-32.183 19.65c-3.151 1.924-3.157 6.466-.01 8.398L8.356 43.394c3.213 1.972 7.275 1.97 10.485-.007l31.904-19.64c3.131-1.928 3.137-6.445.01-8.38z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#632733__e)",
                            d: "M9.143 22.948C9.857 7.364 23.068-4.691 38.652-3.977S66.29 9.948 65.577 25.53c-.713 15.584-13.925 27.639-29.509 26.925S8.43 38.531 9.143 22.948"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#632733__f)",
                            d: "M-13.781 33.222c6.194-2.642 12.875-2.529 18.663-.218 11.582 4.637 18.321 1.77 22.995-9.785 2.329-5.798 6.874-10.71 13.076-13.355 12.399-5.281 26.713.45 31.987 12.812S72.44 49.33 60.045 54.618c-6.215 2.651-12.909 2.527-18.706.195-11.563-4.612-18.29-1.734-22.958 9.835-2.334 5.785-6.878 10.679-13.073 13.321-12.389 5.285-26.703-.445-31.974-12.8s.496-26.661 12.885-31.947"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.44,
                            cy: 10.67,
                            r: 18.16,
                            fill: "url(#632733__g)",
                            transform: "rotate(-.08 42.44 10.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5wtWW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Download);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDownloadGeneric1160Svg = require("illustration:./S2_fill_download_generic1_160.svg");
var _s2FillDownloadGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDownloadGeneric1160Svg);
var _s2FillDownloadGeneric196Svg = require("illustration:./S2_fill_download_generic1_96.svg");
var _s2FillDownloadGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDownloadGeneric196Svg);
var _s2FillDownloadGeneric148Svg = require("illustration:./S2_fill_download_generic1_48.svg");
var _s2FillDownloadGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDownloadGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Download(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDownloadGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDownloadGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDownloadGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_download_generic1_160.svg":"7Zd3j","illustration:./S2_fill_download_generic1_96.svg":"fU9bY","illustration:./S2_fill_download_generic1_48.svg":"6lfBk","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7Zd3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c6de5c__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c6de5c__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c6de5c__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c6de5c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c6de5c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c6de5c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "c6de5c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M28.335 80.742c2.209 0 4 1.79 4 4v29.411c0 4.59 3.682 8.255 8.157 8.255h79.019c4.475 0 8.157-3.665 8.157-8.255V84.741c0-2.209 1.791-4 4-4s4 1.791 4 4v29.412c0 8.947-7.203 16.255-16.157 16.255h-79.02c-8.953 0-16.156-7.308-16.156-16.255V84.741c0-2.209 1.79-4 4-4m51.667-51.15c2.209 0 4 1.79 4 4v64.32l16.671-16.67c1.562-1.563 4.095-1.563 5.657 0 1.562 1.561 1.562 4.094 0 5.656l-23.5 23.5c-1.562 1.562-4.095 1.562-5.657 0l-23.5-23.5c-1.562-1.562-1.562-4.095 0-5.657s4.095-1.562 5.657 0l16.672 16.672V33.59c0-2.209 1.79-4 4-4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c6de5c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#c6de5c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#c6de5c__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c6de5c__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c6de5c__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#c6de5c__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#c6de5c__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fU9bY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d4d9a9__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d4d9a9__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d4d9a9__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d4d9a9__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d4d9a9__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d4d9a9__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "d4d9a9__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M17 48.6c1.105 0 2 .895 2 2v17.647c0 2.971 2.385 5.353 5.294 5.353h47.412c2.909 0 5.294-2.382 5.294-5.353V50.6c0-1.105.895-2 2-2s2 .895 2 2v17.647c0 5.15-4.146 9.353-9.294 9.353H24.294C19.146 77.6 15 73.397 15 68.247V50.6c0-1.105.895-2 2-2m31-30.692c1.105 0 2 .896 2 2v35.863l10.586-10.586c.78-.78 2.047-.78 2.828 0 .781.781.781 2.048 0 2.829l-14 14c-.78.78-2.047.78-2.828 0l-14-14c-.781-.781-.781-2.048 0-2.829.78-.78 2.047-.78 2.828 0L46 55.771V19.908c0-1.104.895-2 2-2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#d4d9a9__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#d4d9a9__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#d4d9a9__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d4d9a9__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d4d9a9__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d4d9a9__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#d4d9a9__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6lfBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab541b__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab541b__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ab541b__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ab541b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ab541b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ab541b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ab541b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M8.5 24.173c.69 0 1.25.56 1.25 1.25v8.823c0 1.35 1.083 2.427 2.397 2.427h23.706c1.314 0 2.397-1.077 2.397-2.427v-8.823c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25v8.823c0 2.712-2.183 4.927-4.897 4.927H12.147c-2.714 0-4.897-2.215-4.897-4.927v-8.823c0-.69.56-1.25 1.25-1.25M24 8.828c.69 0 1.25.56 1.25 1.25V28.66l4.866-4.866c.488-.488 1.28-.488 1.768 0s.488 1.28 0 1.768l-7 7c-.488.488-1.28.488-1.768 0l-7-7c-.488-.488-.488-1.28 0-1.768s1.28-.488 1.768 0l4.866 4.866v-18.58c0-.691.56-1.25 1.25-1.25"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ab541b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ab541b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#ab541b__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab541b__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab541b__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ab541b__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#ab541b__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"31xYA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DropToUpload);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillDropToUploadGeneric1160Svg = require("illustration:./S2_fill_dropToUpload_generic1_160.svg");
var _s2FillDropToUploadGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillDropToUploadGeneric1160Svg);
var _s2FillDropToUploadGeneric196Svg = require("illustration:./S2_fill_dropToUpload_generic1_96.svg");
var _s2FillDropToUploadGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillDropToUploadGeneric196Svg);
var _s2FillDropToUploadGeneric148Svg = require("illustration:./S2_fill_dropToUpload_generic1_48.svg");
var _s2FillDropToUploadGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillDropToUploadGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function DropToUpload(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDropToUploadGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDropToUploadGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillDropToUploadGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_dropToUpload_generic1_160.svg":"cDpts","illustration:./S2_fill_dropToUpload_generic1_96.svg":"5EyN3","illustration:./S2_fill_dropToUpload_generic1_48.svg":"aDAPC","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cDpts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "784b02__d",
                        x1: -32.943,
                        x2: 206.051,
                        y1: 135.365,
                        y2: -10.037,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "784b02__e",
                        x1: 158.85,
                        x2: 56.322,
                        y1: 31.077,
                        y2: 141.323,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "784b02__f",
                        x1: 34.252,
                        x2: 216.005,
                        y1: 156.538,
                        y2: 54.722,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "784b02__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 38.708 48.409)scale(63.953)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "784b02__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 55.938 86.495)scale(63.953)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "784b02__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 147,
                            height: 147,
                            x: 4,
                            y: 4,
                            fill: "#fff",
                            rx: 4.438
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "784b02__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M51.739 21.933h27.404c2.81 0 5.506 1.116 7.494 3.104l29.118 29.118c1.988 1.988 3.104 4.683 3.104 7.494v41.535c0 5.853-4.745 10.598-10.598 10.598H51.739c-5.853 0-10.598-4.745-10.598-10.598V32.531c0-5.853 4.745-10.598 10.598-10.598m31 30.625c.004-1.951-1.574-3.536-3.525-3.54s-3.536 1.573-3.54 3.524l-.079 34.983-11.943-9.5c-1.527-1.214-3.75-.96-4.964.566-1.214 1.528-.96 3.75.566 4.964l17.793 14.152c1.294 1.03 3.13 1.023 4.418-.016L98.999 83.54c1.518-1.226 1.755-3.45.53-4.968s-3.45-1.756-4.968-.53l-11.9 9.605zM22.4 75.523c0-1.767 1.433-3.2 3.2-3.2h5.881c1.767 0 3.2-1.432 3.2-3.2 0-1.767-1.433-3.2-3.2-3.2H25.6c-5.302 0-9.6 4.298-9.6 9.6v5.535c0 1.768 1.433 3.2 3.2 3.2s3.2-1.432 3.2-3.2zm106.119-9.6c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2h5.881c1.767 0 3.2 1.433 3.2 3.2v5.535c0 1.768 1.433 3.2 3.2 3.2s3.2-1.432 3.2-3.2v-5.535c0-5.302-4.298-9.6-9.6-9.6zM144 95.588c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2v11.07c0 1.768 1.433 3.2 3.2 3.2s3.2-1.432 3.2-3.2zm-121.6 0c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2v11.07c0 1.768 1.433 3.2 3.2 3.2s3.2-1.432 3.2-3.2zm0 25.6c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2v5.535c0 5.302 4.298 9.6 9.6 9.6h5.881c1.767 0 3.2-1.432 3.2-3.2 0-1.767-1.433-3.2-3.2-3.2H25.6c-1.767 0-3.2-1.432-3.2-3.2zm121.6 0c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2v5.535c0 1.768-1.433 3.2-3.2 3.2h-5.881c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2h5.881c5.302 0 9.6-4.298 9.6-9.6zm-97.081 8.735c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2H58.68c1.767 0 3.2-1.432 3.2-3.2 0-1.767-1.433-3.2-3.2-3.2zm27.2 0c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2H85.88c1.767 0 3.2-1.432 3.2-3.2 0-1.767-1.433-3.2-3.2-3.2zm27.2 0c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2h11.762c1.767 0 3.2-1.432 3.2-3.2 0-1.767-1.433-3.2-3.2-3.2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#784b02__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#784b02__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 147,
                            height: 147,
                            x: 4,
                            y: 4,
                            fill: "#FFECCF",
                            rx: 4.438
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4 4h147v147H4z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 87.117,
                            cy: 9.701,
                            r: 63.953,
                            fill: "url(#784b02__c)",
                            transform: "rotate(-.08 87.117 9.701)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#784b02__d)",
                            d: "M60.107-21.967c-11.29-6.986-25.593-7.029-36.925-.11L-90.152 47.12c-11.1 6.777-11.119 22.774-.034 29.577L22.4 145.8c11.314 6.943 25.618 6.935 36.923-.025l112.354-69.165c11.025-6.789 11.046-22.696.033-29.51z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#784b02__e)",
                            d: "M25.184 73.792c2.513-54.88 49.038-97.331 103.918-94.818 54.879 2.512 97.331 49.037 94.818 103.917-2.512 54.879-49.037 97.331-103.917 94.818-54.88-2.512-97.331-49.037-94.819-103.917"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#784b02__f)",
                            d: "M-55.557 109.977c21.815-9.306 45.342-8.907 65.725-.767 40.787 16.329 64.52 6.233 80.98-34.46 8.199-20.42 24.207-37.714 46.046-47.03 43.664-18.6 94.073 1.581 112.645 45.116 18.572 43.536-1.756 93.864-45.41 112.488-21.888 9.337-45.46 8.9-65.874.687-40.721-16.242-64.408-6.108-80.848 34.634-8.22 20.371-24.224 37.606-46.039 46.912-43.63 18.613-94.038-1.568-112.6-45.079s1.746-93.888 45.375-112.501"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 142.433,
                            cy: 30.558,
                            r: 63.953,
                            fill: "url(#784b02__g)",
                            transform: "rotate(-.08 142.433 30.558)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5EyN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "851f4c__d",
                        x1: -19.766,
                        x2: 123.63,
                        y1: 81.22,
                        y2: -6.021,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "851f4c__e",
                        x1: 95.308,
                        x2: 33.791,
                        y1: 18.646,
                        y2: 84.794,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "851f4c__f",
                        x1: 20.551,
                        x2: 129.603,
                        y1: 93.923,
                        y2: 32.834,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "851f4c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 23.224 29.045)scale(38.3718)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "851f4c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 33.56 51.896)scale(38.3718)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "851f4c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 88.2,
                            height: 88.2,
                            x: 2.398,
                            y: 2.4,
                            fill: "#fff",
                            rx: 2.663
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "851f4c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M31.046 13.16h16.442c1.687 0 3.304.67 4.496 1.862l17.472 17.47c1.192 1.193 1.862 2.81 1.862 4.497V61.91c0 3.512-2.847 6.359-6.359 6.359H31.046c-3.512 0-6.36-2.847-6.36-6.359V19.518c0-3.512 2.848-6.359 6.36-6.359m18.6 18.374c.002-1.17-.945-2.121-2.115-2.124s-2.122.944-2.125 2.115l-.047 20.99-7.165-5.7c-.916-.729-2.25-.577-2.979.34-.728.916-.576 2.25.34 2.978l10.675 8.49c.777.619 1.879.615 2.651-.009l10.52-8.49c.911-.736 1.054-2.07.319-2.981s-2.07-1.054-2.981-.319l-7.14 5.764zm-36.204 13.78c0-1.06.86-1.92 1.92-1.92h3.528c1.06 0 1.92-.86 1.92-1.92s-.86-1.92-1.92-1.92h-3.528c-3.182 0-5.76 2.578-5.76 5.76v3.32c0 1.061.86 1.92 1.92 1.92s1.92-.859 1.92-1.92zm63.67-5.76c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92h3.53c1.06 0 1.92.86 1.92 1.92v3.32c0 1.061.86 1.92 1.92 1.92s1.92-.859 1.92-1.92v-3.32c0-3.182-2.58-5.76-5.76-5.76zm9.29 17.798c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92 1.92v6.643c0 1.06.86 1.92 1.92 1.92s1.92-.86 1.92-1.92zm-72.96 0c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92 1.92v6.643c0 1.06.86 1.92 1.92 1.92s1.92-.86 1.92-1.92zm0 15.36c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92 1.92v3.322c0 3.18 2.578 5.76 5.76 5.76h3.528c1.06 0 1.92-.86 1.92-1.92s-.86-1.92-1.92-1.92h-3.528c-1.06 0-1.92-.86-1.92-1.92zm72.96 0c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92 1.92v3.322c0 1.06-.86 1.92-1.92 1.92h-3.53c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92h3.53c3.18 0 5.76-2.58 5.76-5.76zm-58.25 5.242c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92h7.058c1.06 0 1.92-.86 1.92-1.92s-.86-1.92-1.92-1.92zm16.32 0c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92h7.058c1.06 0 1.92-.86 1.92-1.92s-.86-1.92-1.92-1.92zm16.32 0c-1.06 0-1.92.86-1.92 1.92s.86 1.92 1.92 1.92h7.058c1.06 0 1.92-.86 1.92-1.92s-.86-1.92-1.92-1.92z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#851f4c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#851f4c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 88.2,
                            height: 88.2,
                            x: 2.398,
                            y: 2.4,
                            fill: "#FFECCF",
                            rx: 2.663
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.398 2.4h88.2v88.2h-88.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 52.269,
                            cy: 5.821,
                            r: 38.372,
                            fill: "url(#851f4c__c)",
                            transform: "rotate(-.08 52.27 5.821)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#851f4c__d)",
                            d: "M36.063-13.18c-6.773-4.19-15.356-4.216-22.154-.065l-68.001 41.519c-6.66 4.066-6.671 13.664-.02 17.746l67.551 41.46c6.789 4.166 15.371 4.161 22.154-.015l67.412-41.499c6.616-4.073 6.628-13.617.02-17.706z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#851f4c__e)",
                            d: "M15.11 44.276c1.507-32.928 29.422-58.4 62.35-56.892s58.398 29.423 56.891 62.35-29.423 58.399-62.35 56.892c-32.928-1.508-58.4-29.423-56.892-62.35"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#851f4c__f)",
                            d: "M-33.334 65.987c13.089-5.584 27.205-5.345 39.435-.46 24.472 9.797 38.711 3.74 48.588-20.677 4.92-12.252 14.524-22.628 27.627-28.218 26.199-11.16 56.444.95 67.587 27.07s-1.053 56.319-27.245 67.493c-13.133 5.602-27.276 5.34-39.525.412-24.433-9.745-38.645-3.665-48.509 20.78-4.932 12.223-14.534 22.564-27.623 28.148-26.178 11.167-56.423-.941-67.56-27.048s1.047-56.333 27.225-67.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 85.457,
                            cy: 18.335,
                            r: 38.372,
                            fill: "url(#851f4c__g)",
                            transform: "rotate(-.08 85.457 18.335)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aDAPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8c4c5f__d",
                        x1: -9.883,
                        x2: 61.815,
                        y1: 40.61,
                        y2: -3.011,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8c4c5f__e",
                        x1: 47.656,
                        x2: 16.898,
                        y1: 9.323,
                        y2: 42.397,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8c4c5f__f",
                        x1: 10.275,
                        x2: 64.802,
                        y1: 46.962,
                        y2: 16.417,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8c4c5f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 11.612 14.523)scale(19.1859)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8c4c5f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 16.78 25.948)scale(19.1859)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8c4c5f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 44.1,
                            height: 44.1,
                            x: 1.199,
                            y: 1.2,
                            fill: "#fff",
                            rx: 1.331
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8c4c5f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M15.523 6.58h8.221c.843 0 1.652.335 2.248.931l8.736 8.736c.596.596.931 1.405.931 2.248v12.46c0 1.756-1.423 3.18-3.18 3.18H15.524c-1.756 0-3.18-1.424-3.18-3.18V9.76c0-1.755 1.424-3.179 3.18-3.179m9.299 9.188c.001-.586-.472-1.061-1.057-1.062-.586-.002-1.061.472-1.063 1.057l-.023 10.495-3.583-2.85c-.458-.364-1.125-.288-1.49.17-.364.458-.288 1.125.17 1.489l5.338 4.245c.389.31.94.307 1.326-.004l5.26-4.246c.455-.367.527-1.035.159-1.49s-1.035-.527-1.49-.16l-3.57 2.882zM6.72 22.658c0-.53.43-.96.96-.96h1.764c.53 0 .96-.43.96-.96s-.43-.96-.96-.96H7.681c-1.59 0-2.88 1.289-2.88 2.88v1.66c0 .53.43.96.96.96s.96-.43.96-.96zm31.836-2.88c-.53 0-.96.43-.96.96s.43.96.96.96h1.764c.53 0 .96.43.96.96v1.66c0 .53.43.96.96.96s.96-.43.96-.96v-1.66c0-1.591-1.29-2.88-2.88-2.88zm4.644 8.899c0-.53-.43-.96-.96-.96s-.96.43-.96.96v3.32c0 .531.43.96.96.96s.96-.429.96-.96zm-36.48 0c0-.53-.43-.96-.96-.96s-.96.43-.96.96v3.32c0 .531.43.96.96.96s.96-.429.96-.96zm0 7.68c0-.53-.43-.96-.96-.96s-.96.43-.96.96v1.66c0 1.59 1.29 2.88 2.88 2.88h1.764c.53 0 .96-.43.96-.96s-.43-.96-.96-.96H7.681c-.53 0-.96-.43-.96-.96zm36.48 0c0-.53-.43-.96-.96-.96s-.96.43-.96.96v1.66c0 .53-.43.96-.96.96h-1.764c-.53 0-.96.43-.96.96s.43.96.96.96h1.764c1.59 0 2.88-1.29 2.88-2.88zm-29.124 2.62c-.53 0-.96.43-.96.96s.43.96.96.96h3.528c.53 0 .96-.43.96-.96s-.43-.96-.96-.96zm8.16 0c-.53 0-.96.43-.96.96s.43.96.96.96h3.528c.53 0 .96-.43.96-.96s-.43-.96-.96-.96zm8.16 0c-.53 0-.96.43-.96.96s.43.96.96.96h3.528c.53 0 .96-.43.96-.96s-.43-.96-.96-.96z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8c4c5f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8c4c5f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 44.1,
                            height: 44.1,
                            x: 1.199,
                            y: 1.2,
                            fill: "#FFECCF",
                            rx: 1.331
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M1.2 1.2h44.1v44.1H1.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.135,
                            cy: 2.911,
                            r: 19.186,
                            fill: "url(#8c4c5f__c)",
                            transform: "rotate(-.08 26.135 2.911)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8c4c5f__d)",
                            d: "M18.032-6.59C14.645-8.686 10.354-8.7 6.954-6.623l-34 20.76c-3.33 2.032-3.336 6.832-.01 8.872L6.72 43.74c3.394 2.084 7.685 2.081 11.076-.007l33.707-20.75c3.307-2.036 3.313-6.808.01-8.852z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8c4c5f__e)",
                            d: "M7.556 22.138C8.31 5.674 22.268-7.062 38.732-6.308S67.93 8.404 67.177 24.867s-14.711 29.2-31.175 28.446-29.2-14.711-28.446-31.175"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8c4c5f__f)",
                            d: "M-16.667 32.993c6.544-2.792 13.602-2.672 19.717-.23 12.236 4.899 19.356 1.87 24.294-10.338 2.46-6.126 7.262-11.314 13.814-14.11 13.1-5.579 28.222.476 33.794 13.536s-.527 28.16-13.623 33.746c-6.567 2.801-13.638 2.67-19.763.206-12.216-4.872-19.322-1.832-24.254 10.39-2.466 6.112-7.267 11.282-13.812 14.074-13.088 5.584-28.21-.47-33.78-13.523-5.568-13.054.524-28.167 13.613-33.75"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.728,
                            cy: 9.168,
                            r: 19.186,
                            fill: "url(#8c4c5f__g)",
                            transform: "rotate(-.08 42.728 9.168)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gD8JL":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Education);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillEducationGeneric1160Svg = require("illustration:./S2_fill_education_generic1_160.svg");
var _s2FillEducationGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillEducationGeneric1160Svg);
var _s2FillEducationGeneric196Svg = require("illustration:./S2_fill_education_generic1_96.svg");
var _s2FillEducationGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillEducationGeneric196Svg);
var _s2FillEducationGeneric148Svg = require("illustration:./S2_fill_education_generic1_48.svg");
var _s2FillEducationGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillEducationGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Education(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEducationGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEducationGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEducationGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_education_generic1_160.svg":"l2SAE","illustration:./S2_fill_education_generic1_96.svg":"4Iap0","illustration:./S2_fill_education_generic1_48.svg":"jrorO","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l2SAE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d3ff__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d3ff__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f3d3ff__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f3d3ff__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f3d3ff__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f3d3ff__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f3d3ff__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m30.444 50.95 46.532-19.008c1.939-.792 4.111-.792 6.05 0L129.56 50.95c6.633 2.71 6.633 12.102 0 14.812l-4.084 1.668v23.183c0 3.005-.803 7.337-3.836 11.853-3.04 4.528-8.165 9.013-16.445 12.562-6.673 2.859-14.368 3.959-21.085 4.208-6.73.251-12.815-.341-16.436-1.087-2.164-.446-3.557-2.561-3.111-4.724s2.56-3.557 4.724-3.112c2.907.599 8.343 1.159 14.526.929 6.196-.23 12.806-1.243 18.23-3.568 7.111-3.047 10.914-6.627 12.955-9.667 2.048-3.05 2.478-5.79 2.478-7.394V70.699L83.026 84.77c-1.939.792-4.111.792-6.05 0L53.93 75.356c.29-.32.633-.596 1.022-.812L81.943 59.55c1.931-1.073 2.627-3.508 1.554-5.439s-3.508-2.627-5.439-1.554L51.067 67.551c-2.014 1.119-3.623 2.768-4.693 4.718l-15.93-6.507c-6.633-2.71-6.633-12.103 0-14.812m14.45 60.659V78.041c0-2.054.526-4.033 1.48-5.772l7.556 3.087c-.656.724-1.035 1.677-1.035 2.685v32.678c2.817 4.951 5.712 11.287 6.278 16.662q.09.615.09 1.253c0 5.09-4.384 9.216-9.793 9.216s-9.792-4.126-9.792-9.216q0-.513.058-1.011c.422-5.11 2.764-11.132 5.159-16.014"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f3d3ff__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f3d3ff__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f3d3ff__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d3ff__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d3ff__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f3d3ff__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f3d3ff__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Iap0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a15cfe__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a15cfe__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a15cfe__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a15cfe__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a15cfe__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a15cfe__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "a15cfe__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m18.526 30.379 27.96-11.422c.97-.396 2.056-.396 3.025 0l27.96 11.421c3.316 1.355 3.316 6.052 0 7.406l-3.903 1.595v13.068c0 1.662-.444 4.073-2.136 6.594-1.697 2.526-4.569 5.048-9.242 7.051-3.756 1.61-8.1 2.233-11.905 2.374-3.813.142-7.255-.194-9.292-.614-1.082-.222-1.778-1.28-1.555-2.362.222-1.082 1.28-1.778 2.362-1.555 1.68.345 4.797.665 8.336.534 3.546-.132 7.347-.712 10.478-2.054 4.089-1.752 6.3-3.822 7.497-5.604 1.2-1.788 1.457-3.402 1.457-4.364V41.013l-20.057 8.193c-.97.396-2.055.396-3.025 0L33.354 43.84c.51-.718 1.18-1.328 1.978-1.771l13.595-7.553c.966-.536 1.314-1.754.777-2.72-.536-.965-1.754-1.313-2.72-.776L33.39 38.573c-1.609.894-2.908 2.194-3.798 3.732l-11.066-4.52c-3.316-1.355-3.316-6.052 0-7.406m9.72 33.466v-16.53c0-1.791.48-3.514 1.346-5.01l3.762 1.536c-.709.998-1.108 2.207-1.108 3.474v16.098c1.688 2.882 3.513 6.735 3.853 9.973q.05.345.05.702v.005c0 2.898-2.496 5.247-5.575 5.247s-5.576-2.35-5.576-5.247q0-.295.034-.581c.258-3.106 1.76-6.8 3.214-9.667"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a15cfe__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#a15cfe__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#a15cfe__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a15cfe__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a15cfe__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a15cfe__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#a15cfe__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jrorO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92faca__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92faca__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92faca__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "92faca__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "92faca__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "92faca__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "92faca__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m9.31 15.316 13.913-5.683c.485-.198 1.028-.198 1.513 0l13.912 5.683c1.659.678 1.659 3.026 0 3.703l-1.612.659v6.669c0 .874-.234 2.13-1.11 3.436-.88 1.31-2.357 2.599-4.73 3.616-1.918.821-4.123 1.136-6.042 1.207-1.924.071-3.665-.098-4.706-.312-.676-.14-1.111-.8-.972-1.476.14-.676.8-1.112 1.476-.972.818.168 2.356.327 4.109.262 1.756-.066 3.623-.353 5.15-1.007 2.007-.86 3.072-1.867 3.639-2.712.57-.848.686-1.605.686-2.042v-5.648l-9.8 4.003c-.485.198-1.028.198-1.513 0l-6.298-2.572c.228-.304.52-.562.864-.753l6.798-3.777c.603-.335.82-1.096.485-1.7s-1.096-.82-1.7-.485l-6.797 3.776c-.85.473-1.536 1.162-2.004 1.977L9.31 19.02c-1.66-.677-1.66-3.025 0-3.703m4.565 17.237V23.78c0-.934.248-1.831.696-2.613l2.354.962c-.351.468-.55 1.045-.55 1.65v8.487c.765 1.378 1.522 3.087 1.676 4.546q.025.174.025.355c0 1.45-1.248 2.624-2.787 2.624-1.54 0-2.788-1.174-2.788-2.623q0-.147.017-.288c.113-1.376.715-2.983 1.357-4.328"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#92faca__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#92faca__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#92faca__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92faca__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92faca__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92faca__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#92faca__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aAN8U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Effects);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillEffectsGeneric1160Svg = require("illustration:./S2_fill_effects_generic1_160.svg");
var _s2FillEffectsGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillEffectsGeneric1160Svg);
var _s2FillEffectsGeneric196Svg = require("illustration:./S2_fill_effects_generic1_96.svg");
var _s2FillEffectsGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillEffectsGeneric196Svg);
var _s2FillEffectsGeneric148Svg = require("illustration:./S2_fill_effects_generic1_48.svg");
var _s2FillEffectsGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillEffectsGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Effects(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEffectsGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEffectsGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEffectsGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_effects_generic1_160.svg":"4Mcwd","illustration:./S2_fill_effects_generic1_96.svg":"2cK3e","illustration:./S2_fill_effects_generic1_48.svg":"gujSn","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Mcwd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bb4408__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bb4408__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bb4408__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bb4408__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bb4408__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "bb4408__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "bb4408__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M73.866 30.965c-3.7 2.817-6.314 7.278-7.825 11.423l-5.35 17.434h28.054c1.454 0 2.795.79 3.5 2.063l10.991 19.857c7.514-7.507 15.095-15.08 20.809-20.786 1.563-1.56 4.096-1.559 5.657.004s1.559 4.096-.004 5.657c-6.126 6.117-14.397 14.38-22.431 22.407l12.442 22.476c1.07 1.933.37 4.367-1.563 5.437s-4.367.371-5.436-1.562l-11.33-20.468-2.719 2.718c-5.15 5.148-9.781 9.779-13.135 13.138-1.677 1.679-3.033 3.039-3.975 3.985-.472.473-.836.84-1.085 1.091l-.182.186-.093.093-.023.025c-1.374 1.499-3.687 1.739-5.347.494-1.767-1.325-2.125-3.833-.8-5.6.102-.136.195-.24.207-.254l.001-.001.067-.074.067-.071.107-.11.308-.313 1.103-1.11c.946-.951 2.307-2.314 3.984-3.995 3.357-3.36 7.99-7.994 13.14-13.142l4.344-4.342-10.962-19.803H58.235L36.95 137.173c-.648 2.112-2.886 3.299-4.998 2.651s-3.298-2.886-2.65-4.998l20.565-67.004H37.059c-2.21 0-4-1.79-4-4s1.79-4 4-4h15.263l6.1-19.877q.03-.093.063-.184c1.806-5.006 5.15-11.06 10.533-15.16 5.602-4.267 13.107-6.161 22.307-3.085 2.095.701 3.226 2.968 2.525 5.063-.7 2.095-2.967 3.225-5.062 2.524-6.672-2.231-11.415-.81-14.922 1.862m6.276 85.204.012-.012c-.053.058-.07.073-.012.012"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#bb4408__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#bb4408__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#bb4408__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bb4408__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bb4408__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bb4408__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#bb4408__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2cK3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac1546__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac1546__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac1546__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ac1546__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ac1546__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ac1546__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ac1546__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M44.124 18.464c-2.279 1.736-3.867 4.464-4.779 6.97L36.013 36.29h17.183c.727 0 1.397.395 1.75 1.031l6.775 12.24 12.721-12.706c.782-.78 2.048-.78 2.828.002s.78 2.048-.001 2.829c-3.692 3.686-8.695 8.683-13.532 13.517l7.531 13.605c.535.967.185 2.184-.781 2.719s-2.183.185-2.718-.782l-6.976-12.6-1.97 1.969c-3.06 3.06-5.813 5.812-7.807 7.808l-2.363 2.368-.645.65-.165.168-.02.02c-.687.752-1.845.873-2.675.25-.884-.663-1.063-1.916-.4-2.8.05-.068.097-.12.103-.127l.001-.001.034-.037.035-.038.023-.024.038-.04.182-.183.654-.66 2.368-2.373c1.995-1.997 4.748-4.75 7.809-7.81l2.783-2.782-6.761-12.213H34.785L22.053 81.774c-.324 1.056-1.443 1.65-2.499 1.325s-1.649-1.443-1.325-2.499l12.372-40.31h-8.122c-1.105 0-2-.895-2-2s.895-2 2-2h9.35l3.707-12.078.03-.092c1.06-2.936 3.014-6.46 6.135-8.838 3.23-2.46 7.56-3.564 12.909-1.775 1.047.35 1.612 1.483 1.262 2.53-.35 1.048-1.483 1.614-2.531 1.263-4.084-1.366-7.033-.499-9.217 1.164m3.687 50.677.004-.004c-.026.03-.034.036-.004.004"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ac1546__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ac1546__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#ac1546__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac1546__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac1546__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac1546__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#ac1546__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gujSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "db9671__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "db9671__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "db9671__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "db9671__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "db9671__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "db9671__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "db9671__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M22.214 9.431c-1.086.827-1.858 2.14-2.304 3.365l-1.565 5.098h8.253c.455 0 .874.247 1.094.645l3.227 5.83 6.125-6.119c.489-.488 1.28-.487 1.768.001.488.489.487 1.28-.001 1.768-1.812 1.81-4.256 4.25-6.632 6.625l3.674 6.639c.334.604.116 1.364-.488 1.699s-1.365.115-1.7-.489l-3.326-6.01-.751.75c-1.53 1.53-2.907 2.906-3.903 3.904l-1.181 1.184-.322.325-.082.082-.006.007c-.43.467-1.152.542-1.67.153-.553-.414-.665-1.197-.25-1.75.032-.042.06-.074.064-.079l.013-.014.008-.01.021-.021.032-.033.092-.093q.116-.118.328-.33l1.184-1.187c.997-1 2.374-2.376 3.905-3.906l1.258-1.258-3.218-5.813h-8.283L11.266 40.96c-.203.66-.902 1.031-1.562.829-.66-.203-1.03-.902-.828-1.562l6.087-19.833H11.24c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25h4.49l1.799-5.861q.009-.03.02-.058c.538-1.494 1.538-3.305 3.15-4.533 1.68-1.28 3.932-1.847 6.685-.926.655.22 1.008.928.79 1.582-.22.655-.928 1.008-1.583.79-1.963-.657-3.351-.239-4.377.543"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#db9671__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#db9671__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#db9671__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#db9671__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#db9671__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#db9671__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#db9671__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deLX9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Emoji);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillEmojiGeneric1160Svg = require("illustration:./S2_fill_emoji_generic1_160.svg");
var _s2FillEmojiGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillEmojiGeneric1160Svg);
var _s2FillEmojiGeneric196Svg = require("illustration:./S2_fill_emoji_generic1_96.svg");
var _s2FillEmojiGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillEmojiGeneric196Svg);
var _s2FillEmojiGeneric148Svg = require("illustration:./S2_fill_emoji_generic1_48.svg");
var _s2FillEmojiGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillEmojiGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Emoji(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmojiGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmojiGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmojiGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_emoji_generic1_160.svg":"4Xpd3","illustration:./S2_fill_emoji_generic1_96.svg":"kPklF","illustration:./S2_fill_emoji_generic1_48.svg":"2gEAr","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Xpd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f2a729__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f2a729__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f2a729__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f2a729__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f2a729__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f2a729__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f2a729__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M80 135.746c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56m-11.629-71.5c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5m37 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5m2.878 26.725c1.733 1.37 2.026 3.886.655 5.619-3.37 4.257-7.696 7.696-12.638 10.06s-10.372 3.593-15.872 3.596-10.932-1.219-15.877-3.577-9.276-5.792-12.65-10.045c-1.373-1.73-1.084-4.247.647-5.62 1.73-1.373 4.247-1.083 5.62.647 2.606 3.285 5.966 5.956 9.827 7.797 3.86 1.842 8.113 2.801 12.428 2.798s8.566-.967 12.425-2.812c3.858-1.846 7.214-4.52 9.817-7.809 1.37-1.732 3.886-2.025 5.618-.654"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f2a729__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f2a729__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f2a729__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f2a729__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f2a729__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f2a729__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f2a729__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kPklF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5cd192__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5cd192__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5cd192__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5cd192__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5cd192__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5cd192__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5cd192__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M48 80.746c18.225 0 33-14.774 33-33s-14.775-33-33-33-33 14.775-33 33 14.775 33 33 33m-6.853-42.134c0 2.116-1.715 3.83-3.83 3.83s-3.831-1.714-3.831-3.83 1.715-3.83 3.83-3.83 3.83 1.715 3.83 3.83m21.803 0c0 2.116-1.715 3.83-3.83 3.83s-3.83-1.714-3.83-3.83 1.714-3.83 3.83-3.83 3.83 1.715 3.83 3.83m1.696 15.749c1.021.808 1.194 2.29.386 3.31-1.986 2.51-4.535 4.537-7.448 5.93-2.912 1.393-6.112 2.117-9.353 2.118-3.241.002-6.442-.718-9.356-2.107s-5.466-3.413-7.454-5.92c-.81-1.02-.639-2.502.381-3.312 1.02-.809 2.503-.638 3.312.382 1.536 1.936 3.516 3.51 5.79 4.594 2.276 1.085 4.782 1.65 7.324 1.65 2.543-.002 5.048-.57 7.322-1.658s4.252-2.664 5.785-4.602c.808-1.02 2.29-1.193 3.311-.385"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5cd192__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5cd192__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#5cd192__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5cd192__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5cd192__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5cd192__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#5cd192__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2gEAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1793e7__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1793e7__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1793e7__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1793e7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1793e7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1793e7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1793e7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M24 40.754c9.113 0 16.5-7.387 16.5-16.5s-7.387-16.5-16.5-16.5-16.5 7.387-16.5 16.5 7.387 16.5 16.5 16.5m-3.427-21.067c0 1.057-.858 1.915-1.916 1.915s-1.915-.858-1.915-1.915c0-1.058.858-1.915 1.915-1.915 1.058 0 1.916.857 1.916 1.915m10.901 0c0 1.057-.857 1.915-1.915 1.915s-1.915-.858-1.915-1.915c0-1.058.858-1.915 1.915-1.915 1.058 0 1.915.857 1.915 1.915m.848 7.874c.51.404.597 1.145.193 1.656-.993 1.254-2.267 2.267-3.724 2.964-1.456.697-3.056 1.058-4.676 1.06-1.62 0-3.221-.36-4.678-1.054s-2.733-1.707-3.727-2.96c-.405-.51-.32-1.252.19-1.656.51-.405 1.252-.32 1.656.19.768.969 1.758 1.756 2.896 2.298s2.39.825 3.661.824c1.272 0 2.524-.285 3.661-.828 1.137-.544 2.126-1.332 2.893-2.301.404-.51 1.145-.597 1.655-.193"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1793e7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1793e7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#1793e7__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1793e7__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1793e7__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1793e7__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#1793e7__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cifcc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EmptyStateExport);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillEmptyStateExportGeneric1160Svg = require("illustration:./S2_fill_EmptyStateExport_generic1_160.svg");
var _s2FillEmptyStateExportGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillEmptyStateExportGeneric1160Svg);
var _s2FillEmptyStateExportGeneric196Svg = require("illustration:./S2_fill_EmptyStateExport_generic1_96.svg");
var _s2FillEmptyStateExportGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillEmptyStateExportGeneric196Svg);
var _s2FillEmptyStateExportGeneric148Svg = require("illustration:./S2_fill_EmptyStateExport_generic1_48.svg");
var _s2FillEmptyStateExportGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillEmptyStateExportGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function EmptyStateExport(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmptyStateExportGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmptyStateExportGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillEmptyStateExportGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_EmptyStateExport_generic1_160.svg":"a4A31","illustration:./S2_fill_EmptyStateExport_generic1_96.svg":"HYkkc","illustration:./S2_fill_EmptyStateExport_generic1_48.svg":"jbzc7","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a4A31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a53a7d__d",
                        x1: -21.932,
                        x2: 196.624,
                        y1: 133.068,
                        y2: -8.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a53a7d__e",
                        x1: 159.425,
                        x2: 68.606,
                        y1: 40.13,
                        y2: 143.748,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a53a7d__f",
                        x1: 41.607,
                        x2: 208.454,
                        y1: 151.936,
                        y2: 52.763,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a53a7d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 56.9922 -60.4726 0 60.473 56.992)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a53a7d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 56.9922 -60.4726 0 60.473 56.992)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a53a7d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139,
                            height: 131,
                            x: 13,
                            y: 16,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "a53a7d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M111.999 16h20c6.627 0 12 5.373 12 12v44c0 6.627-5.373 12-12 12h-20c-6.628 0-12-5.373-12-12V28c0-6.627 5.372-12 12-12m-54 84h44c6.627 0 12 5.373 12 12v20c0 6.627-5.373 12-12 12h-44c-6.628 0-12-5.373-12-12v-20c0-6.627 5.372-12 12-12m8.25-28.53 8.26 20.12c1.34 3.25 5.92 3.32 7.35.11l2.41-5.4c.4-.9 1.12-1.62 2.02-2.02l5.39-2.41c3.21-1.43 3.14-6.02-.11-7.35l-20.11-8.27c-3.29-1.35-6.57 1.93-5.22 5.22zm-9.83 3.88c2.21 0 4 1.79 4 4s-1.79 4-4 4h-20.45c-1.49 3.06-4.61 5.17-8.24 5.17-5.07 0-9.17-4.11-9.17-9.17 0-3.63 2.12-6.75 5.17-8.24V35.9c-3.06-1.49-5.17-4.61-5.17-8.24 0-5.07 4.11-9.17 9.17-9.17 3.63 0 6.75 2.12 8.24 5.17h35.06c1.49-3.06 4.61-5.17 8.24-5.17 5.07 0 9.17 4.11 9.17 9.17 0 3.63-2.12 6.75-5.17 8.24v20.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V35.9c-1.85-.9-3.34-2.4-4.24-4.24h-35.06c-.9 1.85-2.4 3.34-4.24 4.24v35.21c1.85.9 3.34 2.4 4.24 4.24z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a53a7d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#a53a7d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139,
                            height: 131,
                            x: 13,
                            y: 16,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M13 16h139v131H13z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.473,
                            cy: 56.992,
                            fill: "url(#a53a7d__c)",
                            rx: 60.473,
                            ry: 56.992,
                            transform: "matrix(1 -.00132 .00148 1 31.035 -35.831)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a53a7d__d)",
                            d: "M66.054-7.14c-10.675-6.226-24.2-6.264-34.915-.098L-76.028 54.428c-10.495 6.04-10.513 20.296-.032 26.358L30.4 142.365c10.699 6.188 24.224 6.18 34.914-.022l106.239-61.637c10.426-6.05 10.445-20.225.032-26.298z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a53a7d__e)",
                            d: "M33.034 78.196C35.409 29.29 79.403-8.542 131.296-6.303s92.034 43.7 89.658 92.607-46.369 86.737-98.262 84.498-92.034-43.7-89.658-92.606"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a53a7d__f)",
                            d: "M-43.314 110.443c20.628-8.294 42.874-7.938 62.148-.684 38.567 14.552 61.008 5.555 76.573-30.71 7.753-18.197 22.89-33.608 43.54-41.911 41.288-16.574 88.953 1.41 106.515 40.207 17.562 38.796-1.66 83.647-42.938 100.243-20.697 8.321-42.987 7.932-62.29.612-38.505-14.474-60.903-5.443-76.448 30.865-7.773 18.154-22.906 33.513-43.533 41.806-41.255 16.587-88.92-1.397-106.472-40.172s1.65-83.67 42.905-100.256"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 60.473,
                            cy: 56.992,
                            fill: "url(#a53a7d__g)",
                            rx: 60.473,
                            ry: 56.992,
                            transform: "matrix(1 -.00132 .00148 1 83.34 -17.245)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"HYkkc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "28bfb9__d",
                        x1: -13.157,
                        x2: 117.977,
                        y1: 79.84,
                        y2: -4.813,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "28bfb9__e",
                        x1: 95.656,
                        x2: 41.164,
                        y1: 24.077,
                        y2: 86.248,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "28bfb9__f",
                        x1: 24.965,
                        x2: 125.073,
                        y1: 91.161,
                        y2: 31.657,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "28bfb9__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.1953 -36.2836 0 36.284 34.195)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "28bfb9__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 34.1953 -36.2836 0 36.284 34.195)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "28bfb9__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.4,
                            height: 78.6,
                            x: 7.801,
                            y: 9.6,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "28bfb9__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M67.2 9.6h12c3.977 0 7.2 3.223 7.2 7.2v26.4c0 3.976-3.223 7.2-7.2 7.2h-12c-3.976 0-7.2-3.224-7.2-7.2V16.8c0-3.977 3.224-7.2 7.2-7.2M34.8 60h26.4c3.977 0 7.2 3.223 7.2 7.2v12c0 3.976-3.223 7.2-7.2 7.2H34.8c-3.976 0-7.2-3.224-7.2-7.2v-12c0-3.977 3.224-7.2 7.2-7.2m4.951-17.118 4.956 12.072c.804 1.95 3.552 1.992 4.41.066l1.446-3.24c.24-.54.672-.973 1.212-1.212l3.234-1.447c1.926-.858 1.884-3.611-.066-4.41L42.877 39.75c-1.974-.81-3.942 1.158-3.132 3.133zm-5.898 2.328c1.326 0 2.4 1.074 2.4 2.4s-1.074 2.4-2.4 2.4h-12.27c-.894 1.836-2.766 3.102-4.944 3.102-3.042 0-5.502-2.466-5.502-5.502 0-2.178 1.272-4.05 3.102-4.944V21.54c-1.836-.894-3.102-2.766-3.102-4.944 0-3.042 2.466-5.502 5.502-5.502 2.178 0 4.05 1.272 4.944 3.102h21.036c.894-1.836 2.766-3.102 4.944-3.102 3.042 0 5.502 2.466 5.502 5.502 0 2.178-1.272 4.05-3.102 4.944v12.3c0 1.326-1.074 2.4-2.4 2.4s-2.4-1.074-2.4-2.4v-12.3c-1.11-.54-2.004-1.44-2.544-2.544H21.583c-.54 1.11-1.44 2.004-2.544 2.544v21.126c1.11.54 2.004 1.44 2.544 2.544z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#28bfb9__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#28bfb9__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.4,
                            height: 78.6,
                            x: 7.801,
                            y: 9.6,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7.8 9.6h83.4v78.6H7.8z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.284,
                            cy: 34.195,
                            fill: "url(#28bfb9__c)",
                            rx: 36.284,
                            ry: 34.195,
                            transform: "matrix(1 -.00132 .00148 1 18.621 -21.499)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#28bfb9__d)",
                            d: "M39.635-4.285c-6.405-3.735-14.52-3.758-20.95-.06l-64.3 37.001c-6.297 3.624-6.307 12.177-.018 15.815l63.875 36.947c6.419 3.713 14.534 3.708 20.948-.013l63.743-36.982c6.256-3.63 6.267-12.135.02-15.779z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#28bfb9__e)",
                            d: "M19.82 46.917c1.426-29.344 27.822-52.043 58.958-50.7 31.136 1.344 55.221 26.22 53.795 55.565-1.425 29.343-27.821 52.042-58.957 50.699s-55.22-26.22-53.795-55.564"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#28bfb9__f)",
                            d: "M-25.987 66.265c12.376-4.976 25.724-4.763 37.288-.41 23.14 8.73 36.605 3.332 45.944-18.426 4.652-10.919 13.734-20.165 26.124-25.147 24.773-9.945 53.372.846 63.909 24.124s-.996 50.189-25.763 60.146c-12.418 4.993-25.792 4.759-37.374.367-23.103-8.684-36.542-3.265-45.869 18.519-4.663 10.893-13.743 20.108-26.12 25.084-24.753 9.952-53.352-.839-63.883-24.104-10.53-23.264.99-50.201 25.744-60.153"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 36.284,
                            cy: 34.195,
                            fill: "url(#28bfb9__g)",
                            rx: 36.284,
                            ry: 34.195,
                            transform: "matrix(1 -.00132 .00148 1 50.004 -10.348)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jbzc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d48d83__d",
                        x1: -6.582,
                        x2: 58.985,
                        y1: 39.92,
                        y2: -2.406,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d48d83__e",
                        x1: 47.824,
                        x2: 20.578,
                        y1: 12.039,
                        y2: 43.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d48d83__f",
                        x1: 12.481,
                        x2: 62.535,
                        y1: 45.58,
                        y2: 15.829,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d48d83__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.0977 -18.1418 0 18.142 17.098)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d48d83__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.0977 -18.1418 0 18.142 17.098)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d48d83__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.7,
                            height: 39.3,
                            x: 3.898,
                            y: 4.8,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "d48d83__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M33.598 4.8h6c1.989 0 3.6 1.612 3.6 3.6v13.2c0 1.988-1.611 3.6-3.6 3.6h-6c-1.988 0-3.6-1.612-3.6-3.6V8.4c0-1.988 1.612-3.6 3.6-3.6M17.398 30h13.2c1.989 0 3.6 1.612 3.6 3.6v6c0 1.988-1.611 3.6-3.6 3.6h-13.2c-1.988 0-3.6-1.612-3.6-3.6v-6c0-1.988 1.612-3.6 3.6-3.6m2.476-8.56 2.478 6.037c.402.975 1.776.996 2.205.033l.723-1.62c.12-.27.336-.486.606-.606l1.617-.723c.963-.43.942-1.806-.033-2.205l-6.033-2.481c-.987-.405-1.971.579-1.566 1.566zm-2.95 1.165c.663 0 1.2.537 1.2 1.2s-.537 1.2-1.2 1.2H10.79c-.447.918-1.383 1.55-2.472 1.55-1.52 0-2.75-1.232-2.75-2.75 0-1.09.635-2.025 1.55-2.472V10.77c-.918-.447-1.55-1.383-1.55-2.472 0-1.521 1.232-2.751 2.75-2.751 1.09 0 2.025.636 2.472 1.55h10.518c.447-.917 1.383-1.55 2.472-1.55 1.521 0 2.751 1.233 2.751 2.75 0 1.09-.636 2.026-1.55 2.473v6.15c0 .663-.538 1.2-1.2 1.2-.664 0-1.2-.537-1.2-1.2v-6.15c-.556-.27-1.003-.72-1.273-1.272H10.79c-.27.555-.72 1.002-1.272 1.272v10.563c.555.27 1.002.72 1.272 1.272z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#d48d83__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#d48d83__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.7,
                            height: 39.3,
                            x: 3.898,
                            y: 4.8,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.898 4.8h41.7v39.3h-41.7z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.142,
                            cy: 17.098,
                            fill: "url(#d48d83__c)",
                            rx: 18.142,
                            ry: 17.098,
                            transform: "matrix(1 -.00132 .00148 1 9.309 -10.75)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d48d83__d)",
                            d: "M19.814-2.142c-3.203-1.868-7.26-1.88-10.475-.03l-32.15 18.5c-3.149 1.812-3.154 6.09-.01 7.908L9.117 42.71c3.21 1.856 7.267 1.854 10.474-.007l31.872-18.491c3.128-1.815 3.133-6.068.01-7.89z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d48d83__e)",
                            d: "M9.907 23.459c.712-14.672 13.91-26.021 29.478-25.35 15.568.672 27.61 13.11 26.898 27.782-.713 14.672-13.911 26.022-29.479 25.35S9.194 38.13 9.907 23.459"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d48d83__f)",
                            d: "M-12.996 33.132c6.189-2.488 12.862-2.38 18.645-.205 11.57 4.366 18.302 1.667 22.972-9.213 2.325-5.459 6.866-10.082 13.062-12.573 12.386-4.972 26.685.423 31.954 12.062s-.498 25.094-12.882 30.073c-6.209 2.496-12.895 2.38-18.686.184-11.552-4.343-18.271-1.633-22.935 9.26-2.332 5.445-6.872 10.053-13.06 12.541-12.376 4.976-26.676-.42-31.941-12.052s.495-25.1 12.871-30.077"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.142,
                            cy: 17.098,
                            fill: "url(#d48d83__g)",
                            rx: 18.142,
                            ry: 17.098,
                            transform: "matrix(1 -.00132 .00148 1 25 -5.174)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8zJ7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Explosion);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillExplosionGeneric1160Svg = require("illustration:./S2_fill_explosion_generic1_160.svg");
var _s2FillExplosionGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillExplosionGeneric1160Svg);
var _s2FillExplosionGeneric196Svg = require("illustration:./S2_fill_explosion_generic1_96.svg");
var _s2FillExplosionGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillExplosionGeneric196Svg);
var _s2FillExplosionGeneric148Svg = require("illustration:./S2_fill_explosion_generic1_48.svg");
var _s2FillExplosionGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillExplosionGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Explosion(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExplosionGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExplosionGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExplosionGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_explosion_generic1_160.svg":"3GBuZ","illustration:./S2_fill_explosion_generic1_96.svg":"jDR80","illustration:./S2_fill_explosion_generic1_48.svg":"lrISl","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3GBuZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fbfb67__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fbfb67__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fbfb67__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fbfb67__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fbfb67__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "fbfb67__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "fbfb67__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M32.513 26.206c-3.146-5.824 4.07-11.705 9.139-7.446l35.67 29.971 20.785-22.948c4.14-4.572 11.656-.67 10.3 5.346l-5.967 26.478h45.746c6.925 0 8.343 9.788 1.703 11.753l-39.652 11.737 12.026 14.157c3.962 4.664-.782 11.571-6.558 9.546l-18.324-6.422v39.044c0 6.661-9.234 8.361-11.606 2.136l-14.589-38.28c-9.388 5.399-22.184 12.657-30.308 17.255-5.635 3.19-11.534-3.526-7.842-8.711 4.73-6.645 11.689-16.462 16.837-23.915l-27.677-7.103c-6.065-1.557-5.99-10.197.1-11.649l28.654-6.827z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#fbfb67__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#fbfb67__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#fbfb67__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fbfb67__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fbfb67__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fbfb67__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#fbfb67__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jDR80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3d125e__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3d125e__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3d125e__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3d125e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3d125e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3d125e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3d125e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    d: "M19.241 14.645c-1.573-2.912 2.036-5.852 4.57-3.723l22.613 19 13.309-14.694c2.07-2.286 5.828-.335 5.15 2.673l-3.878 17.21h29.483c3.463 0 4.172 4.894.852 5.877l-25.846 7.65 8.141 9.583c1.981 2.332-.391 5.786-3.279 4.774l-12.296-4.31v25.21c0 3.331-4.617 4.181-5.804 1.069l-9.355-24.55c-6.002 3.456-14.548 8.3-19.48 11.09-2.835 1.605-5.751-1.783-3.916-4.358C22.438 63.03 27.193 56.33 30.52 51.5l-18.044-4.63c-3.033-.78-2.995-5.1.05-5.825l18.586-4.428z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3d125e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3d125e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#3d125e__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3d125e__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3d125e__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3d125e__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#3d125e__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lrISl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ed988a__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.896,
                        y2: -4.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ed988a__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.843,
                        y2: 44.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ed988a__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.81,
                        y2: 16.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ed988a__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.503)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ed988a__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.264 26.937)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ed988a__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ed988a__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    d: "M9.403 7.442c-.918-1.699 1.187-3.414 2.665-2.172l11.122 9.345 6.493-7.168c1.208-1.334 3.4-.196 3.004 1.56l-1.87 8.3h14.43c2.019 0 2.432 2.854.496 3.427L33.188 24.45l3.822 4.5c1.156 1.36-.228 3.374-1.913 2.784l-5.815-2.039v12.253c0 1.943-2.694 2.439-3.386.623l-4.573-12c-2.985 1.716-7.09 4.043-9.487 5.4-1.656.936-3.354-1.042-2.285-2.542 1.408-1.976 3.654-5.142 5.302-7.526l-8.675-2.226c-1.769-.454-1.747-2.974.03-3.398l8.975-2.138z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ed988a__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ed988a__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.863,
                            r: 20.883,
                            fill: "url(#ed988a__c)",
                            transform: "rotate(-.08 27.142 1.863)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ed988a__d)",
                            d: "M18.321-8.478c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.657L6.008 46.304c3.694 2.267 8.365 2.264 12.056-.008L54.752 23.71c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ed988a__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.99 40.85-8.17S72.63 7.84 71.809 25.76 55.798 57.543 37.879 56.722C19.957 55.902 6.095 40.71 6.915 22.79"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ed988a__f)",
                            d: "M-19.448 34.606c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.331 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.649-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.279-15.033 15.318-14.246 6.077-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.673,
                            r: 20.883,
                            fill: "url(#ed988a__g)",
                            transform: "rotate(-.08 45.2 8.673)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Ykxh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExportTo);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillExportToGeneric1160Svg = require("illustration:./S2_fill_exportTo_generic1_160.svg");
var _s2FillExportToGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillExportToGeneric1160Svg);
var _s2FillExportToGeneric196Svg = require("illustration:./S2_fill_exportTo_generic1_96.svg");
var _s2FillExportToGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillExportToGeneric196Svg);
var _s2FillExportToGeneric148Svg = require("illustration:./S2_fill_exportTo_generic1_48.svg");
var _s2FillExportToGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillExportToGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function ExportTo(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExportToGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExportToGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExportToGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_exportTo_generic1_160.svg":"68XUu","illustration:./S2_fill_exportTo_generic1_96.svg":"2fABw","illustration:./S2_fill_exportTo_generic1_48.svg":"gxhQy","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"68XUu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5df385__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5df385__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5df385__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5df385__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5df385__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5df385__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5df385__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M136.935 18.969c2.209 0 4 1.79 4 4v25.935c0 2.21-1.791 4-4 4s-4-1.79-4-4V32.595l-9.803 9.803-34.809 34.808c-1.562 1.562-4.094 1.562-5.656 0s-1.562-4.094 0-5.657l34.838-34.838 9.742-9.742h-16.248c-2.209 0-4-1.791-4-4s1.791-4 4-4zm-11.63 31.484q0-.163-.004-.325L93.273 82.156c-4.295 4.296-11.26 4.296-15.556 0s-4.296-11.26 0-15.556l32.137-32.138q-.273-.009-.549-.009H43.75c-8.837 0-16 7.164-16 16v65.555c0 8.836 7.163 16 16 16h65.555c8.836 0 16-7.164 16-16z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5df385__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5df385__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#5df385__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5df385__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5df385__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5df385__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#5df385__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2fABw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7d7e7c__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7d7e7c__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7d7e7c__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7d7e7c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7d7e7c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "7d7e7c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "7d7e7c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M16.999 31c0-4.418 3.582-8 8-8h40q.477 0 .94.055L45.463 43.53c-1.953 1.953-1.953 5.118 0 7.07 1.953 1.954 5.118 1.953 7.071 0L72.957 30.18Q73 30.584 73 31v40c0 4.418-3.582 8-8 8h-40c-4.418 0-8-3.582-8-8zm30.585 14.652 21.52-21.52 5.14-5.14H63.999c-1.104 0-2-.896-2-2s.896-2 2-2h14.967c1.104 0 2 .895 2 2v14.967c0 1.104-.896 2-2 2s-2-.896-2-2v-10.03l-5.05 5.049L50.414 48.48q-.147.146-.314.256c-.776.512-1.831.427-2.515-.256-.78-.781-.78-2.048 0-2.829"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#7d7e7c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#7d7e7c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#7d7e7c__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7d7e7c__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7d7e7c__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7d7e7c__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#7d7e7c__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gxhQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e397a5__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e397a5__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e397a5__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e397a5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e397a5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "e397a5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "e397a5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M8.498 15.5c0-2.21 1.79-4 4-4h19.234q.132.013.266.013h.631L22.553 21.589c-1.074 1.074-1.074 2.815 0 3.889s2.815 1.074 3.89 0l10.054-10.055.001.077v20c0 2.21-1.79 4-4 4h-20c-2.21 0-4-1.79-4-4zm15.116 7.15 10.71-10.71 1.927-1.927h-4.253c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25h7.525c.69 0 1.25.56 1.25 1.25v7.525c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-4.763l-2.193 2.193-10.698 10.7q-.092.09-.196.16c-.486.32-1.145.266-1.572-.16-.488-.49-.488-1.28 0-1.769"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#e397a5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#e397a5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#e397a5__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e397a5__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e397a5__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e397a5__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#e397a5__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"817xM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Exposure);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillExposureGeneric1160Svg = require("illustration:./S2_fill_exposure_generic1_160.svg");
var _s2FillExposureGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillExposureGeneric1160Svg);
var _s2FillExposureGeneric196Svg = require("illustration:./S2_fill_exposure_generic1_96.svg");
var _s2FillExposureGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillExposureGeneric196Svg);
var _s2FillExposureGeneric148Svg = require("illustration:./S2_fill_exposure_generic1_48.svg");
var _s2FillExposureGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillExposureGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Exposure(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExposureGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExposureGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillExposureGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_exposure_generic1_160.svg":"dTILB","illustration:./S2_fill_exposure_generic1_96.svg":"852Wo","illustration:./S2_fill_exposure_generic1_48.svg":"4FKfn","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dTILB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "668b7b__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.982,
                        y2: -15.278,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "668b7b__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "668b7b__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "668b7b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "668b7b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "668b7b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "668b7b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M23.309 79.577c0-15.054 5.985-28.71 15.705-38.718l18.439 56.452H26.496q-.148 0-.294.01c-1.876-5.572-2.893-11.54-2.893-17.744m32.658-12.581L45.55 35.104C54.837 28.131 66.378 24 78.884 24c9.712 0 18.842 2.491 26.786 6.87zM29.613 105.31c9.283 17.737 27.864 29.841 49.271 29.841h.287l9.416-29.841zm58.17 29.133 17.297-54.816 26.091 18.828c-6.756 18.707-23.265 32.75-43.388 35.988m45.657-44.216c.67-3.447 1.02-7.008 1.02-10.651 0-17.916-8.477-33.851-21.639-44.015L85.353 55.527z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#668b7b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#668b7b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#668b7b__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#668b7b__d)",
                            d: "M61.07-28.264c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.549 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#668b7b__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#668b7b__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#668b7b__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"852Wo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24438c__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.166,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24438c__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24438c__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.618,
                        y2: 33.126,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "24438c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "24438c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "24438c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "24438c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M14.688 48.075c0-9.353 3.859-17.804 10.071-23.849l11.205 34.467H16.418c-1.122-3.335-1.73-6.905-1.73-10.618m19.558-7.602-6.195-19.059c5.551-4.152 12.442-6.61 19.907-6.61 5.793 0 11.24 1.48 15.984 4.084zm-16.183 22.22c5.411 11.046 16.765 18.652 29.895 18.652h.141l5.9-18.652zm34.324 18.36 10.821-34.21 16.31 11.79c-3.962 11.85-14.411 20.728-27.131 22.42m-1.279-47.892 29.504 21.326c.405-2.075.617-4.219.617-6.413 0-11.041-5.379-20.826-13.659-26.878z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#24438c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#24438c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#24438c__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24438c__d)",
                            d: "M36.643-16.957c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.426-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24438c__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24438c__f)",
                            d: "M-38.895 69.21c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.315 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#24438c__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4FKfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "97422e__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.894,
                        y2: -4.584,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "97422e__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.841,
                        y2: 44.839,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "97422e__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.808,
                        y2: 16.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "97422e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "97422e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "97422e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "97422e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M14.025 10.707C16.801 8.63 20.246 7.4 23.979 7.4c2.918 0 5.66.752 8.045 2.071l-14.902 10.76zm-2.042 1.805c-2.873 2.99-4.64 7.05-4.64 11.525 0 1.857.305 3.643.867 5.312l.037-.001h9.21zm11.996 28.16c-6.364 0-11.894-3.574-14.691-8.824h17.564l-2.784 8.824zm2.784-.232 5.114-16.214 7.715 5.566c-2.032 5.51-6.898 9.649-12.83 10.648m-.76-23.536 14.306 10.323c.2-1.033.306-2.1.306-3.19 0-5.312-2.49-10.042-6.366-13.088z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#97422e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#97422e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: -0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0-.001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.861,
                            r: 20.883,
                            fill: "url(#97422e__c)",
                            transform: "rotate(-.08 27.142 1.861)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#97422e__d)",
                            d: "M18.321-8.48c-3.686-2.28-8.357-2.295-12.057-.036L-30.743 14.08c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.3c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#97422e__e)",
                            d: "M6.916 22.788C7.736 4.868 22.93-8.993 40.85-8.172S72.63 7.84 71.809 25.758c-.82 17.92-16.012 31.782-33.931 30.962-17.92-.82-31.782-16.013-30.962-33.933"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#97422e__f)",
                            d: "M-19.448 34.604c7.124-3.039 14.806-2.908 21.462-.25C15.332 39.686 23.08 36.389 28.456 23.1c2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.671,
                            r: 20.883,
                            fill: "url(#97422e__g)",
                            transform: "rotate(-.08 45.2 8.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eMsEB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileImage);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFileImageGeneric1160Svg = require("illustration:./S2_fill_fileImage_generic1_160.svg");
var _s2FillFileImageGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFileImageGeneric1160Svg);
var _s2FillFileImageGeneric196Svg = require("illustration:./S2_fill_fileImage_generic1_96.svg");
var _s2FillFileImageGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFileImageGeneric196Svg);
var _s2FillFileImageGeneric148Svg = require("illustration:./S2_fill_fileImage_generic1_48.svg");
var _s2FillFileImageGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFileImageGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FileImage(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileImageGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileImageGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileImageGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fileImage_generic1_160.svg":"6Bg9o","illustration:./S2_fill_fileImage_generic1_96.svg":"03Zwm","illustration:./S2_fill_fileImage_generic1_48.svg":"bul5h","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Bg9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fcf3be__d",
                        x1: -22.794,
                        x2: 202.298,
                        y1: 134.5,
                        y2: -2.444,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fcf3be__e",
                        x1: 157.843,
                        x2: 61.279,
                        y1: 36.277,
                        y2: 140.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fcf3be__f",
                        x1: 40.492,
                        x2: 211.674,
                        y1: 154.441,
                        y2: 58.547,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fcf3be__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 37.068 53.214)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fcf3be__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 53.296 89.084)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "fcf3be__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 12,
                            y: 10.775,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "fcf3be__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m87.515 31.515 32.97 32.97c2.251 2.25 3.515 5.303 3.515 8.486V120c0 6.627-5.373 12-12 12H48c-6.627 0-12-5.373-12-12V40c0-6.627 5.373-12 12-12h31.03c3.182 0 6.234 1.264 8.485 3.515M94.499 68c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.143 0 7.501-3.358 7.501-7.5S98.642 68 94.5 68m-40.494 48h51.989c1.565 0 2.524-1.715 1.704-3.048L96.511 94.769c-.78-1.27-2.626-1.27-3.407 0l-8.816 14.329-13.091-22.199c-.775-1.306-2.666-1.306-3.44 0L52.284 112.98c-.79 1.333.17 3.02 1.72 3.02"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#fcf3be__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#fcf3be__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 12,
                            y: 10.775,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M12 10.775h138.449v138.45H12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.282,
                            cy: 16.146,
                            r: 60.233,
                            fill: "url(#fcf3be__c)",
                            transform: "rotate(-.08 90.282 16.146)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fcf3be__d)",
                            d: "M64.843-13.68c-10.633-6.58-24.105-6.62-34.777-.105L-76.676 51.39c-10.454 6.383-10.472 21.45-.032 27.856l106.037 65.081c10.656 6.54 24.128 6.532 34.775-.023l105.819-65.142c10.384-6.393 10.403-21.376.031-27.793z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fcf3be__e)",
                            d: "M31.952 76.508c2.367-51.688 46.186-91.67 97.873-89.304 51.687 2.367 91.67 46.186 89.303 97.873-2.366 51.687-46.185 91.67-97.872 89.303-51.687-2.366-91.67-46.185-89.304-97.872"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fcf3be__f)",
                            d: "M-44.093 110.588c20.546-8.765 42.704-8.389 61.902-.723 38.414 15.38 60.766 5.871 76.27-32.455 7.722-19.233 22.799-35.52 43.367-44.295 41.125-17.517 88.601 1.49 106.093 42.493s-1.654 88.404-42.768 105.944c-20.615 8.794-42.816 8.382-62.043.647-38.352-15.297-60.662-5.753-76.145 32.62-7.742 19.186-22.815 35.418-43.361 44.183-41.092 17.53-88.568-1.477-106.05-42.457-17.483-40.98 1.644-88.427 42.735-105.957"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 142.38,
                            cy: 35.788,
                            r: 60.233,
                            fill: "url(#fcf3be__g)",
                            transform: "rotate(-.08 142.38 35.788)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"03Zwm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "957091__d",
                        x1: -13.675,
                        x2: 121.38,
                        y1: 80.7,
                        y2: -1.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "957091__e",
                        x1: 94.706,
                        x2: 36.767,
                        y1: 21.766,
                        y2: 84.066,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "957091__f",
                        x1: 24.296,
                        x2: 127.005,
                        y1: 92.664,
                        y2: 35.128,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "957091__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 22.242 31.929)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "957091__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.978 53.45)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "957091__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 7.199,
                            y: 6.465,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "957091__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M52.51 18.909 72.293 38.69c1.35 1.35 2.109 3.182 2.109 5.091V72c0 3.976-3.224 7.2-7.2 7.2h-38.4c-3.977 0-7.2-3.224-7.2-7.2V24c0-3.977 3.223-7.2 7.2-7.2h18.617c1.91 0 3.741.758 5.091 2.109m4.191 21.89c-2.485 0-4.5 2.016-4.5 4.5 0 2.486 2.015 4.5 4.5 4.5 2.486 0 4.5-2.014 4.5-4.5 0-2.484-2.014-4.5-4.5-4.5M32.404 69.6h31.194c.939 0 1.514-1.029 1.022-1.828l-6.712-10.91c-.468-.761-1.575-.761-2.044 0l-5.29 8.598-7.854-13.32c-.465-.783-1.6-.783-2.064 0l-9.284 15.648c-.474.8.102 1.813 1.032 1.813"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#957091__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#957091__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 7.199,
                            y: 6.465,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7.2 6.465h83.07v83.07H7.2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.171,
                            cy: 9.687,
                            r: 36.14,
                            fill: "url(#957091__c)",
                            transform: "rotate(-.08 54.17 9.687)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#957091__d)",
                            d: "M38.907-8.209c-6.38-3.947-14.462-3.972-20.866-.062l-64.045 39.104c-6.273 3.83-6.283 12.87-.02 16.714L17.6 86.595c6.394 3.924 14.477 3.92 20.865-.014l63.491-39.085c6.231-3.836 6.242-12.825.019-16.676z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#957091__e)",
                            d: "M19.171 45.905c1.42-31.013 27.712-55.002 58.724-53.582s55.002 27.711 53.582 58.723c-1.42 31.013-27.711 55.002-58.724 53.582-31.012-1.419-55.001-27.71-53.582-58.723"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#957091__f)",
                            d: "M-26.455 66.352c12.328-5.259 25.623-5.033 37.141-.433 23.049 9.227 36.46 3.522 45.762-19.474 4.633-11.539 13.68-21.312 26.02-26.576 24.675-10.51 53.161.893 63.656 25.495 10.496 24.602-.992 53.043-25.661 63.567-12.369 5.276-25.69 5.029-37.225.388-23.012-9.178-36.397-3.452-45.687 19.572-4.646 11.512-13.69 21.251-26.017 26.51-24.655 10.518-53.14-.886-63.63-25.474s.986-53.057 25.641-63.575"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 85.429,
                            cy: 21.472,
                            r: 36.14,
                            fill: "url(#957091__g)",
                            transform: "rotate(-.08 85.429 21.472)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bul5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "af2342__d",
                        x1: -6.836,
                        x2: 60.692,
                        y1: 40.349,
                        y2: -0.734,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "af2342__e",
                        x1: 47.353,
                        x2: 18.384,
                        y1: 10.883,
                        y2: 42.033,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "af2342__f",
                        x1: 12.15,
                        x2: 63.504,
                        y1: 46.333,
                        y2: 17.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "af2342__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 11.122 15.965)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "af2342__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.99 26.726)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "af2342__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.602,
                            y: 3.232,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "af2342__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m26.255 9.455 9.891 9.891c.675.675 1.055 1.59 1.055 2.546V36c0 1.989-1.612 3.6-3.6 3.6H14.4c-1.989 0-3.6-1.611-3.6-3.6V12c0-1.988 1.611-3.6 3.6-3.6h9.309c.954 0 1.87.38 2.545 1.055M28.351 20.4c-1.243 0-2.25 1.008-2.25 2.25 0 1.243 1.007 2.25 2.25 2.25 1.242 0 2.25-1.007 2.25-2.25 0-1.242-1.008-2.25-2.25-2.25M16.202 34.8H31.8c.47 0 .757-.514.511-.914l-3.356-5.455c-.234-.38-.788-.38-1.022 0l-2.645 4.299-3.927-6.66c-.233-.392-.8-.392-1.032 0l-4.642 7.824c-.237.4.051.906.516.906"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#af2342__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#af2342__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.602,
                            y: 3.232,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.602 3.232h41.535v41.535H3.602z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.087,
                            cy: 4.843,
                            r: 18.07,
                            fill: "url(#af2342__c)",
                            transform: "rotate(-.08 27.087 4.843)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#af2342__d)",
                            d: "M19.456-4.105c-3.19-1.974-7.232-1.986-10.433-.031L-23 15.416c-3.136 1.915-3.142 6.435-.01 8.357L8.801 43.297c3.197 1.962 7.239 1.96 10.433-.007L50.98 23.748c3.115-1.918 3.12-6.413.01-8.338z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#af2342__e)",
                            d: "M9.586 22.952c.71-15.506 13.855-27.5 29.362-26.79s27.5 13.855 26.79 29.361-13.855 27.501-29.361 26.791S8.876 38.46 9.586 22.952"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#af2342__f)",
                            d: "M-13.225 33.177c6.163-2.63 12.81-2.517 18.57-.217 11.524 4.614 18.23 1.761 22.88-9.737 2.318-5.77 6.84-10.656 13.011-13.288 12.338-5.255 26.58.447 31.828 12.748s-.496 26.52-12.83 31.783c-6.185 2.638-12.845 2.515-18.613.194-11.506-4.59-18.199-1.726-22.844 9.786C16.455 70.202 11.933 75.07 5.77 77.7c-12.328 5.259-26.57-.443-31.815-12.737s.493-26.528 12.82-31.787"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.716,
                            cy: 10.736,
                            r: 18.07,
                            fill: "url(#af2342__g)",
                            transform: "rotate(-.08 42.716 10.736)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d4K3F":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileShared);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFileSharedGeneric1160Svg = require("illustration:./S2_fill_fileShared_generic1_160.svg");
var _s2FillFileSharedGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFileSharedGeneric1160Svg);
var _s2FillFileSharedGeneric196Svg = require("illustration:./S2_fill_fileShared_generic1_96.svg");
var _s2FillFileSharedGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFileSharedGeneric196Svg);
var _s2FillFileSharedGeneric148Svg = require("illustration:./S2_fill_fileShared_generic1_48.svg");
var _s2FillFileSharedGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFileSharedGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FileShared(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileSharedGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileSharedGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileSharedGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fileShared_generic1_160.svg":"7sHqg","illustration:./S2_fill_fileShared_generic1_96.svg":"bd0hm","illustration:./S2_fill_fileShared_generic1_48.svg":"78M7n","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7sHqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0b906f__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0b906f__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0b906f__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0b906f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0b906f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0b906f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0b906f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "m87.515 31.515 32.97 32.97c2.251 2.25 3.515 5.303 3.515 8.486V120c0 6.627-5.373 12-12 12H48c-6.627 0-12-5.373-12-12V40c0-6.627 5.373-12 12-12h31.03c3.182 0 6.234 1.264 8.485 3.515M69.84 78.789c0-.804.651-1.455 1.455-1.455 2.209 0 4-1.79 4-4s-1.791-4-4-4c-5.222 0-9.455 4.233-9.455 9.455 0 2.666 1.108 5.08 2.879 6.793 1.587 1.537 4.119 1.496 5.656-.091s1.495-4.12-.092-5.656c-.278-.27-.443-.635-.443-1.046m14.209-5.534c-4.917 0-8.902 3.986-8.902 8.903s3.985 8.901 8.902 8.901 8.902-3.985 8.902-8.901-3.986-8.903-8.902-8.903m-14.824 24.37c1.994-.953 2.838-3.34 1.886-5.334s-3.34-2.838-5.334-1.886c-4.275 2.042-7.397 6.14-8.22 10.986-.37 2.178 1.096 4.243 3.274 4.613s4.243-1.096 4.613-3.274c.391-2.302 1.874-4.195 3.781-5.106m14.824-4.762c-6.847 0-13.079 4.39-14.63 10.827-.977 4.057 2.458 6.977 5.714 6.977h17.832c3.256 0 6.691-2.92 5.713-6.977-1.55-6.436-7.782-10.827-14.63-10.827"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0b906f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0b906f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#0b906f__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0b906f__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0b906f__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0b906f__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#0b906f__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bd0hm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ce80f8__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.166,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ce80f8__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ce80f8__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.618,
                        y2: 33.126,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ce80f8__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ce80f8__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ce80f8__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ce80f8__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "M52.909 18.631 72.69 38.414c1.35 1.35 2.109 3.181 2.109 5.09v28.219c0 3.976-3.224 7.2-7.2 7.2H29.2c-3.976 0-7.2-3.224-7.2-7.2v-48c0-3.977 3.224-7.2 7.2-7.2h18.618c1.91 0 3.74.758 5.09 2.108M41.104 46.795c0-.704.57-1.273 1.273-1.273 1.104 0 2-.896 2-2s-.896-2-2-2c-2.913 0-5.273 2.36-5.273 5.273 0 1.486.617 2.832 1.605 3.788.794.768 2.06.748 2.828-.046.769-.793.748-2.06-.045-2.828-.242-.234-.388-.555-.388-.915m8.925-2.92c-2.729 0-4.94 2.212-4.94 4.94 0 2.73 2.211 4.942 4.94 4.942s4.942-2.212 4.942-4.941c0-2.73-2.213-4.942-4.942-4.942m-9.066 13.86c.996-.477 1.418-1.67.942-2.667s-1.67-1.419-2.666-.943c-2.447 1.169-4.239 3.518-4.71 6.297-.185 1.09.548 2.122 1.637 2.307s2.121-.548 2.306-1.637c.256-1.508 1.228-2.754 2.49-3.357m9.066-2.096c-3.947 0-7.507 2.53-8.388 6.19-.514 2.133 1.29 3.693 3.04 3.693h10.698c1.748 0 3.553-1.56 3.04-3.693-.882-3.66-4.442-6.19-8.39-6.19"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ce80f8__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ce80f8__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#ce80f8__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ce80f8__d)",
                            d: "M36.643-16.957c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.426-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.432 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ce80f8__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ce80f8__f)",
                            d: "M-38.895 69.21c14.246-6.077 29.61-5.817 42.922-.5 26.636 10.663 42.135 4.07 52.885-22.505 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.315 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#ce80f8__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"78M7n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "807425__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.896,
                        y2: -4.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "807425__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.843,
                        y2: 44.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "807425__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.81,
                        y2: 16.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "807425__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.503)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "807425__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.264 26.937)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "807425__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "807425__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#292929",
                    fillRule: "evenodd",
                    d: "m26.454 8.577 9.892 9.891c.675.675 1.054 1.59 1.054 2.546v14.109c0 1.988-1.612 3.6-3.6 3.6H14.6c-1.988 0-3.6-1.612-3.6-3.6v-24c0-1.989 1.612-3.6 3.6-3.6h9.309c.955 0 1.87.379 2.545 1.054m-5.152 14.582c0-.213.173-.386.387-.386.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25c-1.595 0-2.887 1.292-2.887 2.886 0 .814.338 1.55.879 2.074.496.48 1.287.467 1.767-.029s.468-1.287-.028-1.767c-.074-.072-.118-.169-.118-.278m4.213-1.71c-1.503 0-2.72 1.218-2.72 2.72s1.217 2.721 2.72 2.721c1.502 0 2.72-1.218 2.72-2.72s-1.218-2.721-2.72-2.721m-4.426 7.406c.623-.298.887-1.044.59-1.667s-1.044-.887-1.667-.59c-1.298.62-2.245 1.864-2.494 3.333-.116.68.342 1.326 1.023 1.442s1.326-.343 1.442-1.023c.114-.675.549-1.23 1.106-1.495m4.426-1.524c-2.074 0-3.966 1.33-4.438 3.287-.302 1.254.76 2.155 1.763 2.155h5.35c1.002 0 2.065-.9 1.762-2.156-.471-1.956-2.363-3.286-4.437-3.286"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#807425__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#807425__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.863,
                            r: 20.883,
                            fill: "url(#807425__c)",
                            transform: "rotate(-.08 27.142 1.863)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#807425__d)",
                            d: "M18.321-8.478c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.657L6.008 46.304c3.694 2.267 8.365 2.264 12.056-.008L54.752 23.71c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#807425__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.99 40.85-8.17S72.63 7.84 71.809 25.76 55.798 57.543 37.879 56.722C19.957 55.902 6.095 40.71 6.915 22.79"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#807425__f)",
                            d: "M-19.448 34.606c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.331 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.649-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.279-15.033 15.318-14.246 6.077-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.673,
                            r: 20.883,
                            fill: "url(#807425__g)",
                            transform: "rotate(-.08 45.2 8.673)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9JGb8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileText);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFileTextGeneric1160Svg = require("illustration:./S2_fill_fileText_generic1_160.svg");
var _s2FillFileTextGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFileTextGeneric1160Svg);
var _s2FillFileTextGeneric196Svg = require("illustration:./S2_fill_fileText_generic1_96.svg");
var _s2FillFileTextGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFileTextGeneric196Svg);
var _s2FillFileTextGeneric148Svg = require("illustration:./S2_fill_fileText_generic1_48.svg");
var _s2FillFileTextGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFileTextGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FileText(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileTextGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileTextGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileTextGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fileText_generic1_160.svg":"01Lz6","illustration:./S2_fill_fileText_generic1_96.svg":"6973W","illustration:./S2_fill_fileText_generic1_48.svg":"iVmlI","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"01Lz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "899127__d",
                        x1: -24.021,
                        x2: 201.071,
                        y1: 134.5,
                        y2: -2.444,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "899127__e",
                        x1: 156.616,
                        x2: 60.052,
                        y1: 36.277,
                        y2: 140.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "899127__f",
                        x1: 39.265,
                        x2: 210.447,
                        y1: 154.441,
                        y2: 58.547,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "899127__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.455 52.6)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "899127__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.682 88.47)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "899127__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "899127__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m120.485 64.485-32.97-32.97C85.265 29.265 82.212 28 79.029 28H48c-6.627 0-12 5.373-12 12v80c0 6.627 5.373 12 12 12h64c6.627 0 12-5.373 12-12V72.97c0-3.182-1.264-6.234-3.515-8.485M104 84c0 2.209-1.791 4-4 4s-4-1.791-4-4v-4H84v32h4c2.209 0 4 1.791 4 4s-1.791 4-4 4H72c-2.209 0-4-1.791-4-4s1.791-4 4-4h4V80H64v4c0 2.209-1.791 4-4 4s-4-1.791-4-4v-8c0-2.209 1.791-4 4-4h40c2.209 0 4 1.791 4 4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#899127__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#899127__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.773 10.775h138.45v138.45H10.772z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.055,
                            cy: 16.146,
                            r: 60.233,
                            fill: "url(#899127__c)",
                            transform: "rotate(-.08 89.055 16.146)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#899127__d)",
                            d: "M63.616-13.68c-10.633-6.58-24.104-6.62-34.777-.105L-77.903 51.39c-10.454 6.383-10.471 21.45-.031 27.856l106.037 65.081c10.656 6.54 24.127 6.532 34.775-.023l105.818-65.142c10.385-6.393 10.404-21.376.032-27.793z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#899127__e)",
                            d: "M30.726 76.508c2.366-51.688 46.185-91.67 97.872-89.304 51.688 2.367 91.67 46.186 89.304 97.873-2.367 51.687-46.186 91.67-97.873 89.303-51.687-2.366-91.67-46.185-89.303-97.872"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#899127__f)",
                            d: "M-45.32 110.588c20.546-8.765 42.705-8.389 61.902-.723 38.415 15.38 60.767 5.871 76.27-32.455 7.722-19.233 22.799-35.52 43.368-44.295 41.124-17.517 88.601 1.49 106.093 42.493s-1.654 88.404-42.769 105.944c-20.615 8.794-42.816 8.382-62.042.647-38.353-15.297-60.662-5.753-76.146 32.62-7.742 19.186-22.815 35.418-43.36 44.183-41.092 17.53-88.568-1.477-106.05-42.457-17.483-40.98 1.643-88.427 42.735-105.957"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.153,
                            cy: 35.788,
                            r: 60.233,
                            fill: "url(#899127__g)",
                            transform: "rotate(-.08 141.153 35.788)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6973W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa0643__d",
                        x1: -14.409,
                        x2: 120.646,
                        y1: 80.7,
                        y2: -1.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa0643__e",
                        x1: 93.971,
                        x2: 36.033,
                        y1: 21.766,
                        y2: 84.066,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aa0643__f",
                        x1: 23.561,
                        x2: 126.271,
                        y1: 92.664,
                        y2: 35.128,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aa0643__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.875 31.562)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aa0643__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.611 53.083)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "aa0643__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "aa0643__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M72.293 38.691 52.51 18.909c-1.35-1.35-3.181-2.11-5.09-2.11H28.801c-3.977 0-7.2 3.224-7.2 7.2v48c0 3.977 3.223 7.2 7.2 7.2h38.4c3.976 0 7.2-3.223 7.2-7.2V43.783c0-1.91-.759-3.74-2.11-5.091M62.402 50.4c0 1.325-1.075 2.4-2.4 2.4-1.326 0-2.4-1.075-2.4-2.4V48h-7.2v19.2h2.4c1.325 0 2.4 1.074 2.4 2.4s-1.075 2.4-2.4 2.4h-9.6c-1.326 0-2.4-1.075-2.4-2.4 0-1.326 1.074-2.4 2.4-2.4h2.4V48h-7.2v2.4c0 1.325-1.075 2.4-2.4 2.4-1.326 0-2.4-1.075-2.4-2.4v-4.8c0-1.326 1.074-2.4 2.4-2.4h24c1.325 0 2.4 1.074 2.4 2.4z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#aa0643__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#aa0643__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.465 6.465h83.07v83.07H6.465z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.436,
                            cy: 9.687,
                            r: 36.14,
                            fill: "url(#aa0643__c)",
                            transform: "rotate(-.08 53.436 9.687)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa0643__d)",
                            d: "M38.173-8.209c-6.38-3.947-14.463-3.972-20.866-.062L-46.74 30.833c-6.272 3.83-6.283 12.87-.019 16.714l63.623 39.048c6.393 3.924 14.477 3.92 20.865-.014l63.491-39.085c6.231-3.836 6.242-12.825.019-16.676z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa0643__e)",
                            d: "M18.437 45.905c1.42-31.013 27.711-55.002 58.724-53.582s55.001 27.711 53.582 58.723c-1.42 31.013-27.712 55.002-58.724 53.582-31.012-1.419-55.002-27.71-53.582-58.723"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aa0643__f)",
                            d: "M-27.19 66.352c12.328-5.259 25.623-5.033 37.142-.433C33 75.146 46.412 69.44 55.714 46.445c4.633-11.539 13.679-21.312 26.02-26.576 24.675-10.51 53.161.893 63.656 25.495s-.992 53.043-25.661 63.567c-12.369 5.276-25.69 5.029-37.226.388-23.011-9.178-36.397-3.452-45.687 19.572-4.645 11.512-13.689 21.251-26.016 26.51-24.655 10.518-53.141-.886-63.63-25.474s.986-53.057 25.64-63.575"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.694,
                            cy: 21.472,
                            r: 36.14,
                            fill: "url(#aa0643__g)",
                            transform: "rotate(-.08 84.694 21.472)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iVmlI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "99fb20__d",
                        x1: -7.203,
                        x2: 60.325,
                        y1: 40.349,
                        y2: -0.734,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "99fb20__e",
                        x1: 46.986,
                        x2: 18.016,
                        y1: 10.883,
                        y2: 42.033,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "99fb20__f",
                        x1: 11.783,
                        x2: 63.137,
                        y1: 46.333,
                        y2: 17.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "99fb20__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.938 15.782)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "99fb20__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.806 26.543)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "99fb20__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "99fb20__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m36.146 19.346-9.89-9.891C25.58 8.78 24.663 8.4 23.71 8.4H14.4c-1.988 0-3.6 1.612-3.6 3.6v24c0 1.989 1.612 3.6 3.6 3.6h19.2c1.989 0 3.6-1.611 3.6-3.6V21.892c0-.955-.379-1.87-1.054-2.546M31.201 25.2c0 .663-.538 1.2-1.2 1.2-.663 0-1.2-.537-1.2-1.2V24h-3.6v9.6h1.2c.663 0 1.2.538 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-4.8c-.663 0-1.2-.537-1.2-1.2s.537-1.2 1.2-1.2h1.2V24h-3.6v1.2c0 .663-.538 1.2-1.2 1.2-.663 0-1.2-.537-1.2-1.2v-2.4c0-.662.537-1.2 1.2-1.2h12c.662 0 1.2.538 1.2 1.2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#99fb20__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#99fb20__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.234 3.232H44.77v41.535H3.234z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.72,
                            cy: 4.843,
                            r: 18.07,
                            fill: "url(#99fb20__c)",
                            transform: "rotate(-.08 26.72 4.843)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#99fb20__d)",
                            d: "M19.088-4.105c-3.19-1.974-7.231-1.986-10.433-.031l-32.022 19.552c-3.137 1.915-3.142 6.435-.01 8.357L8.434 43.297c3.197 1.962 7.239 1.96 10.433-.007l31.745-19.542c3.116-1.918 3.121-6.413.01-8.338z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#99fb20__e)",
                            d: "M9.219 22.952c.71-15.506 13.855-27.5 29.361-26.79s27.501 13.855 26.791 29.361S51.516 53.024 36.01 52.314 8.509 38.46 9.219 22.952"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#99fb20__f)",
                            d: "M-13.593 33.177c6.164-2.63 12.812-2.517 18.57-.217 11.525 4.614 18.23 1.761 22.882-9.737 2.316-5.77 6.84-10.656 13.01-13.288 12.337-5.255 26.58.447 31.828 12.748s-.496 26.52-12.83 31.783c-6.185 2.638-12.845 2.515-18.613.194-11.506-4.59-18.199-1.726-22.844 9.786C16.087 70.202 11.566 75.07 5.402 77.7c-12.328 5.259-26.57-.443-31.815-12.737s.493-26.528 12.82-31.787"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.349,
                            cy: 10.736,
                            r: 18.07,
                            fill: "url(#99fb20__g)",
                            transform: "rotate(-.08 42.35 10.736)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d4Ej5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileVideo);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFileVideoGeneric1160Svg = require("illustration:./S2_fill_fileVideo_generic1_160.svg");
var _s2FillFileVideoGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFileVideoGeneric1160Svg);
var _s2FillFileVideoGeneric196Svg = require("illustration:./S2_fill_fileVideo_generic1_96.svg");
var _s2FillFileVideoGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFileVideoGeneric196Svg);
var _s2FillFileVideoGeneric148Svg = require("illustration:./S2_fill_fileVideo_generic1_48.svg");
var _s2FillFileVideoGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFileVideoGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FileVideo(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileVideoGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileVideoGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileVideoGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fileVideo_generic1_160.svg":"7562C","illustration:./S2_fill_fileVideo_generic1_96.svg":"JR6ib","illustration:./S2_fill_fileVideo_generic1_48.svg":"dswch","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7562C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3e224d__d",
                        x1: -24.537,
                        x2: 201.681,
                        y1: 134.772,
                        y2: -2.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3e224d__e",
                        x1: 157.003,
                        x2: 59.956,
                        y1: 36.058,
                        y2: 140.411,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3e224d__f",
                        x1: 39.065,
                        x2: 211.102,
                        y1: 154.813,
                        y2: 58.44,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3e224d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.639 52.464)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3e224d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.948 88.515)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3e224d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3e224d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M120.689 64.407 87.554 31.272c-2.262-2.262-5.33-3.533-8.528-3.533H47.84c-6.66 0-12.06 5.4-12.06 12.06v80.4c0 6.661 5.4 12.06 12.06 12.06h64.32c6.661 0 12.06-5.399 12.06-12.06V72.935c0-3.199-1.27-6.266-3.532-8.528M95.072 93.314 71.126 107.1c-2.682 1.544-6.03-.394-6.026-3.489l.033-27.632c.004-3.094 3.356-5.024 6.034-3.474L95.08 86.351c2.678 1.55 2.674 5.418-.008 6.963"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3e224d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3e224d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10.43,
                            y: 10.429,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.43 10.429h139.142V149.57H10.43z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.103,
                            cy: 15.826,
                            r: 60.534,
                            fill: "url(#3e224d__c)",
                            transform: "rotate(-.08 89.103 15.826)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3e224d__d)",
                            d: "M63.539-14.15c-10.686-6.612-24.225-6.653-34.95-.104L-78.689 51.244C-89.194 57.66-89.212 72.8-78.72 79.24l106.568 65.406c10.71 6.572 24.248 6.564 34.949-.023l106.347-65.468c10.437-6.425 10.456-21.483.032-27.932z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3e224d__e)",
                            d: "M30.483 76.49c2.378-51.946 46.417-92.128 98.362-89.75 51.946 2.378 92.128 46.417 89.75 98.362-2.378 51.946-46.416 92.128-98.362 89.75s-92.128-46.416-89.75-98.362"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3e224d__f)",
                            d: "M-45.943 110.741c20.649-8.809 42.918-8.432 62.211-.727 38.607 15.456 61.07 5.9 76.651-32.618 7.761-19.328 22.913-35.697 43.585-44.516 41.33-17.604 89.044 1.497 106.623 42.705s-1.662 88.847-42.982 106.474c-20.718 8.839-43.03 8.425-62.353.65-38.544-15.373-60.965-5.781-76.526 32.784-7.78 19.282-22.93 35.595-43.578 44.404-41.297 17.617-89.01-1.485-106.58-42.669-17.57-41.185 1.652-88.87 42.95-106.487"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.463,
                            cy: 35.567,
                            r: 60.534,
                            fill: "url(#3e224d__g)",
                            transform: "rotate(-.08 141.463 35.567)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"JR6ib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac80b9__d",
                        x1: -14.724,
                        x2: 121.006,
                        y1: 80.863,
                        y2: -1.714,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac80b9__e",
                        x1: 94.203,
                        x2: 35.974,
                        y1: 21.635,
                        y2: 84.246,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ac80b9__f",
                        x1: 23.438,
                        x2: 126.661,
                        y1: 92.888,
                        y2: 35.064,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ac80b9__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.982 31.479)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ac80b9__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.768 53.108)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ac80b9__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ac80b9__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M72.41 38.644 52.527 18.763c-1.357-1.357-3.197-2.12-5.117-2.12h-18.71c-3.997 0-7.236 3.24-7.236 7.237v48.24c0 3.996 3.24 7.236 7.236 7.236h38.592c3.996 0 7.236-3.24 7.236-7.236V43.76c0-1.918-.762-3.759-2.12-5.116M57.04 55.988 42.67 64.261c-1.609.926-3.617-.237-3.615-2.094l.02-16.579c.002-1.857 2.013-3.015 3.62-2.084l14.348 8.307c1.607.93 1.604 3.25-.005 4.177"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ac80b9__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ac80b9__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6.258,
                            y: 6.258,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.258 6.258h83.485v83.485H6.258z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.461,
                            cy: 9.496,
                            r: 36.321,
                            fill: "url(#ac80b9__c)",
                            transform: "rotate(-.08 53.461 9.496)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac80b9__d)",
                            d: "M38.121-8.49c-6.412-3.967-14.535-3.992-20.97-.062l-64.366 39.3c-6.304 3.848-6.314 12.933-.02 16.797l63.941 39.243c6.426 3.944 14.55 3.939 20.97-.014l63.808-39.28c6.262-3.855 6.274-12.89.019-16.76z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac80b9__e)",
                            d: "M18.29 45.894c1.428-31.167 27.85-55.277 59.018-53.85s55.277 27.85 53.85 59.018-27.85 55.276-59.017 53.849c-31.168-1.426-55.277-27.85-53.85-59.017"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ac80b9__f)",
                            d: "M-27.566 66.445c12.389-5.285 25.75-5.059 37.326-.436 23.164 9.274 36.642 3.54 45.99-19.57 4.657-11.598 13.749-21.42 26.152-26.71 24.798-10.563 53.426.898 63.974 25.623 10.547 24.724-.998 53.307-25.79 63.884-12.43 5.303-25.818 5.055-37.412.39-23.126-9.224-36.579-3.469-45.915 19.67C32.09 140.865 23 150.653 10.612 155.938c-24.778 10.571-53.406-.89-63.948-25.601s.991-53.322 25.77-63.892"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.875,
                            cy: 21.34,
                            r: 36.321,
                            fill: "url(#ac80b9__g)",
                            transform: "rotate(-.08 84.875 21.34)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dswch":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "596207__d",
                        x1: -7.36,
                        x2: 60.505,
                        y1: 40.432,
                        y2: -0.857,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "596207__e",
                        x1: 47.099,
                        x2: 17.985,
                        y1: 10.818,
                        y2: 42.124,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "596207__f",
                        x1: 11.721,
                        x2: 63.332,
                        y1: 46.444,
                        y2: 17.532,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "596207__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.992 15.74)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "596207__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.885 26.555)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "596207__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "596207__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "m36.207 19.323-9.941-9.941c-.678-.679-1.599-1.06-2.558-1.06h-9.356c-1.998 0-3.618 1.62-3.618 3.618v24.12c0 1.998 1.62 3.618 3.618 3.618h19.296c1.999 0 3.618-1.62 3.618-3.618V21.88c0-.959-.38-1.879-1.06-2.557m-7.685 8.672-7.184 4.136c-.805.463-1.81-.118-1.808-1.047l.01-8.29c.001-.928 1.007-1.507 1.81-1.042l7.174 4.154c.804.465.802 1.625-.002 2.089"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#596207__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#596207__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3.129,
                            y: 3.129,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.129 3.129H44.87V44.87H3.129z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.733,
                            cy: 4.748,
                            r: 18.16,
                            fill: "url(#596207__c)",
                            transform: "rotate(-.08 26.733 4.748)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#596207__d)",
                            d: "M19.062-4.245c-3.205-1.984-7.267-1.996-10.485-.031l-32.183 19.65c-3.151 1.924-3.157 6.466-.01 8.398L8.356 43.394c3.213 1.972 7.275 1.97 10.485-.007l31.904-19.64c3.131-1.928 3.137-6.445.01-8.38z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#596207__e)",
                            d: "M9.143 22.948C9.857 7.364 23.068-4.691 38.652-3.977S66.29 9.948 65.577 25.53c-.713 15.584-13.925 27.639-29.509 26.925S8.43 38.531 9.143 22.948"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#596207__f)",
                            d: "M-13.781 33.222c6.194-2.642 12.875-2.529 18.663-.218 11.582 4.637 18.321 1.77 22.995-9.785 2.329-5.798 6.874-10.71 13.076-13.355 12.399-5.281 26.713.45 31.987 12.812S72.44 49.33 60.045 54.618c-6.215 2.651-12.909 2.527-18.706.195-11.563-4.612-18.29-1.734-22.958 9.835-2.334 5.785-6.878 10.679-13.073 13.321-12.389 5.285-26.703-.445-31.974-12.8s.496-26.661 12.885-31.947"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.44,
                            cy: 10.67,
                            r: 18.16,
                            fill: "url(#596207__g)",
                            transform: "rotate(-.08 42.44 10.67)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"544yl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileZip);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFileZipGeneric1160Svg = require("illustration:./S2_fill_fileZip_generic1_160.svg");
var _s2FillFileZipGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFileZipGeneric1160Svg);
var _s2FillFileZipGeneric196Svg = require("illustration:./S2_fill_fileZip_generic1_96.svg");
var _s2FillFileZipGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFileZipGeneric196Svg);
var _s2FillFileZipGeneric148Svg = require("illustration:./S2_fill_fileZip_generic1_48.svg");
var _s2FillFileZipGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFileZipGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FileZip(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileZipGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileZipGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFileZipGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fileZip_generic1_160.svg":"cuID4","illustration:./S2_fill_fileZip_generic1_96.svg":"oaoaA","illustration:./S2_fill_fileZip_generic1_48.svg":"5OfgI","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cuID4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6ec67d__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6ec67d__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "6ec67d__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6ec67d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "6ec67d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "6ec67d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "6ec67d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m87.792 31.35 32.96 31.53v.02c2.4 2.28 3.75 5.46 3.75 8.78v48.21c0 6.7-5.41 12.13-12.07 12.13h-64.87c-6.67 0-12.07-5.43-12.07-12.13V40.14c0-6.7 5.41-12.13 12.07-12.13h31.91c3.1 0 6.08 1.19 8.32 3.34m4.75 38.51c0-2.21-1.79-4-4-4h-5.07V59.2h5.08c2.21 0 4-1.79 4-4s-1.79-4-4-4h-5.08v-3.33c0-2.21-1.79-4-4-4h-7.99c-2.21 0-4 1.79-4 4s1.79 4 4 4h3.99v6.66h-3.99c-2.21 0-4 1.79-4 4s1.79 4 4 4h3.99v6.66h-3.99c-2.21 0-4 1.79-4 4s1.79 4 4 4h3.99v6.66h-2.99c-2.21 0-4 1.79-4 4v20.09c0 4.41 3.59 8 8 8h6.01c4.41 0 8-3.59 8-8V91.85c0-2.21-1.79-4-4-4h-3.03V73.86h5.08c2.21 0 4-1.79 4-4m-16.06 34.03h6.02v8.04h-6.02z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#6ec67d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#6ec67d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#6ec67d__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6ec67d__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6ec67d__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#6ec67d__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#6ec67d__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"oaoaA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e79f68__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e79f68__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e79f68__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e79f68__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e79f68__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "e79f68__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "e79f68__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m52.673 18.81 19.776 18.918v.012c1.44 1.368 2.25 3.276 2.25 5.268v28.926c0 4.02-3.246 7.278-7.242 7.278H28.535c-4.002 0-7.242-3.258-7.242-7.278v-47.85c0-4.02 3.246-7.278 7.242-7.278h19.146c1.86 0 3.648.714 4.992 2.004m2.85 23.106c0-1.326-1.074-2.4-2.4-2.4h-3.042V35.52h3.048c1.326 0 2.4-1.074 2.4-2.4s-1.074-2.4-2.4-2.4h-3.048v-1.998c0-1.326-1.074-2.4-2.4-2.4h-4.794c-1.326 0-2.4 1.074-2.4 2.4s1.074 2.4 2.4 2.4h2.394v3.996h-2.394c-1.326 0-2.4 1.074-2.4 2.4s1.074 2.4 2.4 2.4h2.394v3.996h-2.394c-1.326 0-2.4 1.074-2.4 2.4s1.074 2.4 2.4 2.4h2.394v3.996h-1.794c-1.326 0-2.4 1.074-2.4 2.4v12.054c0 2.646 2.154 4.8 4.8 4.8h3.606c2.646 0 4.8-2.154 4.8-4.8V55.11c0-1.326-1.074-2.4-2.4-2.4h-1.818v-8.394h3.048c1.326 0 2.4-1.074 2.4-2.4m-9.636 20.418H49.5v4.824h-3.612z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#e79f68__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#e79f68__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#e79f68__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e79f68__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e79f68__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e79f68__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#e79f68__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5OfgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f13434__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f13434__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f13434__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f13434__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f13434__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f13434__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f13434__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m26.338 9.405 9.888 9.46v.005c.72.684 1.125 1.638 1.125 2.634v14.463c0 2.01-1.623 3.64-3.62 3.64H14.268c-2 0-3.62-1.63-3.62-3.64V12.042c0-2.01 1.622-3.639 3.62-3.639h9.573c.93 0 1.824.357 2.496 1.002m1.425 11.553c0-.663-.537-1.2-1.2-1.2h-1.52V17.76h1.523c.663 0 1.2-.537 1.2-1.2s-.537-1.2-1.2-1.2h-1.524v-.999c0-.663-.537-1.2-1.2-1.2h-2.397c-.663 0-1.2.537-1.2 1.2s.537 1.2 1.2 1.2h1.197v1.998h-1.197c-.663 0-1.2.537-1.2 1.2s.537 1.2 1.2 1.2h1.197v1.998h-1.197c-.663 0-1.2.537-1.2 1.2s.537 1.2 1.2 1.2h1.197v1.998h-.897c-.663 0-1.2.537-1.2 1.2v6.027c0 1.323 1.077 2.4 2.4 2.4h1.803c1.323 0 2.4-1.077 2.4-2.4v-6.027c0-.663-.537-1.2-1.2-1.2h-.909v-4.197h1.524c.663 0 1.2-.537 1.2-1.2m-4.818 10.21h1.806v2.411h-1.806z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f13434__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f13434__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#f13434__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f13434__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f13434__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f13434__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#f13434__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aDNoU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filmstrip);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFilmstripGeneric1160Svg = require("illustration:./S2_fill_filmstrip_generic1_160.svg");
var _s2FillFilmstripGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFilmstripGeneric1160Svg);
var _s2FillFilmstripGeneric196Svg = require("illustration:./S2_fill_filmstrip_generic1_96.svg");
var _s2FillFilmstripGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFilmstripGeneric196Svg);
var _s2FillFilmstripGeneric148Svg = require("illustration:./S2_fill_filmstrip_generic1_48.svg");
var _s2FillFilmstripGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFilmstripGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Filmstrip(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilmstripGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilmstripGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilmstripGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_filmstrip_generic1_160.svg":"4IWde","illustration:./S2_fill_filmstrip_generic1_96.svg":"8vDRN","illustration:./S2_fill_filmstrip_generic1_48.svg":"8a28G","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4IWde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ea20e__d",
                        x1: -24.966,
                        x2: 201.252,
                        y1: 134.343,
                        y2: -3.286,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ea20e__e",
                        x1: 156.573,
                        x2: 59.526,
                        y1: 35.63,
                        y2: 139.982,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ea20e__f",
                        x1: 38.635,
                        x2: 210.673,
                        y1: 154.384,
                        y2: 58.011,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1ea20e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.638 52.035)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1ea20e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.947 88.086)scale(60.5342)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1ea20e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10,
                            y: 10,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1ea20e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M36 34c-8.837 0-16 7.163-16 16v60c0 8.837 7.163 16 16 16h88c8.837 0 16-7.163 16-16V50c0-8.837-7.163-16-16-16zm-4 19c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm17-49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm17-49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm17-49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm17-49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm17-49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm0 49c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1ea20e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1ea20e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 139.142,
                            height: 139.142,
                            x: 10,
                            y: 10,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10 10h139.142v139.142H10z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 88.673,
                            cy: 15.397,
                            r: 60.534,
                            fill: "url(#1ea20e__c)",
                            transform: "rotate(-.08 88.673 15.397)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ea20e__d)",
                            d: "M63.11-14.579c-10.687-6.612-24.226-6.653-34.951-.104l-107.276 65.5c-10.507 6.414-10.524 21.556-.032 27.995l106.567 65.406c10.71 6.572 24.249 6.565 34.949-.023l106.348-65.468c10.436-6.425 10.455-21.482.031-27.932z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ea20e__e)",
                            d: "M30.054 76.061c2.378-51.945 46.416-92.128 98.362-89.75s92.128 46.417 89.749 98.363c-2.378 51.945-46.416 92.128-98.362 89.749-51.945-2.378-92.128-46.416-89.75-98.362"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ea20e__f)",
                            d: "M-46.373 110.312c20.649-8.809 42.918-8.431 62.212-.726 38.606 15.456 61.07 5.9 76.65-32.618 7.762-19.329 22.914-35.698 43.585-44.517 41.33-17.604 89.044 1.498 106.624 42.706 17.579 41.207-1.662 88.846-42.983 106.473-20.718 8.839-43.03 8.425-62.353.651-38.543-15.374-60.965-5.782-76.526 32.783-7.78 19.282-22.929 35.595-43.577 44.404-41.297 17.618-89.011-1.484-106.58-42.669-17.571-41.185 1.651-88.87 42.948-106.487"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.033,
                            cy: 35.138,
                            r: 60.534,
                            fill: "url(#1ea20e__g)",
                            transform: "rotate(-.08 141.033 35.138)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8vDRN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4b5cda__d",
                        x1: -14.982,
                        x2: 120.749,
                        y1: 80.605,
                        y2: -1.972,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4b5cda__e",
                        x1: 93.945,
                        x2: 35.717,
                        y1: 21.377,
                        y2: 83.989,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "4b5cda__f",
                        x1: 23.18,
                        x2: 126.403,
                        y1: 92.63,
                        y2: 34.806,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4b5cda__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.982 31.22)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "4b5cda__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.768 52.85)scale(36.3205)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "4b5cda__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6,
                            y: 6,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "4b5cda__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M21.6 20.5c-5.302 0-9.6 4.298-9.6 9.6v36c0 5.302 4.298 9.6 9.6 9.6h52.8c5.302 0 9.6-4.298 9.6-9.6v-36c0-5.302-4.298-9.6-9.6-9.6zm-2.4 11.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm10.2-29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm10.2-29.4c0-.663.537-1.2 1.2-1.2H45c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2H45c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm10.2-29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2H51c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2H51c-.663 0-1.2-.537-1.2-1.2zM60 31.9c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm10.2-29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm0 29.4c0-.663.537-1.2 1.2-1.2h4.2c.663 0 1.2.537 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#4b5cda__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#4b5cda__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.485,
                            height: 83.485,
                            x: 6,
                            y: 6,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6 6h83.485v83.485H6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.203,
                            cy: 9.238,
                            r: 36.321,
                            fill: "url(#4b5cda__c)",
                            transform: "rotate(-.08 53.203 9.238)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4b5cda__d)",
                            d: "M37.863-8.748c-6.411-3.967-14.535-3.991-20.97-.062l-64.366 39.3c-6.304 3.848-6.314 12.933-.019 16.797l63.94 39.244c6.426 3.943 14.55 3.938 20.97-.015l63.808-39.28c6.262-3.855 6.274-12.89.019-16.76z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4b5cda__e)",
                            d: "M18.033 45.636C19.46 14.47 45.883-9.64 77.05-8.214s55.277 27.85 53.85 59.018-27.85 55.277-59.017 53.85-55.277-27.85-53.85-59.018"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#4b5cda__f)",
                            d: "M-27.824 66.187c12.389-5.285 25.75-5.059 37.326-.436 23.164 9.274 36.643 3.54 45.991-19.57 4.657-11.598 13.748-21.42 26.15-26.71 24.799-10.563 53.427.898 63.975 25.623s-.997 53.308-25.79 63.884c-12.43 5.303-25.818 5.055-37.411.39-23.127-9.224-36.58-3.469-45.916 19.67-4.668 11.569-13.757 21.357-26.147 26.643-24.778 10.57-53.406-.891-63.948-25.602s.992-53.322 25.77-63.892"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.617,
                            cy: 21.082,
                            r: 36.321,
                            fill: "url(#4b5cda__g)",
                            transform: "rotate(-.08 84.617 21.082)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8a28G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7cdde9__d",
                        x1: -7.489,
                        x2: 60.376,
                        y1: 40.303,
                        y2: -0.986,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7cdde9__e",
                        x1: 46.97,
                        x2: 17.856,
                        y1: 10.689,
                        y2: 41.995,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "7cdde9__f",
                        x1: 11.592,
                        x2: 63.203,
                        y1: 46.315,
                        y2: 17.403,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7cdde9__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.992 15.611)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "7cdde9__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.885 26.426)scale(18.1603)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "7cdde9__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3,
                            y: 3,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "7cdde9__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M10.8 10.3c-2.651 0-4.8 2.149-4.8 4.8v18c0 2.65 2.149 4.8 4.8 4.8h26.4c2.651 0 4.8-2.15 4.8-4.8v-18c0-2.651-2.149-4.8-4.8-4.8zM9.6 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zM14.7 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zM19.8 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zM24.9 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zM30 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zM35.1 16c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm0 14.7c0-.332.269-.6.6-.6h2.1c.331 0 .6.268.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#7cdde9__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#7cdde9__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.742,
                            height: 41.742,
                            x: 3,
                            y: 3,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3 3h41.742v41.742H3z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.604,
                            cy: 4.619,
                            r: 18.16,
                            fill: "url(#7cdde9__c)",
                            transform: "rotate(-.08 26.604 4.62)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7cdde9__d)",
                            d: "M18.934-4.374c-3.206-1.984-7.268-1.996-10.486-.031l-32.183 19.65c-3.151 1.924-3.157 6.467-.009 8.398l31.97 19.622c3.213 1.972 7.275 1.97 10.485-.007l31.904-19.64c3.131-1.928 3.137-6.445.01-8.38z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7cdde9__e)",
                            d: "M9.015 22.819C9.728 7.235 22.938-4.82 38.523-4.106S66.162 9.819 65.448 25.402c-.713 15.584-13.925 27.639-29.508 26.925C20.356 51.614 8.3 38.402 9.015 22.82"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#7cdde9__f)",
                            d: "M-13.91 33.094c6.194-2.643 12.875-2.53 18.663-.218 11.582 4.636 18.321 1.77 22.996-9.786 2.328-5.798 6.873-10.71 13.075-13.355 12.399-5.281 26.713.45 31.987 12.812S72.312 49.2 59.916 54.489c-6.215 2.652-12.909 2.527-18.706.195-11.563-4.612-18.29-1.734-22.957 9.835-2.335 5.785-6.88 10.679-13.074 13.321-12.389 5.286-26.703-.445-31.974-12.8-5.27-12.356.496-26.661 12.885-31.947"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.311,
                            cy: 10.541,
                            r: 18.16,
                            fill: "url(#7cdde9__g)",
                            transform: "rotate(-.08 42.31 10.541)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k74aO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filter);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFilterGeneric1160Svg = require("illustration:./S2_fill_filter_generic1_160.svg");
var _s2FillFilterGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFilterGeneric1160Svg);
var _s2FillFilterGeneric196Svg = require("illustration:./S2_fill_filter_generic1_96.svg");
var _s2FillFilterGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFilterGeneric196Svg);
var _s2FillFilterGeneric148Svg = require("illustration:./S2_fill_filter_generic1_48.svg");
var _s2FillFilterGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFilterGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Filter(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilterGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilterGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFilterGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_filter_generic1_160.svg":"3cATS","illustration:./S2_fill_filter_generic1_96.svg":"fP2v2","illustration:./S2_fill_filter_generic1_48.svg":"8aLMN","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3cATS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8b41e7__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8b41e7__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8b41e7__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8b41e7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8b41e7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8b41e7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8b41e7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M121.171 28.052H38.827c-6.617 0-10.373 7.576-6.367 12.843l38.843 45.814v48.554c0 3.442 4.059 5.276 6.642 3.002l9.393-8.267c.863-.759 1.358-1.853 1.358-3.002V86.709l38.843-45.814c4.005-5.267.249-12.843-6.368-12.843"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8b41e7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8b41e7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#8b41e7__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8b41e7__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8b41e7__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8b41e7__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#8b41e7__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fP2v2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41dbf8__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41dbf8__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "41dbf8__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "41dbf8__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "41dbf8__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "41dbf8__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "41dbf8__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M72.703 16.831H23.297c-3.97 0-6.224 4.546-3.82 7.706l23.305 27.489v29.131c0 2.066 2.436 3.167 3.986 1.802L52.404 78c.517-.456.814-1.112.814-1.802V52.026l23.306-27.49c2.403-3.16.15-7.705-3.82-7.705"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#41dbf8__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#41dbf8__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#41dbf8__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41dbf8__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41dbf8__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#41dbf8__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#41dbf8__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8aLMN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "81283e__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "81283e__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "81283e__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "81283e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "81283e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "81283e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "81283e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M36.35 8.415H11.647c-1.986 0-3.112 2.273-1.91 3.853l11.652 13.744v14.566c0 1.033 1.218 1.583 1.993.901L26.2 39c.259-.228.407-.556.407-.9V26.011L38.26 12.268c1.202-1.58.075-3.853-1.91-3.853"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#81283e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#81283e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#81283e__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#81283e__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#81283e__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#81283e__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#81283e__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4PuMK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFiltersGeneric1160Svg = require("illustration:./S2_fill_filters_generic1_160.svg");
var _s2FillFiltersGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFiltersGeneric1160Svg);
var _s2FillFiltersGeneric196Svg = require("illustration:./S2_fill_filters_generic1_96.svg");
var _s2FillFiltersGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFiltersGeneric196Svg);
var _s2FillFiltersGeneric148Svg = require("illustration:./S2_fill_filters_generic1_48.svg");
var _s2FillFiltersGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFiltersGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Filters(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFiltersGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFiltersGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFiltersGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_filters_generic1_160.svg":"jImOy","illustration:./S2_fill_filters_generic1_96.svg":"cIgJP","illustration:./S2_fill_filters_generic1_48.svg":"gs6X7","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jImOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bf1e2f__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bf1e2f__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "bf1e2f__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bf1e2f__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "bf1e2f__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "bf1e2f__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "bf1e2f__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M19.52 96.801c0-11.294 4.776-21.472 12.418-28.625 1.58 15.08 10.261 28.046 22.638 35.494 1.769 12.132 8.152 22.766 17.311 30.065-4.115 1.467-8.548 2.266-13.168 2.266-21.65 0-39.2-17.55-39.2-39.2m68.592 36.934c4.116 1.467 8.548 2.266 13.168 2.266 21.649 0 39.2-17.55 39.2-39.2 0-12.289-5.655-23.257-14.505-30.444-.979 14.829-8.807 27.786-20.349 35.738-1.427 12.785-7.96 24.027-17.514 31.64m28.375-81.63C111.701 35.859 96.675 24 78.879 24c-18.134 0-33.393 12.314-37.87 29.036 5.47-2.215 11.447-3.434 17.71-3.434 7.656 0 14.886 1.822 21.28 5.058 6.395-3.236 13.625-5.058 21.281-5.058 5.32 0 10.435.88 15.207 2.503m-76.802 10.42q-.006.337-.006.675c0 12.289 5.655 23.257 14.505 30.444.902-13.665 7.621-25.742 17.703-33.776-4.115-1.467-8.548-2.266-13.168-2.266-6.907 0-13.398 1.786-19.034 4.923m78.351-1.172q.043.918.043 1.847c0 11.294-4.776 21.472-12.419 28.625-1.353-12.916-7.916-24.28-17.548-31.957 4.116-1.467 8.548-2.266 13.168-2.266 5.995 0 11.675 1.345 16.756 3.751M80 129.728c8.038-5.206 14.049-13.275 16.589-22.763-5.469 2.215-11.447 3.435-17.71 3.435-5.32 0-10.435-.881-15.207-2.504 2.676 9.085 8.554 16.797 16.328 21.832m17.92-32.927c0-13.804-7.136-25.942-17.92-32.926-10.784 6.984-17.92 19.122-17.92 32.926q0 .93.043 1.847c5.08 2.406 10.761 3.752 16.756 3.752 6.908 0 13.398-1.787 19.034-4.924q.006-.337.006-.675"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#bf1e2f__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#bf1e2f__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#bf1e2f__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bf1e2f__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bf1e2f__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#bf1e2f__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#bf1e2f__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cIgJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "420398__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "420398__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "420398__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "420398__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "420398__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "420398__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "420398__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M12 57.9c0-6.975 3.092-13.228 7.98-17.464.768 8.999 5.933 16.743 13.338 21.074.965 7.252 4.799 13.598 10.323 17.86C40.999 80.422 38.117 81 35.1 81 22.342 81 12 70.658 12 57.9m39.639 21.47c2.642 1.052 5.524 1.63 8.54 1.63 12.759 0 23.1-10.342 23.1-23.1 0-7.554-3.625-14.26-9.23-18.475-.426 8.833-5.08 16.557-11.983 21.191-.76 7.624-4.677 14.318-10.427 18.754M69.37 32.398C66.832 22.399 57.771 15 46.98 15c-10.996 0-20.197 7.682-22.529 17.972C27.72 31.574 31.32 30.8 35.1 30.8c4.525 0 8.79 1.109 12.54 3.07 3.75-1.961 8.015-3.07 12.54-3.07 3.226 0 6.321.564 9.191 1.598m-45.488 5.303-.003.399c0 7.554 3.626 14.26 9.232 18.475.394-8.198 4.432-15.44 10.529-20.144-2.642-1.052-5.524-1.63-8.541-1.63-4.07 0-7.895 1.052-11.217 2.9M47.64 77.303c4.978-3.224 8.637-8.311 9.989-14.275C54.36 64.426 50.76 65.2 46.98 65.2c-3.226 0-6.321-.564-9.191-1.598 1.45 5.716 5.033 10.581 9.851 13.701M70.08 38.1c0 6.975-3.092 13.228-7.98 17.464-.664-7.781-4.616-14.624-10.461-19.133 2.642-1.052 5.524-1.63 8.54-1.63 3.534 0 6.882.792 9.876 2.21q.025.541.025 1.089M58.2 57.9c0-8.135-4.205-15.288-10.56-19.403-6.355 4.115-10.56 11.268-10.56 19.403q0 .548.025 1.089C40.1 60.407 43.447 61.2 46.98 61.2c4.07 0 7.895-1.053 11.217-2.901z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#420398__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#420398__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#420398__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#420398__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#420398__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#420398__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#420398__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gs6X7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "33e29d__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "33e29d__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "33e29d__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "33e29d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "33e29d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "33e29d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "33e29d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M6 28.95c0-3.263 1.353-6.21 3.529-8.31.498 4.419 3.045 8.217 6.669 10.422.535 3.552 2.4 6.669 5.072 8.826-1.167.397-2.418.612-3.72.612C11.171 40.5 6 35.33 6 28.95m20.37 10.938c1.167.397 2.418.612 3.72.612 6.379 0 11.55-5.17 11.55-11.55 0-3.557-1.608-6.74-4.138-8.858-.319 4.348-2.617 8.147-5.997 10.499-.436 3.747-2.346 7.045-5.135 9.297m8.15-24.275c-1.463-4.7-5.848-8.113-11.03-8.113-5.28 0-9.733 3.544-11.11 8.382 1.6-.633 3.344-.982 5.17-.982 2.253 0 4.383.53 6.27 1.474 1.887-.943 4.017-1.474 6.27-1.474 1.548 0 3.037.25 4.43.713m-22.578 3.238-.002.199c0 3.558 1.609 6.74 4.138 8.859.293-3.995 2.255-7.525 5.192-9.896-1.167-.397-2.418-.613-3.72-.613-2.035 0-3.948.527-5.608 1.451M23.82 38.652c2.32-1.502 4.066-3.813 4.84-6.534-1.6.634-3.344.982-5.17.982-1.548 0-3.037-.25-4.43-.713.81 2.604 2.518 4.813 4.76 6.265M35.04 19.05c0 3.263-1.353 6.21-3.529 8.31-.424-3.768-2.34-7.085-5.142-9.347 1.168-.397 2.42-.613 3.721-.613 1.767 0 3.44.397 4.937 1.106q.013.27.013.544m-5.94 9.9c0-4.067-2.103-7.643-5.28-9.701-3.178 2.058-5.28 5.634-5.28 9.701q0 .274.013.544c1.497.71 3.17 1.106 4.937 1.106 2.035 0 3.948-.526 5.608-1.45z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#33e29d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#33e29d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#33e29d__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#33e29d__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#33e29d__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#33e29d__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#33e29d__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8NEyY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Fireworks);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFireworksGeneric1160Svg = require("illustration:./S2_fill_fireworks_generic1_160.svg");
var _s2FillFireworksGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFireworksGeneric1160Svg);
var _s2FillFireworksGeneric196Svg = require("illustration:./S2_fill_fireworks_generic1_96.svg");
var _s2FillFireworksGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFireworksGeneric196Svg);
var _s2FillFireworksGeneric148Svg = require("illustration:./S2_fill_fireworks_generic1_48.svg");
var _s2FillFireworksGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFireworksGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Fireworks(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFireworksGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFireworksGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFireworksGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_fireworks_generic1_160.svg":"la79z","illustration:./S2_fill_fireworks_generic1_96.svg":"jTyVh","illustration:./S2_fill_fireworks_generic1_48.svg":"aWVPX","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"la79z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ee1f53__d",
                        x1: -19.921,
                        x2: 186.087,
                        y1: 131.011,
                        y2: -1.943,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ee1f53__e",
                        x1: 150.995,
                        x2: 65.38,
                        y1: 43.401,
                        y2: 141.06,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ee1f53__f",
                        x1: 39.959,
                        x2: 197.223,
                        y1: 148.798,
                        y2: 55.343,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ee1f53__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ee1f53__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ee1f53__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 13,
                            y: 20.654,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ee1f53__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M128.11 28.244c.035-2.21-1.727-4.028-3.936-4.064-2.209-.035-4.028 1.727-4.063 3.936l-.056 3.498-3.503-.054c-2.209-.034-4.027 1.73-4.061 3.938-.034 2.21 1.729 4.027 3.938 4.061l3.498.054-.056 3.503c-.036 2.209 1.726 4.028 3.935 4.063s4.028-1.727 4.064-3.935l.056-3.508 3.503.053c2.209.034 4.027-1.73 4.061-3.938s-1.73-4.027-3.938-4.06l-3.498-.055zM66.99 30.79c0-2.21-1.79-4-4-4s-4 1.79-4 4v10.14c0 2.209 1.79 4 4 4s4-1.791 4-4zm-25.03 2.823c1.788-1.298 4.29-.9 5.587.887l5.96 8.21c1.298 1.788.9 4.289-.887 5.587-1.788 1.297-4.29.9-5.587-.887l-5.96-8.21c-1.298-1.788-.9-4.29.887-5.587m-7.965 15.332c-2.1-.682-4.357.468-5.04 2.57-.682 2.1.469 4.357 2.57 5.04l9.64 3.13c2.1.681 4.357-.469 5.04-2.57s-.469-4.358-2.57-5.04zm12.21 19.08c.681 2.102-.47 4.358-2.57 5.04l-9.65 3.13c-2.102.681-4.358-.47-5.04-2.571-.681-2.102.47-4.358 2.57-5.04l9.65-3.13c2.102-.68 4.358.47 5.04 2.572m7.29 14.416c1.3-1.787.904-4.288-.883-5.587s-4.289-.903-5.588.884l-5.96 8.2c-1.298 1.787-.903 4.288.884 5.587 1.787 1.3 4.289.903 5.588-.884zM66.98 84.22c0-2.21-1.79-4-4-4s-4 1.79-4 4v10.14c0 2.209 1.79 4 4 4s4-1.791 4-4zm17.052-50.596c1.787 1.299 2.183 3.8.884 5.587l-5.96 8.2c-1.3 1.787-3.8 2.183-5.588.884-1.787-1.299-2.182-3.8-.884-5.587l5.96-8.2c1.3-1.787 3.8-2.183 5.588-.884m10.423 22.94c2.101-.682 3.252-2.938 2.57-5.04-.683-2.1-2.94-3.251-5.04-2.569l-9.64 3.13c-2.101.682-3.252 2.939-2.57 5.04.683 2.101 2.94 3.251 5.04 2.57zm-14.68 11.47c.683-2.1 2.94-3.251 5.04-2.569l9.64 3.13c2.101.682 3.252 2.939 2.57 5.04-.683 2.101-2.94 3.251-5.04 2.57l-9.64-3.13c-2.101-.683-3.252-2.94-2.57-5.04m-.828 9.706c-1.298-1.788-3.8-2.185-5.587-.887-1.788 1.297-2.185 3.799-.887 5.587l5.96 8.21c1.298 1.787 3.8 2.185 5.587.887 1.788-1.298 2.185-3.8.887-5.587zm30.09 37.22c2.209.009 3.992 1.807 3.984 4.016l-.02 4.95c-.009 2.209-1.807 3.993-4.017 3.984-2.209-.009-3.992-1.807-3.983-4.016l.02-4.95c.009-2.21 1.807-3.993 4.016-3.984m-8.94 1.182c1.917-1.097 2.583-3.541 1.486-5.459s-3.541-2.582-5.459-1.485l-4.3 2.46c-1.917 1.097-2.582 3.54-1.485 5.458s3.54 2.583 5.458 1.486zm-9.734-20.574c1.111-1.91 3.56-2.557 5.469-1.446l4.28 2.49c1.91 1.111 2.557 3.56 1.446 5.469s-3.56 2.557-5.469 1.446l-4.28-2.49c-1.91-1.11-2.557-3.56-1.446-5.469m22.658-6.742c.008-2.21-1.775-4.007-3.984-4.016s-4.007 1.774-4.016 3.983l-.02 4.95c-.009 2.21 1.774 4.008 3.983 4.017s4.008-1.775 4.017-3.984zm14.672 6.777c1.097 1.918.431 4.362-1.486 5.459l-4.3 2.46c-1.918 1.097-4.361.432-5.458-1.486s-.432-4.361 1.485-5.458l4.3-2.46c1.918-1.097 4.362-.432 5.459 1.485m-5.751 13.589c-1.909-1.111-4.358-.463-5.469 1.446s-.463 4.358 1.446 5.469l4.28 2.49c1.91 1.111 4.358.464 5.469-1.446s.464-4.358-1.446-5.469zm-98.461 15.296c.034-2.209 1.852-3.972 4.06-3.938l3.496.054.054-3.506c.034-2.209 1.852-3.972 4.06-3.938 2.21.034 3.973 1.852 3.939 4.061l-.054 3.505 3.506.054c2.209.034 3.972 1.852 3.938 4.061s-1.852 3.972-4.06 3.938l-3.506-.054-.054 3.496c-.034 2.209-1.852 3.972-4.06 3.938-2.21-.034-3.973-1.852-3.94-4.061l.055-3.495-3.496-.054c-2.209-.034-3.972-1.852-3.938-4.061"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ee1f53__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ee1f53__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 13,
                            y: 20.654,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M13 20.654h131v123.491H13z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#ee1f53__c)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 30 -28.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ee1f53__d)",
                            d: "M63.002-1.16C52.94-7.027 40.194-7.063 30.096-1.251l-101 58.132c-9.891 5.693-9.907 19.132-.03 24.847L29.4 139.776c10.082 5.833 22.83 5.826 32.904-.021l100.125-58.103c9.826-5.703 9.844-19.067.03-24.79z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ee1f53__e)",
                            d: "M31.878 79.285C34.118 33.183 75.58-2.48 124.485-.369c48.907 2.11 86.738 41.195 84.499 87.298s-43.701 81.765-92.607 79.655c-48.906-2.111-86.738-41.196-84.499-87.299"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ee1f53__f)",
                            d: "M-40.075 109.683c19.44-7.818 40.406-7.483 58.57-.645 36.349 13.718 57.498 5.237 72.167-28.949 7.307-17.154 21.572-31.682 41.035-39.509 38.911-15.624 83.833 1.33 100.384 37.902s-1.565 78.853-40.467 94.497c-19.506 7.845-40.512 7.477-58.705.577-36.288-13.644-57.398-5.13-72.048 29.096-7.325 17.113-21.588 31.592-41.028 39.41-38.88 15.636-83.803-1.318-100.344-37.87-16.542-36.552 1.555-78.873 40.436-94.509"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#ee1f53__g)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 79.293 -10.685)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jTyVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b9507e__d",
                        x1: -11.953,
                        x2: 111.651,
                        y1: 78.607,
                        y2: -1.166,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b9507e__e",
                        x1: 90.597,
                        x2: 39.227,
                        y1: 26.041,
                        y2: 84.636,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b9507e__f",
                        x1: 23.977,
                        x2: 118.335,
                        y1: 89.279,
                        y2: 33.206,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b9507e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b9507e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b9507e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 7.801,
                            y: 12.393,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "b9507e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M76.868 16.946c.02-1.325-1.036-2.417-2.362-2.438-1.325-.021-2.417 1.036-2.438 2.361l-.033 2.1-2.103-.033c-1.325-.02-2.416 1.038-2.436 2.363s1.037 2.416 2.363 2.436l2.099.033-.034 2.101c-.021 1.326 1.036 2.417 2.361 2.439 1.326.02 2.417-1.037 2.439-2.362l.033-2.105 2.102.032c1.325.02 2.416-1.037 2.436-2.362s-1.038-2.417-2.363-2.437l-2.098-.032zm-36.674 1.528c0-1.326-1.074-2.4-2.4-2.4s-2.4 1.074-2.4 2.4v6.084c0 1.325 1.075 2.4 2.4 2.4 1.326 0 2.4-1.075 2.4-2.4zm-15.016 1.694c1.073-.779 2.573-.54 3.352.532l3.576 4.926c.779 1.073.54 2.573-.532 3.352s-2.574.54-3.352-.532l-3.576-4.926c-.779-1.073-.54-2.574.532-3.352m-4.78 9.2c-1.26-.41-2.614.28-3.024 1.54s.281 2.615 1.542 3.025L24.7 35.81c1.26.409 2.614-.281 3.024-1.542.409-1.26-.281-2.614-1.542-3.024zm7.326 11.447c.409 1.261-.282 2.615-1.543 3.024l-5.79 1.878c-1.26.409-2.614-.282-3.023-1.543s.282-2.614 1.542-3.023l5.79-1.878c1.261-.409 2.615.282 3.024 1.542m4.375 8.65c.78-1.072.542-2.573-.53-3.353-1.072-.779-2.573-.541-3.352.53l-3.576 4.92c-.78 1.073-.542 2.574.53 3.353s2.573.542 3.352-.53zm8.09 1.067c0-1.326-1.075-2.4-2.4-2.4-1.326 0-2.4 1.074-2.4 2.4v6.084c0 1.325 1.074 2.4 2.4 2.4s2.4-1.075 2.4-2.4zM50.42 20.175c1.073.779 1.31 2.28.53 3.352l-3.575 4.92c-.78 1.072-2.28 1.31-3.353.53-1.072-.779-1.31-2.28-.53-3.352l3.576-4.92c.78-1.072 2.28-1.31 3.352-.53m6.253 13.764c1.26-.41 1.95-1.764 1.541-3.024s-1.763-1.951-3.023-1.542l-5.784 1.878c-1.261.41-1.951 1.763-1.542 3.024.41 1.26 1.763 1.95 3.024 1.542zm-8.808 6.882c.41-1.261 1.763-1.951 3.024-1.542l5.784 1.878c1.26.41 1.95 1.763 1.541 3.024-.409 1.26-1.763 1.95-3.023 1.542l-5.784-1.878c-1.261-.41-1.951-1.764-1.542-3.024m-.495 5.823c-.779-1.073-2.28-1.311-3.352-.532s-1.311 2.28-.533 3.352l3.576 4.926c.779 1.072 2.28 1.31 3.352.532 1.073-.779 1.311-2.28.533-3.352zm18.051 22.332c1.326.005 2.396 1.084 2.39 2.41l-.012 2.97c-.005 1.325-1.084 2.395-2.41 2.39-1.325-.005-2.395-1.084-2.39-2.41l.012-2.97c.006-1.325 1.085-2.395 2.41-2.39m-5.364.71c1.15-.66 1.55-2.125.892-3.276-.659-1.15-2.125-1.55-3.275-.891l-2.58 1.476c-1.151.658-1.55 2.124-.892 3.275s2.125 1.55 3.275.891zm-5.84-12.345c.666-1.146 2.136-1.534 3.281-.868l2.568 1.494c1.146.667 1.535 2.136.868 3.282s-2.136 1.534-3.281.867l-2.568-1.494c-1.146-.666-1.535-2.135-.868-3.281m13.594-4.045c.006-1.326-1.064-2.405-2.39-2.41-1.325-.005-2.404 1.065-2.41 2.39L63 56.246c-.005 1.326 1.065 2.404 2.39 2.41 1.326.005 2.405-1.065 2.41-2.39zm8.805 4.066c.658 1.15.259 2.617-.892 3.275l-2.58 1.476c-1.15.658-2.617.26-3.275-.891-.658-1.15-.259-2.617.892-3.275l2.58-1.476c1.15-.658 2.617-.26 3.275.891m-3.45 8.153c-1.146-.666-2.616-.278-3.282.868-.667 1.146-.278 2.615.867 3.281l2.569 1.494c1.145.667 2.614.278 3.28-.867.667-1.146.279-2.615-.867-3.282zM14.09 74.693c.02-1.325 1.111-2.383 2.437-2.363l2.097.032.033-2.103c.02-1.325 1.11-2.383 2.436-2.363s2.383 1.111 2.363 2.437l-.032 2.103 2.103.032c1.325.02 2.383 1.111 2.363 2.437s-1.112 2.383-2.437 2.363l-2.103-.033-.032 2.098c-.02 1.325-1.111 2.383-2.436 2.363-1.326-.02-2.384-1.112-2.363-2.437l.032-2.097-2.098-.032c-1.325-.02-2.383-1.112-2.363-2.437"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b9507e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#b9507e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 7.801,
                            y: 12.393,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7.8 12.393h78.6v74.094H7.8z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#b9507e__c)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 18 -16.924)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b9507e__d)",
                            d: "M37.8-.696c-6.036-3.52-13.684-3.542-19.743-.055l-60.6 34.879c-5.935 3.416-5.945 11.48-.018 14.908l60.2 34.83c6.05 3.5 13.697 3.495 19.742-.013l60.075-34.862c5.895-3.422 5.906-11.44.018-14.874z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b9507e__e)",
                            d: "M19.126 47.571C20.47 19.91 45.346-1.488 74.69-.222c29.344 1.267 52.043 24.718 50.7 52.38-1.344 27.661-26.22 49.059-55.565 47.792-29.343-1.266-52.042-24.717-50.699-52.379"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#b9507e__f)",
                            d: "M-24.044 65.81C-12.379 61.12.2 61.32 11.1 65.423c21.809 8.23 34.498 3.142 43.3-17.37 4.384-10.292 12.943-19.008 24.62-23.705 23.348-9.374 50.301.798 60.231 22.742 9.931 21.943-.939 47.311-24.28 56.698-11.703 4.707-24.307 4.486-35.223.346-21.773-8.186-34.439-3.078-43.229 17.458-4.395 10.268-12.952 18.955-24.617 23.645-23.328 9.382-50.281-.79-60.206-22.721s.933-47.324 24.261-56.706"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#b9507e__g)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 47.578 -6.411)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aWVPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a33da__d",
                        x1: -5.977,
                        x2: 55.826,
                        y1: 39.303,
                        y2: -0.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a33da__e",
                        x1: 45.296,
                        x2: 19.612,
                        y1: 13.02,
                        y2: 42.317,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "3a33da__f",
                        x1: 11.986,
                        x2: 59.166,
                        y1: 44.639,
                        y2: 16.603,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3a33da__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "3a33da__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "3a33da__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 3.898,
                            y: 6.196,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "3a33da__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M38.432 8.473c.01-.663-.518-1.208-1.18-1.219-.663-.01-1.21.518-1.22 1.18l-.016 1.05-1.052-.016c-.662-.01-1.208.519-1.218 1.181-.01.663.519 1.209 1.181 1.219l1.05.016-.017 1.05c-.01.663.518 1.21 1.181 1.22s1.208-.518 1.219-1.18l.017-1.053 1.05.016c.663.01 1.209-.519 1.219-1.182s-.519-1.208-1.182-1.218l-1.049-.016zm-18.335.764c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v3.042c0 .662.537 1.2 1.2 1.2s1.2-.537 1.2-1.2zm-7.51.847c.537-.39 1.287-.27 1.677.266l1.788 2.463c.39.536.27 1.287-.266 1.676-.537.39-1.287.27-1.676-.266l-1.788-2.463c-.39-.537-.27-1.287.266-1.676m-2.389 4.6c-.63-.205-1.307.14-1.512.77-.204.63.14 1.308.771 1.512l2.892.94c.63.204 1.307-.141 1.512-.772.205-.63-.14-1.307-.77-1.511zm3.664 5.724c.204.63-.141 1.307-.771 1.511l-2.895.94c-.63.204-1.308-.141-1.512-.772-.205-.63.14-1.307.771-1.511l2.895-.94c.63-.204 1.307.141 1.512.772m2.186 4.324c.39-.536.27-1.286-.265-1.676-.537-.39-1.287-.27-1.677.265l-1.788 2.46c-.39.537-.27 1.287.266 1.677s1.286.27 1.676-.266zm4.045.534c0-.663-.537-1.2-1.2-1.2s-1.2.537-1.2 1.2v3.042c0 .663.538 1.2 1.2 1.2.663 0 1.2-.537 1.2-1.2zm5.116-15.179c.536.39.655 1.14.265 1.676l-1.788 2.46c-.39.536-1.14.655-1.676.265s-.655-1.14-.266-1.676l1.788-2.46c.39-.536 1.14-.654 1.677-.265m3.127 6.882c.63-.204.976-.881.771-1.512-.205-.63-.882-.975-1.512-.77l-2.892.939c-.63.204-.975.881-.77 1.511s.88.976 1.511.771zm-4.404 3.441c.205-.63.882-.975 1.512-.77l2.892.938c.63.205.976.882.771 1.512s-.882.976-1.512.771l-2.892-.939c-.63-.204-.975-.881-.77-1.512m-.248 2.912c-.389-.536-1.14-.655-1.676-.266-.536.39-.655 1.14-.266 1.676l1.788 2.463c.39.536 1.14.655 1.676.266.537-.39.656-1.14.266-1.676zm9.027 11.166c.663.003 1.198.542 1.195 1.205l-.006 1.485c-.002.663-.542 1.198-1.205 1.195-.662-.003-1.198-.542-1.195-1.205l.006-1.485c.003-.663.542-1.198 1.205-1.195m-2.682.354c.575-.329.775-1.062.446-1.637-.33-.575-1.062-.775-1.638-.446l-1.29.738c-.575.33-.774 1.063-.445 1.638s1.062.775 1.637.445zm-2.921-6.172c.333-.573 1.068-.767 1.64-.433l1.285.747c.572.333.767 1.067.433 1.64-.333.573-1.067.767-1.64.434l-1.284-.747c-.573-.333-.767-1.068-.434-1.64m6.798-2.022c.003-.663-.532-1.203-1.195-1.205s-1.202.532-1.205 1.195l-.006 1.485c-.003.663.533 1.202 1.195 1.205.663.003 1.203-.533 1.205-1.195zm4.4 2.033c.33.575.13 1.308-.445 1.637l-1.29.738c-.576.33-1.309.13-1.638-.445s-.13-1.309.446-1.638l1.29-.738c.575-.329 1.308-.13 1.637.446m-1.724 4.077c-.573-.334-1.307-.14-1.64.433-.334.573-.14 1.308.433 1.641l1.284.747c.573.333 1.308.14 1.641-.434.333-.573.139-1.307-.434-1.64zM7.043 37.346c.01-.662.556-1.191 1.218-1.181l1.05.016.015-1.051c.01-.663.556-1.192 1.219-1.182.662.01 1.191.556 1.181 1.218l-.016 1.052 1.051.016c.663.01 1.192.556 1.182 1.218-.01.663-.556 1.192-1.218 1.182l-1.052-.016-.016 1.048c-.01.663-.556 1.192-1.218 1.182-.663-.01-1.192-.556-1.182-1.218l.016-1.05-1.048-.015c-.663-.01-1.192-.556-1.182-1.218"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#3a33da__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#3a33da__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 3.898,
                            y: 6.196,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.898 6.196h39.3v37.047h-39.3z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#3a33da__c)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 9 -8.462)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a33da__d)",
                            d: "M18.9-.348c-3.018-1.76-6.842-1.771-9.872-.028l-30.3 17.44c-2.967 1.708-2.972 5.74-.008 7.454l30.1 17.415c3.024 1.75 6.848 1.748 9.87-.006l30.038-17.431c2.948-1.711 2.953-5.72.009-7.438z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a33da__e)",
                            d: "M9.561 23.785C10.233 9.955 22.671-.745 37.343-.11c14.672.633 26.021 12.358 25.35 26.19-.672 13.83-13.11 24.529-27.782 23.896-14.672-.634-26.022-12.359-25.35-26.19"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#3a33da__f)",
                            d: "M-12.024 32.905C-6.192 30.56.098 30.66 5.548 32.712c10.904 4.115 17.249 1.57 21.65-8.685 2.192-5.146 6.471-9.505 12.31-11.853 11.673-4.687 25.15.399 30.115 11.37 4.965 10.973-.47 23.657-12.14 28.35-5.852 2.353-12.154 2.243-17.611.173-10.887-4.093-17.22-1.54-21.615 8.729-2.198 5.134-6.476 9.477-12.308 11.823-11.664 4.69-25.141-.395-30.104-11.361-4.962-10.966.467-23.662 12.131-28.353"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#3a33da__g)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 23.785 -3.206)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"H9h76":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Flag);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFlagGeneric1160Svg = require("illustration:./S2_fill_flag_generic1_160.svg");
var _s2FillFlagGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFlagGeneric1160Svg);
var _s2FillFlagGeneric196Svg = require("illustration:./S2_fill_flag_generic1_96.svg");
var _s2FillFlagGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFlagGeneric196Svg);
var _s2FillFlagGeneric148Svg = require("illustration:./S2_fill_flag_generic1_48.svg");
var _s2FillFlagGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFlagGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Flag(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_flag_generic1_160.svg":"fp84D","illustration:./S2_fill_flag_generic1_96.svg":"eGVIE","illustration:./S2_fill_flag_generic1_48.svg":"5rUFc","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fp84D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "245de2__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "245de2__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "245de2__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "245de2__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "245de2__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "245de2__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "245de2__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M41.277 28.25c0-2.21-1.79-4-4-4s-4 1.79-4 4v103.5c0 2.209 1.791 4 4 4s4-1.791 4-4v-30.897h69.445c6.628 0 12-5.372 12-12V46.895c0-6.628-5.372-12-12-12H41.277z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#245de2__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#245de2__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#245de2__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#245de2__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#245de2__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#245de2__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#245de2__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eGVIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d23a20__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d23a20__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "d23a20__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d23a20__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d23a20__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d23a20__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "d23a20__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M25.484 18.219c0-1.105-.895-2-2-2s-2 .895-2 2V77.78c0 1.105.896 2 2 2s2-.895 2-2v-17.78h41.172c3.314 0 6-2.686 6-6V28.043c0-3.314-2.686-6-6-6H25.484z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#d23a20__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#d23a20__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#d23a20__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d23a20__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d23a20__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#d23a20__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#d23a20__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5rUFc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "223fb4__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "223fb4__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "223fb4__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "223fb4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "223fb4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "223fb4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "223fb4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M12.992 9.11c0-.691-.56-1.25-1.25-1.25s-1.25.559-1.25 1.25v29.78c0 .691.56 1.25 1.25 1.25s1.25-.559 1.25-1.25V30h20.336c1.657 0 3-1.343 3-3V14.022c0-1.657-1.343-3-3-3H12.992z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#223fb4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#223fb4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#223fb4__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#223fb4__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#223fb4__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#223fb4__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#223fb4__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dFij3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FlagCheckmark);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFlagCheckmarkGeneric1160Svg = require("illustration:./S2_fill_flagCheckmark_generic1_160.svg");
var _s2FillFlagCheckmarkGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCheckmarkGeneric1160Svg);
var _s2FillFlagCheckmarkGeneric196Svg = require("illustration:./S2_fill_flagCheckmark_generic1_96.svg");
var _s2FillFlagCheckmarkGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCheckmarkGeneric196Svg);
var _s2FillFlagCheckmarkGeneric148Svg = require("illustration:./S2_fill_flagCheckmark_generic1_48.svg");
var _s2FillFlagCheckmarkGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCheckmarkGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FlagCheckmark(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCheckmarkGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCheckmarkGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCheckmarkGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_flagCheckmark_generic1_160.svg":"heetm","illustration:./S2_fill_flagCheckmark_generic1_96.svg":"hzysc","illustration:./S2_fill_flagCheckmark_generic1_48.svg":"gP8RD","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"heetm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deebe8__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deebe8__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "deebe8__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "deebe8__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "deebe8__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "deebe8__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "deebe8__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M37.277 24.25c2.21 0 4 1.79 4 4v6.645h69.445c6.628 0 12 5.372 12 12v41.958c0 6.628-5.372 12-12 12H41.277v30.897c0 2.209-1.79 4-4 4s-4-1.791-4-4V28.25c0-2.21 1.791-4 4-4m64.802 35.827c1.632-1.488 1.75-4.018.261-5.65s-4.018-1.75-5.65-.262l-1.178 1.073-.066.06-.068.062-.14.128-.147.134-.153.14-.323.294-.346.315-.368.335-.047.043-.048.044-.048.044-.048.044-.197.179-.832.758-1.861 1.697-2.066 1.883-.54.492-.273.248-.069.063-.068.063-.069.062-.069.063-.138.125-.069.063-.069.064-.069.063-.07.063-.138.126-.56.51-.28.256-.07.064-.07.064-.071.064-.07.065-.567.515-.07.065-.072.065-.07.064-.071.065-.284.259-.071.064-.072.065-.142.13-.284.259-.568.518-.567.516-.282.258-.07.064-.071.064-.07.064-.07.064-.282.256-.28.255-.555.507-.07.063-.069.063-.137.125-.274.25-.273.249-.136.123-.067.062-.068.062-.134.122-.135.123-.066.06-.067.061-.067.061-.066.06-1.043.95-.127.117-.063.057-.064.058-.25.229-.249.226-.122.112-.061.055-.061.056-.06.055-.061.055-.12.11-.06.054-.06.055-.118.108-.235.213-.058.053-.057.053-.058.052-.057.052-.114.104-.056.052-.057.05-.222.204-.219.199-.214.195-.81.739-.227.206-9.261-8.638c-1.616-1.506-4.147-1.418-5.654.198s-1.418 4.146.197 5.653l11.96 11.153c1.523 1.42 3.882 1.434 5.422.03l-2.695-2.956 2.695 2.956.004-.004.013-.011.052-.047.2-.184.07-.063.039-.035.02-.018.02-.018.176-.161.206-.188.233-.213.26-.236.285-.26.643-.586L80 80.2l.045-.04.045-.041.045-.042.046-.041.185-.17.095-.085.096-.088.395-.36.206-.187.051-.048.053-.047.105-.097.214-.195.109-.099.11-.1.449-.41.23-.21.234-.213.06-.054.059-.054.12-.108.12-.11.12-.11.062-.056.06-.056.062-.055.062-.056.247-.226.251-.23.127-.115.127-.116.257-.234.26-.236.065-.06.065-.06.131-.119.066-.06.066-.06.133-.12 1.078-.984.55-.501.556-.507.07-.064.07-.063.14-.128.281-.256.14-.128.071-.064.07-.065.071-.064.071-.064.141-.13.567-.516.071-.064.07-.065.143-.13.284-.259.284-.258.071-.065.072-.065.141-.13.285-.258.141-.13.071-.064.071-.065.283-.258.071-.064.07-.065.142-.129.07-.064.071-.064.07-.064.07-.064.141-.129.07-.064.07-.064.141-.127.14-.128.279-.254.139-.127.069-.063.07-.063.068-.063.07-.063.137-.126.138-.125.137-.125.068-.062.069-.062.136-.125.068-.062.068-.061.067-.062.068-.062.135-.123.067-.06.067-.062 1.054-.96.129-.118.064-.059.064-.058.064-.058.064-.058.063-.058.064-.058.063-.057.063-.058.063-.057.062-.057.125-.114.062-.056.062-.057.061-.056.062-.056.06-.055.062-.056.242-.22.06-.055.06-.055.118-.108.06-.054.058-.053.117-.107.058-.053.058-.053.058-.052.057-.053.114-.104.057-.051.057-.052.056-.051.056-.051.056-.05.055-.051.055-.05.055-.05.055-.05.054-.05.215-.196.21-.192.206-.187.051-.047.05-.046.05-.045.05-.046.756-.688.345-.315.324-.295.077-.07.076-.07.146-.133.141-.128.068-.062.033-.03.033-.03.472-.43.359-.327z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#deebe8__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#deebe8__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#deebe8__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deebe8__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deebe8__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#deebe8__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#deebe8__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hzysc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "80346d__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "80346d__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "80346d__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "80346d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "80346d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "80346d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "80346d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M23.484 16.219c1.105 0 2 .895 2 2v3.824h41.172c3.314 0 6 2.686 6 6v25.958c0 3.314-2.686 6-6 6H25.484v17.78c0 1.105-.895 2-2 2s-2-.895-2-2V18.22c0-1.105.896-2 2-2M60.573 36.52c.816-.744.875-2.009.13-2.825-.743-.817-2.008-.875-2.825-.131l-.062.057-.137.125-.207.188-.015.014-.015.014-.032.029-.066.06-.07.063-.073.067-.038.035-.04.036-.08.073-.085.077-.021.02-.022.02-.022.02-.023.02-.091.084-.024.021-.023.022-.024.021-.024.022-.048.044-.05.045-.1.093-.105.095-.107.097-.223.204-.058.052-.058.053-.119.108-.245.223-1.07.977-.288.262-.295.268-.3.274-.153.14-.154.14-.154.14-.04.036-.038.035-.078.071-.079.072-.078.072-.04.035-.04.036-.039.036-.04.037-.64.583-.08.074-.081.074-.04.036-.041.037-.04.037-.041.037-.163.149-.163.148-.082.075-.081.074-.041.037-.041.037-.082.075-.082.074-.04.038-.041.037-.164.149-.163.149-.041.037-.041.037-.082.075-.081.074-.082.075-.163.148-.081.074-.082.074-.162.148-.04.037-.04.037-.04.037-.041.036-.08.074-.041.037-.04.036-.08.073-.08.073-.04.037-.04.036-.04.037-.04.036-.08.072-.04.036-.039.036-.158.144-.62.566-.077.07-.038.034-.038.035-.037.034-.038.035-.038.034-.037.034-.075.068-.075.068-.037.034-.037.034-.074.067-.146.133-.072.066-.072.066-.283.258-.276.252-.068.061-.034.03-.033.031-.133.121-.033.03-.032.03-.065.06-.065.058-.031.029-.032.029-.25.227-.238.217-.029.027-.029.026-.028.026-.03.026-.112.103-.055.05-.054.05-.107.097-.026.024-.026.024-.026.023-.026.023-.016.015-5.533-5.16c-.808-.754-2.074-.71-2.827.098s-.71 2.073.099 2.827l6.882 6.418c.762.71 1.941.717 2.711.015l-1.347-1.478 1.347 1.478.002-.001v-.001l.008-.007.03-.027.116-.105.04-.037.044-.04.102-.094.028-.025.015-.013.014-.014.03-.027.016-.014.016-.014.134-.123.073-.066.077-.07.164-.15.043-.04.022-.02.022-.02.022-.02.023-.02.046-.042.094-.086.097-.089.42-.383.029-.025.028-.026.056-.051.116-.105.058-.054.06-.054.03-.027.03-.028.06-.055.062-.056.062-.056.03-.029.032-.028.032-.029.031-.029.032-.029.032-.029.064-.059.033-.03.032-.029.033-.03.033-.03.132-.12.135-.123.137-.125.139-.127.14-.128.072-.065.036-.032.035-.033.072-.066.037-.033.036-.033.146-.133.037-.033.037-.034.074-.067.037-.034.037-.034.075-.069.075-.068.076-.069.038-.034.038-.035.076-.07.62-.565.04-.036.04-.036.039-.036.04-.036.079-.072.04-.037.04-.036.32-.291.646-.59.327-.298.04-.037.041-.037.041-.037.041-.038.164-.149.081-.074.082-.075.041-.037.04-.037.083-.075.04-.037.041-.037.041-.038.041-.037.041-.037.04-.037.082-.075.041-.037.04-.037.042-.037.04-.037.041-.037.04-.037.082-.074.081-.074.04-.037.041-.037.162-.148.04-.036.04-.037.04-.037.041-.036.04-.037.04-.037.08-.073.04-.036.04-.037.08-.072.08-.073.08-.072.039-.036.04-.036.039-.036.04-.036.078-.072.078-.071.04-.036.038-.035.04-.036.038-.035.078-.071.038-.035.039-.036.154-.14.038-.034.038-.035.038-.035.038-.035.038-.034.038-.034.037-.035.038-.034.075-.068.037-.034.038-.034.294-.269.073-.066.036-.033.036-.033.036-.032.035-.033.072-.065.28-.256.069-.062.034-.032.034-.03.034-.032.034-.03.034-.031.034-.03.518-.473.914-.833.199-.181.186-.17.088-.08.084-.077.081-.074.077-.07.074-.068.035-.032.018-.016.017-.015.033-.03.017-.015.016-.015.062-.057.111-.101.095-.087z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#80346d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#80346d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#80346d__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#80346d__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#80346d__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#80346d__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#80346d__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gP8RD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "37e19d__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "37e19d__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "37e19d__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "37e19d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "37e19d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "37e19d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "37e19d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M11.742 7.86c.69 0 1.25.559 1.25 1.25v1.912h20.336c1.657 0 3 1.343 3 3V27c0 1.657-1.343 3-3 3H12.992v8.89c0 .691-.56 1.25-1.25 1.25s-1.25-.559-1.25-1.25V9.11c0-.691.56-1.25 1.25-1.25M30.455 18.2c.51-.466.547-1.256.082-1.767s-1.256-.546-1.766-.081L24 20.699l-.039.035-1.381 1.26-2.599-2.424c-.505-.47-1.295-.443-1.766.062s-.444 1.296.061 1.767l3.441 3.209c.477.444 1.214.448 1.695.01zm-7.884 5.494.842.923z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#37e19d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#37e19d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#37e19d__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#37e19d__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#37e19d__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#37e19d__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#37e19d__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2YHMf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FlagCross);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFlagCrossGeneric1160Svg = require("illustration:./S2_fill_flagCross_generic1_160.svg");
var _s2FillFlagCrossGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCrossGeneric1160Svg);
var _s2FillFlagCrossGeneric196Svg = require("illustration:./S2_fill_flagCross_generic1_96.svg");
var _s2FillFlagCrossGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCrossGeneric196Svg);
var _s2FillFlagCrossGeneric148Svg = require("illustration:./S2_fill_flagCross_generic1_48.svg");
var _s2FillFlagCrossGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFlagCrossGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FlagCross(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCrossGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCrossGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFlagCrossGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_flagCross_generic1_160.svg":"ehewX","illustration:./S2_fill_flagCross_generic1_96.svg":"eThWH","illustration:./S2_fill_flagCross_generic1_48.svg":"bxLeD","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ehewX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "329fea__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "329fea__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "329fea__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "329fea__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "329fea__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "329fea__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "329fea__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M41.277 28.25c0-2.21-1.79-4-4-4s-4 1.79-4 4v103.5c0 2.209 1.791 4 4 4s4-1.791 4-4v-30.897h69.445c6.628 0 12-5.372 12-12V46.895c0-6.628-5.372-12-12-12H41.277zm25.124 26.072c1.562-1.562 4.095-1.562 5.657 0l8.39 8.39 8.389-8.39c1.562-1.562 4.095-1.562 5.657 0s1.562 4.095 0 5.657l-8.39 8.39 8.39 8.39c1.562 1.561 1.562 4.094 0 5.656s-4.095 1.562-5.657 0l-8.39-8.39-8.39 8.39c-1.561 1.562-4.094 1.562-5.656 0s-1.562-4.095 0-5.657l8.39-8.39-8.39-8.39c-1.562-1.561-1.562-4.094 0-5.656"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#329fea__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#329fea__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#329fea__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#329fea__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#329fea__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#329fea__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#329fea__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eThWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dfdf00__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dfdf00__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "dfdf00__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "dfdf00__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "dfdf00__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "dfdf00__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "dfdf00__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M25.484 18.219c0-1.105-.895-2-2-2s-2 .895-2 2V77.78c0 1.105.896 2 2 2s2-.895 2-2v-17.78h41.172c3.314 0 6-2.686 6-6V28.043c0-3.314-2.686-6-6-6H25.484zm14.904 15.425c.78-.78 2.047-.78 2.828 0l5.042 5.042 5.041-5.042c.781-.78 2.047-.78 2.829 0 .78.781.78 2.048 0 2.829l-5.042 5.041 5.042 5.042c.78.781.78 2.047 0 2.828-.782.782-2.048.782-2.829 0l-5.041-5.041-5.042 5.041c-.781.782-2.047.782-2.828 0-.782-.78-.782-2.047 0-2.828l5.041-5.042-5.041-5.041c-.782-.781-.782-2.048 0-2.829"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#dfdf00__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#dfdf00__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#dfdf00__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dfdf00__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dfdf00__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#dfdf00__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#dfdf00__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bxLeD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ba83c3__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ba83c3__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ba83c3__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ba83c3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "ba83c3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ba83c3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "ba83c3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M12.992 9.11c0-.691-.56-1.25-1.25-1.25s-1.25.559-1.25 1.25v29.78c0 .691.56 1.25 1.25 1.25s1.25-.559 1.25-1.25V30h20.336c1.657 0 3-1.343 3-3V14.022c0-1.657-1.343-3-3-3H12.992zm6.796 7.274c.489-.489 1.28-.489 1.768 0l2.344 2.344 2.344-2.344c.488-.489 1.28-.489 1.768 0 .488.488.488 1.28 0 1.767l-2.344 2.345 2.344 2.344c.488.488.488 1.28 0 1.767-.488.488-1.28.488-1.768 0L23.9 22.263l-2.344 2.344c-.488.488-1.28.488-1.768 0s-.488-1.28 0-1.767l2.345-2.344-2.344-2.344c-.489-.489-.489-1.28 0-1.768"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ba83c3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#ba83c3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#ba83c3__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ba83c3__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ba83c3__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#ba83c3__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#ba83c3__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j55y7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FolderClose);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFolderCloseGeneric1160Svg = require("illustration:./S2_fill_folderClose_generic1_160.svg");
var _s2FillFolderCloseGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFolderCloseGeneric1160Svg);
var _s2FillFolderCloseGeneric196Svg = require("illustration:./S2_fill_folderClose_generic1_96.svg");
var _s2FillFolderCloseGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFolderCloseGeneric196Svg);
var _s2FillFolderCloseGeneric148Svg = require("illustration:./S2_fill_folderClose_generic1_48.svg");
var _s2FillFolderCloseGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFolderCloseGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FolderClose(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderCloseGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderCloseGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderCloseGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_folderClose_generic1_160.svg":"2bikx","illustration:./S2_fill_folderClose_generic1_96.svg":"fHWGj","illustration:./S2_fill_folderClose_generic1_48.svg":"lotYA","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2bikx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9e0d5d__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9e0d5d__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "9e0d5d__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9e0d5d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "9e0d5d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "9e0d5d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "9e0d5d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M71.544 43H20v-5.8c0-5.081 4.155-9.2 9.28-9.2h25.7c2.819 0 5.485 1.27 7.246 3.453zm54.61 8H20v67.059C20 125.753 26.204 132 33.846 132h92.308c7.642 0 13.846-6.247 13.846-13.941V64.941C140 57.247 133.796 51 126.154 51"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#9e0d5d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#9e0d5d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#9e0d5d__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9e0d5d__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9e0d5d__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#9e0d5d__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#9e0d5d__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fHWGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "757c77__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "757c77__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "757c77__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "757c77__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "757c77__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "757c77__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "757c77__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M42.927 26H12v-3.48c0-3.049 2.493-5.52 5.568-5.52h15.42c1.691 0 3.291.762 4.348 2.072zM75.692 30.8H12v40.235c0 4.617 3.723 8.365 8.308 8.365h55.384c4.586 0 8.308-3.748 8.308-8.365v-31.87c0-4.617-3.722-8.365-8.308-8.365"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                        strokeWidth: 4.8,
                        d: "M42.927 26H12v-3.48c0-3.049 2.493-5.52 5.568-5.52h15.42c1.691 0 3.291.762 4.348 2.072zM75.692 30.8H12v40.235c0 4.617 3.723 8.365 8.308 8.365h55.384c4.586 0 8.308-3.748 8.308-8.365v-31.87c0-4.617-3.722-8.365-8.308-8.365Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#757c77__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#757c77__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#757c77__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#757c77__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#757c77__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#757c77__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#757c77__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lotYA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5142c2__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5142c2__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5142c2__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5142c2__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5142c2__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5142c2__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("clipPath", {
                id: "5142c2__a",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M21.463 12.5H6v-1.74C6 9.236 7.246 8 8.784 8h7.71c.846 0 1.646.381 2.174 1.036zM37.846 14.9H6v20.118c0 2.308 1.861 4.182 4.154 4.182h27.692C40.14 39.2 42 37.326 42 35.018V19.082c0-2.308-1.861-4.182-4.154-4.182"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                        strokeWidth: 2.4,
                        d: "M21.463 12.5H6v-1.74C6 9.236 7.246 8 8.784 8h7.71c.846 0 1.646.381 2.174 1.036zM37.846 14.9H6v20.118c0 2.308 1.861 4.182 4.154 4.182h27.692C40.14 39.2 42 37.326 42 35.018V19.082c0-2.308-1.861-4.182-4.154-4.182Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5142c2__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5142c2__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#5142c2__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5142c2__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5142c2__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5142c2__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#5142c2__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"957Z0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FolderOpen);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFolderOpenGeneric1160Svg = require("illustration:./S2_fill_folderOpen_generic1_160.svg");
var _s2FillFolderOpenGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFolderOpenGeneric1160Svg);
var _s2FillFolderOpenGeneric196Svg = require("illustration:./S2_fill_folderOpen_generic1_96.svg");
var _s2FillFolderOpenGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFolderOpenGeneric196Svg);
var _s2FillFolderOpenGeneric148Svg = require("illustration:./S2_fill_folderOpen_generic1_48.svg");
var _s2FillFolderOpenGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFolderOpenGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FolderOpen(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderOpenGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderOpenGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderOpenGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_folderOpen_generic1_160.svg":"k3Duw","illustration:./S2_fill_folderOpen_generic1_96.svg":"g9DkM","illustration:./S2_fill_folderOpen_generic1_48.svg":"hlXMM","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k3Duw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92ffa5__d",
                        x1: -32.728,
                        x2: 209.883,
                        y1: 133.353,
                        y2: -14.249,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92ffa5__e",
                        x1: 161.965,
                        x2: 57.886,
                        y1: 27.487,
                        y2: 139.401,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "92ffa5__f",
                        x1: 35.482,
                        x2: 219.987,
                        y1: 154.848,
                        y2: 51.491,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "92ffa5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 41.68 47.468)scale(64.9209)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "92ffa5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 59.17 86.13)scale(64.9209)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "92ffa5__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 149.225,
                            height: 149.225,
                            x: 4.773,
                            fill: "#fff",
                            rx: 3.731
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "92ffa5__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M129.5 68v-4.364c0-7.38-5.992-13.363-13.385-13.363H69.269l-15.167-18.93C52.41 29.23 49.845 28 47.135 28H22.423c-4.928 0-8.923 3.989-8.923 8.91v81.726c0 1.264.176 2.487.504 3.646.1-1.703.47-3.442 1.147-5.174l.055-.138 15.788-38.276C33.586 72.16 39.949 68 46.876 68zm-98.435 64h98.059q.357 0 .71-.027c3.466-.265 6.498-2.453 7.752-5.66l15.811-38.333c2.119-5.42-1.597-11.207-7.297-11.909q-.57-.07-1.165-.071H46.876c-3.758 0-7.125 2.263-8.463 5.687L22.602 120.02c-2.26 5.782 2.118 11.98 8.462 11.98"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#92ffa5__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#92ffa5__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 149.225,
                            height: 149.225,
                            x: 4.773,
                            fill: "#FFECCF",
                            rx: 3.731
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.773 0h149.225v149.225H4.773z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.148,
                            cy: 5.788,
                            r: 64.921,
                            fill: "url(#92ffa5__c)",
                            transform: "rotate(-.08 89.148 5.788)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92ffa5__d)",
                            d: "M61.73-26.36c-11.46-7.091-25.98-7.135-37.484-.112l-115.05 70.246c-11.267 6.88-11.286 23.118-.034 30.024l114.29 70.146c11.486 7.049 26.006 7.04 37.482-.025l114.054-70.211c11.193-6.891 11.213-23.04.034-29.957z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92ffa5__e)",
                            d: "M26.277 70.849c2.55-55.71 49.78-98.804 105.49-96.254s98.804 49.78 96.253 105.49c-2.55 55.71-49.779 98.804-105.489 96.254-55.71-2.551-98.805-49.78-96.254-105.49"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#92ffa5__f)",
                            d: "M-55.685 107.582c22.144-9.447 46.027-9.042 66.719-.779 41.404 16.576 65.496 6.327 82.206-34.982 8.323-20.729 24.573-38.284 46.743-47.742 44.324-18.88 95.496 1.606 114.349 45.8s-1.782 95.284-46.097 114.189c-22.219 9.479-46.148 9.035-66.871.698-41.337-16.488-65.383-6.2-82.072 35.158-8.344 20.68-24.59 38.175-46.735 47.622-44.29 18.895-95.461-1.592-114.304-45.761s1.772-95.309 46.062-114.203"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 145.301,
                            cy: 26.96,
                            r: 64.921,
                            fill: "url(#92ffa5__g)",
                            transform: "rotate(-.08 145.301 26.96)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g9DkM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c99d7__d",
                        x1: -19.632,
                        x2: 125.934,
                        y1: 80.012,
                        y2: -8.549,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c99d7__e",
                        x1: 97.184,
                        x2: 34.737,
                        y1: 16.492,
                        y2: 83.641,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c99d7__f",
                        x1: 21.293,
                        x2: 131.996,
                        y1: 92.908,
                        y2: 30.894,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0c99d7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.009 28.482)scale(38.9525)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0c99d7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 35.504 51.68)scale(38.9525)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0c99d7__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 89.535,
                            height: 89.535,
                            x: 2.867,
                            fill: "#fff",
                            rx: 2.238
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0c99d7__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M77.702 40.8v-2.618c0-4.429-3.596-8.019-8.031-8.019H41.563l-9.1-11.357c-1.016-1.268-2.554-2.006-4.18-2.006H13.454c-2.956 0-5.353 2.393-5.353 5.345v49.037c0 .757.105 1.49.302 2.186.06-1.021.281-2.064.688-3.104l.033-.082 9.472-22.966c1.556-3.92 5.374-6.416 9.53-6.416zm.536 38.348c1.938-.268 3.603-1.54 4.314-3.36l9.487-23c1.356-3.47-1.27-7.188-5.077-7.188H28.127c-2.255 0-4.275 1.357-5.078 3.412l-9.487 23c-1.353 3.462 1.26 7.172 5.053 7.188h58.861"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0c99d7__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0c99d7__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 89.535,
                            height: 89.535,
                            x: 2.867,
                            fill: "#FFECCF",
                            rx: 2.238
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.867 0h89.535v89.535H2.867z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.491,
                            cy: 3.473,
                            r: 38.953,
                            fill: "url(#0c99d7__c)",
                            transform: "rotate(-.08 53.491 3.473)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c99d7__d)",
                            d: "M37.043-15.816c-6.877-4.255-15.589-4.28-22.49-.067l-69.03 42.147c-6.761 4.128-6.772 13.872-.02 18.015l68.573 42.088c6.891 4.229 15.603 4.224 22.489-.015l68.432-42.127c6.716-4.135 6.728-13.824.021-17.974z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c99d7__e)",
                            d: "M15.772 42.51c1.53-33.427 29.868-59.283 63.294-57.753s59.282 29.868 57.752 63.294c-1.531 33.426-29.868 59.283-63.294 57.752S14.24 75.935 15.772 42.509"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c99d7__f)",
                            d: "M-33.407 64.548c13.286-5.668 27.616-5.425 40.031-.467 24.843 9.946 39.298 3.797 49.324-20.989 4.994-12.437 14.744-22.97 28.045-28.645 26.595-11.328 57.298.963 68.61 27.48 11.312 26.516-1.069 57.17-27.658 68.513-13.331 5.688-27.689 5.421-40.123.419-24.802-9.893-39.23-3.72-49.243 21.095-5.006 12.408-14.754 22.905-28.041 28.573-26.574 11.337-57.276-.955-68.582-27.456s1.063-57.186 27.637-68.523"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 87.183,
                            cy: 16.175,
                            r: 38.953,
                            fill: "url(#0c99d7__g)",
                            transform: "rotate(-.08 87.183 16.175)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hlXMM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "95b76e__d",
                        x1: -9.82,
                        x2: 62.963,
                        y1: 40.006,
                        y2: -4.275,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "95b76e__e",
                        x1: 48.588,
                        x2: 17.364,
                        y1: 8.246,
                        y2: 41.82,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "95b76e__f",
                        x1: 10.645,
                        x2: 65.996,
                        y1: 46.455,
                        y2: 15.447,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "95b76e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.503 14.239)scale(19.4763)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "95b76e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 17.75 25.839)scale(19.4763)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "95b76e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 44.767,
                            height: 44.767,
                            x: 1.43,
                            fill: "#fff",
                            rx: 1.119
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "95b76e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M38.847 20.4v-1.309c0-2.214-1.798-4.009-4.016-4.009H20.778l-4.55-5.679C15.718 8.77 14.95 8.4 14.138 8.4H6.723c-1.479 0-2.677 1.197-2.677 2.673v24.518q.002.572.152 1.096c.03-.511.14-1.034.344-1.554q.007-.021.017-.042L9.296 23.61c.778-1.96 2.686-3.209 4.764-3.209zm4.63 2.4H14.06c-1.127 0-2.137.68-2.538 1.706l-4.744 11.5c-.676 1.731.63 3.586 2.527 3.594h29.428c1.128 0 2.138-.678 2.54-1.706l4.743-11.5c.652-1.666-.536-3.448-2.318-3.585q-.11-.009-.22-.009"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#95b76e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#95b76e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 44.767,
                            height: 44.767,
                            x: 1.43,
                            fill: "#FFECCF",
                            rx: 1.119
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M1.43 0h44.767v44.767H1.43z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.742,
                            cy: 1.736,
                            r: 19.476,
                            fill: "url(#95b76e__c)",
                            transform: "rotate(-.08 26.742 1.736)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#95b76e__d)",
                            d: "M18.517-7.908c-3.438-2.127-7.794-2.14-11.245-.034l-34.515 21.074c-3.38 2.064-3.386 6.936-.01 9.008L7.034 43.183c3.446 2.115 7.802 2.112 11.245-.007l34.216-21.064c3.358-2.067 3.364-6.911.01-8.987z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#95b76e__e)",
                            d: "M7.882 21.255C8.647 4.542 22.816-8.387 39.529-7.621S69.17 7.313 68.405 24.026s-14.934 29.64-31.647 28.876C20.045 52.136 7.117 37.968 7.882 21.255"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#95b76e__f)",
                            d: "M-16.706 32.275c6.644-2.834 13.809-2.713 20.016-.234 12.421 4.973 19.649 1.898 24.662-10.494 2.497-6.22 7.372-11.486 14.023-14.323 13.297-5.664 28.649.482 34.305 13.74s-.535 28.585-13.83 34.257c-6.665 2.843-13.844 2.71-20.06.209-12.402-4.946-19.616-1.86-24.622 10.548-2.504 6.203-7.377 11.452-14.02 14.286-13.288 5.668-28.64-.477-34.292-13.728s.532-28.593 13.818-34.261"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 43.589,
                            cy: 8.088,
                            r: 19.476,
                            fill: "url(#95b76e__g)",
                            transform: "rotate(-.08 43.59 8.088)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4DM6V":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FolderShared);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillFolderSharedGeneric1160Svg = require("illustration:./S2_fill_folderShared_generic1_160.svg");
var _s2FillFolderSharedGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillFolderSharedGeneric1160Svg);
var _s2FillFolderSharedGeneric196Svg = require("illustration:./S2_fill_folderShared_generic1_96.svg");
var _s2FillFolderSharedGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillFolderSharedGeneric196Svg);
var _s2FillFolderSharedGeneric148Svg = require("illustration:./S2_fill_folderShared_generic1_48.svg");
var _s2FillFolderSharedGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillFolderSharedGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function FolderShared(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderSharedGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderSharedGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillFolderSharedGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_folderShared_generic1_160.svg":"gpxIh","illustration:./S2_fill_folderShared_generic1_96.svg":"g276c","illustration:./S2_fill_folderShared_generic1_48.svg":"1M2wb","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gpxIh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21adf3__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21adf3__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "21adf3__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "21adf3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "21adf3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "21adf3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "21adf3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M20 43h51.544l-9.318-11.547C60.466 29.27 57.8 28 54.98 28h-25.7C24.155 28 20 32.119 20 37.2zm0 8h106.154C133.796 51 140 57.247 140 64.941v53.118c0 7.694-6.204 13.941-13.846 13.941H33.846C26.204 132 20 125.753 20 118.059zm52.294 26.334c-.803 0-1.455.651-1.455 1.455 0 .41.165.776.443 1.046 1.588 1.536 1.629 4.069.092 5.656s-4.07 1.628-5.656.091c-1.77-1.714-2.879-4.127-2.879-6.793 0-5.222 4.233-9.455 9.455-9.455 2.21 0 4 1.79 4 4s-1.79 4-4 4m3.852 4.823c0-4.916 3.986-8.901 8.902-8.901s8.902 3.985 8.902 8.901-3.986 8.903-8.902 8.903-8.902-3.986-8.902-8.903M72.11 92.292c.952 1.993.108 4.381-1.886 5.333-1.906.91-3.39 2.804-3.78 5.106-.37 2.178-2.436 3.644-4.614 3.274s-3.643-2.435-3.274-4.613c.823-4.845 3.946-8.944 8.22-10.986 1.994-.952 4.382-.108 5.334 1.886m-1.691 11.399c1.55-6.436 7.782-10.827 14.63-10.827 6.846 0 13.078 4.39 14.629 10.827.977 4.057-2.457 6.977-5.714 6.977H76.133c-3.257 0-6.692-2.92-5.714-6.977"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#21adf3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#21adf3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#21adf3__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21adf3__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21adf3__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#21adf3__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#21adf3__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g276c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8754f3__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8754f3__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "8754f3__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8754f3__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "8754f3__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "8754f3__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "8754f3__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M12 25.8h30.927l-5.591-6.928c-1.057-1.31-2.657-2.072-4.348-2.072h-15.42C14.493 16.8 12 19.27 12 22.32zm0 4.8h63.692c4.586 0 8.308 3.748 8.308 8.365v31.87c0 4.617-3.722 8.365-8.308 8.365H20.308C15.723 79.2 12 75.452 12 70.835zm31.377 15.399c-.704 0-1.274.57-1.274 1.273 0 .36.147.681.388.915.794.768.814 2.034.046 2.828s-2.035.814-2.828.046c-.988-.957-1.606-2.302-1.606-3.789 0-2.912 2.361-5.273 5.273-5.273 1.105 0 2 .895 2 2s-.895 2-2 2m2.711 3.294c0-2.729 2.212-4.94 4.941-4.94 2.73 0 4.941 2.211 4.941 4.94s-2.212 4.941-4.94 4.941c-2.73 0-4.942-2.212-4.942-4.94m-3.183 6.252c.476.997.054 2.191-.943 2.667-1.262.603-2.234 1.85-2.49 3.357-.185 1.09-1.218 1.822-2.307 1.638s-1.822-1.218-1.637-2.307c.472-2.78 2.264-5.129 4.71-6.297.997-.476 2.191-.054 2.667.942m-.265 6.761c.882-3.659 4.442-6.19 8.39-6.19 3.947 0 7.506 2.531 8.388 6.19.514 2.134-1.29 3.693-3.04 3.693H45.68c-1.749 0-3.554-1.56-3.04-3.693"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#8754f3__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#8754f3__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#8754f3__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8754f3__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8754f3__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#8754f3__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#8754f3__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1M2wb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c51ca__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.896,
                        y2: -4.582,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c51ca__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.843,
                        y2: 44.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "0c51ca__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.81,
                        y2: 16.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0c51ca__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.503)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "0c51ca__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.264 26.937)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "0c51ca__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "0c51ca__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M6 12.9h15.463l-2.795-3.464C18.14 8.782 17.34 8.4 16.494 8.4h-7.71C7.246 8.4 6 9.636 6 11.16zm0 2.4h31.846C40.14 15.3 42 17.174 42 19.483v15.935c0 2.308-1.861 4.182-4.154 4.182H10.154C7.86 39.6 6 37.726 6 35.418zm15.688 7.95c-.213 0-.386.173-.386.387 0 .109.043.206.117.277.497.48.51 1.272.03 1.768-.481.496-1.273.509-1.769.028-.54-.523-.878-1.26-.878-2.073 0-1.595 1.292-2.887 2.886-2.887.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25m1.106 1.397c0-1.502 1.218-2.72 2.72-2.72s2.721 1.218 2.721 2.72-1.218 2.72-2.72 2.72-2.721-1.217-2.721-2.72m-1.116 3.019c.298.622.034 1.369-.59 1.666-.556.266-.991.82-1.106 1.495-.115.68-.76 1.139-1.441 1.023-.68-.115-1.139-.76-1.023-1.441.249-1.47 1.196-2.713 2.493-3.333.623-.297 1.37-.034 1.667.59m-.6 3.429c.47-1.956 2.363-3.286 4.437-3.286s3.966 1.33 4.437 3.286c.302 1.255-.76 2.155-1.763 2.155h-5.35c-1.002 0-2.064-.9-1.762-2.155"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#0c51ca__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#0c51ca__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            y: 0.001,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 .001h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.863,
                            r: 20.883,
                            fill: "url(#0c51ca__c)",
                            transform: "rotate(-.08 27.142 1.863)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c51ca__d)",
                            d: "M18.321-8.478c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.657L6.008 46.304c3.694 2.267 8.365 2.264 12.056-.008L54.752 23.71c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c51ca__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.99 40.85-8.17S72.63 7.84 71.809 25.76 55.798 57.543 37.879 56.722C19.957 55.902 6.095 40.71 6.915 22.79"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#0c51ca__f)",
                            d: "M-19.448 34.606c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.331 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.649-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.279-15.033 15.318-14.246 6.077-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.673,
                            r: 20.883,
                            fill: "url(#0c51ca__g)",
                            transform: "rotate(-.08 45.2 8.673)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8muEX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Gift);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillGiftGeneric1160Svg = require("illustration:./S2_fill_gift_generic1_160.svg");
var _s2FillGiftGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillGiftGeneric1160Svg);
var _s2FillGiftGeneric196Svg = require("illustration:./S2_fill_gift_generic1_96.svg");
var _s2FillGiftGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillGiftGeneric196Svg);
var _s2FillGiftGeneric148Svg = require("illustration:./S2_fill_gift_generic1_48.svg");
var _s2FillGiftGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillGiftGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Gift(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGiftGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGiftGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGiftGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_gift_generic1_160.svg":"atd9Y","illustration:./S2_fill_gift_generic1_96.svg":"cz2Jk","illustration:./S2_fill_gift_generic1_48.svg":"deJDT","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"atd9Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "77911b__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "77911b__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "77911b__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "77911b__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "77911b__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "77911b__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "77911b__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M46 41.488C46 31.278 54.277 23 64.488 23c5.87 0 11.6 2.736 14.987 7.001C82.862 25.736 87.593 23 93.462 23c10.211 0 18.488 8.277 18.488 18.488 0 3.894-1.204 7.507-3.26 10.487H93.571c5.742-.059 10.379-4.732 10.379-10.487C103.95 35.696 99.254 31 93.462 31c-5.766 0-9.445 4.654-9.487 10.41v10.565l-9-.006v-10.56C74.933 35.655 70.254 31 64.488 31 58.695 31 54 35.696 54 41.488c0 5.755 4.637 10.428 10.379 10.487H49.26C47.204 48.995 46 45.382 46 41.488M24 60c0-4.418 3.582-8 8-8h43v33H32c-4.418 0-8-3.582-8-8zm111 0c0-4.418-3.582-8-8-8H84v33h43c4.418 0 8-3.582 8-8zM84 93h44v25c0 9.941-8.059 18-18 18H84zm-53 0h44v43H49c-9.941 0-18-8.059-18-18z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#77911b__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#77911b__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#77911b__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#77911b__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#77911b__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#77911b__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#77911b__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cz2Jk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f49234__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f49234__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f49234__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f49234__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f49234__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f49234__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f49234__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M28.685 25.506c0-5.887 4.772-10.66 10.66-10.66 3.384 0 6.688 1.578 8.64 4.038 1.953-2.46 4.68-4.037 8.065-4.037 5.887 0 10.66 4.772 10.66 10.66 0 2.244-.694 4.328-1.88 6.046h-8.717c3.31-.034 5.984-2.728 5.984-6.047 0-3.34-2.707-6.047-6.047-6.047-3.324 0-5.446 2.683-5.47 6.002v6.092l-5.189-.004v-6.088c-.024-3.319-2.722-6.002-6.047-6.002-3.34 0-6.047 2.708-6.047 6.047 0 3.319 2.674 6.013 5.984 6.047h-8.717c-1.185-1.718-1.88-3.802-1.88-6.047M16 36.18c0-2.547 2.065-4.613 4.613-4.613h24.792v19.027H20.613c-2.548 0-4.613-2.065-4.613-4.612zm64 0c0-2.547-2.065-4.612-4.613-4.612H50.595v19.027h24.792c2.548 0 4.613-2.065 4.613-4.613zM50.595 55.207h25.369v14.415C75.964 75.353 71.317 80 65.586 80H50.595zm-30.559 0h25.37V80H30.413c-5.731 0-10.378-4.647-10.378-10.378z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f49234__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f49234__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#f49234__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f49234__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f49234__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f49234__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#f49234__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deJDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5eadaf__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5eadaf__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "5eadaf__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5eadaf__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "5eadaf__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "5eadaf__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "5eadaf__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#D9D9D9",
                    fillRule: "evenodd",
                    d: "M14.357 12.342c0-2.95 2.392-5.342 5.342-5.342 1.696 0 3.352.79 4.33 2.023C25.01 7.79 26.376 7 28.073 7c2.95 0 5.342 2.392 5.342 5.342 0 1.126-.348 2.17-.942 3.03h-4.369c1.66-.016 3-1.367 3-3.03 0-1.673-1.358-3.03-3.031-3.03-1.666 0-2.73 1.344-2.742 3.008v3.053l-2.6-.002V12.32c-.013-1.664-1.365-3.008-3.031-3.008-1.674 0-3.03 1.357-3.03 3.03 0 1.663 1.34 3.014 2.999 3.03h-4.37c-.593-.86-.941-1.904-.941-3.03M8 17.692c0-1.277 1.035-2.312 2.312-2.312h12.425v9.536H10.312C9.035 24.916 8 23.881 8 22.604zm32.075 0c0-1.277-1.035-2.312-2.312-2.312H25.339v9.536h12.426c1.276 0 2.311-1.035 2.311-2.312zm-14.738 9.536h12.715v7.224c0 2.873-2.329 5.201-5.201 5.201h-7.514zm-15.314 0h12.715v12.425h-7.513c-2.873 0-5.202-2.328-5.202-5.201z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#5eadaf__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#5eadaf__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#5eadaf__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5eadaf__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5eadaf__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#5eadaf__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#5eadaf__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aqJ7U":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Globe);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillGlobeGeneric1160Svg = require("illustration:./S2_fill_globe_generic1_160.svg");
var _s2FillGlobeGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGeneric1160Svg);
var _s2FillGlobeGeneric196Svg = require("illustration:./S2_fill_globe_generic1_96.svg");
var _s2FillGlobeGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGeneric196Svg);
var _s2FillGlobeGeneric148Svg = require("illustration:./S2_fill_globe_generic1_48.svg");
var _s2FillGlobeGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function Globe(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_globe_generic1_160.svg":"fAfay","illustration:./S2_fill_globe_generic1_96.svg":"berii","illustration:./S2_fill_globe_generic1_48.svg":"aUc4r","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fAfay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2264ae__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2264ae__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "2264ae__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2264ae__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "2264ae__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "2264ae__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "2264ae__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M23.977 79.987c0-17.009 7.579-32.247 19.544-42.521.923 2.022 2.32 4.67 4.003 7.132 1.05 1.537 2.278 3.099 3.645 4.41 1.329 1.273 3.038 2.551 5.077 3.134 3.287.939 7.097.801 9.977.697q.456-.017.878-.03c1.63-.052 2.943-.066 4.03.045 1.114.114 1.57.325 1.709.417.307.205.386.367.412.43.033.08.067.223.026.458-.089.522-.525 1.277-1.398 1.762-2.073 1.152-4.143 2.599-5.695 4.594-1.626 2.09-2.542 4.602-2.542 7.554 0 .862-.068 1.398-.148 1.719l-.009.032c-.273.055-.798.104-1.69.03l-.857-.075c-2.318-.206-5.688-.504-8.868-.171-3.54.37-8.095 1.644-10.558 5.955-1.08 1.89-2.33 5.037-2.032 8.799.31 3.924 2.267 7.993 6.713 11.55 5.12 4.097 10.752 4.977 18.123 5.796 4.2.467 6.581 1.367 7.939 2.325 1.19.841 1.846 1.898 2.175 3.546.575 2.877-.395 7.187-2.433 12.445-.975 2.516-2.113 5.054-3.246 7.518l-.743 1.612c-.812 1.755-1.607 3.473-2.273 5.028-24.032-6.309-41.76-28.18-41.76-54.191m26.362-46.902q-.104-.255-.237-.486c3.834-2.424 7.982-4.395 12.37-5.84q.075.452.258.89c2.056 4.898 8.302 10.941 16.68 10.941 4.327 0 7.798-1.855 10.35-3.972 2.527-2.096 4.343-4.6 5.473-6.33.413-.632.624-1.338.649-2.042q1.035.305 2.051.649-.085.276-.129.57c-.673 4.46-1.437 10.7-.74 16.343.686 5.544 3.007 11.908 9.759 14.252 5.356 1.86 10.656.945 14.796-.9 2.737-1.22 5.23-2.963 7.071-4.904 2.109 3.695 3.81 7.653 5.04 11.814-.535-.113-1.121-.233-1.75-.357-3.013-.59-7.064-1.262-11.28-1.542-4.159-.276-8.77-.193-12.777.906-4.021 1.102-8.103 3.444-9.84 8.134-4.859 13.115 1.7 21.061 3.393 22.755 2.554 2.553 5.174 3.747 7.1 4.624q.351.159.67.307c1.861.87 3.188 1.627 4.54 3.58.467.675.945 1.887 1.3 3.74.343 1.796.517 3.894.583 6.106.065 2.199.021 4.415-.043 6.435-.017.551-.036 1.1-.055 1.634v.007c-.038 1.074-.074 2.09-.087 2.944-9.662 7.916-22.018 12.667-35.484 12.667q-3.135-.001-6.181-.337c.435-.967.91-1.993 1.413-3.082v-.002q.385-.83.79-1.709c1.145-2.492 2.367-5.214 3.435-7.968 2.047-5.281 3.89-11.544 2.82-16.905-.67-3.35-2.304-6.323-5.407-8.513-2.936-2.073-6.855-3.206-11.67-3.741-7.456-.83-10.891-1.598-14.008-4.091-2.896-2.318-3.617-4.428-3.736-5.935-.132-1.67.435-3.206 1.003-4.2.513-.897 1.725-1.682 4.444-1.967 2.354-.246 4.903-.025 7.3.182h.001l.928.08c2.863.238 5.98-.099 8.18-2.42 2.064-2.18 2.331-5.133 2.331-7.334 0-1.168.32-1.952.857-2.641.61-.786 1.63-1.605 3.265-2.513 2.835-1.575 4.87-4.32 5.398-7.403.56-3.262-.636-6.73-3.886-8.896-1.715-1.144-3.68-1.55-5.332-1.72-1.682-.172-3.485-.134-5.098-.083l-.653.022c-3.224.105-5.75.187-7.75-.385-.268-.076-.862-.377-1.739-1.217-.837-.802-1.715-1.888-2.577-3.149-1.728-2.528-3.124-5.366-3.789-6.998m73.361 81.962c7.71-9.598 12.324-21.79 12.324-35.06 0-2.487-.162-4.937-.476-7.338l-.125-.022c-.135-.026-.285-.057-.423-.087-.199-.044-.454-.1-.739-.165l-.348-.078c-.873-.195-2.06-.456-3.471-.733-2.838-.556-6.524-1.162-10.272-1.41-3.805-.254-7.384-.116-10.131.638-2.733.749-3.97 1.891-4.454 3.198-3.383 9.13 1.142 13.912 1.549 14.32 1.487 1.487 2.844 2.113 4.772 3.003l.726.336c2.423 1.132 5.216 2.641 7.731 6.274 1.387 2.003 2.136 4.472 2.58 6.79.455 2.376.65 4.941.722 7.373.03 1 .039 1.994.035 2.961m.277-69.772c-4.974-6.294-11.271-11.495-18.471-15.183-.572 4.097-.995 8.747-.502 12.734.564 4.557 2.101 6.864 4.442 7.676 2.957 1.027 6.112.6 8.917-.65 2.913-1.297 4.847-3.21 5.456-4.315q.075-.136.158-.262M80 23.963c2.755 0 5.463.199 8.111.583-.9 1.306-2.058 2.753-3.458 3.915-1.606 1.332-3.332 2.129-5.242 2.129-4.395 0-7.991-3.273-9.188-5.777 3.175-.559 6.442-.85 9.777-.85"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#2264ae__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#2264ae__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#2264ae__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2264ae__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2264ae__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#2264ae__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#2264ae__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"berii":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24dc54__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24dc54__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "24dc54__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "24dc54__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "24dc54__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "24dc54__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "24dc54__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M48 14.74c1.787 0 3.541.142 5.252.416-.539.73-1.25 1.565-2.082 2.276-1.154.985-2.349 1.568-3.517 1.568-1.23 0-2.546-.54-3.716-1.414-.997-.745-1.719-1.608-2.095-2.272 1.995-.377 4.053-.574 6.158-.574m9.122 1.854q.157-.244.238-.508.724.214 1.434.46-.038.129-.058.265c-.394 2.607-.878 6.313-.463 9.631.411 3.293 1.829 6.914 5.851 8.1 3.074.905 5.989.302 8.271-.828 1.56-.772 2.917-1.836 3.901-2.964 1.485 2.468 2.656 5.146 3.458 7.979q-.466-.101-1.018-.211c-1.724-.344-4.044-.733-6.478-.895-2.41-.16-5.063-.105-7.398.519-2.34.625-4.636 1.906-5.809 4.395-1.725 3.662-1.522 6.785-.697 9.117.804 2.27 2.15 3.67 2.548 4.068 1.456 1.457 2.943 2.134 4.077 2.652q.208.094.398.183c1.122.524 1.969 1.003 2.817 2.228.327.473.62 1.225.833 2.277.209 1.03.316 2.217.36 3.46.058 1.661.005 3.163-.041 4.49-.024.695-.047 1.342-.05 1.939-5.748 4.86-13.18 7.79-21.296 7.79q-2.038-.002-4.012-.242c.27-.604.567-1.246.882-1.927l.463-1.003c.674-1.466 1.39-3.062 2.015-4.673 1.205-3.11 2.253-6.712 1.644-9.76-.38-1.896-1.298-3.562-3.041-4.793-1.66-1.171-3.899-1.828-6.708-2.14-4.388-.488-6.51-.946-8.434-2.486-1.775-1.42-2.255-2.75-2.334-3.746-.085-1.076.28-2.053.637-2.678.389-.68 1.252-1.165 2.89-1.336 1.423-.15 2.96-.016 4.368.106l.546.047c1.651.138 3.348-.068 4.53-1.315 1.115-1.177 1.276-2.791 1.276-4.075 0-.768.215-1.306.58-1.775.4-.516 1.048-1.027 2.03-1.572 1.583-.88 2.71-2.408 3.002-4.11.307-1.792-.345-3.69-2.135-4.884-.94-.626-2.03-.857-2.98-.955-.964-.098-2.004-.077-2.955-.047l-.41.014c-1.873.06-3.415.112-4.65-.241-.724-.207-1.876-1.09-2.993-2.567-1.086-1.434-1.8-2.982-1.959-4.011q-.046-.294-.167-.55c2.41-1.56 5.035-2.815 7.822-3.71q.03.1.071.197c.63 1.499 1.958 3.08 3.564 4.28 1.62 1.212 3.76 2.211 6.111 2.211 2.505 0 4.596-1.23 6.114-2.526 1.534-1.309 2.684-2.854 3.355-3.88m16.282 52.21C78.148 63.09 81 55.749 81 47.74c0-1.598-.114-3.17-.333-4.708l-.096-.021-.423-.096-.198-.045c-.5-.114-1.182-.267-1.995-.43-1.632-.325-3.766-.68-5.962-.826-2.22-.147-4.374-.07-6.1.392-1.72.46-2.743 1.217-3.223 2.236-1.253 2.658-1.037 4.686-.545 6.078.515 1.454 1.385 2.353 1.606 2.574.923.924 1.778 1.318 2.912 1.84l.427.199c1.403.655 2.983 1.51 4.413 3.575.764 1.105 1.2 2.453 1.464 3.76.27 1.326.39 2.754.437 4.115.028.793.03 1.62.02 2.422m-32.145 8.048c-.47 1.014-.926 2.002-1.312 2.899C25.614 76.156 15 63.188 15 47.74c0-10.08 4.519-19.104 11.64-25.157.497 1.524 1.382 3.093 2.382 4.413 1.28 1.69 3.092 3.43 5.084 3.999 1.878.536 4.063.458 5.768.397l.517-.018c.96-.03 1.755-.04 2.42.029.681.07 1.017.202 1.169.303.236.158.331.308.375.414.047.115.07.268.037.466-.072.421-.4.955-1.002 1.289-1.202.668-2.374 1.492-3.246 2.613-.91 1.17-1.422 2.572-1.422 4.23 0 .524-.041.872-.099 1.1-.032.128-.063.192-.078.217-.076.041-.395.163-1.297.088l-.509-.044c-1.37-.121-3.317-.294-5.153-.102-2.048.215-4.583.944-5.947 3.33-.613 1.074-1.319 2.856-1.151 4.979.174 2.204 1.272 4.513 3.822 6.553 2.927 2.342 6.146 2.855 10.491 3.338 2.502.278 3.973.819 4.843 1.433.787.556 1.216 1.264 1.425 2.31.361 1.805-.25 4.431-1.45 7.53-.579 1.491-1.253 2.995-1.92 4.448zm32.627-49.58C70.858 23.446 67 20.308 62.585 18.13c-.354 2.473-.65 5.35-.342 7.816.342 2.735 1.307 4.256 3.012 4.758 1.899.56 3.77.216 5.366-.575 1.64-.812 2.791-1.998 3.232-2.798zM38.537 42.05q0 0 .002-.003zm.02-.02.009-.007z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#24dc54__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#24dc54__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#24dc54__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24dc54__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24dc54__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#24dc54__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#24dc54__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aUc4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "06859c__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "06859c__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "06859c__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "06859c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "06859c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "06859c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "06859c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m29.252 8.222-.347-.112q-.049.136-.13.261c-.337.516-.925 1.324-1.715 2.015-.777.68-1.884 1.364-3.233 1.364-2.736 0-4.442-2.084-5.106-3.323q-.045-.083-.076-.17c-1.19.408-2.317.948-3.367 1.603q.057.106.093.226c.146.487.529 1.293 1.037 2.018.25.357.508.662.752.886.255.233.43.32.511.343.578.165 1.31.14 2.267.11l.186-.006c.475-.015 1.01-.027 1.511.025.492.05 1.084.171 1.603.518.982.655 1.345 1.705 1.176 2.692-.16.93-.774 1.757-1.626 2.23-.478.266-.769.502-.94.722-.148.19-.237.406-.237.734 0 .65-.078 1.546-.707 2.21-.67.707-1.617.805-2.467.734l-.274-.023c-.707-.061-1.45-.126-2.136-.054-.794.083-1.12.31-1.254.543-.162.285-.323.723-.286 1.196.033.422.234 1.026 1.073 1.697.9.72 1.892.946 4.09 1.19 1.423.158 2.59.494 3.47 1.114.93.658 1.42 1.55 1.621 2.552.32 1.602-.231 3.464-.834 5.02-.315.813-.676 1.616-1.013 2.35l-.233.505q-.218.47-.407.886.861.09 1.746.091c3.896 0 7.477-1.35 10.3-3.61l-.001-.064c0-.325.02-.748.04-1.189l.016-.347c.026-.585.048-1.22.039-1.847-.01-.632-.053-1.226-.146-1.733-.095-.523-.229-.858-.357-1.043-.388-.56-.765-.777-1.308-1.03q-.093-.045-.197-.09c-.567-.259-1.35-.615-2.112-1.377-.51-.51-2.46-2.88-1.016-6.778.524-1.415 1.76-2.113 2.96-2.438 1.197-.324 2.571-.346 3.807-.262 1.253.085 2.457.286 3.351.462l.427.087c-.37-1.232-.88-2.402-1.512-3.494-.522.532-1.206 1.061-2.006 1.458-1.175.582-2.677.913-4.294.436-2.183-.643-2.87-2.645-3.045-4.332-.177-1.712.102-3.618.297-4.904zm11.119 13.57-.127-.026-.22-.05-.102-.023c-.259-.057-.61-.135-1.028-.217-.84-.165-1.93-.345-3.039-.42-1.125-.077-2.179-.038-2.983.18-.801.217-1.14.543-1.27.894-.983 2.653.332 4.033.44 4.141.429.429.817.608 1.385.87l.214.1c.719.335 1.554.787 2.306 1.872.417.603.636 1.335.76 2.015.128.696.175 1.442.186 2.144.005.304.003.606-.003.898 2.26-2.823 3.61-6.404 3.61-10.3q0-1.057-.13-2.078M7.5 23.869c0-4.978 2.204-9.44 5.69-12.466.274.676.688 1.447 1.171 2.136.32.458.695.913 1.11 1.293.404.37.915.733 1.513.904.98.28 2.114.24 2.96.208l.26-.009c.48-.015.862-.019 1.177.014.323.033.444.093.47.11.078.053.093.089.095.095.004.01.013.038.004.095-.023.13-.137.335-.376.469-.615.34-1.234.773-1.7 1.371-.488.629-.763 1.384-.763 2.269 0 .22-.015.363-.034.453-.082.01-.219.018-.432 0l-.252-.022c-.682-.06-1.682-.15-2.626-.05-1.05.11-2.422.49-3.165 1.79-.322.564-.696 1.506-.607 2.632.093 1.178.68 2.394 2.004 3.452 1.526 1.222 3.204 1.482 5.374 1.723 1.232.137 1.92.4 2.305.672.333.235.518.53.611 1 .165.825-.113 2.076-.713 3.625-.286.738-.62 1.484-.954 2.21l-.218.474c-.241.52-.478 1.032-.676 1.494C12.686 37.929 7.5 31.505 7.5 23.869m29.33-10.376c-1.418-1.751-3.188-3.207-5.202-4.258-.17 1.195-.314 2.532-.195 3.687.142 1.374.584 1.99 1.265 2.19.87.256 1.715.1 2.476-.278.75-.372 1.342-.924 1.656-1.34M24 7.37q1.177.001 2.31.16c-.246.323-.55.673-.897.976-.561.491-1.1.745-1.587.745-1.186 0-2.129-.82-2.679-1.635Q22.54 7.37 24 7.369"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#06859c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#06859c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#06859c__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#06859c__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#06859c__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#06859c__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#06859c__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kbYRW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobeGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillGlobeGridGeneric1160Svg = require("illustration:./S2_fill_globeGrid_generic1_160.svg");
var _s2FillGlobeGridGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGridGeneric1160Svg);
var _s2FillGlobeGridGeneric196Svg = require("illustration:./S2_fill_globeGrid_generic1_96.svg");
var _s2FillGlobeGridGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGridGeneric196Svg);
var _s2FillGlobeGridGeneric148Svg = require("illustration:./S2_fill_globeGrid_generic1_48.svg");
var _s2FillGlobeGridGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillGlobeGridGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function GlobeGrid(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGridGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGridGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGlobeGridGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_globeGrid_generic1_160.svg":"iSM8B","illustration:./S2_fill_globeGrid_generic1_96.svg":"13YHb","illustration:./S2_fill_globeGrid_generic1_48.svg":"h9PIs","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iSM8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f5dd6c__d",
                        x1: -40.209,
                        x2: 219.921,
                        y1: 142.983,
                        y2: -15.277,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f5dd6c__e",
                        x1: 168.544,
                        x2: 56.949,
                        y1: 29.472,
                        y2: 149.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "f5dd6c__f",
                        x1: 32.925,
                        x2: 230.753,
                        y1: 166.029,
                        y2: 55.209,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f5dd6c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 42.131 48.337)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "f5dd6c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 60.885 89.79)scale(69.6088)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "f5dd6c__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "f5dd6c__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M83.947 25.206v23.08h14.48c-3.451-8.022-8.27-15.778-14.48-23.08m23.127 23.08c-2.976-7.693-7.08-15.182-12.331-22.325 12.936 3.52 24.009 11.563 31.417 22.324zm-5.681 8H83.947v20.312h20.999c-.288-6.837-1.468-13.642-3.553-20.313m11.56 20.312c-.258-6.824-1.323-13.624-3.208-20.313h20.13q.427-.001.83-.086c2.94 6.254 4.758 13.14 5.193 20.399zm-8.077 8H83.947v20.312h17.089c2.151-6.693 3.435-13.498 3.84-20.312m4.52 20.312c1.953-6.699 3.121-13.5 3.491-20.312h22.927c-.59 7.252-2.561 14.115-5.651 20.322q-.142-.01-.288-.01zm-11.368 8h-14.08v22.953l.082-.006c5.9-7.309 10.573-15.018 13.998-22.947m-2.506 20.911c4.624-6.732 8.346-13.74 11.148-20.911h18.644c-7.238 9.948-17.671 17.421-29.792 20.911M33.84 48.285c7.382-10.724 18.405-18.748 31.285-22.288-5.24 7.132-9.334 14.61-12.305 22.288zm-3.215 8H50.15c-1.886 6.689-2.95 13.49-3.209 20.313h-22.84c.438-7.306 2.277-14.234 5.25-20.52.4.134.829.207 1.274.207m27.876 0c-2.085 6.671-3.265 13.477-3.552 20.313h20.998V56.284zM24.186 84.598h22.821c.37 6.813 1.538 13.613 3.491 20.312H30.625q-.39 0-.758.072c-3.107-6.224-5.09-13.108-5.681-20.385m30.833 0c.404 6.814 1.688 13.619 3.84 20.312h17.088V84.598zM34.686 112.91h18.538c2.797 7.157 6.51 14.153 11.122 20.873-12.065-3.506-22.449-10.961-29.66-20.873m27.18 0c3.424 7.927 8.095 15.632 13.991 22.939l.09.006V112.91zm14.081-87.704c-6.21 7.302-11.029 15.058-14.48 23.079h14.48z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#f5dd6c__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#f5dd6c__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h160v160H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.468,
                            cy: 6.206,
                            r: 69.609,
                            fill: "url(#f5dd6c__c)",
                            transform: "rotate(-.08 90.468 6.206)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f5dd6c__d)",
                            d: "M61.07-28.263c-12.288-7.603-27.857-7.65-40.19-.12l-123.358 75.318c-12.081 7.377-12.101 24.788-.036 32.193l122.542 75.211c12.315 7.557 27.884 7.548 40.188-.027l122.29-75.281c12.001-7.39 12.023-24.703.037-32.12z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f5dd6c__e)",
                            d: "M23.058 75.965C25.793 16.232 76.433-29.975 136.166-27.24c59.732 2.735 105.938 53.375 103.204 113.108s-53.375 105.939-113.108 103.204C66.53 186.337 20.324 135.697 23.058 75.965"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#f5dd6c__f)",
                            d: "M-64.825 115.35c23.744-10.129 49.351-9.695 71.537-.835 44.394 17.773 70.225 6.784 88.141-37.508 8.925-22.226 26.348-41.049 50.119-51.19 47.525-20.243 102.392 1.723 122.607 49.108 20.214 47.385-1.912 102.165-49.426 122.435-23.824 10.163-49.48 9.687-71.7.747-44.322-17.678-70.104-6.648-87.998 37.698-8.947 22.173-26.366 40.931-50.11 51.061-47.488 20.258-102.354-1.707-122.558-49.066-20.203-47.359 1.9-102.191 49.388-122.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 150.675,
                            cy: 28.906,
                            r: 69.609,
                            fill: "url(#f5dd6c__g)",
                            transform: "rotate(-.08 150.675 28.906)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"13YHb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a7a5c4__d",
                        x1: -24.124,
                        x2: 131.953,
                        y1: 85.79,
                        y2: -9.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a7a5c4__e",
                        x1: 101.128,
                        x2: 34.171,
                        y1: 17.683,
                        y2: 89.68,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a7a5c4__f",
                        x1: 19.755,
                        x2: 138.452,
                        y1: 99.617,
                        y2: 33.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a7a5c4__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.279 29.002)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a7a5c4__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.531 53.875)scale(41.7653)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a7a5c4__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "a7a5c4__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m50.028 15.075-.06-.004v14.605h9.21c-2.07-4.968-5.037-9.767-8.915-14.265q-.137-.159-.235-.336m13.46 14.6c-1.804-4.74-4.35-9.348-7.652-13.725 8.128 1.98 15.076 6.972 19.596 13.726zm-2.845 4H49.968v12.676h12.816c-.115-4.266-.826-8.516-2.141-12.675m6.143 12.676c-.105-4.259-.755-8.506-1.961-12.675H77.72c1.867 3.865 3.001 8.15 3.224 12.675zm-4.067 4H49.968V63.03h10.231c1.423-4.17 2.266-8.42 2.52-12.678m1.685 12.678c1.309-4.174 2.086-8.421 2.321-12.678h14.178c-.32 4.542-1.56 8.83-3.533 12.678zm-5.758 4h-8.678v13.898l.061-.004q.087-.155.203-.298c3.55-4.322 6.36-8.89 8.414-13.596M55.71 80.078c3.042-4.18 5.469-8.558 7.267-13.049h11.967c-4.548 6.429-11.34 11.158-19.234 13.049M20.568 29.676c4.505-6.733 11.424-11.714 19.518-13.707-3.295 4.371-5.836 8.974-7.637 13.707zm-2.006 4h12.55c-1.206 4.17-1.857 8.416-1.962 12.675H15.055c.223-4.532 1.36-8.824 3.232-12.694q.135.018.275.019m16.732 0c-1.316 4.16-2.026 8.41-2.142 12.675h12.816V33.676zM15.097 50.35H29.21c.236 4.257 1.012 8.505 2.32 12.678H18.63c-1.974-3.849-3.213-8.136-3.533-12.678m18.12 0c.255 4.258 1.098 8.508 2.52 12.678h10.23V50.351zM21.054 67.03h11.904c1.796 4.485 4.218 8.856 7.254 13.03-7.862-1.902-14.624-6.622-19.158-13.03m24.65 13.596q.115.141.201.294l.063.004V67.029H37.29c2.054 4.705 4.863 9.274 8.413 13.596m-.03-65.214c-3.879 4.498-6.845 9.297-8.916 14.265h9.21v-14.6l-.062.003q-.097.175-.233.332"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a7a5c4__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#a7a5c4__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h96v96H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 54.281,
                            cy: 3.723,
                            r: 41.765,
                            fill: "url(#a7a5c4__c)",
                            transform: "rotate(-.08 54.28 3.723)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a7a5c4__d)",
                            d: "M36.643-16.958c-7.373-4.562-16.714-4.59-24.114-.072l-74.015 45.19c-7.249 4.427-7.26 14.873-.022 19.316l73.526 45.127c7.389 4.534 16.73 4.529 24.113-.016l73.374-45.17c7.2-4.433 7.213-14.821.021-19.27z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a7a5c4__e)",
                            d: "M13.837 45.579C15.477 9.739 45.86-17.984 81.7-16.344s63.563 32.025 61.922 67.865-32.024 63.563-67.864 61.922-63.563-32.025-61.922-67.864"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#a7a5c4__f)",
                            d: "M-38.895 69.21c14.246-6.078 29.61-5.818 42.922-.502 26.636 10.664 42.135 4.071 52.885-22.504 5.355-13.336 15.809-24.63 30.071-30.714 28.515-12.146 61.435 1.033 73.564 29.464s-1.147 61.299-29.655 73.461c-14.294 6.098-29.688 5.813-43.02.449-26.593-10.607-42.063-3.989-52.799 22.618-5.368 13.304-15.82 24.559-30.066 30.637-28.493 12.155-61.413-1.024-73.535-29.44-12.122-28.415 1.14-61.314 29.633-73.47"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 90.406,
                            cy: 17.344,
                            r: 41.765,
                            fill: "url(#a7a5c4__g)",
                            transform: "rotate(-.08 90.406 17.344)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"h9PIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e399fc__d",
                        x1: -12.062,
                        x2: 65.977,
                        y1: 42.895,
                        y2: -4.583,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e399fc__e",
                        x1: 50.562,
                        x2: 17.084,
                        y1: 8.842,
                        y2: 44.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "e399fc__f",
                        x1: 9.878,
                        x2: 69.226,
                        y1: 49.809,
                        y2: 16.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e399fc__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.64 14.502)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "e399fc__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.265 26.936)scale(20.8826)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "e399fc__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 5.125
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "e399fc__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m25.235 7.062.053.003c1.941 2.303 3.435 4.75 4.488 7.28h-4.54zm3.74.695c1.482 2.116 2.644 4.325 3.49 6.588h5.508c-2.15-3.104-5.307-5.458-8.999-6.588m-3.74 9.088h5.432c.595 2 .927 4.038 1 6.084h-6.432zm8.032 0c.537 2.006.837 4.042.902 6.084h6.78c-.134-2.162-.674-4.215-1.543-6.084zm-8.032 8.584h6.392c-.139 2.044-.534 4.083-1.182 6.09h-5.21zm-2.5 6.09v-6.09h-6.39c.138 2.044.533 4.083 1.181 6.09zm-4.261 2.5h4.261v6.762q0 .079.01.155l-.052-.004c-1.77-2.204-3.18-4.526-4.22-6.913m-3.561-2.5c-.588-2.008-.947-4.047-1.073-6.09H7.077c.181 2.172.77 4.228 1.692 6.09zm-4.626 2.5h5.483c.841 2.139 1.949 4.23 3.317 6.242-3.572-1.078-6.648-3.3-8.8-6.242m14.948 0h4.262c-1.04 2.388-2.45 4.71-4.22 6.916l-.051.003q.01-.077.01-.157zm6.966 0c-.843 2.142-1.953 4.237-3.324 6.252 3.587-1.073 6.676-3.301 8.836-6.252zm7.03-2.5c.921-1.862 1.51-3.918 1.692-6.09H34.13c-.126 2.043-.485 4.082-1.073 6.09zM18.989 7.77c-3.676 1.133-6.82 3.482-8.962 6.576h5.479c.845-2.26 2.004-4.464 3.483-6.576m-4.284 9.076H8.75q-.077 0-.152-.009c-.872 1.871-1.413 3.927-1.547 6.093h6.752c.064-2.042.364-4.078.902-6.084m1.6 6.084c.072-2.046.404-4.083 1-6.084h5.43v6.084zm1.89-8.584c1.053-2.529 2.546-4.976 4.486-7.277l.054-.004v7.281z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#e399fc__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#e399fc__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#FFECCF",
                            rx: 5.125
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M0 0h48v48H0z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 27.142,
                            cy: 1.862,
                            r: 20.883,
                            fill: "url(#e399fc__c)",
                            transform: "rotate(-.08 27.142 1.862)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e399fc__d)",
                            d: "M18.321-8.479c-3.686-2.28-8.357-2.295-12.057-.036l-37.007 22.596c-3.624 2.213-3.63 7.436-.01 9.658L6.008 46.302c3.694 2.267 8.365 2.264 12.056-.008l36.687-22.585c3.6-2.216 3.607-7.41.011-9.635z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e399fc__e)",
                            d: "M6.916 22.79C7.736 4.87 22.93-8.993 40.85-8.173S72.63 7.841 71.809 25.76c-.82 17.92-16.012 31.782-33.931 30.961-17.92-.82-31.782-16.012-30.962-33.932"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#e399fc__f)",
                            d: "M-19.448 34.605c7.124-3.039 14.806-2.908 21.462-.25 13.318 5.332 21.067 2.035 26.442-11.253 2.677-6.667 7.904-12.314 15.036-15.357 14.257-6.073 30.717.517 36.782 14.733 6.064 14.215-.574 30.65-14.828 36.73-7.147 3.05-14.844 2.906-21.51.224-13.297-5.303-21.031-1.994-26.4 11.31-2.684 6.651-7.91 12.28-15.033 15.318-14.246 6.078-30.706-.512-36.767-14.72-6.06-14.207.57-30.657 14.816-36.735"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 45.201,
                            cy: 8.672,
                            r: 20.883,
                            fill: "url(#e399fc__g)",
                            transform: "rotate(-.08 45.2 8.672)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gMm0k":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GraphBarChart);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillGraphBarChartGeneric1160Svg = require("illustration:./S2_fill_graphBarChart_generic1_160.svg");
var _s2FillGraphBarChartGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillGraphBarChartGeneric1160Svg);
var _s2FillGraphBarChartGeneric196Svg = require("illustration:./S2_fill_graphBarChart_generic1_96.svg");
var _s2FillGraphBarChartGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillGraphBarChartGeneric196Svg);
var _s2FillGraphBarChartGeneric148Svg = require("illustration:./S2_fill_graphBarChart_generic1_48.svg");
var _s2FillGraphBarChartGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillGraphBarChartGeneric148Svg);
var _icon = require("../../../src/Icon");
var _slots = require("react-aria-components/slots");
'use client';
function GraphBarChart(props) {
    [props] = (0, _slots.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGraphBarChartGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGraphBarChartGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillGraphBarChartGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_graphBarChart_generic1_160.svg":"lgx2D","illustration:./S2_fill_graphBarChart_generic1_96.svg":"9Vrjn","illustration:./S2_fill_graphBarChart_generic1_48.svg":"gZU4D","../../../src/Icon":"jQAJE","react-aria-components/slots":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lgx2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "30a420__d",
                        x1: -32.175,
                        x2: 194.7,
                        y1: 136.536,
                        y2: -9.887,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "30a420__e",
                        x1: 156.055,
                        x2: 61.768,
                        y1: 40.051,
                        y2: 147.602,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "30a420__f",
                        x1: 33.771,
                        x2: 206.966,
                        y1: 156.124,
                        y2: 53.203,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "30a420__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 59.1674 -62.7654 0 62.765 59.167)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "30a420__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 59.1674 -62.7654 0 62.765 59.167)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "30a420__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 144.27,
                            height: 136,
                            x: 4.082,
                            y: 15,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "30a420__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M24.21 136h111.791c2.21 0 4 1.79 4 4s-1.79 4-4 4H20.211c-2.21 0-4-1.79-4-4V24c0-2.21 1.79-4 4-4s4 1.79 4 4zM44 71.05h4c4.418 0 8 3.582 8 8V116c0 4.418-3.582 8-8 8h-4c-4.418 0-8-3.582-8-8V79.05c0-4.418 3.582-8 8-8M120 96h-4c-4.418 0-8 3.582-8 8v12c0 4.418 3.582 8 8 8h4c4.418 0 8-3.582 8-8v-12c0-4.418-3.582-8-8-8M80 40h4c4.418 0 8 3.582 8 8v68c0 4.418-3.582 8-8 8h-4c-4.418 0-8-3.582-8-8V48c0-4.418 3.582-8 8-8"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#30a420__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#30a420__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 144.27,
                            height: 136,
                            x: 4.082,
                            y: 15,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.082 15h144.27v136H4.082z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 62.765,
                            cy: 59.167,
                            fill: "url(#30a420__c)",
                            rx: 62.765,
                            ry: 59.167,
                            transform: "matrix(1 -.00132 .00148 1 22.805 -38.81)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#30a420__d)",
                            d: "M59.146-9.023c-11.08-6.463-25.118-6.503-36.239-.102l-111.23 64.02c-10.893 6.27-10.912 21.07-.033 27.364L22.14 146.188c11.105 6.424 25.143 6.416 36.238-.023l110.267-63.99c10.821-6.28 10.841-20.997.033-27.3z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#30a420__e)",
                            d: "M24.872 79.57C27.338 28.797 73-10.478 126.86-8.154c53.86 2.325 95.524 45.369 93.058 96.142s-48.127 90.048-101.988 87.723c-53.86-2.324-95.523-45.368-93.058-96.141"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#30a420__f)",
                            d: "M-54.37 113.047c21.41-8.61 44.5-8.24 64.504-.71 40.03 15.108 63.322 5.767 79.477-31.881 8.047-18.892 23.757-34.892 45.191-43.511 42.853-17.207 92.326 1.463 110.553 41.74s-1.723 86.841-44.566 104.071c-21.482 8.638-44.616 8.234-64.651.635-39.965-15.026-63.213-5.651-79.347 32.043-8.067 18.847-23.775 34.792-45.184 43.402-42.82 17.219-92.292-1.451-110.509-41.706s1.713-86.863 44.532-104.083"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 62.765,
                            cy: 59.167,
                            fill: "url(#30a420__g)",
                            rx: 62.765,
                            ry: 59.167,
                            transform: "matrix(1 -.00132 .00148 1 77.09 -19.515)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Vrjn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "afe6b0__d",
                        x1: -19.305,
                        x2: 116.82,
                        y1: 81.922,
                        y2: -5.932,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "afe6b0__e",
                        x1: 93.635,
                        x2: 37.062,
                        y1: 24.031,
                        y2: 88.561,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "afe6b0__f",
                        x1: 20.262,
                        x2: 124.179,
                        y1: 93.675,
                        y2: 31.922,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "afe6b0__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 35.5005 -37.6593 0 37.66 35.5)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "afe6b0__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 35.5005 -37.6593 0 37.66 35.5)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "afe6b0__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 86.562,
                            height: 81.6,
                            x: 2.449,
                            y: 9,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "afe6b0__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M14.527 81.6H81.6c1.326 0 2.4 1.074 2.4 2.4s-1.074 2.4-2.4 2.4H12.127c-1.326 0-2.4-1.074-2.4-2.4V14.4c0-1.326 1.074-2.4 2.4-2.4s2.4 1.074 2.4 2.4zM26.4 42.63h2.4c2.651 0 4.8 2.15 4.8 4.8V69.6c0 2.651-2.149 4.8-4.8 4.8h-2.4c-2.651 0-4.8-2.149-4.8-4.8V47.43c0-2.65 2.149-4.8 4.8-4.8M72 57.6h-2.4c-2.651 0-4.8 2.149-4.8 4.8v7.2c0 2.651 2.149 4.8 4.8 4.8H72c2.651 0 4.8-2.149 4.8-4.8v-7.2c0-2.651-2.149-4.8-4.8-4.8M48 24h2.4c2.651 0 4.8 2.149 4.8 4.8v40.8c0 2.651-2.149 4.8-4.8 4.8H48c-2.651 0-4.8-2.149-4.8-4.8V28.8c0-2.651 2.149-4.8 4.8-4.8"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#afe6b0__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#afe6b0__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 86.562,
                            height: 81.6,
                            x: 2.449,
                            y: 9,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.45 9H89.01v81.6H2.45z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.659,
                            cy: 35.501,
                            fill: "url(#afe6b0__c)",
                            rx: 37.659,
                            ry: 35.501,
                            transform: "matrix(1 -.00132 .00148 1 13.684 -23.286)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#afe6b0__d)",
                            d: "M35.488-5.414c-6.648-3.878-15.071-3.901-21.744-.061l-66.738 38.412c-6.536 3.762-6.547 12.642-.02 16.418l66.298 38.358c6.662 3.854 15.085 3.85 21.742-.014l66.16-38.393c6.493-3.768 6.505-12.599.02-16.381z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#afe6b0__e)",
                            d: "M14.925 47.742c1.48-30.464 28.876-54.029 61.193-52.634s57.314 27.221 55.834 57.685-28.876 54.029-61.192 52.634-57.315-27.221-55.835-57.685"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#afe6b0__f)",
                            d: "M-32.623 67.829c12.846-5.166 26.7-4.945 38.703-.426 24.018 9.064 37.993 3.46 47.686-19.13C58.594 36.94 68.02 27.34 80.88 22.168c25.712-10.324 55.396.878 66.332 25.045 10.937 24.166-1.034 52.104-26.74 62.442-12.888 5.183-26.77 4.94-38.79.381-23.98-9.016-37.928-3.39-47.608 19.226-4.84 11.308-14.265 20.875-27.11 26.041-25.692 10.332-55.376-.871-66.306-25.024s1.028-52.117 26.72-62.45"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 37.659,
                            cy: 35.501,
                            fill: "url(#afe6b0__g)",
                            rx: 37.659,
                            ry: 35.501,
                            transform: "matrix(1 -.00132 .00148 1 46.254 -11.709)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gZU4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ff87e__d",
                        x1: -9.655,
                        x2: 58.408,
                        y1: 40.96,
                        y2: -2.966,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ff87e__e",
                        x1: 46.813,
                        x2: 18.527,
                        y1: 12.015,
                        y2: 44.28,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "1ff87e__f",
                        x1: 10.129,
                        x2: 62.087,
                        y1: 46.837,
                        y2: 15.961,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1ff87e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.7502 -18.8296 0 18.83 17.75)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "1ff87e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 17.7502 -18.8296 0 18.83 17.75)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "1ff87e__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 43.281,
                            height: 40.8,
                            x: 1.223,
                            y: 4.5,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "1ff87e__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M7.263 40.8H40.8c.663 0 1.2.537 1.2 1.2s-.537 1.2-1.2 1.2H6.063c-.663 0-1.2-.537-1.2-1.2V7.2c0-.663.537-1.2 1.2-1.2s1.2.537 1.2 1.2zM13.2 21.315h1.2c1.326 0 2.4 1.075 2.4 2.4V34.8c0 1.326-1.075 2.4-2.4 2.4h-1.2c-1.325 0-2.4-1.075-2.4-2.4V23.715c0-1.325 1.074-2.4 2.4-2.4M36 28.8h-1.2c-1.325 0-2.4 1.075-2.4 2.4v3.6c0 1.326 1.075 2.4 2.4 2.4H36c1.325 0 2.4-1.075 2.4-2.4v-3.6c0-1.325-1.075-2.4-2.4-2.4M24 12h1.2c1.326 0 2.4 1.075 2.4 2.4v20.4c0 1.326-1.075 2.4-2.4 2.4H24c-1.326 0-2.4-1.075-2.4-2.4V14.4c0-1.325 1.074-2.4 2.4-2.4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#1ff87e__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#1ff87e__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 43.281,
                            height: 40.8,
                            x: 1.223,
                            y: 4.5,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M1.223 4.5h43.28v40.8H1.224z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.83,
                            cy: 17.75,
                            fill: "url(#1ff87e__c)",
                            rx: 18.83,
                            ry: 17.75,
                            transform: "matrix(1 -.00132 .00148 1 6.84 -11.643)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ff87e__d)",
                            d: "M17.742-2.707c-3.324-1.94-7.536-1.951-10.872-.031l-33.369 19.206c-3.268 1.881-3.273 6.321-.01 8.21L6.64 43.855c3.331 1.927 7.543 1.925 10.871-.007l33.08-19.197c3.247-1.884 3.253-6.299.01-8.19z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ff87e__e)",
                            d: "M7.459 23.87C8.199 8.64 21.897-3.143 38.055-2.445c16.158.697 28.657 13.61 27.917 28.842S51.534 53.41 35.376 52.713 6.719 39.103 7.459 23.87"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#1ff87e__f)",
                            d: "M-16.313 33.914c6.423-2.583 13.35-2.472 19.351-.213 12.009 4.532 18.996 1.73 23.843-9.564 2.414-5.668 7.127-10.468 13.557-13.053 12.856-5.162 27.698.439 33.166 12.522 5.469 12.083-.517 26.052-13.37 31.22-6.444 2.593-13.385 2.471-19.395.191-11.99-4.507-18.964-1.695-23.804 9.613-2.42 5.654-7.132 10.438-13.555 13.02-12.846 5.167-27.688-.434-33.153-12.51s.514-26.06 13.36-31.226"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 18.83,
                            cy: 17.75,
                            fill: "url(#1ff87e__g)",
                            rx: 18.83,
                            ry: 17.75,
                            transform: "matrix(1 -.00132 .00148 1 23.125 -5.854)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=s2.5e408000.js.map
